import ClassicEditor from "./ckeditor/ckeditor"
// Lazy load D3 only when needed
let d3 = null;
async function loadD3() {
    if (!d3) {
        d3 = await import("d3");
    }
    return d3;
}
import * as voiceNotes from "./voice_note";
import { FabricAnnotator } from "./fabric_annotations";
import Sortable from "sortablejs";

// touch-aware sortable: sortablejs on touch, jquery ui on desktop (matches admin pattern)
function makeEsSortable($el, opts) {
    const el = $el[0];
    if (!el) return;
    if ("ontouchend" in document) {
        if (el._esSortable) el._esSortable.destroy(); // avoid duplicate instances
        el._esSortable = Sortable.create(el, {
            handle: opts.handle,
            delay: 200,
            animation: 150,
            dragoverBubble: true,
            ghostClass: "blue-background-class",
            onUpdate: opts.onUpdate
        });
    } else {
        if ($el.hasClass("ui-sortable")) $el.sortable("destroy");
        $el.sortable({
            axis: "y",
            items: opts.items,
            placeholder: opts.placeholder,
            handle: opts.handle,
            cursor: "move",
            opacity: 0.6,
            update: opts.onUpdate
        });
    }
}

// write current dot coords into the active create/edit hidden inputs
function writeDotCoords(x, y) {
    if ($modalDotEdit.hasClass('d-none')) {
        $editDotPositionInput.find('input[name="coord_x"]').val(x);
        $editDotPositionInput.find('input[name="coord_y"]').val(y);
    } else {
        $('.dots-card').eq(curPage()).find('input[name="coord_x"]').val(x);
        $('.dots-card').eq(curPage()).find('input[name="coord_y"]').val(y);
    }
}

// make the red preview dot draggable so users can fine-tune position before save
function attachNewDotDrag(el, viewer) {
    let dragging = false;
    function onMove(e) {
        if (!dragging) return;
        e.preventDefault();
        // anchor to viewer.container (the .openseadragon-container) so .shrink class shifts are honored
        const rect = viewer.container.getBoundingClientRect();
        const pos = new OpenSeadragon.Point(e.clientX - rect.left, e.clientY - rect.top);
        const vpt = viewer.viewport.pointFromPixel(pos);
        viewer.updateOverlay(el, new OpenSeadragon.Point(vpt.x, vpt.y));
        writeDotCoords(vpt.x, vpt.y);
    }
    function onUp() {
        if (!dragging) return;
        dragging = false;
        viewer.gestureSettingsMouse.dragToPan = true;
        viewer.gestureSettingsTouch.dragToPan = true;
        document.removeEventListener('pointermove', onMove);
        document.removeEventListener('pointerup', onUp);
        document.removeEventListener('pointercancel', onUp);
    }
    el.addEventListener('pointerdown', function (e) {
        e.preventDefault();
        e.stopPropagation();
        dragging = true;
        viewer.gestureSettingsMouse.dragToPan = false;
        viewer.gestureSettingsTouch.dragToPan = false;
        document.addEventListener('pointermove', onMove);
        document.addEventListener('pointerup', onUp);
        // ios frequently emits pointercancel instead of pointerup; without it the
        // drag stays stuck (dragToPan false, dragging true) and the circle flies off
        document.addEventListener('pointercancel', onUp);
    });
}

const $modalExhibitInfo = $('#modal-exhibitinfo');
const $dotShare = $('.dotShare');
const exhibit_id = $modalExhibitInfo.attr('data-exhibit-id');
const $dotsWrapper = $('.dots-wrapper');
const $exhibitStoryNavigation = $('.exhibit-story-navigation');
const $dotFullClose = $('.dot-full-close');
const $buttonsWrapper = $('.buttons-wrapper');
const $closeExhText = $('#close-exh-text');
const $startExhibitStory = $('.start-exhibit-story');
const $startExhibitStoryParent = $startExhibitStory.parent();
const $dotsCounter = $('.dotsCounter');
const $currentEsStep = $('#current-es-step');
const $showDotsButton = $('#showDots');
const $windowWidth = $(window).width();
const $modalDotFull = $('#modal-dotfull');
const $shareLink = $('#shareLink');
const $personalAlert = $('.personal-alert');
// dotcrt share-link mode: tailors the guest "leave your dot" flow (bare form, hidden pins).
// mobile only — on desktop the ?dotcrt=true link still auto-opens create mode but keeps the normal form
window.dotShareMode = new URLSearchParams(window.location.search).get('dotcrt') === 'true' && $windowWidth < 600;
// persistent marker for the whole share session (dot-share-hiding is transient, cleared after create/cancel)
if (window.dotShareMode) $('body').addClass('dot-share');

const $openseadragonViewer = $('#openseadragon_viewer');
const $exhInfoButton = $('.exh-info-button');
const $esFormWrapper = $('.es-form-wrapper');
const $exhDotCreateMobile = $('.exh-dot-create-mobile');
const $exhibitAttributionWrapper = $('.exhibit-attribution-wrapper');
const $exhInfo = $('#exh-info');
const $navButton = $('.nav-button');
const $exhThumbsButton = $('.exh-thumbs-button');
const $exhHideButtons = $('#exh-hide-buttons');
const $exhDziRotateRight = $('#exh-dzi-rotate-right');
const $exhDziReset = $('#exh-dzi-reset');
const $printBuy = $('.printBuy');
const $blankButton = $('.blank-button');
const $viewerWrapper = $('.viewer-wrapper');
const $thumbsWrapper = $('.thumbs-wrapper');
const $dotVoiceContainer = $('.dot-voice-container');
const $currentEsStepLeftDotModal = $('#current-es-step-left-dotModal');
const $currentEsStepLeft = $('#current-es-step-left');
const $modalDotEdit = $('#modal-dotedit');
const $exhibitVoiceContainer = $('.exhibit-voice-container');
const $dotVoiceVisibility = $('.dot-voice-visibility');
const $exhibitStoryLeft = $('#exhibit-story-left');
const $dotFrom = $('.dotFrom');
const $dotAll = $('.dotAll');
const $esFormData = $('#esFormData');
const $finaliseEsModal = $('#finaliseEsModal');
const $saveExhibitStory = $('#saveExhibitStory');
const $header = $('header');
const $exhibitStorySetup = $('#exhibit-story-setup');
const $esButtonWrapper = $('#es-button-wrapper');
const $dotFooter = $('.dot-footer');
const $closeModalBtn = $('.close-modal-btn');
const $exhibitTextFooter = $('.exhibit-text-footer');
const $totalEsStepsLeft = $('#total-es-steps-left');
const $esInfoArea = $('#es-info-area');
const $expandExhibitText = $('.expand-exhibit-text');
const $contentWrapper = $('.content-wrapper');
const $exhibitStoryShare = $('#exhibit-story-share');
const $exhibitVoiceVisibility = $('.exhibit-voice-visibility');
const $copyShortURL = $('#copyShortURL');
const $embedLink = $('#embedLink');
const $exhDescription = $('.exh-description');
const $toolbar = $('#toolbar');
// TODO: remove 4k/8k
// const $preview4k = $('#preview-4k');
const $bottomImageName = $('.bottom-image-name');
const $imageEdit = $('#imageEdit');
const $generatedShortURL = $('#generatedShortURL');
const $iiifManifestURL = $('#iiifManifestURL');
const $iiifShareRow = $('#iiif-share-row');
const $embedCode = $('#embedCode');
const $videoContainer = $('#video-container');
const $modalDotFullContent = $('#modal-dotfull .modal-dialog .modal-content');
const $exhibitStoryNavPrev = $('.exhibit-story-navigation .prev');
const $exhibitStoryNavNext = $('.exhibit-story-navigation .next');
const $exhibitInputComment = $('.exhibit-input-comment');
const $modalCrtexh = $('#modal-crtexh');
const $mode = $('#mode');
const $upperRightExhButtons = $('.upper-right-exh-buttons');
const $editDotPositionInput = $('#edit-dot-position-input');
const $imageTags = $('#image_tags');
const $updateDot = $('#updateDot');
const $socialExhibitCommentContainer = $('.social-exhibit-comment-container');
const $esFormDataTr = $('#esFormData tr');
const $loopEsModalBody = $('#loopEsModal .modal-body');
const $imageInfo = $('.image-info');
const $blankStoryNavigation = $('.blank-story-navigation');
const $shortAlerts = $('#short-alerts');

// append a short alert and auto-dismiss the appended node after 3s. removing the
// captured element (not a cached first-child selector) is what lets stacked alerts
// each clear themselves.
function showShortAlert(html) {
    const $el = $(html).appendTo($shortAlerts);
    setTimeout(function () {
        $el.removeClass('show-alert');
        setTimeout(function () {
            $el.remove();
        }, 500);
    }, 3000);
    return $el;
}

const $zoomableModal = $('#zoomable-modal');
const $exhSideButton = $('.exh-side-button');

const redB = '<span style="text-shadow:-1px -1px 0 red,1px -1px 0 red,-1px 1px 0 red,1px 1px 0 red;">b</span>';
function setStepBText($el) {
    const base = $el.text().trim().slice(0, -1);
    $el.html(base + redB);
}

if (window.exhibitConfig && window.exhibitConfig.defaultHideButtons) {
    $(document).ready(function () {
        $exhSideButton.attr('style', 'display: none !important');
        $('#exh-hide-buttons').find('i').removeClass('fa-eye-slash').addClass('fa-eye');
        $('#exh-hide-buttons').attr('data-title-right', 'Show buttons');
    });
}

// iOS Safari ignores user-scalable=no, so gesture* is the only reliable page-zoom block.
// OSD drives its own pinch off touch/pointer events, so image zoom is unaffected.
['gesturestart', 'gesturechange', 'gestureend'].forEach(function (type) {
    document.addEventListener(type, function (e) { e.preventDefault(); }, { passive: false });
});

// set by the canvas-pinch handler; lets a pin ignore the click OSD reports after a pinch
let lastCanvasPinch = 0;

let exhibit_story_create_mode = false
let anno;
// OCR/AI region boxes on the annotation layer: toggled by the "Show OCR" side
// button (#showOcrAi), reset when dots hide (see loadWordHighlights / hidePins)
let ocrHighlightsOn = false;

// ── AJAX image data cache ──────────────────────────────────────────────────
window.imageDataCache = {};      // resolved data keyed by imageId
const imageDataFetchCache = {};  // in-flight promises to avoid duplicate fetches
let currentZoomableImages = [];
let currentZoomableIndex = 0;
let currentZoomableViewer = null;
let isLoadingZoomable = false;
let currentZoomableRequestId = 0;

$(document).on('click', '#confirm-dot-position', function () {
    $('.modal-backdrop').removeClass('d-none');
    $modalDotEdit.removeClass('d-none');
});

$('.edit-dot-position').on('click', function () {

    $('.modal-backdrop').addClass('d-none');
    $modalDotEdit.addClass('d-none');

    if ($('#confirm-dot-position').length == 0) {
        let button = document.createElement('button');
        button.id = 'confirm-dot-position';
        button.textContent = 'Confirm new DOT position';
        button.classList.add('btn', 'btn-primary', 'position-absolute');
        button.style.top = '80px';
        button.style.right = '70px';
        button.style.zIndex = '9999';
        document.body.appendChild(button);
    }

    if (!$('.pin-button').hasClass('active')) {
        $('.pin-button').click();
    }
});


function calculateDuration(duration) {
    if (duration) {
        let roundedSeconds = Math.round(duration);
        let minutes = Math.floor(roundedSeconds / 60);
        let seconds = roundedSeconds % 60;

        if (duration >= 3600) {
            let hours = Math.floor(roundedSeconds / 3600);
            minutes = Math.floor((roundedSeconds % 3600) / 60);
            return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
        }

        return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    } else {
        return "00:00";
    }
}

$(function () {
    $thumbsWrapper.on('classChange', function () {
        if (!$(this).hasClass('active')) {
            autoplay_image_first_voice_note()
        }
    });

    $imageInfo.on('multipleClassChange', function () {
        autoplay_image_first_voice_note()
    });

    const observeClassChange = function (className) {
        const target = $('.' + className)[0];
        const observer = new MutationObserver(function () {
            $('.' + className).trigger('classChange');
        });

        observer.observe(target, {attributes: true, attributeFilter: ['class']});
    };

    const observeMultipleClassChange = function (className) {
        const imageInfoElements = document.querySelectorAll('.' + className);
        const observer = new MutationObserver((mutationsList) => {
            for (const mutation of mutationsList) {
                if (
                    mutation.type === 'attributes' &&
                    mutation.attributeName === 'class'
                ) {
                    const targetElement = mutation.target;
                    if (targetElement.classList.contains('active')) {
                        $('.' + className).trigger('multipleClassChange');
                    }
                }
            }
        });

        $('.' + className).each(function () {
            observer.observe(this, {attributes: true, attributeFilter: ['class']});
        });
    }

    observeClassChange('thumbs-wrapper');
    observeMultipleClassChange('image-info');
});

let voice_note_clicked = false;

function autoplay_image_first_voice_note(time = 1500) {
    const isMobile = $windowWidth <= 600;
    const $imageInfoActive = isMobile
        ? $('.image-info-mobile .image-info.active')
        : $('#exhibit-sidebar-left .image-info.active');
    const active_image_info_id = $imageInfoActive.data('image-id');
    if (window.autoplay_image_voice_note && $imageInfo.hasClass('active') && $exhInfoButton.hasClass('active')) {
        const type = 'image'
        let voiceNoteButton = $imageInfoActive.find('.image-info-wrapper').find('.voice-visibility-image-footer');
        const voice_note_count = $imageInfoActive.find('.image-info-wrapper').find('.voice-visibility-image-footer .badge').html()

        if (voice_note_count > 0 && !voice_note_clicked) {
            // on mobile, show a one-time prompt to get user gesture before playing
            if (isMobile) {
                $('.voice-note-prompt').remove();
                if (window._vnAutoplayChoice === 'no') return;
                if (window._vnAutoplayChoice === 'yes') {
                    _triggerVoiceNoteAutoplay($imageInfoActive, voiceNoteButton, type, time);
                    return;
                }
                const $wrapper = $imageInfoActive.find('.image-info-wrapper.active');
                if ($wrapper.length && !$wrapper.find('.voice-note-prompt').length) {
                    const $prompt = $('<div class="voice-note-prompt">' +
                        '<span><i class="fas fa-volume-up"></i> Play voice notes?</span>' +
                        '<div>' +
                        '<button class="btn btn-sm btn-tdg-blue voice-note-prompt-yes">Yes</button>' +
                        '<button class="btn btn-sm btn-outline-secondary voice-note-prompt-no">No</button>' +
                        '</div></div>');
                    $wrapper.prepend($prompt);

                    $prompt.find('.voice-note-prompt-yes').on('click', function() {
                        $prompt.remove();
                        window._vnAutoplayChoice = 'yes';
                        _triggerVoiceNoteAutoplay($imageInfoActive, voiceNoteButton, type, time);
                    });
                    $prompt.find('.voice-note-prompt-no').on('click', function() {
                        $prompt.remove();
                        window._vnAutoplayChoice = 'no';
                    });
                }
                return;
            }

            _triggerVoiceNoteAutoplay($imageInfoActive, voiceNoteButton, type, time);
        }
    }
}

function _triggerVoiceNoteAutoplay($imageInfoActive, voiceNoteButton, type, time) {
    if (!voiceNoteButton.hasClass('active')) {
        voiceNoteButton.click();
        voice_note_clicked = true;
    }
    setTimeout(function () {
        let audioElement = $imageInfoActive.find('.image-info-wrapper .image-voice-container').find('audio').first();

        if (audioElement.length > 0) {
            audioElement[0].play().catch(function(e) {
                console.log('autoplay blocked:', e.message);
            });

            if (!voiceNoteButton.hasClass('active')) {
                voiceNoteButton.addClass('active');

                if (type == 'image') {
                    $('.image-voice-container').removeClass('d-none');
                    $('.image-voice-group').removeClass('d-none');
                }
            }
        }
        voice_note_clicked = false;
    }, time)
}

// handle voice note playback logic
function handleVoiceNotePlayback(voiceId, type) {
    if (isLoopMode) {
        return;
    }

    let $voiceNoteButtonHandle
    let $audioElement

    if (type == 'exhibit') {
        $voiceNoteButtonHandle = $('.voice-visibility-exhibit-footer');
        $audioElement = $modalExhibitInfo.find("[data-voice-exhibit-id='" + voiceId + "']").find('audio').first();
    } else if (type == 'dot') {
        $voiceNoteButtonHandle = $dotVoiceVisibility;
        $audioElement = $modalDotFull.find("[data-voice-dot-id='" + voiceId + "']").find('audio').first();
    }

    if ($audioElement.length <= 0) {
        return;
    }

    if ($('.overlay-exhibit-story').length > 0) {
        if ($audioElement.length > 0) {
            voiceNoteDuration = $audioElement[0].duration;
            $audioElement[0].play().catch(function(e) {
                console.log('autoplay blocked:', e.message);
            });

            if (!$voiceNoteButtonHandle.hasClass('active')) {
                $voiceNoteButtonHandle.addClass('active');

                if (type == 'exhibit') {
                    $exhibitVoiceContainer.removeClass('d-none');
                    $('.exhibit-voice-group').removeClass('d-none');
                } else if (type == 'dot') {
                    $dotVoiceContainer.removeClass('d-none');
                    $('.dot-voice-group').removeClass('d-none');
                }
            }
        }
    }
}

// setup or reset the voice note button state based on auto_play_voice
function setupVoiceNoteButtonState(auto_play_voice, type) {

    let $voiceNoteButtonSetup

    if (type == 'exhibit') {
        $voiceNoteButtonSetup = $('.voice-visibility-exhibit-footer');
    } else if (type == 'dot') {
        $voiceNoteButtonSetup = $dotVoiceVisibility;
    }

    if (auto_play_voice == 1) {
        if ($dotVoiceContainer.hasClass('d-none')) {
            $voiceNoteButtonSetup.click();
        }
    } else {
        $voiceNoteButtonSetup.click();
        $dotVoiceContainer.addClass('d-none');
    }
}

// setup or reset the auto play voice functionality
let voiceNoteDuration = 0;

function setupAutoPlayVoice(auto_play_voice, type) {
    $(document).off('audioLoaded');

    if (auto_play_voice == 1) {
        $(document).on('audioLoaded', function (e, voiceId) {
            handleVoiceNotePlayback(voiceId, type);
        });
    }
    setupVoiceNoteButtonState(auto_play_voice, type);
}

// auto play dot voice switch
$(document).on("click", ".auto-play-voice", function () {
    if (exhibit_story_create_mode == true) {
        $(this).toggleClass('active');

        let dotId = $(this).parent().parent().data('id');
        let imgId = $(this).parent().parent().data('image-id');

        if (dotId != undefined) {
            let inputValue = $('.es-form-wrapper').find('.added-dot-to-es-wrapper[data-id="' + dotId + '"]').find('form').find('input[name="autoPlayVoice"]').val();

            if (typeof inputValue != "undefined") {
                if (inputValue == 1) {
                    $('.es-form-wrapper').find('.added-dot-to-es-wrapper[data-id="' + dotId + '"]').find('form').find('input[name="autoPlayVoice"]').val(0);
                } else {
                    $('.es-form-wrapper').find('.added-dot-to-es-wrapper[data-id="' + dotId + '"]').find('form').find('input[name="autoPlayVoice"]').val(1);
                }
            } else {
                inputValue = $('#dot-' + dotId).find('.auto-play-wrapper').find('input[type="checkbox"]').val();

                if (inputValue == 1) {
                    $('#dot-' + dotId).find('.auto-play-wrapper').find('input[type="checkbox"]').val(0);
                } else {
                    $('#dot-' + dotId).find('.auto-play-wrapper').find('input[type="checkbox"]').val(1);
                }
            }

            if ($('#dot-' + dotId).length > 0) {
                if (!$(this).parent().parent().parent().parent().hasClass('card-header')) {
                    let wrapper = $('#dot-' + dotId).find('.auto-play-wrapper');
                    if (inputValue == 1) {
                        wrapper.find('input[type="checkbox"]').prop('checked', false);
                        wrapper.find('.custom-toggle-slider').removeClass('active');
                    } else {
                        wrapper.find('input[type="checkbox"]').prop('checked', true);
                        wrapper.find('.custom-toggle-slider').addClass('active');
                    }
                } else {
                    let sidebarWrapper = $('.dot-short[data-id="' + dotId + '"]').find('.auto-play-wrapper');

                    if (inputValue == 1) {
                        sidebarWrapper.find('input[type="checkbox"]').prop('checked', false);
                        sidebarWrapper.find('.custom-toggle-slider').removeClass('active');
                    } else {
                        sidebarWrapper.find('input[type="checkbox"]').prop('checked', true);
                        sidebarWrapper.find('.custom-toggle-slider').addClass('active');
                    }
                }
            }
        } else if (imgId != undefined) {
            let inputValue = $('.es-form-wrapper').find('.added-img-to-es-wrapper[data-id="' + imgId + '"]').find('form').find('input[name="autoPlayVoice"]').val();

            if (typeof inputValue != "undefined") {
                if (inputValue == 1) {
                    $('.es-form-wrapper').find('.added-img-to-es-wrapper[data-id="' + imgId + '"]').find('form').find('input[name="autoPlayVoice"]').val(0);
                } else {
                    $('.es-form-wrapper').find('.added-img-to-es-wrapper[data-id="' + imgId + '"]').find('form').find('input[name="autoPlayVoice"]').val(1);
                }
            } else {
                inputValue = $('#img-' + imgId).find('.auto-play-wrapper').find('input[type="checkbox"]').val();

                if (inputValue == 1) {
                    $('#img-' + imgId).find('.auto-play-wrapper').find('input[type="checkbox"]').val(0);
                } else {
                    $('#img-' + imgId).find('.auto-play-wrapper').find('input[type="checkbox"]').val(1);
                }
            }

            if ($('#img-' + imgId).length > 0) {
                if (!$(this).parent().parent().parent().hasClass('card-header')) {
                    let wrapper = $('#img-' + imgId).find('.auto-play-wrapper');
                    if (inputValue == 1) {
                        wrapper.find('input[type="checkbox"]').prop('checked', false);
                        wrapper.find('.custom-toggle-slider').removeClass('active');
                    } else {
                        wrapper.find('input[type="checkbox"]').prop('checked', true);
                        wrapper.find('.custom-toggle-slider').addClass('active');
                    }
                } else {
                    let sidebarWrapper = $('.image-info').find('.auto-play-wrapper[data-image-id="' + imgId + '"]');

                    if (inputValue == 1) {
                        sidebarWrapper.find('input[type="checkbox"]').prop('checked', false);
                        sidebarWrapper.find('.custom-toggle-slider').removeClass('active');
                    } else {
                        sidebarWrapper.find('input[type="checkbox"]').prop('checked', true);
                        sidebarWrapper.find('.custom-toggle-slider').addClass('active');
                    }
                }
            }
        }
    }
});

//set zoom and pan
$(document).on("click", ".set-zoom-and-position", function () {
    let dotId = $(this).parent().attr('data-id');
    let zoomLevel = viewer.viewport.getZoom();
    let panPosition = viewer.viewport.getCenter();
    let panX = panPosition.x;
    let panY = panPosition.y;
    // capture the container aspect ratio too, so playback can reconstruct this exact
    // framing even when the viewer width differs (e.g. presentation mode un-shrinks it)
    let captureAspect = viewer.viewport.getAspectRatio();
    // and the container width in css px: zoom is relative to the image, so only the
    // width tells the cache warmer which pyramid level this framing actually reads.
    let captureWidth = viewer.viewport.containerSize.x;

    if (exhibit_story_create_mode == true) {
        let autoPlayVoice = $(this).parent().parent().find('.auto-play-wrapper').find('.custom-toggle').find('.auto-play-voice');
        let order = $('.es-form-wrapper').find('form').length + 1;

        let autoPlayInput = 0;

        if (autoPlayVoice.hasClass('active')) {
            autoPlayInput = 1;
        }

        let formWrapper = $('.es-form-wrapper').find('.added-dot-to-es-wrapper[data-id="' + dotId + '"]');
        let imgId = $('.image-info.active').data('image-id');

        let existingForm;
        let form = '<form>\
                                <input name="imgId" value="' + imgId + '">\
                                <input name="dotId" value="' + dotId + '">\
                                <input name="zoom" value="' + zoomLevel + '">\
                                <input name="panX" value="' + panX + '">\
                                <input name="panY" value="' + panY + '">\
                                <input name="captureAspect" value="' + captureAspect + '">\
                                <input name="captureWidth" value="' + captureWidth + '">\
                                <input type="checkbox" name="autoPlayVoice" value="' + autoPlayInput + '">\
                                <input class="d-none" type="text" name="order" value="' + order + '">\
                                <input type="hidden" name="group_id" value="">\
                                <input type="hidden" name="line_group_id" value="">\
                                <input type="hidden" name="skip_zoom_out" value="">\
                                </form>';


        if (formWrapper.find('form').length) {
            existingForm = formWrapper.find('form');
            existingForm.find('input[name="dotId"]').val(dotId);
            existingForm.find('input[name="zoom"]').val(zoomLevel);
            existingForm.find('input[name="panX"]').val(panX);
            existingForm.find('input[name="panY"]').val(panY);
            existingForm.find('input[name="captureAspect"]').val(captureAspect);
            existingForm.find('input[name="captureWidth"]').val(captureWidth);
            existingForm.find('input[name="autoPlayVoice"]').val(autoPlayInput);
        } else {
            formWrapper.append(form);
        }

        $(this).removeClass('btn-secondary').addClass('btn-success');
        viewer.viewport.goHome();
        $('.dot-pointer[data-id="' + dotId + '"]').removeClass('active')
    }
});

$(document).on('click', '#exhibitStoryAutoplayAll', function () {
    if ($(this).prop('checked')) {
        $esFormWrapper.each(function () {
            $(this).find('input[name="autoPlayVoice"]').prop('checked', true).val(1);
        });

        $('.auto-play-wrapper').each(function () {
            $(this).find('input[type="checkbox"]').prop('checked', true);
            $(this).find('.custom-toggle-slider').addClass('active');
        });
    } else {
        $esFormWrapper.each(function () {
            $(this).find('input[name="autoPlayVoice"]').prop('checked', false).val(0);
        });

        $('.auto-play-wrapper').each(function () {
            $(this).find('input[type="checkbox"]').prop('checked', false);
            $(this).find('.custom-toggle-slider').removeClass('active');
        });
    }
});

// only "don't show pins" and "show current step pin" are mutually exclusive;
// "don't show dot text" is independent and combinable with either
$(document).on('change', '#exhibitStoryShowOnlyActiveDot, #exhibitStoryDontShowPins', function () {
    if ($(this).prop('checked')) {
        $('#exhibitStoryShowOnlyActiveDot, #exhibitStoryDontShowPins').not(this).prop('checked', false);
    }
});

$expandExhibitText.on('click', function () {
    $(this).removeClass('d-block').addClass('d-none');
    $modalExhibitInfo.css('height', '');
    $esButtonWrapper.addClass('d-flex').removeClass('d-none');
    $closeExhText.addClass('d-sm-block').removeClass('d-none');
    $expandExhibitText.tooltip('hide');
});

$('#image-voice-note-share').on('click', function () {
    $('#image-voice-note-share').addClass('d-none').removeClass('d-flex');
    autoplay_image_first_voice_note(150);
});

document.addEventListener('DOMContentLoaded', function () {
    //show exhibit info modal
    initCkEditorReadMoreToggles();

    // start dot/exh story from share link
    const url = new URL(window.location.href);
    const exhibitStorySlug = url.searchParams.get('exhibit-story-slug');
    const esRunSlug = url.searchParams.get('es-run-slug');
    const shareWithoutThumbs = url.searchParams.get('thb');
    const dot = url.searchParams.get('dot')

    setTimeout(function () {
        if (shareWithoutThumbs == 'false' && window.autoplay_image_voice_note && dot == 'false') {
            $('#image-voice-note-share').removeClass('d-none').addClass('d-flex');

            let imageTitle = $('.image-info.active').find('.image-title').first().text().trim();
            $('#image-voice-note-share-title').text(imageTitle);
        }
    }, 200)

    if (exhibitStorySlug) {
        setTimeout(function () {
            $thumbsWrapper.removeClass('active');
            $modalExhibitInfo.modal('hide');
        }, 150)

        $exhibitStoryShare.addClass('d-flex').removeClass('d-none').attr('data-es-id', exhibitStorySlug);
        $blankStoryNavigation.removeClass('d-none');

        const matchingButton = document.querySelector(`button[data-exhibit-story-slug="${exhibitStorySlug}"]`);
        $('#exhibit-story-share-title').text(matchingButton.textContent.trim());
    }

    // arm the share overlay for a shared run of show
    if (esRunSlug) {
        setTimeout(function () {
            $thumbsWrapper.removeClass('active');
            $modalExhibitInfo.modal('hide');
        }, 150)

        $exhibitStoryShare.addClass('d-flex').removeClass('d-none').attr('data-es-run-id', esRunSlug);
        $blankStoryNavigation.removeClass('d-none');

        const matchingRunButton = document.querySelector(`button.start-es-run[data-es-run-slug="${esRunSlug}"]`);
        if (matchingRunButton) $('#exhibit-story-share-title').text(matchingRunButton.textContent.trim());
    }

    $(function () {
        if (window.image_text_open) {
            const _activeId = parseInt($('.image-info.active').data('image-id'));
            if (_activeId) loadImageData(_activeId);
            if ($windowWidth > 600) {
                $openseadragonViewer.find('.openseadragon-container').addClass('shrink');
                $bottomImageName.css({'padding-left': '330px', 'transition-duration': '300ms'})
            } else {
                mobileImageModalActivator();

                if ($exhibitStoryShare.hasClass('d-flex')) {
                    $exhInfoButton.removeClass('active');
                }
            }
        }
    });

    // Add event listener to detect the first click

    // don't show modal when coming from exhibit story / run of show share link
    if (!exhibitStorySlug && !esRunSlug) {
        $('#modal-exhibitinfo:not(.hidemodal)').modal('show');
    }

    if (($windowWidth < 600) && exhibitStorySlug == null && esRunSlug == null && !$('#modal-exhibitinfo').hasClass('hidemodal')) {
        document.addEventListener('click', detectFirstClick);

        function detectFirstClick(event) {
            const modalHeader = document.querySelector('#modal-exhibitinfo');
            const specificButton = document.querySelector('.expand-exhibit-text');

            // Check if the click happened inside the modal header or on the specific button
            const clickedInsideModalHeader = modalHeader.contains(event.target);
            const clickedOnSpecificButton = specificButton.contains(event.target);

            if (clickedInsideModalHeader || clickedOnSpecificButton) {
                // console.log('Clicked inside modal header or on the specific button:', event.target);
            } else {
                $expandExhibitText.removeClass('d-block').addClass('d-none');
                $esButtonWrapper.addClass('d-flex').removeClass('d-none');
                $closeExhText.addClass('d-sm-block').removeClass('d-none');
                $expandExhibitText.tooltip('hide');
                $modalExhibitInfo.modal('hide');

                setTimeout(function () {
                    $modalExhibitInfo.css('height', '');
                }, 450);

                document.removeEventListener('click', detectFirstClick);
            }
        };

        $modalExhibitInfo.addClass('exhibit-text-modal-loaded-mobile');
        $exhInfoButton.removeClass('active');
        $modalExhibitInfo.css('height', '64px');
        $esButtonWrapper.removeClass('d-flex').addClass('d-none');
        $closeExhText.removeClass('d-sm-block').addClass('d-none');
        $expandExhibitText.tooltip({ boundary: 'viewport' });
        $('.modal-backdrop').css({'height': '0', 'width': '0'});

        setTimeout(function () {
            $expandExhibitText.removeClass('d-none').addClass('d-block');
            $expandExhibitText.tooltip('show');
        }, 200);

    }

    $('#page-loader').remove();
    //stop playing yt iframe when closing modals
    $("#modal-exhibitinfo").on('hidden.bs.modal', function (e) {
        $('.exhibit-voice-container').find('audio').each(function () {
            this.pause();
        });

        if ($exhibitVoiceVisibility.hasClass('active')) {
            $exhibitVoiceVisibility.click();
        }

        if ($('.exhibit-comments-visibility').hasClass('active')) {
            $('.exhibit-comments-visibility').click();
        }

        stopIframeVid('#modal-exhibitinfo');
    });

    $("#modal-dotfull").on('hidden.bs.modal', function (e) {

        $('.dot-voice-container').find('audio').each(function () {
            this.pause();
        });

        if ($dotVoiceVisibility.hasClass('active')) {
            $dotVoiceVisibility.click();
        }

        $('.dot-number').removeClass('active');
        $('.dot-pointer').removeClass('active');
        $('.dot-short').removeClass('active');

        stopIframeVid('#modal-dotfull');

        if ($dotVoiceVisibility.hasClass('active')) {
            $dotVoiceVisibility.click();
        }
    });

    $(document).on('hidden.bs.modal', '#modal-dotfull', function (e) {
        if (!$('.overlay-exhibit-story').length > 0) {
            $header.removeClass('hiddenHeader');
        }

        //stop playing audio when modal is closed
        $modalDotFull.find('.modal-dialog').find('.modal-content').find('.dot-voice-container').find('audio').each(function () {
            this.pause();
        });
    });

    loadIframe('.exh-description');

    document.querySelectorAll('.buttons-wrapper button').forEach(element => {
        element.setAttribute('title', '');
        element.removeAttribute('style');
    });

    $(function () {
        if (window.image_text_open) {
            if ($windowWidth > 600) {
                $openseadragonViewer.find('.openseadragon-container').addClass('shrink');
                $bottomImageName.css({'padding-left': '330px', 'transition-duration': '300ms'})
            } else {
                if (!$exhibitStoryShare.hasClass('d-flex')) {
                    if (!window.autoplay_image_voice_note) {
                        $thumbsWrapper.removeClass('active');
                    }

                    setTimeout(function () {
                        $modalExhibitInfo.modal('hide');
                        $modalExhibitInfo.removeClass('show');
                        $('body').removeClass('modal-open');
                        $('.modal-backdrop').remove();
                        $expandExhibitText.removeClass('d-block').addClass('d-none');
                        $header.addClass('hiddenHeader');
                        $modalExhibitInfo.modal('hide');
                        $expandExhibitText.tooltip('hide');
                    }, 225);

                    mobileImageModalActivator();
                }

                if ($exhibitStoryShare.hasClass('d-flex')) {
                    $exhInfoButton.removeClass('active');
                }
            }
        }
    });

    const bstepInput = document.querySelector('input[name="bstep-duration"]');
    const zoomInput = document.querySelector('input[name="zoom-in-duration"]');

    // Only initialize if elements exist (admin/curator features)
    if (bstepInput && zoomInput) {
        const getPlusButton = (fieldName) =>
            document.querySelector(`.b-zoom-step[data-type="plus"][data-field="${fieldName}"]`);

        const getMinusButton = (fieldName) =>
            document.querySelector(`.b-zoom-step[data-type="minus"][data-field="${fieldName}"]`);

        function updateZoomMax() {
            const bstepVal = parseInt(bstepInput.value, 10);
            const zoomVal = parseInt(zoomInput.value, 10);
            const zoomPlusBtn = getPlusButton("zoom-in-duration");
            const zoomMinusBtn = getMinusButton("zoom-in-duration");

            // Update max
            zoomInput.max = bstepVal;

            // Clamp zoom-in-duration value if above new max
            if (zoomVal > bstepVal) {
                zoomInput.value = bstepVal;
            }

            // Enable or disable plus button based on zoomVal < bstepVal
            if (zoomVal < bstepVal && zoomPlusBtn) {
                zoomPlusBtn.removeAttribute('disabled');
            } else if (zoomPlusBtn) {
                zoomPlusBtn.setAttribute('disabled', 'disabled');
            }

            // Enable or disable minus button if needed
            if (zoomVal > parseInt(zoomInput.min, 10) && zoomMinusBtn) {
                zoomMinusBtn.removeAttribute('disabled');
            } else if (zoomMinusBtn) {
                zoomMinusBtn.setAttribute('disabled', 'disabled');
            }
        }

        // Update on manual input
        bstepInput.addEventListener('input', updateZoomMax);
        zoomInput.addEventListener('input', updateZoomMax);

        // Handle button clicks
        document.querySelectorAll('.b-zoom-step').forEach(btn => {
            btn.addEventListener('click', function () {
            const fieldName = this.getAttribute('data-field');
            const type = this.getAttribute('data-type');
            const input = document.querySelector(`input[name="${fieldName}"]`);
            const currentVal = parseInt(input.value, 10);
            const min = parseInt(input.getAttribute('min'), 10);
            const max = parseInt(input.getAttribute('max'), 10);
            const plusBtn = getPlusButton(fieldName);
            const minusBtn = getMinusButton(fieldName);

            if (!isNaN(currentVal)) {
                let newVal;
                if (type === 'minus' && currentVal > min) {
                    newVal = currentVal;
                } else if (type === 'plus' && currentVal < max) {
                    newVal = currentVal;
                }

                if (newVal !== undefined) {
                    input.value = newVal;
                    input.dispatchEvent(new Event('input'));

                    // Enable/disable buttons based on new value
                    if (newVal <= min) {
                        minusBtn.setAttribute('disabled', 'disabled');
                    } else {
                        minusBtn.removeAttribute('disabled');
                    }

                    if (newVal >= max) {
                        plusBtn.setAttribute('disabled', 'disabled');
                    } else {
                        plusBtn.removeAttribute('disabled');
                    }
                }
            }
        });
    });
    }
});

$('.shootPrompt').on('click', function (e) {
    e.stopPropagation();
    e.preventDefault();

    let modelPromptType = $(this).data('input-type');
    let selectedOption = $('input[name="option-' + modelPromptType + '"]:checked').val();
    let prompt = '';

    if (selectedOption === 'option1-' + modelPromptType) {
        prompt = $('#input1-' + modelPromptType).val();
    } else if (selectedOption === 'option2-' + modelPromptType) {
        prompt = $('#input2-' + modelPromptType).val();
    } else if (selectedOption === 'option3-' + modelPromptType) {
        prompt = $('#input3-' + modelPromptType).val();
    }

    // const payload = {
    //     model: "sonar-pro",
    //     messages: [
    //         { role: "system", content: "You are a helpful AI assistant that provides precise and concise information.\n" +
    //                 "Rules:\n" +
    //                 "1. If there is a word count limit in the user prompt, make sure your response is within the limit"},
    //         { role: "user", content: prompt }
    //     ],
    //     max_tokens: 500,
    //     temperature: 0,
    //     top_p: 0.9,
    //     search_domain_filter: null,
    //     return_images: false,
    //     return_related_questions: false,
    //     search_recency_filter: "",
    //     top_k: 0,
    //     stream: false,
    //     presence_penalty: 0,
    //     frequency_penalty: 1,
    //     response_format: null
    // };
    //
    // const options =  {
    //     method: 'POST',
    //     headers: {
    //         Authorization: 'Bearer token',
    //         'Content-Type': 'application/json'
    //     },
    //     body: JSON.stringify(payload)
    // };

    navigator.clipboard.writeText(prompt);

    if (modelPromptType == 'exhibit') {
        let existingDesc = window.editor_exh.getData();
        let newDesc = 'Perplexity | <br> <br>' + existingDesc;

        if (existingDesc.indexOf("<p>Perplexity") !== 0) {
            window.editor_exh.setData(newDesc);
        }
    } else if (modelPromptType == 'image') {
        let existingDesc = window.editor_img_desc.getData();
        let newDesc = 'Perplexity | <br> <br>' + existingDesc;
        if (existingDesc.indexOf("<p>Perplexity") !== 0) {
            window.editor_img_desc.setData(newDesc);
        }

    } else if (modelPromptType == 'dot') {
        let existingDesc = window.editor_dot.getData();
        let newDesc = 'Perplexity | <br> <br>' + existingDesc;
        if (existingDesc.indexOf("<p>Perplexity") !== 0) {
            window.editor_dot.setData(newDesc);
        }
    } else if (modelPromptType.indexOf('dotCreate') === 0) {
        let ck_id = $('.dots-card.active').find('.save-comment').attr('data-identifier');
        let ck_instance = 'editor_crt_dot_' + ck_id;

        let existingDesc = editors[ck_instance].getData();
        let newDesc = 'Perplexity | <br> <br>' + existingDesc;
        if (existingDesc.indexOf("<p>Perplexity") !== 0) {
            editors[ck_instance].setData(newDesc);
        }
    }

    // sendAiPrompt(options, modelPromptType);

    $('#input1-dot').val('write a 200-word history of ');
    $('#input2-dot').val('');
    $('#input3-dot').val('write a 200-word biography of ');
    $('#input1-image').val('write a 200-word history of ');
    $('#input2-image').val('');
    $('#input3-image').val('write a 200-word biography of ');
    $('#input1-exhibit').val('write a 200-word history of ');
    $('#input2-exhibit').val('');
    $('#input3-exhibit').val('write a 200-word biography of ');

    $('#option1-dot').prop('checked', true);
    $('#option2-dot').prop('checked', false);
    $('#option3-dot').prop('checked', false);
    $('#option1-image').prop('checked', true);
    $('#option2-image').prop('checked', false);
    $('#option3-image').prop('checked', false);
    $('#option1-exhibit').prop('checked', true);
    $('#option2-exhibit').prop('checked', false);
    $('#option3-exhibit').prop('checked', false);

    const totalEditors = Object.keys(editors).length;

    for (let index = 0; index < totalEditors; index++) {
        $('#input1-dotCreate' + index).val('write a 200-word history for ');
        $('#input2-dotCreate' + index).val('');
        $('#input3-dotCreate' + index).val('write a 200-word history for ');

        $('#option1-dotCreate' + index).prop('checked', true);
        $('#option2-dotCreate' + index).prop('checked', false);
        $('#option3-dotCreate' + index).prop('checked', false);
    }

    $('#dropdownMenuButton-' + modelPromptType).dropdown('toggle');
    window.open('https://www.perplexity.ai/', '_blank');
});

// function sendAiPrompt (options, modelPromptType) {
//     $('.ai-spin').removeClass('d-none');
//     fetch('https://api.perplexity.ai/chat/completions', options)
//         .then(response => response.json())
//         .then(data => {
//             const citations = data.citations;
//             let citationLinksHTML = '<ul>';
//             citations.forEach((url, index) => {
//                 citationLinksHTML += `<li><a href="${url}" target="_blank" rel="noopener noreferrer">[${index + 1}] ${url}</a></li>`;
//             });
//             citationLinksHTML += '</ul>';
//
//             if(modelPromptType == 'exhibit') {
//                 let existingDesc = editor_exh.getData();
//                 let newDesc = existingDesc + '<br> Perplexity AI <br> <br>' + data.choices[0].message.content
//
//                 newDesc = newDesc + ' ' + citationLinksHTML;
//
//                 editor_exh.setData(newDesc);
//             } else if (modelPromptType == 'image') {
//                 let existingDesc = editor_img_desc.getData();
//                 let newDesc = existingDesc + '<br> Perplexity AI <br> <br>' + data.choices[0].message.content
//
//                 newDesc = newDesc + ' ' + citationLinksHTML;
//
//                 editor_img_desc.setData(newDesc);
//             }
//
//             $('.ai-spin').addClass('d-none');
//         })
//         .catch(err => console.error("Error sending prompt to Perplexity AI:", err));
// }

$(document).ready(function () {

    $('.ai-dropdown').on('click', function (event) {
        event.stopPropagation();
    });

    Echo.channel('dot-action-' + exhibit_id)
        .listen('DotAction', function (event) {
            let _alert = '';

            //create dot pusher
            if (event.action == 'create') {
                let lastNumber = $(".dots-card[data-image-id='" + event.imageId + "'] .comments .dot-short").length;
                let dotNumber = 1;
                if (lastNumber) {
                    dotNumber = parseInt(lastNumber) + 1;
                }

                let _htmlnew = '<div class="dot-short" data-id="' + event.content.dot_id + '">\
                                <div class="dot-meta" data-dot-id="' + event.content.dot_id + '">\
                                <div class="dot-avatar" style="background: url(' + event.content.avatar + ')">\
                                <div class="dot-number">' + (dotNumber) + '</div>\
                        </div>\
                            <div class="dot-created-info">\
                                <div class="dot-author">' + event.content.author.name + '</div>\
                                <div class="dot-author-username">(@' + event.content.author.username + ')</div>\
                                <div class="dot-created">' + event.content.created_at + '</div>\
                            </div>\
                            <div class="coord-x">' + event.content.coordx + '</div>\
                            <div class="coord-y">' + event.content.coordy + '</div>\
                        </div>\
                            <blockquote class="blockquote mt-2" class="dot">\
                                <small class="mb-0">' + event.content.dot_content + '</small>\
                            </blockquote>\
                        </div>';
                // keep the client-side image data cache in sync so renderDotPointers()
                // (called by showPins) rebuilds the new pin from the cache. syncing the
                // cache (not the transient DOM) is what makes the pin survive a
                // hide->show toggle of the dots panel.
                let _cache = window.imageDataCache[event.imageId];
                if (_cache && Array.isArray(_cache.dots)) {
                    _cache.dots.push({
                        id: event.content.dot_id,
                        coord_x: event.content.coordx,
                        coord_y: event.content.coordy,
                        content: event.content.dot_content,
                        total_voices: 0,
                        order: _cache.dots.length + 1,
                        user: {
                            name: event.content.author.name,
                            username: event.content.author.username,
                            image: event.content.avatar,
                            is_user_role: !!event.content.is_user_role,
                        },
                    });
                    if (typeof _cache.dots_count === 'number') {
                        _cache.dots_count += 1;
                    }
                }
                $(".dots-card[data-image-id='" + event.imageId + "'] .comments").append(_htmlnew);
                $(".dots-card[data-image-id='" + event.imageId + "'] .comment-count").text($('.dots-card[data-image-id="' + event.imageId + '"] .dot-short').length);
                $(".dots-card[data-image-id='" + event.imageId + "'] .no-comments").hide();

                if ($modalDotFull.is(':visible')) {
                    let dot_max = parseInt($dotAll.html());
                    let dot_current = parseInt($dotFrom.html());
                    $dotAll.html(dot_max + 1);
                    if (dot_current == dot_max) {
                        $('.dot-pag .next').removeAttr('disabled');
                    }
                }

                if ($('.dots-card[data-image-id=' + event.imageId + ']').hasClass('active') && ($showDotsButton.hasClass('active') || $dotsWrapper.hasClass('active'))) {
                    // not hidePins(): it would close an open dot modal
                    refreshPins();
                    _alert = '<div class="short-alert alert alert-success show-alert my-1"><i class="fa fa-map-pin mr-1" aria-hidden="true"></i> New dot created by <strong>' + event.content.author.name + '</strong> on this image<i class="ml-1 fa fa-times" style="opacity: .5" aria-hidden="true"></i></div>';
                } else if ($('.dots-card[data-image-id=' + event.imageId + ']').hasClass('active')) {
                    _alert = '<div class="short-alert alert alert-success show-alert my-1"><i class="fa fa-map-pin mr-1" aria-hidden="true"></i> New dot created by <strong>' + event.content.author.name + '</strong> on this image<i class="ml-1 fa fa-times" style="opacity: .5" aria-hidden="true"></i></div>';
                } else {
                    _alert = '<div class="short-alert alert alert-success show-alert my-1"><i class="fa fa-map-pin mr-1" aria-hidden="true"></i>New dot created by <strong>' + event.content.author.name + '</strong> on image #' + event.content.img_order.image_order + '<i class="ml-1 fa fa-times" style="opacity: .5" aria-hidden="true"></i></div>';
                }

                showShortAlert(_alert);

                loadIframe('.dot-short[data-id="' + event.content.dot_id + '"] .blockquote small');
            } else if (event.action == 'delete') {
                //delete dot pusher
                // keep the cache in sync (regardless of panel state) so a later
                // showPins()/panel toggle renumbers from correct data
                let _delCache = window.imageDataCache[event.imageId];
                if (_delCache && Array.isArray(_delCache.dots)) {
                    _delCache.dots = _delCache.dots.filter(d => d.id != event.content.dot_id);
                    if (typeof _delCache.dots_count === 'number') {
                        _delCache.dots_count = Math.max(0, _delCache.dots_count - 1);
                    }
                }
                $('.dot-short[data-id="' + event.content.dot_id + '"]').remove();
                $('.dot-pointer[data-id="' + event.content.dot_id + '"]').remove();
                if ($('.dots-card[data-image-id=' + event.imageId + ']').hasClass('active') && ($showDotsButton.hasClass('active') || $dotsWrapper.hasClass('active'))) {
                    // only close the dot modal if it was showing the deleted dot
                    if (String($modalDotFull.find('.dotShare').attr('data-dotid')) === String(event.content.dot_id)) {
                        $modalDotFull.modal('hide');
                    }
                    refreshPins();
                    // renumber the sidebar rows (showPins already renumbers the pins from
                    // the synced cache; don't touch pin .dot-number - it holds the
                    // .dot-sort-number + voice-badge spans)
                    $dotsWrapper.find('div.dots-card.active').find('.card-body').find('.comments').find('.dot-short').find('.dot-meta').find('.dot-avatar').find('.dot-number').each(function (i) {
                        $(this).html(i + 1);
                    });

                    // update total dots number
                    let dot_count = parseInt($('div.dots-card.mt-4.active').find('.comment-count').html());
                    $('div.dots-card.mt-4.active').find('.comment-count').html(dot_count - 1);

                    // if dot modal is open update total dots number and next/prev buttons
                    if ($modalDotFull.is(':visible')) {
                        let dot_max = parseInt($dotAll.html());
                        let dot_current = parseInt($dotFrom.html());

                        $dotAll.html(dot_max - 1);

                        if (dot_current + 1 == dot_max) {
                            $('.dot-pag .next').attr('disabled', 'disabled');
                        } else if (dot_current - 1 == 1) {
                            $dotFrom.html(1);
                            $('.dot-pag .prev').attr('disabled', 'disabled');
                        }
                    }


                    //close dot modal if the dot is deleted
                    if ($modalDotFull.is(':visible') && ($modalDotFull.find('.dotShare').attr('data-dotid') == event.content.dot_id)) {
                        $modalDotFull.modal('hide');

                        $('.short-alert').addClass('alert alert-danger show-alert').css({'left': '50%'}).html('<i class="fa fa-times" aria-hidden="true"></i> ');

                        _alert = '<div class="short-alert alert alert-danger show-alert my-1"><i class="fa fa-map-pin mr-1" aria-hidden="true"></i>Dot was deleted by the author <i class="ml-1 fa fa-times" style="opacity: .5" aria-hidden="true"></i></div>';
                        showShortAlert(_alert);

                    }
                }
            } else if (event.action == 'edit') {
                //edit dot pusher
                if ($modalDotFull.is(':visible') && ($modalDotFull.find('.dotShare').attr('data-dotid') == event.content.dot_id)) {
                    $modalDotFull.find('.modal-body').html('').append('<img style="position: absolute;left: 45%;top: 40%;z-index: 100000;height: 54px;width: 54px;" src="../../images/local/loading.gif" alt="loading"/>');

                    setTimeout(function () {
                        $modalDotFull.find('.modal-body').html(event.content.new_content);
                        loadIframe('.dot-full .modal-body');
                    }, 500)


                    _alert = '<div class="short-alert alert alert-warning show-alert my-1"><i class="fa fa-map-pin mr-1" aria-hidden="true"></i>Dot #' + event.content.dot_id + ' was edited by the author <i class="ml-1 fa fa-times" style="opacity: .5" aria-hidden="true"></i></div>';
                    showShortAlert(_alert);
                }

                // keep cached content in sync so a later re-render shows the edit
                let _editCache = window.imageDataCache[event.imageId];
                if (_editCache && Array.isArray(_editCache.dots)) {
                    let _editDot = _editCache.dots.find(d => d.id == event.content.dot_id);
                    if (_editDot) _editDot.content = event.content.new_content;
                }

                $('.dot-short[data-id="' + event.content.dot_id + '"] .blockquote small').html(event.content.new_content);
                loadIframe('.dot-short[data-id="' + event.content.dot_id + '"] .blockquote small');
            }
        });


    let voiceNoteChannel = pusher.subscribe('voice-note-action-' + exhibit_id);

    voiceNoteChannel.bind('voice-note-action-event', function (data) {
        if (data.type == 'exhibit') {
            $('.exhibit-voice-visibility[data-voice-exhibit-id="' + data.exhibit_id + '"] .badge').html(data.extra_data['voice_count'])
            if ($exhibitVoiceVisibility.hasClass('active')) {
                voiceNotes.fetchExhibitVoiceNotes(data.exhibit_id)
            }
        } else if (data.type == 'image') {
            $('.image-voice-visibility[data-voice-image-id="' + data.extra_data['model_id'] + '"] .badge').html(data.extra_data['voice_count'])
            if ($('.image-voice-visibility').hasClass('active')) {
                voiceNotes.fetchImageVoiceNotes(data.extra_data['model_id'])
            }
        } else if (data.type == 'dot') {
            // the pin's speaker badge tracks the count for every viewer, whether or not
            // this dot's sidebar row is currently rendered - so it sits outside the guard
            voiceNotes.syncDotVoiceBadge(data.extra_data['model_id'], data.extra_data['voice_count'])
            if ($('.dot-voice-visibility[data-dot-id="' + data.extra_data['model_id'] + '"] span').length) {
                $('.dot-voice-visibility[data-dot-id="' + data.extra_data['model_id'] + '"] .badge').html(data.extra_data['voice_count'])
                if ($dotVoiceVisibility.hasClass('active')) {
                    voiceNotes.fetchDotVoiceNotes(data.extra_data['model_id'])
                }
            }
        }
    })

    if (typeof logged_user != "undefined") {
        let channelDzi = pusher.subscribe('private-upload-image-' + logged_user.id);
        channelDzi.bind('upload-image-event', function (data) {
            let modal_mode = 'new-dot-progress-bar';
            if ($modalCrtexh.hasClass('show')) {
                modal_mode = 'exh-progress-bar';
            } else if ($imageEdit.hasClass('show')) {
                modal_mode = 'img-progress-bar';
            } else if ($modalDotEdit.hasClass('show')) {
                modal_mode = 'dot-progress-bar';
            }
            if (data.source === 'zoomable' && data.status === 'Saving the image data on the Database...' && $('.img-upload-msg').length > 0) {
                $('.progressBar').removeClass('d-none');

                var bar = new ProgressBar.Line('#' + modal_mode, {
                    strokeWidth: 4,
                    easing: 'easeInOut',
                    duration: 1400,
                    color: '#25A600FF',
                    trailColor: '#eee',
                    trailWidth: 1,
                    svgStyle: {width: '100%', height: '100%'},
                    text: {
                        style: {
                            // Text color.
                            // Default: same as stroke color (options.color)
                            color: '#999',
                            position: 'absolute',
                            left: '0',
                            top: '30px',
                            padding: 0,
                            margin: 0,
                            transform: null
                        },
                        autoStyleContainer: false
                    },
                    from: {color: '#FFEA82'},
                    to: {color: '#ED6A5A'},
                    step: (state, bar) => {
                        bar.setText(Math.round(bar.value() * 99.5) + ' %');
                    }
                });

                bar.animate(0.995 / data.current_step);  // Number from 0.0 to 1.0
            }

            if (data.status === 'Image created successfully') {
                $('.progressBar').addClass('d-none');
                $('#' + modal_mode).empty();
            }
        })
    }

    // helper function to extract thumbnail URL from a zoomable element
    function extractThumbnailUrl($zoomableElement) {
        // method 1: from img src (ZoomablePlugin)
        const $img = $zoomableElement.find('img');
        if ($img.length && $img.attr('src')) {
            return $img.attr('src');
        }

        // method 2: from data-mention (Mention plugin)
        // data-mention is only an image id, so we cannot build an IIIF URL here.
        // Skip rather than emit a dead /images/thumbs/ path (the rendered <img> in
        // method 1 already carries the correct IIIF thumbnail_link when available).

        // method 3: from background-image style
        const bgImage = $zoomableElement.css('background-image');
        if (bgImage && bgImage !== 'none') {
            const url = bgImage.match(/url\(['"]?([^'"]+)['"]?\)/);
            return url ? url[1] : null;
        }

        return null;
    }

    // helper function to extract image title from a zoomable element
    function extractZoomableTitle($zoomableElement) {
        // from data-image-title attribute
        if ($zoomableElement.attr('data-image-title')) {
            return $zoomableElement.attr('data-image-title');
        }

        // from img alt attribute
        const $img = $zoomableElement.find('img');
        if ($img.length && $img.attr('alt')) {
            return $img.attr('alt');
        }

        // from data-image-id as fallback
        const imageId = $zoomableElement.attr('data-image-id');
        return imageId ? `Image #${imageId}` : 'Untitled';
    }

    // function to build the zoomable thumbnail grid
    function buildZoomableThumbnailGrid() {
        const $container = $('.zoomable-thumbs-content');

        // clear existing thumbnails (keep grid-sizer)
        $container.find('.zoomable-thumb-item').remove();

        // build thumbnails from currentZoomableImages array
        currentZoomableImages.forEach((element, index) => {
            const $element = $(element);
            const thumbnailUrl = extractThumbnailUrl($element);
            const title = extractZoomableTitle($element);

            if (thumbnailUrl) {
                const $thumbItem = $(`
                    <div class="zoomable-thumb-item" data-zoomable-index="${index}">
                        <img loading="lazy" src="${thumbnailUrl}" alt="${title}"/>
                        <div class="thumb-title">${title}</div>
                    </div>
                `);

                // highlight current image
                if (index === currentZoomableIndex) {
                    $thumbItem.addClass('border-danger');
                }

                $container.append($thumbItem);
            }
        });

        // initialize masonry using native API
        if (typeof Masonry !== 'undefined') {
            let masonryInstance = $container.data('masonry-instance');

            if (!masonryInstance) {
                // create new instance
                masonryInstance = new Masonry($container[0], {
                    fitWidth: true,
                    itemSelector: '.zoomable-thumb-item',
                    columnWidth: '.grid-sizer',
                    percentPosition: true,
                    gutter: 10
                });
                $container.data('masonry-instance', masonryInstance);
            } else {
                // reinitialize existing instance
                masonryInstance.reloadItems();
                masonryInstance.layout();
            }
        }
    }

    // function to load a zoomable image at a specific index
    function loadZoomableImage(index) {
        if (index < 0 || index >= currentZoomableImages.length) {
            return;
        }

        // increment request ID and capture it for this request
        currentZoomableRequestId++;
        const thisRequestId = currentZoomableRequestId;

        // loading state and disable navigation buttons
        isLoadingZoomable = true;
        $('#zoomable-prev-btn').prop('disabled', true);
        $('#zoomable-next-btn').prop('disabled', true);

        const $clickedImage = $(currentZoomableImages[index]);
        let href = '';

        // build url
        if ($clickedImage.attr('data-attr')) {
            const dataAttr = $clickedImage.attr('data-attr');
            if (dataAttr.includes('/exhibits/')) {
                href = dataAttr;
            } else if ($clickedImage.attr('data-image-id')) {
                let imageId = $clickedImage.attr('data-image-id');
                href = '/exhibits/' + exhibit_id + '/images/' + imageId + '/dzipreview';
            }
        } else if ($clickedImage.attr('data-image-id')) {
            let imageId = $clickedImage.attr('data-image-id');
            href = '/exhibits/' + exhibit_id + '/images/' + imageId + '/dzipreview';
        }

        if (!href) {
            isLoadingZoomable = false;
            return;
        }

        $.ajax({
            url: href,
            success: function (result) {
                // if this is still the most recent request retrun
                if (thisRequestId !== currentZoomableRequestId) {
                    return;
                }

                isLoadingZoomable = false;
                const $html = $('<div>').html(result);
                const headerContent = $html.find('#zoomable-header-data').html();
                const bodyContent = $html.find('#zoomable-osd');

                $('#zoomable-modal .modal-header').html(headerContent);

                const $prevBtn = $('#zoomable-prev-btn').detach();
                const $nextBtn = $('#zoomable-next-btn').detach();
                const $thumbsBtn = $('.zoomable-thumbs-button').detach();

                $('#zoomableBody').html(bodyContent);
                $('#zoomableBody').prepend($prevBtn);
                $('#zoomableBody').prepend($nextBtn);
                $('#zoomableBody').prepend($thumbsBtn);

                if (currentZoomableViewer) {
                    currentZoomableViewer.destroy();
                    currentZoomableViewer = null;
                }

                const dziSource = $('#openseadragon_zoomable').attr('data-dzi');

                const startZoomableViewer = function () {
                    currentZoomableViewer = OpenSeadragon({
                        id: "openseadragon_zoomable",
                        prefixUrl: "https://cdn.jsdelivr.net/npm/openseadragon@5.0.1/build/openseadragon/images/",
                        tileSources: dziSource,
                        maxZoomLevel: 40.0,
                    });

                    // ensure image opens at home zoom level
                    currentZoomableViewer.addHandler('open', function () {
                        currentZoomableViewer.viewport.goHome(true);
                    });

                    // stay at home while the container is still settling, until the user takes over
                    let zoomableUserInteracted = false;
                    ['canvas-drag', 'canvas-scroll', 'canvas-pinch', 'canvas-click', 'canvas-double-click'].forEach(function (evt) {
                        currentZoomableViewer.addOnceHandler(evt, function () {
                            zoomableUserInteracted = true;
                        });
                    });
                    currentZoomableViewer.addHandler('after-resize', function () {
                        if (zoomableUserInteracted) {
                            return;
                        }
                        // OSD re-applies its own zoom right after this event, so re-home a frame later
                        const viewerAtResize = currentZoomableViewer;
                        requestAnimationFrame(function () {
                            if (currentZoomableViewer && currentZoomableViewer === viewerAtResize) {
                                currentZoomableViewer.viewport.goHome(true);
                            }
                        });
                    });

                    // add swipe handlers for mobile devices
                    addZoomableSwipeHandlers();
                };

                // update navigation button states
                updateZoomableNavButtons();

                // OSD measures its container when built, so wait until the modal is on screen
                $zoomableModal.off('shown.bs.modal.zoomable');
                if (dziSource) {
                    if ($zoomableModal.hasClass('show')) {
                        startZoomableViewer();
                    } else {
                        $zoomableModal.one('shown.bs.modal.zoomable', startZoomableViewer);
                    }
                }

                $zoomableModal.modal("show");

                // update thumbnail grid highlighting if active
                if ($('.zoomable-thumbs-wrapper').hasClass('active')) {
                    $('.zoomable-thumb-item').removeClass('border-danger');
                    $(`.zoomable-thumb-item[data-zoomable-index="${currentZoomableIndex}"]`).addClass('border-danger');
                }
            },
            error: function (jqXHR, testStatus, error) {
                if (thisRequestId !== currentZoomableRequestId) {
                    return;
                }

                isLoadingZoomable = false;
                updateZoomableNavButtons();
                alert("Page " + href + " cannot open. Error:" + error);
            },
            timeout: 8000
        });
    }

    // function to update navigation button visibility and state
    function updateZoomableNavButtons() {

        const $prevBtn = $('#zoomable-prev-btn');
        const $nextBtn = $('#zoomable-next-btn');
        const $thumbsBtn = $('.zoomable-thumbs-button');

        if (currentZoomableImages.length > 1) {
            $prevBtn.show();
            $nextBtn.show();
            $thumbsBtn.show();

            // disable/enable buttons for current index
            if (currentZoomableIndex === 0) {
                $prevBtn.prop('disabled', true);
            } else {
                $prevBtn.prop('disabled', false);
            }

            if (currentZoomableIndex === currentZoomableImages.length - 1) {
                $nextBtn.prop('disabled', true);
            } else {
                $nextBtn.prop('disabled', false);
            }
        } else {
            $prevBtn.hide();
            $nextBtn.hide();
            $thumbsBtn.hide();
        }
    }

    // swipe function for zoomable image
    function addZoomableSwipeHandlers() {
        if (!currentZoomableViewer) {
            return;
        }

        if (($windowWidth < 600 || ((navigator.userAgent.includes("Mac") || navigator.userAgent.includes("Android")) && "ontouchend" in document))) {
            let startX = [];
            let startY = [];
            let endX, endY;

            currentZoomableViewer.addHandler("canvas-drag", function (event) {
                if (currentZoomableViewer.viewport.getZoom() <= 1) {
                    startX.push(event.position.x);
                    startY.push(event.position.y);
                } else {
                    startX = null;
                }
            });

            currentZoomableViewer.addHandler("canvas-drag-end", function (event) {
                if (startX != null) {
                    endX = event.position.x;
                    endY = event.position.y;

                    let xDiff = startX[0] - endX;
                    let yDiff = startY[0] - endY;

                    if (Math.abs(xDiff) > Math.abs(yDiff)) {
                        if (xDiff > 10) {
                            // swipe right - next image
                            if (!isLoadingZoomable && currentZoomableIndex < currentZoomableImages.length - 1) {
                                currentZoomableIndex++;
                                loadZoomableImage(currentZoomableIndex);
                            }
                        } else if (xDiff < -10) {
                            // swipe left - previous image
                            if (!isLoadingZoomable && currentZoomableIndex > 0) {
                                currentZoomableIndex--;
                                loadZoomableImage(currentZoomableIndex);
                            }
                        }
                    }

                    startX = [];
                    startY = [];
                    endX = null;
                    endY = null;
                } else {
                    startX = [];
                    startY = [];
                    endX = null;
                    endY = null;
                }
            });
        }
    }

    $(document).on('click', '.zoomable-image', function (event) {
        event.preventDefault();
        event.stopPropagation();

        if (!$('.edit-crtexh').hasClass('show') && !$imageEdit.hasClass('show') && !$('.edit-dotedit').hasClass('show')) {
            // find the parent .ck-content container
            const $ckContent = $(this).closest('.ck-content');

            // collect all zoomable images within the same description container
            if ($ckContent.length > 0) {
                currentZoomableImages = $ckContent.find('.zoomable-image').toArray();
                currentZoomableIndex = currentZoomableImages.indexOf(this);
            } else {
                currentZoomableImages = [this];
                currentZoomableIndex = 0;
            }

            loadZoomableImage(currentZoomableIndex);
        }
    });

    // navigation button click handlers
    $(document).on('click', '#zoomable-prev-btn', function () {
        if (isLoadingZoomable) {
            return;
        }
        if (currentZoomableIndex > 0) {
            currentZoomableIndex--;
            loadZoomableImage(currentZoomableIndex);
        }
    });

    $(document).on('click', '#zoomable-next-btn', function () {
        if (isLoadingZoomable) {
            return;
        }
        if (currentZoomableIndex < currentZoomableImages.length - 1) {
            currentZoomableIndex++;
            loadZoomableImage(currentZoomableIndex);
        }
    });

    // thumbnail grid button click handler

    $(document).on('click', '.zoomable-thumbs-button', function () {
        console.log('Zoomable thumbs button clicked');
        console.log('Current zoomable images count:', currentZoomableImages.length);

        const $wrapper = $('.zoomable-thumbs-wrapper');
        console.log('Wrapper found:', $wrapper.length);

        // only show if there are multiple images
        if (currentZoomableImages.length > 1) {
            console.log('Building thumbnail grid...');
            // build/update the grid
            buildZoomableThumbnailGrid();

            // toggle visibility
            $wrapper.toggleClass('active');
            console.log('Wrapper active class toggled, has active:', $wrapper.hasClass('active'));

            // scroll to current image's row (similar to exhibit grid logic)
            const $target = $(`.zoomable-thumb-item[data-zoomable-index="${currentZoomableIndex}"]`);
            if ($target.length) {
                const itemsPerRow = Math.floor($wrapper.width() / 220); // approximate
                const targetIndex = currentZoomableIndex;
                const targetRow = Math.floor(targetIndex / itemsPerRow);
                const rowStartIndex = targetRow * itemsPerRow;
                const $rowFirstItem = $wrapper.find('.zoomable-thumb-item').eq(rowStartIndex);
                if ($rowFirstItem.length) {
                    const rowOffsetTop = $rowFirstItem.position().top;
                    const headerHeight = 32;
                    const scrollPosition = rowOffsetTop - headerHeight;
                    if (scrollPosition > 0) {
                        $wrapper.animate({scrollTop: scrollPosition}, 0);
                    }
                }
            }
        } else {
            console.log('Not enough images to show grid (need > 1)');
        }
    });

    // thumbnail click handler
    $(document).on('click', '.zoomable-thumb-item', function (e) {
        e.stopPropagation();
        const index = parseInt($(this).attr('data-zoomable-index'));
        currentZoomableIndex = index;
        loadZoomableImage(currentZoomableIndex);
        $('.zoomable-thumbs-wrapper').removeClass('active');
    });

    // close grid handler
    $(document).on('click', '.zoomable-thumbs-wrapper', function (e) {
        if (!$(e.target).closest('.zoomable-thumb-item').length) {
            $(this).removeClass('active');
        }
    });

    // nodal cleanup on hide
    $zoomableModal.on('hidden.bs.modal', function () {
        $zoomableModal.off('shown.bs.modal.zoomable');
        if (currentZoomableViewer) {
            currentZoomableViewer.destroy();
            currentZoomableViewer = null;
        }
        currentZoomableImages = [];
        currentZoomableIndex = 0;
        isLoadingZoomable = false;
        currentZoomableRequestId = 0;
        // close thumbnail grid if open
        $('.zoomable-thumbs-wrapper').removeClass('active');
    });

    // Auto hide the eye icon in sidebar after 2 seconds of inactivity
    let buttons = $exhHideButtons;
    let timer;

    function hideButtons() {
        if (!buttons.find('i').hasClass('fa-eye-slash') && $exhSideButton.attr('style')) {
            buttons.css('opacity', 0);
            buttons.css('pointer-events', 'none');
        }
    }

    function resetTimer() {
        if (!buttons.find('i').hasClass('fa-eye-slash') && $exhSideButton.attr('style')) {
            clearTimeout(timer);
            timer = setTimeout(hideButtons, 2000);
            buttons.css('opacity', 1);
            buttons.removeAttr('style');
        }
    }

    $(document).on('mousemove click', resetTimer);


    if (navigator.userAgent.includes("Mac") && "ontouchend" in document) {
        jQuery('.image-info.bottom-image-name').addClass('ipaded');
    }

    window.EXIT_FULL_SCREEN_CODE_STATUS = $('.exhibit-info-wrapper').attr('data-exit-code');

    if (window.innerWidth < 768) {
        $('#exhibit-sidebar-left .content-wrapper').remove();
    } else {
        $('.image-info-mobile').remove();
    }

    $(function () {
        $('[data-toggle="tooltip"]').tooltip()
    })

    //create ckeditor for dot create for current open image (page)
    create_ck_for_create_dot(curPage())

    //open dots when opened from activity page or share link

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const dot = urlParams.get('dot')


    // opened from the search page: highlight the searched words once — in the dot, the
    // image, or the exhibit, depending on which result was clicked — and drop q from the
    // URL so share links built from location don't carry it
    const searchTerm = urlParams.get('q');
    if (searchTerm) {
        const cleanUrl = new URL(window.location.href);
        cleanUrl.searchParams.delete('q');
        history.replaceState(history.state, '', cleanUrl.toString());

        const searchPageId = parseInt(urlParams.get('page'));
        if (dot != null && dot !== 'false' && dot !== 'true') {
            dotSearchHighlight = {dotId: String(dot), term: searchTerm};
        } else if (!isNaN(searchPageId)) {
            loadImageData(searchPageId).then(() => {
                highlightSearchTerms(
                    $(`.image-info[data-image-id="${searchPageId}"]`).find('.image-title, .image-content').toArray(),
                    searchTerm
                );
            });
        } else {
            highlightSearchTerms(
                $('#modal-exhibitinfo .exh-description, .exhibit-info-wrapper .exh-title').toArray(),
                searchTerm
            );
        }
    }

    if (dot != null && dot !== 'false' && dot !== 'true') {
        if ($windowWidth < 600 && $('.image-info-wrapper').hasClass('active') && $exhInfoButton.hasClass('active')) {
            mobileImageModalDeactivator();
        }

        // wait for image data to be ready before opening the dot, so showPins() has time to initialise `anno`
        const _dotPageId = parseInt(urlParams.get('page'), 10);
        // the dot's image may have been removed from the exhibit since the link was shared;
        // opening it then would show an empty modal against an unrelated image
        const _dotImgPresent = isNaN(_dotPageId) || window.imageIds.indexOf(_dotPageId) > -1;
        const _waitForData = (!isNaN(_dotPageId) && _dotImgPresent) ? loadImageData(_dotPageId) : Promise.resolve();
        if (_dotImgPresent) {
            _waitForData.then(async () => {
                $showDotsButton.click();
                await showPins(curPage());
                openDot(dot);
                $('.image-info-wrapper').removeClass('active');
                $exhInfoButton.removeClass('active');
            });
        }
    }

    //end open dots

    // open image with dot-create mode active from share link (?dotcrt=true)
    const dotCreate = urlParams.get('dotcrt');
    if (dotCreate === 'true' && (dot == null || dot === 'false' || dot === 'true')) {
        const _dcPageId = parseInt(urlParams.get('page'), 10);
        // don't arm dot-create on a different image than the one that was shared
        const _dcImgPresent = isNaN(_dcPageId) || window.imageIds.indexOf(_dcPageId) > -1;
        const _dcWait = (!isNaN(_dcPageId) && _dcImgPresent) ? loadImageData(_dcPageId) : Promise.resolve();
        if (_dcImgPresent) _dcWait.then(async () => {
            $showDotsButton.click();
            await showPins(curPage());
            // hide existing pins so the guest only sees their own placement marker (mobile share mode only)
            if (window.dotShareMode) $('body').addClass('dot-share-hiding');
            if ($windowWidth < 600) {
                // mobile: this button sets .pin-button active, shows the guide + dims toolbar
                if (!$exhDotCreateMobile.hasClass('active')) $exhDotCreateMobile.click();
            } else {
                // desktop: activate the current card's pin button
                const $pin = $('.dots-card.active .pin-button');
                if ($pin.length && !$pin.hasClass('active')) $pin.click();
            }
        });
    }

    //open sidebar when opened from activity page
    const _descImageId = new URLSearchParams(window.location.search).get('page');
    const _descFlag    = new URLSearchParams(window.location.search).get('img-desc');
    if (_descImageId != null && _descFlag === 'true') {
        const _descId = parseInt(_descImageId);
        if (_descId) {
            // wait for image data so sidebar content + voice note button are in DOM before clicking
            // only open if not already open (e.g. exhibit has open_img_info flag set)
            loadImageData(_descId).then(() => {
                if (!$contentWrapper.hasClass('active')) $exhInfoButton.click();
            });
        } else {
            if (!$contentWrapper.hasClass('active')) $exhInfoButton.click();
        }
    }

    /**
     * It copies the share link to the clipboard by press button. (we use it for safari Clipboard API rules)
     */
    let el = document.getElementById('copyShortURL');

    if (el) {
        document.getElementById('copyShortURL').addEventListener('click', async event => {
            if (!navigator.clipboard) {
                return
            }
            const text = $generatedShortURL.val()
            if (text.length > 0) {
                try {
                    await navigator.clipboard.writeText(text)
                    $copyShortURL.tooltip('dispose')
                        .attr('title', 'Copied to clipboard 🎉')
                        .tooltip().tooltip('show');
                    setTimeout(() => {
                        $copyShortURL.tooltip('dispose')
                            .attr('title', 'Copy link')
                            .tooltip();
                    }, 1500);
                } catch (err) {
                    // // console.error('Failed to copy!', err)
                }
            }
        })
    }

    let copyIiif = document.getElementById('copyIiifURL');
    if (copyIiif) {
        copyIiif.addEventListener('click', async () => {
            if (!navigator.clipboard) return;
            const text = $iiifManifestURL.val();
            if (text.length > 0) {
                try {
                    await navigator.clipboard.writeText(text);
                    const $btn = $('#copyIiifURL');
                    $btn.tooltip('dispose')
                        .attr('title', 'Copied to clipboard 🎉')
                        .tooltip().tooltip('show');
                    setTimeout(() => {
                        $btn.tooltip('dispose')
                            .attr('title', 'Copy IIIF Manifest URL')
                            .tooltip();
                    }, 1500);
                } catch (err) {}
            }
        });
    }

    let copyEmbed = document.getElementById('copyEmbedCode');
    if (copyEmbed) {
        copyEmbed.addEventListener('click', async () => {
            if (!navigator.clipboard) return;
            const text = $embedCode.val();
            if (text.length > 0) {
                try {
                    await navigator.clipboard.writeText(text);
                    const $btn = $('#copyEmbedCode');
                    $btn.tooltip('dispose')
                        .attr('title', 'Copied to clipboard 🎉')
                        .tooltip().tooltip('show');
                    setTimeout(() => {
                        $btn.tooltip('dispose')
                            .attr('title', 'Copy embed code')
                            .tooltip();
                    }, 1500);
                } catch (err) {}
            }
        });
    }

    let mapCount = $('.content-wrapper .image-info').length;

    if ($('#share-id').data('dot') == true) {
        $showDotsButton.addClass('active');
        // showPins is deferred until image data loads — handled in open handler
    }



    /* The below  code is adding the current page number to the page number element and adding the active class to the
    current page. */
    if (typeof viewer != 'undefined') {
        // lazy-load tile sources: inject the real source just before OSD navigates to each page.
        // goToNextPage/goPreviousPage both call goToPage internally, so this covers all navigation.
        const _origGoToPage = viewer.goToPage.bind(viewer);
        viewer.goToPage = function(page) {
            const p = window.pages && window.pages[page];
            if (p && p.type === 'image') {
                viewer.tileSources[page] = window.buildIiifTileSource
                    ? window.buildIiifTileSource(p)
                    : p.tileSource;
            }
            return _origGoToPage(page);
        };

        // tracks last prefetched index so the page handler can infer navigation direction
        let _lastPrefetchIdx = curPage();

        $('.content-wrapper .page-number').attr('data-page', curPage() + 1);
        $('.content-wrapper .image-info').eq(curPage()).addClass('active');
        $('.exhibit-attribution-wrapper .image-info').eq(curPage()).addClass('active');
        $('.dots-wrapper .dots-card').eq(curPage()).addClass('active');

        // Show/hide Voice Note icon on Image and Dot text icon on sidebar
        let image_and_dots_voice_count = detectImageAndDotVoiceNotesCount()
        handleSidebarImageVoiceNoteIcon(image_and_dots_voice_count.image_voice_count)
        handleSidebarDotVoiceNoteIcon(image_and_dots_voice_count.image_dots_voice_count)

        /* This code is adding a handler to the viewer that will trigger when the zoom level of the viewer changes. */

        viewer.addHandler('canvas-pinch', function () {
            lastCanvasPinch = Date.now();
        });

        // the visitor moved the view themselves: the AI card stops auto-panning it
        ['canvas-drag', 'canvas-scroll', 'canvas-pinch', 'canvas-key'].forEach(name => viewer.addHandler(name, () => { aiRegionViewMoved = true; }));

        viewer.addHandler('zoom', function (event) {
            if (viewer.viewport.getZoom() / viewer.viewport.getHomeZoom() <= 1.1) {
                $exhibitAttributionWrapper.addClass('active');
            } else {
                $exhibitAttributionWrapper.removeClass('active');
            }
        })

        // Go home(zoom level) after maximum un-zoom using button
        viewer.addHandler('animation-finish', function (event) {
            const current_zoom = event.eventSource.viewport.zoomSpring.current.value
            const old_zoom = event.eventSource.viewport.zoomSpring.start.value
            if (!(current_zoom >= 1) && current_zoom < old_zoom && current_zoom !== event.eventSource.viewport.getHomeZoom()) {
                viewer.viewport.goHome();
            }
        })

        // changing the image (page) next/prev

        viewer.addHandler('page', function (event) {

            const index = event.page;
            const page = window.pages[index];
            $modalDotFull.modal('hide');
            // a region selection belongs to the image it was drawn on
            exitAiRegionMode();
            closeAiRegionCard();

            if (page.type === 'video') {
                // Hide viewer, show video
                viewer.container.style.display = 'none';
                document.getElementById('video-container').style.display = 'block';

                let url = page.videoUrl;
                if (!url.includes('enablejsapi')) {
                    url += url.includes('?') ? '&enablejsapi=1' : '?enablejsapi=1';
                }

                const vid = (typeof window.ccYtVideoId === 'function')
                    ? window.ccYtVideoId(url)
                    : (url.match(/embed\/([^?&]+)/) || [])[1];

                if (vid) {
                    if (typeof window.ccRequestVideo === 'function') {
                        // Consent-gated: cues the video, or shows a one-click prompt if media consent is absent.
                        window.ccRequestVideo(vid);
                    } else if (window.playerReady && window.player) {
                        window.player.stopVideo();
                        window.player.cueVideoById(vid);
                    } else {
                        console.warn('⏳ Player not ready, queuing video:', vid);
                        window.videoQueue = vid;
                    }
                }

                if (!exhibit_story_create_mode) {
                    $showDotsButton.removeClass('d-flex').addClass('d-none');
                    $dotsWrapper.removeClass('active');
                }

                if ($exhInfoButton.hasClass('active')) {
                    $videoContainer.addClass('vid-shrink')
                } else {
                    $videoContainer.removeClass('vid-shrink')
                }

                $mode.addClass('d-none');
                $('.exh-ss-button').removeClass('d-lg-flex');
                if ($showDotsButton.hasClass('active')) {
                    $exhDotCreateMobile.removeClass('d-sm-flex').addClass('d-none');
                } else {
                    $exhDotCreateMobile.removeClass('d-sm-flex');
                }
                $upperRightExhButtons.addClass('hidden');
            } else {
                // Show viewer, hide video
                document.getElementById('video-container').style.display = 'none';

                if (window.player && typeof window.player.stopVideo === 'function') {
                    window.player.stopVideo();
                }

                viewer.container.style.display = 'block';

                $showDotsButton.addClass('d-flex').removeClass('d-none');

                if ($showDotsButton.hasClass('active')) {
                    $mode.removeClass('d-none');
                    if ($windowWidth > 600) {
                        if (stepsArray.length == 0) {
                            $dotsWrapper.addClass('active');
                        }
                    }
                    $exhDotCreateMobile.addClass('d-sm-flex').removeClass('d-none');
                } else {
                    $exhDotCreateMobile.addClass('d-sm-flex');
                }


                $exhDotCreateMobile.addClass('d-sm-flex');
                $('.exh-ss-button').addClass('d-lg-flex');
                $upperRightExhButtons.removeClass('hidden');
            }

            stopIframeVid('.image-info.active .image-content');
            stopIframeVid('.dots-card.mt-4.active .blockquote');

            $('.image-voice-container').find('audio').each(function () {
                this.pause();
            });


            $('.content-wrapper .page-number').attr('data-page', curPage() + 1);
            $('.content-wrapper .image-info').removeClass('active');
            $('.content-wrapper .image-info').eq(curPage()).addClass('active');
            $('.exhibit-attribution-wrapper .image-info').removeClass('active');
            $('.exhibit-attribution-wrapper .image-info').eq(curPage()).addClass('active');
            $('.dots-wrapper .dots-card').removeClass('active');
            $('.dots-wrapper .dots-card').eq(curPage()).addClass('active');

            // change show anno image id
            $showDotsButton.attr('data-image-id', $('.image-info.active').data('image-id'));

            // async: load image data then do data-dependent operations
            const _pageIdx = curPage();
            const _imageId = window.imageIds && window.imageIds[_pageIdx];
            // synchronous, before OSD opens the new image: drop the old image's
            // annotations so they can't be redrawn at the new image's scale
            if (typeof anno !== 'undefined' && anno) anno.dropIfNot(_imageId);
            if (_imageId) {
                loadImageData(_imageId).then(() => {
                    create_ck_for_create_dot(_pageIdx);
                    if (($dotsWrapper.hasClass('active') || $showDotsButton.hasClass('active')) && $openseadragonViewer.attr('data-dots') === 'true') {
                        showPins(_pageIdx);
                    } else if (ocrHighlightsOn) {
                        // dots off: showPins() won't run, so the OCR boxes follow the page here
                        showOcrHighlights(_imageId, false);
                    }
                    const _counts = detectImageAndDotVoiceNotesCount();
                    handleSidebarImageVoiceNoteIcon(_counts.image_voice_count);
                    handleSidebarDotVoiceNoteIcon(_counts.image_dots_voice_count);
                    // maintain sidebar state when exhibit has open_img_info
                    if (window.image_text_open || $exhInfoButton.hasClass('active')) {
                        loadIframe('.image-content');

                        if ($windowWidth <= 600) {
                            const _cw = document.querySelector('.image-info-mobile .content-wrapper.active');
                            if (_cw) {
                                $('.image-info.active .image-info-wrapper').addClass('active');
                                if (_cw.style.height === 'var(--doc-height)') {
                                    mobileImageModalDeactivator();
                                } else {
                                    mobileImageModalActivator();
                                }
                            }
                        }
                    }
                });
                // prefetch next 2 images (image data)
                [_pageIdx + 1, _pageIdx + 2].forEach(i => {
                    if (window.imageIds[i]) loadImageData(window.imageIds[i]);
                });
                // background-prefetch tile sources in navigation direction
                const _tileDir = _pageIdx - _lastPrefetchIdx;
                _lastPrefetchIdx = _pageIdx;
                if (typeof requestIdleCallback !== 'undefined') {
                    requestIdleCallback(() => prefetchRemainingTileSources(_pageIdx, _tileDir));
                } else {
                    setTimeout(() => prefetchRemainingTileSources(_pageIdx, _tileDir), 1500);
                }
            }

            if (curPage() == 0) {
                $('#exh-first-img').addClass('disabledOp').attr('disabled', true);
                $('.exh-prev').addClass('disabledOp');
                $('#exh-prev').addClass('disabledOp').attr('disabled', true);
            } else {
                $('#exh-first-img').removeClass('disabledOp').removeAttr('disabled');
                $('.exh-prev').removeClass('disabledOp');
                $('#exh-prev').removeClass('disabledOp').removeAttr('disabled');
            }

            if (curPage() == (mapCount - 1)) {
                $('.exh-next').addClass('disabledOp');
                $('#exh-last-img').addClass('disabledOp').attr('disabled', true);
            } else {
                $('.exh-next').removeClass('disabledOp');
                $('#exh-last-img').removeClass('disabledOp').removeAttr('disabled');
            }

            if ($shareLink.length > 0) {
                let str = $shareLink.val();
                let subst = str.substring(str.indexOf('page=') + 5, str.indexOf('&key'));
                $shareLink.attr('value', str.replace('page=' + subst, 'page=' + ($('.image-info.active').data('image-id'))));
            }
            if ($embedLink.length > 0) {
                let str = $embedLink.val();
                let subst = str.substring(str.indexOf('page=') + 5, str.indexOf('&key'));
                $('#embedLink').attr('value', str.replace('page=' + subst, 'page=' + ($('.image-info.active').data('image-id'))));
            }

        })

        // handler for when OSD opens a tile source (fires on every page navigation in sequence mode)
        function onViewerOpen() {
            $imageInfo.eq(curPage()).addClass('active');
            $('.dots-wrapper .dots-card').eq(curPage()).addClass('active');

            const _openIdx = curPage();
            const _openId  = window.imageIds && window.imageIds[_openIdx];
            if (_openId) {
                loadImageData(_openId).then(() => {
                    create_ck_for_create_dot(_openIdx);
                    if ($('#share-id').data('dot') == true) {
                        const _highlightTerm = new URLSearchParams(window.location.search).get('highlight');
                        // a search-result deep link needs the OCR boxes to find and open the word
                        if (_highlightTerm) {
                            ocrHighlightsOn = true;
                            $('#showOcrAi').addClass('active');
                        }
                        showPins(_openIdx);
                        if (_highlightTerm && anno) anno.highlightSearchTerm(_highlightTerm);
                    }
                    // sidebar open from server (open_img_info): run post-render setup
                    if (window.image_text_open) {
                        loadIframe('.image-content');
                        if ($windowWidth <= 600) {
                            $header.addClass('hiddenHeader');
                            $('.image-info.active .image-info-wrapper').addClass('active');
                            mobileImageModalActivator();
                        }
                        if (window.autoplay_image_voice_note) {
                            autoplay_image_first_voice_note();
                        }
                    }
                    // once initial image is ready, background-prefetch tile sources during idle time
                    _lastPrefetchIdx = _openIdx;
                    if (typeof requestIdleCallback !== 'undefined') {
                        requestIdleCallback(() => prefetchRemainingTileSources(_openIdx, 1));
                    } else {
                        setTimeout(() => prefetchRemainingTileSources(_openIdx, 1), 1500);
                    }
                });
                // prefetch next 2 images
                [_openIdx + 1, _openIdx + 2].forEach(i => {
                    if (window.imageIds[i]) loadImageData(window.imageIds[i]);
                });
            }
        }

        viewer.addHandler('open', onViewerOpen);

        // if the viewer already opened before this handler was registered, run init now
        if (viewer.isOpen()) {
            onViewerOpen();
        }


        /* The below code is adding a handler to the canvas-click event. The handler is a function that is called when the
       canvas-click event is triggered. The handler is adding a circle to the SVG overlay of the viewer. */
        viewer.addHandler('canvas-click', function (event) {

            //don't zoom on newly created dots
            if (event.originalEvent.target.classList.contains('added-dot')) {
                event.preventDefaultAction = true;
            }

            let webPoint = event.position;
            let viewportPoint = viewer.viewport.pointFromPixel(webPoint);

            if ($('.newDot').length > 0) {
                $('.newDot').remove();
            }
            if ($('.pin-button').hasClass('active')) {
                // note: don't touch zoomPerClick here — the native #exh-dzi-plus/#exh-dzi-minus
                // buttons use it (zoomBy(zoomPerClick)), so setting it to 1 broke them while
                // placing a dot. click-to-zoom during placement is already suppressed below via
                // event.preventDefaultAction = true.
                // direct float reads, no string round-trip (Point.toString rounds to 2 decimals)
                let coordViewX = viewportPoint.x;
                let coordViewY = viewportPoint.y;

                writeDotCoords(coordViewX, coordViewY);

                const dotEl = document.createElement('div');
                dotEl.className = 'newDot';
                viewer.addOverlay(dotEl, new OpenSeadragon.Point(coordViewX, coordViewY), OpenSeadragon.Placement.CENTER);
                attachNewDotDrag(dotEl, viewer);
            }

            //don't zoom if pin button for create dot is active
            if (event.eventSource.currentOverlays[0] != undefined) {
                if ($('.pin-button').hasClass('active') || (event.eventSource.currentOverlays[0].element.classList.contains('dot-pointer') && event.eventSource.currentOverlays[0].element.classList.contains('vis-active'))) {
                    event.preventDefaultAction = true;
                } else {
                    viewer.zoomPerClick = 1.3; // keep in sync with OSD config zoomPerClick
                }
            } else if ($('.pin-button').hasClass('active')) {
                event.preventDefaultAction = true;
            } else {
                viewer.zoomPerClick = 1.3; // keep in sync with OSD config zoomPerClick
            }

        });

        // center image after panning
        const panStartCenter = viewer.viewport.getCenter();

        // viewer.addHandler("canvas-release", function () {
        //     if (viewer.viewport.getZoom() / viewer.viewport.getHomeZoom() <= 1.1) {
        //         // Pan the viewport to the center same as pressing the Home button
        //         viewer.viewport.goHome();
        //     }
        // });

        // right click zoom out
        viewer.addHandler('canvas-nonprimary-press', function (event) {
            if (event.button === 2) { // Right mouse
                event.shift = true;
                event.quick = true;
                viewer.innerTracker.clickHandler(event);

                //center image after full zoom-out
                if (viewer.viewport.getZoom() / viewer.viewport.getHomeZoom() <= 1.1) {
                    viewer.viewport.goHome();
                }
            }
        });


        // open the shared image by id, not by its position in the exhibit
        const _shareImgId = parseInt(new URLSearchParams(window.location.search).get('page'), 10);
        if (!isNaN(_shareImgId)) {
            const _shareIdx = window.imageIds.indexOf(_shareImgId);
            if (_shareIdx > -1) viewer.goToPage(_shareIdx);
        }


        // Add event listener for swipe action for next/prev image for mobile devices
        if (($windowWidth < 600 || ((navigator.userAgent.includes("Mac") || navigator.userAgent.includes("Android")) && "ontouchend" in document)) && viewer) {


            let startX = [];
            let startY = [];
            let endX, endY;

            viewer.addHandler("canvas-drag", function (event) {
                if ($('.overlay-exhibit-story').length > 0) {
                    return;
                }

                // while placing a dot, don't track swipe-to-switch-image state
                if ($('.pin-button').hasClass('active')) {
                    startX = [];
                    return;
                }

                // Catch x and y position on canvas drag if image is not zoomed
                if (viewer.viewport.getZoom() <= 1) {
                    startX.push(event.position.x);
                    startY.push(event.position.y);
                } else {
                    startX = null;
                }
            });

            viewer.addHandler("canvas-drag-end", function (event) {
                // while placing a dot, a finger drag must not switch the image
                // (the pan itself still happens via osd); just reset and bail
                if ($('.pin-button').hasClass('active')) {
                    startX = [];
                    startY = [];
                    endX = null;
                    endY = null;
                    return;
                }

                if (startX != null) {

                    // Catch x and y position on canvas drag end
                    endX = event.position.x;
                    endY = event.position.y;

                    // Calculate difference from initial drag point and end drag point
                    let xDiff = startX[0] - endX;
                    let yDiff = startY[0] - endY;

                    // Switch image if X axis movement is bigger than Y axis
                    if (Math.abs(xDiff) > Math.abs(yDiff)) {
                        // Switch next/prev image if swipe is bigger than 10px
                        if (xDiff > 10) {
                            viewer.viewport.panEnabled = false;
                            let current_page = viewer.currentPage();
                                if (!$('.image-info-mobile .content-wrapper').hasClass('active')) {
                                    mobileImageModalDeactivator()
                                }
                                viewer.goToPage(current_page + 1);
                                viewer.viewport.goHome();

                        } else if (xDiff < -10) {
                            viewer.viewport.panEnabled = false;
                            let current_page = viewer.currentPage()
                                if (!$('.image-info-mobile .content-wrapper').hasClass('active')) {
                                    mobileImageModalDeactivator()
                                }
                                viewer.goToPage(current_page - 1);
                                viewer.viewport.goHome();
                        }
                        // Reset variables
                        startX = [];
                        startY = [];
                        endX = null;
                        endY = null;
                        viewer.viewport.panEnabled = true;
                    }

                } else {
                    // If startX is null reset variables and return
                    startX = [];
                    startY = [];
                    endX = null;
                    endY = null;

                    return;
                }
            });
        }

        //set image id for show annotations for current image

        $showDotsButton.attr('data-image-id', $('.image-info.active').data('image-id'));
    }
});

/*
//image bar functionality

$('#showImageBar').on('click', function () {
    $(this).toggleClass('active');
    $('.referencestrip').toggleClass('d-none');
});

document.querySelector('.referencestrip').addEventListener("mouseout", function () {
    document.querySelector('.referencestrip').style.marginBottom = "-210px";
});
*/


function getUrlParameter(sParam) {
    let sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
}

// Show "Click for fullscreen layer"
$(document).ready(function () {
    if (getUrlParameter('shr-full') == 'true') {
        // Prevent for mobile phone
        if (window.innerWidth > 768) {
            $('.fs-overlay').addClass('active');
            $viewerWrapper.attr('data-full', 'true');
        }
    }
});

$(".modal").on('show.bs.modal', function () {
    setTimeout(function () {
        $('.modal .modal-body').scrollTop(0);
    }, 175)
});


function payload(url, data, method) {
    let response = false

    if (data != null) {
        data['_token'] = $('meta[name="csrf-token"]').attr('content')
    }

    return new Promise(function (resolve, reject) {
        $.ajax({
            url: url,
            dataType: "json",
            method: method,
            data: data,
        }).done(function (data) {
            response = data
            resolve(response)
        }).fail(function (xhr) {
            response = xhr
            reject(response)
        });
    })
}


//load iframe
function loadIframe(classSelector) {
    document.querySelectorAll(classSelector + ' oembed[url]').forEach(element => {
        // get just the code for this youtube video from the url
        let vCode = ''

        if (element.attributes.url.value.includes('youtube.com/watch') || element.attributes.url.value.includes('youtu.be')) {
            if (element.attributes.url.value.includes('youtube.com/watch')) {

                vCode = element.attributes.url.value.split('?v=')[1];
                // Remove any additional query parameters
                if (vCode.includes('&')) {
                    vCode = vCode.split('&')[0];
                }

            } else if (element.attributes.url.value.includes('youtu.be')) {

                vCode = element.attributes.url.value.split('be/')[1];
                // Remove any additional query parameters
                if (vCode.includes('?')) {
                    vCode = vCode.split('?')[0];
                }

            }

            const iframeWrapper = document.createElement('div');
            iframeWrapper.className = 'ratio ratio-16x9';
            // Consent-gated: show a click-to-load placeholder until the visitor accepts media cookies.
            if (window.CookieConsent && !window.CookieConsent.hasMedia() && typeof window.ccYtPlaceholderHtml === 'function') {
                iframeWrapper.innerHTML = window.ccYtPlaceholderHtml(vCode, 250);
            } else if (typeof window.ccYtIframeHtml === 'function') {
                iframeWrapper.innerHTML = window.ccYtIframeHtml(vCode, 250);
            } else {
                iframeWrapper.innerHTML = `<iframe src="https://www.youtube-nocookie.com/embed/${vCode}?rel=0&origin=${window.location.origin}" allowfullscreen style="min-height: 250px; width: 100%"></iframe>`;
            }

            element.parentElement.replaceChild(iframeWrapper, element);
            return;
        }

        vCode = element.attributes.url.value;

        const link = document.createElement('a');
        link.href = vCode;
        link.target = '_blank';
        link.textContent = vCode;

        element.parentElement.replaceChild(link, element);
    });
}

//stop iframe vid
function stopIframeVid(classSelector) {
    $(classSelector + " iframe").each(function () {
        let src = $(this).attr("src");
        $(this).attr("src", src);
    });
}


//ckeditor
$(function () {

    //variables for editor instances for exhibit description, image title and description
    window.editor_exh;
    let editor_img_title;
    window.editor_img_desc;
    let editor_img_private_note;

    //on edit exhibit button create cke instance with existing exhibit description
    $(document).on('click', '#modal-crtexh-button', function () {
        const exhibitDescElement = document.querySelector('#exhibits-description');

        if (!window.editor_exh && exhibitDescElement) {
            ClassicEditor.create(exhibitDescElement)
                .then(newEditor => {
                    window.editor_exh = newEditor;
                })
                .catch(error => {
                    console.error(error);
                });
        }
        payload("/exhibits/" + exhibit_id + "/edit", null, "GET")
            .then(function (response) {
                if (response.status == 404) {
                    alert(response.message);
                    $modalExhibitInfo.modal('hide');
                } else {
                    $modalCrtexh.modal({
                        focus: false
                    });
                    $('#exhibits-title').val(response.exhibit.title);
                    $('.exhibit-voice-edit').load('/voice_notes/exhibit/' + exhibit_id + '/edit');
                    if (response.exhibit.description) {
                        window.editor_exh.setData(response.exhibit.description)
                    } else {
                        window.editor_exh.setData('')
                    }
                }
            }).catch(function (response) {
            // console.log(response)
        });

        // unsubscribe from any existing exhibit transcription channels to prevent duplicates
        if (window.currentExhibitTranscriptionChannel) {
            window.currentExhibitTranscriptionChannel.unbind_all();
            pusher.unsubscribe(window.currentExhibitTranscriptionChannel.name);
        }

        // subscribe to new channel for this exhibit
        let voiceNoteChannel = pusher.subscribe('voice-note-transcribe-exhibit-' + exhibit_id);
        voiceNoteChannel.bind('voice-note-transcribe-event', function (data) {
            voiceNotes.addTranscriptToDescription(data.voiceId, data.modelType, data.transcript, data.voiceTitle)
        });

        // store reference for cleanup
        window.currentExhibitTranscriptionChannel = voiceNoteChannel;
    });
    // update exhibit description and button style
    $(document).on('click', '#updateExhibit', function (e) {
        e.preventDefault();
        $(this).text('Updating..');
        let new_title = '';
        if ($('#exhibits-title').attr('name') == 'title') {
            new_title = $('#exhibits-title').val();
        }
        let data = {
            'title': new_title,
            'description': window.editor_exh.getData()
        }

        payload("/exhibits/" + exhibit_id, data, "PUT").then(function (response) {
            if (response.status == 404) {
                alert(response.message);
                $modalCrtexh.modal('hide');
                $('#updateExhibit').text('Update');
            } else {
                $('.personal-alert').addClass('alert alert-success show-alert').css({'left': '50%'}).html(response.message);
                setTimeout(function () {
                    $personalAlert.removeClass('show-alert');
                }, 2500)
                setTimeout(function () {
                    $('.personal-alert').removeClass('alert alert-success show-alert').removeAttr('style').html('');
                }, 3000)

                $('.exh-title').html(response.new_title);
                $('#updateExhibit').text('Update');
                $modalCrtexh.modal('hide');
                $modalExhibitInfo.modal('hide');
                $exhDescription.html(response.new_description);
                loadIframe('.exh-description');
                initCkEditorReadMoreToggles();
            }
        }).catch(function (result) {
            if (result.responseJSON && result.responseJSON.errors) {
                let errorMessages = [];

                for (let field in result.responseJSON.errors) {
                    if (result.responseJSON.errors.hasOwnProperty(field)) {
                        result.responseJSON.errors[field].forEach(function (error) {
                            errorMessages.push(error);
                        });
                    }
                }

                let formattedErrors = errorMessages.join("\n");
                alert(formattedErrors);
            } else {
                alert(result.responseJSON.message || "An error occurred.");
            }

            $('#updateExhibit').text('Update');
        })
    });

    $modalCrtexh.on('hide.bs.modal', function () {
        pusher.unsubscribe('voice-note-transcribe-exhibit-' + exhibit_id);
    });

    //create cke instance for image title and description with existing data
    $(document).on('click', '.editImage', function () {
        let Image_id = $(this).data('id');
        const imageTitleElement = document.querySelector('#image-title');
        const imageDescElement = document.querySelector('#image-description');
        const imagePrivateNoteElement = document.querySelector('#image-private-note');

        if (!editor_img_title && !window.editor_img_desc) {
            if (imageTitleElement) {
                ClassicEditor.create(imageTitleElement, {
                    plugins: ['Essentials', 'Paragraph', 'Bold', 'Italic', 'ClearText'],
                    toolbar: {
                        items: [
                            'bold', 'italic', 'ClearText'
                        ]
                    }
                })
                    .then(newEditor => {
                        editor_img_title = newEditor;

                        editor_img_title.model.document.on('change:data', () => {
                            updateCKEditorCharCount(editor_img_title);
                        });

                        // Initialize the counter on page load
                        updateCKEditorCharCount(editor_img_title);
                    })
                    .catch(error => {
                        console.error(error);
                    });
            }

            function updateCKEditorCharCount(editor) {
                const content = editor.getData();
                const charCount = content.replace(/<[^>]*>/g, '').length;
                const charCountDisplay = document.getElementById('image-title-char-count');
                if (charCountDisplay) {
                    charCountDisplay.textContent = charCount + ' / 255';
                }
            }

            if (imageDescElement) {
                ClassicEditor.create(imageDescElement)
                    .then(newEditor => {
                        window.editor_img_desc = newEditor;
                    })
                    .catch(error => {
                        console.error(error);
                    });
            }

            if (imagePrivateNoteElement) {
                ClassicEditor.create(imagePrivateNoteElement, {
                    uploadFrom: 'note',
                })
                    .then(newEditor => {
                        editor_img_private_note = newEditor;
                    })
                    .catch(error => {
                        console.error(error);
                    });
            }
        }

        payload("/images/" + Image_id + "/edit", null, "GET").then(function (response) {
            if (response.status == 404) {
                alert(response.message);
                $imageEdit.modal('hide');
            } else {
                $imageEdit.modal({
                    focus: false
                });
                $('#Image_id').val(response.image.id);
                const _editFormatLabel = _buildFormatLabel(response.image.tile_format, !!response.image.is_external_iiif);
                const _editFmtSuffix = _editFormatLabel ? ' | ' + _editFormatLabel : '';
                $('.data-imId').text('#' + response.image.id + ' | ' + response.image.width + ' x ' + response.image.height + ' px' + _editFmtSuffix);
                $('.edit-dots-count').text(response.dots_count);
                $('.edit-voice-count').text(response.image.total_voices);
                $('.image-creator').text('Creator: ' + response.image.author_data.name);
                $('.edit-image-size').text(response.image_size);
                $('.image-voice-edit').load('/voice_notes/image/' + Image_id + '/edit');
                if (response.image.private_note) {
                    editor_img_private_note.setData(response.image.private_note.note);
                    $('#private_note_history').html('Recently updated by: ' + response.image.private_note.author_data.name + ', At: ' + response.image.private_note.updated_at);
                } else {
                    editor_img_private_note.setData('');
                    $('#private_note_history').html('');
                }
                $('#im-title').val(response.image.title);
                $('#image-edit-admin').attr('href', window.location.origin + '/admin/images/' + Image_id + '/edit')
                $('#image-download').attr('href', response.main_image_download_link)
                $('#image-analyze-btn').attr('data-image-id', Image_id)
                $imageTags.tagsinput('removeAll');
                $imageTags.tagsinput('add', response.tags);
                let tagsInput = $imageTags.tagsinput('input');
                let bootstrapTagsInput = $('.bootstrap-tagsinput');
                if (response.image.is_public) {
                    tagsInput.css('visibility', 'hidden');
                    bootstrapTagsInput.hover(function () {
                        $(this).css('cursor', 'not-allowed');
                    }, function () {
                        $(this).css('cursor', 'default');
                    });
                    bootstrapTagsInput.find('span span').addClass('d-none');
                    bootstrapTagsInput.css('background', '#e8e8e8');
                    $('.tags-error').remove();
                    $('label[for="image_tags"]').append('<span class="tags-error text-danger" style="font-size: 10px"> (Tags are disable for private images)</span>');
                } else {
                    tagsInput.removeAttr('style');
                    bootstrapTagsInput.removeAttr('style');
                    bootstrapTagsInput.hover(function () {
                        $(this).css('cursor', 'default');
                    });
                    bootstrapTagsInput.find('span span').removeClass('d-none');
                    $('.tags-error').remove();
                }
                if (response.image.description != null) {
                    window.editor_img_desc.setData(response.image.description);
                } else {
                    window.editor_img_desc.setData('');
                }
                editor_img_title.setData(response.image.title);
            }
        }).catch(function (result) {
            // // console.log(result)
        });

        // unsubscribe from any existing image transcription channels to prevent duplicates
        if (window.currentImageTranscriptionChannel) {
            window.currentImageTranscriptionChannel.unbind_all();
            pusher.unsubscribe(window.currentImageTranscriptionChannel.name);
        }

        // subscribe to new channel for this image
        let voiceNoteChannel = pusher.subscribe('voice-note-transcribe-image-' + Image_id);
        voiceNoteChannel.bind('voice-note-transcribe-event', function (data) {
            // console.log(data);
            voiceNotes.addTranscriptToDescription(data.voiceId, data.modelType, data.transcript, data.voiceTitle)
        });

        // store reference for cleanup
        window.currentImageTranscriptionChannel = voiceNoteChannel;

        if ($(this).hasClass('editZoomable')) {
            $zoomableModal.addClass('d-none');
        }
    });

    //save image and button style

    $(document).on('click', '#saveImageBtn', function (e) {
        e.preventDefault();
        $(this).text('Updating..');
        let id = $('#Image_id').val();
        let data_title = editor_img_title.getData();
        let image_tags = $imageTags.val();
        let image_tags_array = $("#image_tags").tagsinput('items');
        let data = {
            'title': data_title,
            'description': window.editor_img_desc.getData(),
            'private_note': editor_img_private_note.getData(),
            'image_tags': image_tags
        }

        payload("/images/" + id, data, "PUT").then(function (response) {
            if (response.status == 404) {
                alert(response.message);
                $imageEdit.modal('hide');
                $('#saveImageBtn').text('Update');
            } else {
                $('.personal-alert').addClass('alert alert-success show-alert').html(response.message);
                $('#saveImageBtn').text('Update');
                $('.image-info[data-image-id="' + id + '"] .image-title h5').html(data_title);
                $('.exhibit-attribution-wrapper .image-info[data-image-id="' + id + '"]').html(data_title);
                $('.image-info[data-image-id="' + id + '"] .image-content').html(response.description);
                $('.image-info[data-image-id="' + id + '"] .image-info-header .image-title-mobile').text(response.title);
                $imageEdit.modal('hide');
                loadIframe('.image-content');
                initCkEditorReadMoreToggles();
                // invalidate AJAX cache so next navigation re-fetches fresh data
                invalidateImageDataCache(parseInt(id));

                if (image_tags_array.length > 0) {
                    $('.image-info[data-image-id="' + id + '"] .image-content').append('<div class="image-tags"><div class="image-tag-items"><hr>Tags: </div></div>');
                    image_tags_array.forEach(tag => {
                        $('.image-tag-items').append('<a href="/search?search=' + tag + '" class="btn btn-tdg-blue text-white text-decoration-none m-0 py-0 text-capitalize mr-1">' + tag + '</a>');
                    })
                }
                setTimeout(function () {
                    $personalAlert.removeClass('show-alert');
                }, 2500)

                setTimeout(function () {
                    $('.personal-alert').removeClass('alert alert-success show-alert').html('');
                }, 3000)
            }
        }).catch(function (result) {
            if (result.responseJSON && result.responseJSON.errors) {
                let errorMessages = [];

                for (let field in result.responseJSON.errors) {
                    if (result.responseJSON.errors.hasOwnProperty(field)) {
                        result.responseJSON.errors[field].forEach(function (error) {
                            errorMessages.push(error);
                        });
                    }
                }

                let formattedErrors = errorMessages.join("\n");
                alert(formattedErrors);
            } else {
                alert(result.responseJSON.message || "An error occurred.");
            }

            $('#updateExhibit').text('Update');
        })

    });

    $(document).on('hidden.bs.modal', '#imageEdit', function () {
        $zoomableModal.removeClass('d-none');
        $('.zoomable-image-title').html(editor_img_title.getData().replace(/<\/?[^>]+(>|$)/g, ''));
    });

    const input = document.getElementById('exhibits-title');
    const clearBtn = document.getElementById('clearTitle');

    // Only initialize if elements exist (curator/admin features)
    if (input && clearBtn) {
        function toggleClearBtn() {
            if (input.value && document.activeElement === input) {
                clearBtn.style.display = 'block';
            } else {
                clearBtn.style.display = 'none';
            }
        }

        input.addEventListener('input', toggleClearBtn);
        input.addEventListener('focus', toggleClearBtn);
        input.addEventListener('blur', toggleClearBtn);

        clearBtn.addEventListener('mousedown', function (e) {
            e.preventDefault();
            input.value = '';
            const charCountDisplay = document.getElementById('char-count-et');
            if (charCountDisplay) {
                charCountDisplay.textContent = 0 + ' / 125';
            }
            toggleClearBtn();
            input.focus();
        });
    }
});


// Edit dot

window.editor_dot;

// untrusted authors (guests + regular users) get a restricted toolbar without
// image/zoomable/embed buttons (they can't upload anyway, and the server strips
// such markup). returns undefined for admin/curator so they keep the default toolbar.
function dotEditorConfig() {
    // dotcrt share mode: bare text box, no toolbar buttons
    if (window.dotShareMode) return { toolbar: { items: [] } };
    const cfg = window.exhibitConfig;
    if (cfg.isAdmin || cfg.isCurator) return undefined;
    return { toolbar: { items: [
        'link', 'bold', 'italic', '|', 'heading', '|', 'readMore', 'ClearText', '|', 'undo', 'redo', '|',
    ] } };
}

function createDotEditor(element) {
    const cfg = dotEditorConfig();
    return cfg ? ClassicEditor.create(element, cfg) : ClassicEditor.create(element);
}

$(document).on('click', '.editDot', function () {
    let Dot_id = $(this).attr('data-id');
    const dotContentElement = document.querySelector('#dot-content');

    if (!window.editor_dot && dotContentElement) {
        createDotEditor(dotContentElement)
            .then(newEditor => {
                window.editor_dot = newEditor;
            })
            .catch(error => {
                console.error(error);
            });
    }

    if ($windowWidth <= 600) {
        mobileDotModalDeactivator()
        $modalDotFullContent.css('height', '');
        $modalDotFullContent.css('top', '');
    }

    payload("/dots/" + Dot_id + "/edit", null, "GET").then(function (response) {
        if (response.status == 404) {
            alert(response.message);
            $modalDotEdit.modal('hide');
        } else {
            $modalDotEdit.modal({
                focus: false
            });

            $('span.modal-dot-id').text(response.dot.id);
            $('span.dot-author-edit').text(response.dot.author_username);
            window.editor_dot.setData(response.dot.content);

            if (response.user_role[0] === 'admin' || response.user_role[0] === 'curator') {
                $('#modal-dotedit form').attr('action', '/admin/dots/' + Dot_id);
            } else if (response.user_role[0] === 'user') {
                $('#modal-dotedit form').attr('action', '/dots/' + Dot_id);
            }

            $('.deleteDot').attr('data-dot-id', Dot_id);
            $('.dot-voice-edit').load('/voice_notes/dot/' + Dot_id + '/edit');
        }
    }).catch(function (result) {
        //console.log(result)
    })

    // unsubscribe from any existing dot transcription channels to prevent duplicates
    if (window.currentDotTranscriptionChannel) {
        window.currentDotTranscriptionChannel.unbind_all();
        pusher.unsubscribe(window.currentDotTranscriptionChannel.name);
    }

    // subscribe to new channel for this dot
    let voiceNoteChannel = pusher.subscribe('voice-note-transcribe-dot-' + Dot_id);
    voiceNoteChannel.bind('voice-note-transcribe-event', function (data) {
        voiceNotes.addTranscriptToDescription(data.voiceId, data.modelType, data.transcript, data.voiceTitle)
    });

    // store reference for cleanup
    window.currentDotTranscriptionChannel = voiceNoteChannel;
});

$('.edit-dot-author').on('click', function () {
    payload("/get-users-dot-author", null, "GET").then(function (response) {
        if (response.status == 404) {
            alert(response.message);
        } else {
            $modalDotEdit.modal('hide');
            const selectElement = $('#dot-author-edit-select');

            selectElement.empty();
            selectElement.append(new Option("Select User", ""));

            const users = response.users;

            users.forEach(user => {
                selectElement.append(new Option(user.username, user.id));
            });

            $('#edit-dot-author').modal({
                backdrop: false,
                show: true
            });

            $('#dot-author-filter').on('input', function () {
                const searchText = $(this).val().toLowerCase();

                if (searchText.length > 0) {
                    selectElement.attr('size', Math.min(users.length, 5));
                } else {
                    selectElement.attr('size', 1);
                }

                selectElement.empty();
                selectElement.append(new Option("Select User", ""));

                users.forEach(user => {
                    if (user && user.username) {
                        if (user.username.toLowerCase().includes(searchText)) {
                            selectElement.append(new Option(user.username, user.id));
                        }
                    }
                });

                selectElement.on('change', function () {
                    selectElement.attr('size', 1);
                });
            });
        }
    }).catch(function (result) {
        // console.log(result)
    })
});

$('#updateDotAuthor').on('click', function () {
    const selectedUserId = $('#dot-author-edit-select').val();

    if (selectedUserId) {
        const formAction = document.querySelector('#dot-modal-edit-footer form').getAttribute('action');
        const dotId = formAction.split('/').pop();

        const data = {
            userId: selectedUserId,
            dotId: dotId
        }

        $('#edit-dot-author').modal('hide');
        payload("/update-dot-author", data, "POST")
            .then(function (response) {
                if (response.status === 200) {
                    $('span.dot-author-edit').text(response.new_author);
                    alert("Dot author updated successfully!");
                } else {
                    alert("Error updating dot author.");
                }
            }).catch(function (error) {
            // console.log(error);
        });
    } else {
        alert("Please select a user.");
    }
});

$('#edit-dot-author').on('hidden.bs.modal', function () {
    $modalDotEdit.modal('show');
});

$('.deleteDot').on('click', function () {
    return confirm('Are you sure to delete dot: ' + $(this).attr('data-dot-id'));
});

$('#modal-dotedit form').on('submit', function (e) {
    e.preventDefault();
    let url = $('#modal-dotedit form').attr('action');
    let _token = $("meta[name='csrf-token']").attr('content');


    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': _token
        }
    });

    payload(url, null, "DELETE").then(function (response) {
        if (response.status == 404) {
            alert(response.message);
            $modalDotEdit.modal('hide');
            $updateDot.text('Update');
        } else {

            $('.personal-alert').removeAttr('style').addClass('alert alert-success show-alert').html(response.message);

            setTimeout(function () {
                $personalAlert.removeClass('show-alert');
            }, 2500)

            setTimeout(function () {
                $('.personal-alert').removeClass('alert alert-success show-alert').removeAttr('style').html('');
            }, 3000)

            // remove dot from DOM

            $('.dot-short[data-id="' + response.dot_id + '"]').remove();
            $('.dot-pointer[data-id="' + response.dot_id + '"]').remove();

            // keep the cache in sync BEFORE showPins, otherwise renderDotPointers
            // rebuilds the just-deleted pin from stale cache (ghost pin)
            const _delImgId = parseInt($('.image-info.active').data('image-id'));
            const _delCache = window.imageDataCache[_delImgId];
            if (_delCache && Array.isArray(_delCache.dots)) {
                _delCache.dots = _delCache.dots.filter(d => d.id != response.dot_id);
                if (typeof _delCache.dots_count === 'number') {
                    _delCache.dots_count = Math.max(0, _delCache.dots_count - 1);
                }
            }

            $modalDotFull.modal('hide');
            refreshPins();

            // hide modal and change button text
            $updateDot.text('Update');
            $modalDotEdit.modal('hide');


            // renumber the sidebar rows (showPins renumbers the pins from the synced
            // cache; never overwrite pin .dot-number - it holds the sort-number + badge)
            $dotsWrapper.find('div.dots-card.active').find('.card-body').find('.comments').find('.dot-short').find('.dot-meta').find('.dot-avatar').find('.dot-number').each(function (i) {
                $(this).html(i + 1);
            });


            // update total dots number
            let dot_count = parseInt($('div.dots-card.mt-4.active').find('.comment-count').html());
            $('div.dots-card.mt-4.active').find('.comment-count').html(dot_count - 1);
        }
    }).catch(function (result) {
        // reset the button so it doesn't stay stuck
        $updateDot.text('Update');
    });
});

// save dot and button style

$(document).on('click', '#updateDot', function (e) {
    e.preventDefault();
    $(this).text('Updating..');
    let id = $('#modal-dotedit .modal-dot-id').text();
    let coord_x = $editDotPositionInput.find('input[name="coord_x"]').val();
    let coord_y = $editDotPositionInput.find('input[name="coord_y"]').val();
    let data = {
        'dot_content': editor_dot.getData(),
        'coord_x': coord_x,
        'coord_y': coord_y
    }


    if (editor_dot.getData() == '') {
        alert('Dot content cannot be empty!')
        $updateDot.text('Update');
    } else {
        payload("/dots/" + id, data, "PUT").then(function (response) {
            if (response.status == 404) {
                alert(response.message);
                $modalDotEdit.modal('hide');
                $updateDot.text('Update');
            } else {
                if (coord_x != '' && coord_y != '') {

                    $('.dot-meta[data-dot-id="' + id + '"]').find('.coord-x').text(coord_x);
                    $('.dot-meta[data-dot-id="' + id + '"]').find('.coord-y').text(coord_y);


                    $modalDotFull.modal('hide');
                    refreshPins();

                }


                $('.personal-alert').removeAttr('style').addClass('alert alert-success show-alert').html(response.message);

                setTimeout(function () {
                    $personalAlert.removeClass('show-alert');
                }, 2500)

                setTimeout(function () {
                    $('.personal-alert').removeClass('alert alert-success show-alert').removeAttr('style').html('');
                }, 3000)

                $('.dot-short[data-id="' + id + '"] .blockquote small').html(response.new_content);

                // keep the cache in sync so a later re-render preserves the edit
                const _editImgId = parseInt($('.image-info.active').data('image-id'));
                const _editCache = window.imageDataCache[_editImgId];
                if (_editCache && Array.isArray(_editCache.dots)) {
                    const _d = _editCache.dots.find(d => d.id == id);
                    if (_d) {
                        _d.content = response.new_content;
                        if (coord_x != '' && coord_y != '') {
                            _d.coord_x = coord_x;
                            _d.coord_y = coord_y;
                        }
                    }
                }

                $updateDot.text('Update');
                $modalDotEdit.modal('hide');
                loadIframe('.dot-short[data-id="' + id + '"] .blockquote small');
                initCkEditorReadMoreToggles();
            }
        }).catch(function (result) {
            // reset the button so it doesn't stay stuck on "Updating.."
            $updateDot.text('Update');
        })
    }
});

//end edit dot
//endckeditor

// ordered dot ids for the active image (sidebar list; real DOM siblings,
// unlike .dot-pointer overlays which OSD wraps individually)
function activeImageDotIds() {
    return $('.dots-card.active .comments .dot-short').map(function () {
        return String($(this).data('id'));
    }).get();
}

// {dotId, term} set when the page was opened from a search result for a dot
let dotSearchHighlight = null;

// Wrap every occurrence of the search terms inside roots in <mark>, touching
// text nodes only so links and other markup in the content stay intact.
// Terms are split like SearchHelper::parse: "quoted phrases" stay together.
// Scrolls to the first visible match, in roots order.
function highlightSearchTerms(roots, searchValue) {
    roots = [].concat(roots).filter(Boolean);
    if (!roots.length) return;

    const matches = [...searchValue.trim().matchAll(/"([^"]+)"|(\S+)/g)];
    const terms = matches
        .map(m => (m[1] || m[2] || '').trim())
        .filter(t => t && (t.length >= 2 || matches.length === 1));
    if (!terms.length) return;

    // collapse read-more blocks first, so a match in the hidden part is detected below
    initCkEditorReadMoreToggles();

    const pattern = new RegExp('(' + terms.map(t => t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|') + ')', 'gi');
    roots.forEach(root => highlightTextNodes(root, pattern));

    const marks = roots.flatMap(root => [...root.querySelectorAll('mark.search-hit')]);
    if (!marks.length) return;

    // a match in the collapsed part of a read-more block needs the block open to be seen
    marks.forEach(mark => {
        const hidden = mark.closest('.read-more-hidden');
        if (hidden && hidden.style.display === 'none') {
            const toggle = hidden.closest('.read-more-block')?.querySelector('.read-more-toggle');
            if (toggle) toggle.click();
        }
    });

    // wait for modal/sidebar show animations so the scroll lands
    setTimeout(() => {
        const first = marks.find(m => m.offsetParent !== null);
        if (first) first.scrollIntoView({block: 'nearest', behavior: 'smooth'});
    }, 300);
}

function highlightTextNodes(root, pattern) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
        acceptNode: node => node.parentElement.closest('script, style, mark, .read-more-toggle, .read-less-toggle')
            ? NodeFilter.FILTER_REJECT
            : NodeFilter.FILTER_ACCEPT
    });

    const textNodes = [];
    while (walker.nextNode()) textNodes.push(walker.currentNode);

    textNodes.forEach(node => {
        const parts = node.nodeValue.split(pattern);
        if (parts.length < 2) return;

        const fragment = document.createDocumentFragment();
        parts.forEach((part, i) => {
            if (i % 2) {
                const mark = document.createElement('mark');
                mark.className = 'search-hit';
                mark.textContent = part;
                fragment.appendChild(mark);
            } else if (part) {
                fragment.appendChild(document.createTextNode(part));
            }
        });
        node.parentNode.replaceChild(fragment, node);
    });
}

function openDot(dotId) {
    if ($('.pin-button').hasClass('active') || exhibit_story_create_mode) {
        return;
    }

    if (anno && typeof anno.cancelSelected === 'function') anno.cancelSelected();

    let prevDotId = '';
    let $dotNumberActive = $('.dot-number.active');

    if ($dotNumberActive.length > 0) {
        prevDotId = $dotNumberActive.parent('.dot-pointer').data('id');
    }
    $('.dot-number').removeClass('active');

    if ($('.overlay-exhibit-story').length < 1) {
        $('.dot-pointer').removeClass('active');
    }

    $('.dot-pointer[data-id="' + dotId + '"]').addClass('active').find('.dot-number').addClass('active');
    $modalDotFull.modal('show');

    if ($('.dot-pointer[data-id="' + dotId + '"]').find('.dot-number').hasClass('blob')) {
        $('.dot-pointer[data-id="' + dotId + '"]').find('.dot-number').removeClass('blob');
    }

    //if clicked dot number from sidebar
    // if (dotId == undefined) {
    //     dotId = $(this).closest('.dot-short').data('id');
    //     $('.dot-pointer[data-id="' + dotId + '"] .dot-number').addClass('active');
    // }

    $modalDotFull.find('.modal-body').html('').append('<img style="position: absolute;left: 45%;top: 40%;z-index: 100000;height: 54px;width: 54px;" src="../../images/local/loading.gif" alt="loading"/>');
    $modalDotFull.find('.modal-body').load('/dots/' + dotId, function (responseText, status) {
        // jQuery leaves the previous content (the loading gif) in place on failure
        if (status === 'error' || status === 'timeout' || status === 'abort') {
            $modalDotFull.find('.modal-body').html('<div class="p-4 text-center">This dot is no longer available.</div>');
            return;
        }
        const dot_image_id = $('#dot-image-id').html();
        const images_count_desktop = $('.image-info[data-image-id=' + dot_image_id + '] .image-count div span').html();
        const images_data_mobile = $('.image-info-mobile .content-wrapper').find('.image-info[data-image-id=' + dot_image_id + '] span:first').html();
        const image_count = (images_data_mobile != 0 && images_data_mobile != undefined) ? images_data_mobile : images_count_desktop;
        const image_data = image_count + ' | ' + $('#dot-image-data').html();

        $modalDotFull.find('.editDot').attr('data-id', dotId);
        $modalDotFull.find('.dotShare').attr('data-dotid', dotId);
        $modalDotFull.find('#dot-creator-name').html($('#dot-creator-name-get').html());
        $modalDotFull.find('.dot-image-data').html(image_data);
        $modalDotFull.find('.dot-voice-visibility .badge').html($('#dot-voice-count').html())
        $('.dot-footer').find('#user-edit-dot').remove();
        let user_edit_dot = $modalDotFull.find('#user-edit-dot');
        user_edit_dot.insertBefore('#modal-dotfull .close-dot-modal');
        if (user_edit_dot.length > 0) {
            $('.empty-space-div').addClass('d-none');
        } else {
            $('.empty-space-div').removeClass('d-none');
        }
        $('.dot-footer').find('#user-edit-dot').removeClass('d-none');
        loadIframe('.dot-full .modal-body');
        initCkEditorReadMoreToggles();
        voiceNotes.fetchDotVoiceNotes(dotId)

        if (dotSearchHighlight && dotSearchHighlight.dotId === String(dotId)) {
            highlightSearchTerms($modalDotFull.find('.modal-body .container .col-12')[0], dotSearchHighlight.term);
            dotSearchHighlight = null;
        }
    });

    // derive prev/next state and the counter from the ordered dot list, not the
    // .dot-pointer DOM (OSD wraps each overlay in its own elementWrapper, so pointers
    // have no sibling pointers to traverse; reading pin text is also fragile if a
    // stale overlay lingers, which doubled the number e.g. "1313")
    const dotIds = activeImageDotIds();
    const idx = dotIds.indexOf(String(dotId));

    if ($('.overlay-exhibit-story').length < 1) {
        $dotFrom.text(idx >= 0 ? idx + 1 : '');
        $dotAll.text(dotIds.length)
    }

    if (idx >= 0 && idx < dotIds.length - 1) {
        $('.dot-pag .next').removeAttr('disabled');
    } else {
        $('.dot-pag .next').attr('disabled', true);
    }

    if (idx > 0) {
        $('.dot-pag .prev').removeAttr('disabled');
    } else {
        $('.dot-pag .prev').attr('disabled', true);
    }

    if ($windowWidth < 600 && !presentationMode) {
        $header.addClass('hiddenHeader');
        mobileDotModalActivator();
    }

    if ($shareLink.length > 0) {
        let str = $shareLink.val();
        let subst = str.substring(str.indexOf('dot=') + 4, str.indexOf('&dotst'));
        $shareLink.attr('value', str.replace('dot=' + subst, 'dot=' + ($(this).data('id'))));
    }
}

// Open Dot by clicking on dot desc in the sidebar
$(document).on('click', '.dot-short', function (e) {
    if (exhibit_story_create_mode) {
        return;
    }
    openDot($(this).data('id'));
})


let scrollAnimationId;

// Function to smoothly scroll the .thumbs-wrapper container
function scrollThumbsWrapper(container, distance, duration, callback) {
    let start = null;

    function step(timestamp) {
        if (!start) start = timestamp;
        const progress = timestamp - start;
        const scrollDistance = Math.min(progress / duration * distance, distance);

        container.scrollTop = scrollDistance;

        if (scrollDistance < distance) {
            scrollAnimationId = window.requestAnimationFrame(step);
        } else if (callback) {
            callback();
        }
    }

    scrollAnimationId = window.requestAnimationFrame(step);
}

function startScrollingLoop() {
    const container = document.querySelector('.thumbs-wrapper');
    if (!container) return;

    const scrollDistance = container.scrollHeight - container.clientHeight;
    const duration = 30000;

    function scrollDown() {
        scrollThumbsWrapper(container, scrollDistance, duration, scrollUp);
    }

    function scrollUp() {
        scrollThumbsWrapper(container, 0, duration, scrollDown);
    }

    scrollDown();
}

function stopScrolling() {
    if (scrollAnimationId) {
        window.cancelAnimationFrame(scrollAnimationId);
    }
}

$('.go-waterfall').on('click', function () {
    $('#screensaverModal').modal('hide');
    $exhThumbsButton.click();

    setTimeout(function () {
        startScrollingLoop();
    }, 500);
});

$exhibitStoryShare.on('click', function (event) {
    const isButton = event.target.closest('button');
    const isGridButton = isButton && isButton.classList.contains('share-overlay-grid-button');

    if (isGridButton) {
        $(this).removeClass('d-flex').addClass('d-none');
        $blankStoryNavigation.addClass('d-none');
        window.history.pushState(null, null, window.location.pathname);

        // open thumbnail grid
        if (!$thumbsWrapper.hasClass('active')) {
            $thumbsWrapper.addClass('active');
        }
        return;
    }

    if (isButton) {
        $(this).removeClass('d-flex').addClass('d-none');
        $blankStoryNavigation.addClass('d-none');
        $modalExhibitInfo.modal('show');

        window.history.pushState(null, null, window.location.pathname);
        return;
    }

    $(this).removeClass('d-flex').addClass('d-none');
    $blankStoryNavigation.addClass('d-none');

    // shared run of show takes precedence
    const esRunId = $(this).attr('data-es-run-id');
    if (esRunId) {
        const matchingRunButton = document.querySelector(`button.start-es-run[data-es-run-slug="${esRunId}"]`);
        if (matchingRunButton) {
            matchingRunButton.click();
        } else {
            alert('Run of show not found');
        }
        return;
    }

    const exhibitStorySlug = $(this).attr('data-es-id');
    const matchingButton = document.querySelector(`button[data-exhibit-story-slug="${exhibitStorySlug}"]`);

    if (matchingButton) {
        matchingButton.click();
    } else {
        alert('Exhibit story not found');
    }
});

$blankStoryNavigation.on('click', function () {
    if (!$exhibitStoryShare.hasClass('d-none')) {
        $exhibitStoryShare.click();
    }
});

/**
 * It shows the dots on the map.
 * @param curPage - the current page number
 */
let mouseTrackers = [];

async function showPins(curPage) {

    mouseTrackers.forEach(t => t.destroy());
    mouseTrackers = [];

    $openseadragonViewer.attr('data-dots', 'true');

    // re-render dot-pointer elements since clearOverlays() detaches them from the DOM
    const imageId = parseInt($('.image-info.active').data('image-id'));
    if (imageId && window.imageDataCache[imageId]) {
        renderDotPointers(imageId, window.imageDataCache[imageId]);
    }

    // renderDotPointers rebuilds the pointer DOM and drops the .active state, so
    // remember the currently-open dot and re-apply it below (keeps the modal counter's
    // current-number and next/prev working after a live create/delete re-render)
    const activeDotId = $modalDotFull.is(':visible')
        ? $modalDotFull.find('.dotShare').attr('data-dotid')
        : null;

    $('.dots-card').eq(curPage).find('.dot-short').each(function () {
        let dataX = $(this).find('.coord-x').text();
        let dataY = $(this).find('.coord-y').text();
        let dataId = $(this).data('id');
        let textDiv = $('.dot-pointer[data-id="' + dataId + '"]')[0];
        if (!textDiv) return;
        let textPoint = new OpenSeadragon.Point(parseFloat(dataX), parseFloat(dataY));
        viewer.addOverlay(textDiv, textPoint);
        $('.dot-pointer[data-id="' + dataId + '"]').show();
        $('.dot-pointer[data-id="' + dataId + '"] .dot-number').show();
        if (activeDotId && String(dataId) === String(activeDotId)) {
            $('.dot-pointer[data-id="' + dataId + '"]').addClass('active')
                .find('.dot-number').addClass('active');
        }

        const tracker = new OpenSeadragon.MouseTracker({
            element: textDiv,
            clickHandler: function () {
                // OSD reports a click on the pin after a pinch that started on it -- ignore it
                if (Date.now() - lastCanvasPinch < 300) {
                    return;
                }
                if ($('.overlay-exhibit-story').length < 1) {
                    openDot(this.element.attributes['data-id'].value);
                }
            }
        });
        mouseTrackers.push(tracker);
    });

    const _imgId = parseInt($showDotsButton.attr('data-image-id')) || $showDotsButton.attr('data-image-id');

    if (!anno) {
        ensureAnnotator(_imgId);
    } else {
        anno.cancelSelected();
        anno.setImageId(_imgId);
        anno.loadAnnotations('/load-annotations/' + _imgId);
        loadWordHighlights(_imgId);
    }
}

function showAnnoToast(msg) {
    const offsetLeft = ($contentWrapper.hasClass('active') || $dotsWrapper.hasClass('active'))
        ? '540px' : '210px';
    $personalAlert.addClass('alert alert-success show-alert')
        .css({ top: '110px', left: offsetLeft })
        .html(msg);
    setTimeout(() => $personalAlert.removeClass('show-alert'), 2500);
}

/**
 * Create the fabric annotation layer for an image if it doesn't exist yet.
 * Shared by the dots panel (showPins) and the AI "explain this region" mode,
 * which needs the layer even when dots are hidden.
 */
function ensureAnnotator(imageId, loadShapes = true) {
    if (anno) return anno;
    const _token = $('meta[name="csrf-token"]').attr('content');

    anno = new FabricAnnotator(viewer, {
        imageId: imageId,
        csrfToken: _token,
        readOnly: true,
    });
    if (loadShapes) anno.loadAnnotations('/load-annotations/' + imageId);

    anno.on('createAnnotation', () => showAnnoToast('<i class="fa fa-check" aria-hidden="true"></i> Annotation created'));
    anno.on('updateAnnotation', () => showAnnoToast('<i class="fa fa-check" aria-hidden="true"></i> Annotation updated'));
    anno.on('deleteAnnotation', () => showAnnoToast('<i class="fa fa-check" aria-hidden="true"></i> Annotation deleted'));
    anno.on('aiRegionSelected', onAiRegionSelected);
    loadWordHighlights(imageId);
    return anno;
}

/**
 * Render OCR word/region highlights for an image (title, main content,
 * watermark_credit, embedded figures, etc.) onto the read-only annotation
 * layer — only while "Show OCR" is on, otherwise clears them. Uses whatever
 * image data is already cached/in-flight for the sidebar so it doesn't
 * trigger an extra request.
 */
function loadWordHighlights(imageId) {
    if (!anno) return;
    if (!ocrHighlightsOn) {
        anno.loadWordRegions([], 0, 0);
        return;
    }
    const cached = window.imageDataCache[imageId];
    if (cached) {
        anno.loadWordRegions(cached.word_regions || [], cached.width, cached.height);
    } else {
        loadImageData(imageId).then(data => {
            if (data && anno) anno.loadWordRegions(data.word_regions || [], data.width, data.height);
        });
    }
}

// OCR boxes need the annotation layer even with dots hidden: create it without
// the admin shapes (loadShapes) unless dots are showing
function showOcrHighlights(imageId, loadShapes) {
    if (!imageId) return;
    ensureAnnotator(imageId, loadShapes);
    if (anno.imageId != imageId) anno.setImageId(imageId);
    loadWordHighlights(imageId);
}

// redraw pins and shapes in place; hidePins() + showPins() would also tear down the
// annotation layer and hide #mode / the drawing toolbar
function refreshPins() {
    viewer.clearOverlays();
    return showPins(curPage());
}

/**
 * Hide all the pins on the map
 */
async function hidePins() {
    mouseTrackers.forEach(t => t.destroy());
    mouseTrackers = [];
    viewer.clearOverlays();
    $('.dot-pointer').hide();
    $openseadragonViewer.attr('data-dots', 'false');
    $modalDotFull.modal('hide');

    if (typeof anno != 'undefined' && anno) {
        anno.destroy();
        anno = '';
        $mode.removeClass('active').addClass('d-none');
        $toolbar.addClass('d-none');
        $('.current-tool').removeClass('active');
        $('.current-tool[data-tool-name="rect"]').addClass('active');
        if ($windowWidth < 600 && $('.overlay-exhibit-story').length < 1) {
            mobileDotModalDeactivator();
        }
    }

    // "Show OCR" is independent of dots: rebuild a shape-less layer for its boxes
    if (ocrHighlightsOn) showOcrHighlights(window.imageIds && window.imageIds[curPage()], false);
}

// ── AJAX lazy-loading helpers ───────────────────────────────────────────────

/**
 * Fetch image sidebar data from API, cache it, render it into placeholders.
 * Returns a Promise that resolves once the data is rendered (or immediately if cached).
 */
function loadImageData(imageId) {
    // callers reading data-image-id attrs pass a string; the renderers do window.imageIds.indexOf(imageId)
    // (strict), which then yields -1 → "Image 0 of N" in the sidebar/dots header
    if (!isNaN(parseInt(imageId))) imageId = parseInt(imageId);
    if (window.imageDataCache[imageId]) {
        // re-render if the sidebar element exists but has no content (race condition protection)
        const $check = $(`#exhibit-sidebar-left .content-wrapper .image-info[data-image-id="${imageId}"]`);
        if ($check.length && !$check.children().length) {
            renderImageData(imageId, window.imageDataCache[imageId]);
        }
        return Promise.resolve(window.imageDataCache[imageId]);
    }
    if (!imageDataFetchCache[imageId]) {
        const exhibitId = window.exhibitConfig.exhibitId;
        const _sp = new URLSearchParams(window.location.search);
        const _sharable = _sp.get('sharable');
        const _key = _sp.get('key');
        let _apiUrl = `/exhibits/${exhibitId}/images/${imageId}/data`;
        if (_sharable && _key) {
            _apiUrl += `?sharable=${encodeURIComponent(_sharable)}&key=${encodeURIComponent(_key)}`;
        }
        imageDataFetchCache[imageId] = fetch(_apiUrl, {
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
        })
            .then(r => { if (!r.ok) throw new Error('image data fetch failed'); return r.json(); })
            .then(data => {
                window.imageDataCache[imageId] = data;
                renderImageData(imageId, data);
                return data;
            })
            .catch(err => {
                // allow retry on next navigation
                delete imageDataFetchCache[imageId];
                delete window.imageDataCache[imageId];
                console.error('Failed to load image data for id ' + imageId + ':', err);
            });
    }
    return imageDataFetchCache[imageId];
}

/** Remove a cached image entry so next navigation re-fetches fresh data. */
function invalidateImageDataCache(imageId) {
    delete window.imageDataCache[imageId];
    delete imageDataFetchCache[imageId];
}

// background-prefetch .dzi manifests + low-res overview tiles for the next 3 pages in navigation direction
// background-prefetch .dzi manifests for the next 2 pages in navigation direction so OSD
// can start tile requests immediately on navigation without a cold manifest round-trip
function prefetchRemainingTileSources(fromIdx, direction) {
    if (!window.pages) return;
    const step = (direction < 0) ? -1 : 1;
    for (let i = 1; i <= 2; i++) {
        const idx = fromIdx + step * i;
        const p = window.pages[idx];
        if (!p || p.type !== 'image' || typeof p.tileSource !== 'string') continue;
        // Skip IIIF info.json URLs — tileSource is built from DB dimensions, no fetch needed
        if (p.imageWidth && p.imageHeight && p.tileSource.endsWith('/info.json')) continue;
        fetch(p.tileSource, { priority: 'low' }).catch(() => {});
    }
}

function renderImageData(imageId, data) {
    renderDesktopSidebar(imageId, data);
    renderMobileSidebar(imageId, data);
    renderDotsCard(imageId, data);
    renderDotPointers(imageId, data);

    // re-init iframes and read-more toggles on new HTML
    loadIframe(`[data-image-id="${imageId}"] .image-content`);
    if (typeof initCkEditorReadMoreToggles === 'function') initCkEditorReadMoreToggles();

    // update voice-note icons if this is the active image
    const activeId = parseInt($('.image-info.active').data('image-id'));
    if (activeId === imageId) {
        const counts = detectImageAndDotVoiceNotesCount();
        handleSidebarImageVoiceNoteIcon(counts.image_voice_count);
        handleSidebarDotVoiceNoteIcon(counts.image_dots_voice_count);
    }
}

function _buildFormatLabel(tileFormat, isExternal) {
    if (isExternal) return 'EXT';
    if (tileFormat === 'tif') return 'PTIF';
    if (tileFormat === 'dzi') return 'DZI';
    return '';
}

function _buildTagsHtml(tags) {
    if (!tags || !tags.length) return '';
    const links = tags.map(t =>
        `<a href="/search?search=${encodeURIComponent(t.name)}" class="btn btn-tdg-blue text-white text-decoration-none m-0 py-0">${t.name.replace(/\b\w/g, c => c.toUpperCase())}</a>`
    ).join('');
    return `<div class="image-tags"><div class="image-tag-items"><hr>Tags: ${links}</div></div>`;
}

function renderDesktopSidebar(imageId, data) {
    const $el = $(`#exhibit-sidebar-left .content-wrapper .image-info[data-image-id="${imageId}"]`);
    if (!$el.length) return;

    const cfg   = window.exhibitConfig;
    const index = window.imageIds.indexOf(imageId);
    const isLoggedIn      = typeof window.logged_user !== 'undefined';
    const isNotBasicUser  = isLoggedIn && window.logged_user_role !== 'user';
    const canEdit         = isNotBasicUser && (cfg.isAdmin || cfg.isCurator || cfg.authorId == cfg.userId);
    const canAdminSearch  = isNotBasicUser && (cfg.isAdmin || cfg.isCurator);

    let html = '<div class="mobile-overlay-image-info"></div><div class="image-info-wrapper">';

    if (cfg.isAdmin || cfg.isCurator) {
        html += `<div><button class="btn btn-secondary mx-auto my-3 add-image-to-es d-none" data-image-id="${imageId}"> Add image to exhibit story</button></div>`;
    }
    if (cfg.hideImageTitle) {
        html += `<div class="image-title"><h5>${data.title}</h5></div>`;
    }

    html += `<div class="image-content ck-content" data-comment-image-id="${imageId}">${data.description}${_buildTagsHtml(data.tags)}</div>`;
    html += `<div class="image-documents" data-image-id="${imageId}"></div>`;

    if (!cfg.hideVoiceNotes) {
        html += `<div class="image-voice-container pr-3 d-none" data-voice-image-id="${imageId}"><div class="image-voice-group d-none" data-voice-image-id="${imageId}"><div class="voice_notes"></div></div></div>`;
    }

    const formatLabel = _buildFormatLabel($el.data('tile-format'), !!$el.data('is-external-iiif'));
    let infoHtml = `<span>Image ${index + 1} of ${cfg.imageCount}</span>`;
    if (cfg.showImageInfo) {
        const fmtSuffix = formatLabel ? ` | ${formatLabel}` : '';
        infoHtml += `<div class="image-size tile-format pt-1"> e${cfg.exhibitId} | i${imageId}${fmtSuffix}</div><div class="image-size">${data.width}x${data.height}px</div>`;
    }

    let voiceBtn = '';
    if (!cfg.hideSocialMetricsDots && !cfg.hideVoiceNotes) {
        voiceBtn = `<button type="button" class="btn btn-tdg-blue text-decoration-none text-white voice-visibility-image-footer image-voice-visibility voice_note_button_blank_class" title="Image Voice Notes" data-voice-image-id="${imageId}" data-dots-voice-count="${data.dots_voice_count}"><i class="fas fa-volume-up"></i> <span class="badge badge-light">${data.voice_notes_count}</span></button>`;
    }

    let shareBtn = '';
    if (cfg.isAdmin || cfg.allowShare) {
        shareBtn = `<a class="btn my-auto btn-tdg-blue exhShare imageShare d-inline ml-1 mr-0" data-id="${imageId}" title="Share Image" style="white-space:nowrap;"><i class="fas fa-share"></i> <img src="/images/iiif-logo.png" alt="IIIF" width="17" height="15" style="vertical-align:-.1em;filter:brightness(0) invert(1);"></a>`;
    }

    let actionBtns = '';
    if (canEdit) {
        actionBtns += `<a class="btn my-auto btn-tdg-blue editImage d-lg-inline button-round mr-0" data-id="${imageId}" title="Edit Image"><i class="fas fa-edit"></i></a>`;
    }
    if (canAdminSearch) {
        actionBtns += `<a href="/search-google/${imageId}" class="btn my-auto mr-0 ml-1 btn-tdg-white d-inline" target="_blank" title="Google Search Image"><i class="fa fa-search-plus" aria-hidden="true"></i></a>`;
    }
    if (cfg.downloadable || cfg.isAdmin || cfg.isCurator) {
        actionBtns += `<a class="btn btn-tdg-blue text-white ml-1 image-download" data-image-id="${imageId}" title="Download Image"><i class="fa fa-download" aria-hidden="true"></i></a>`;
    }

    html += `<div class="image-count d-flex justify-content-between align-items-center"><div>${infoHtml}</div><div class="flex-column"><div class="d-flex align-items-center">${voiceBtn}${shareBtn}</div><div class="d-flex">${actionBtns}</div></div></div>`;
    html += '</div>';

    $el.html(html);
    renderImageDocuments(imageId);
}

function renderMobileSidebar(imageId, data) {
    const $el = $(`.image-info-mobile .content-wrapper .image-info[data-image-id="${imageId}"]`);
    if (!$el.length) return;

    const cfg   = window.exhibitConfig;
    const index = window.imageIds.indexOf(imageId);
    const isLoggedIn      = typeof window.logged_user !== 'undefined';
    const isNotBasicUser  = isLoggedIn && window.logged_user_role !== 'user';
    const canEdit         = isNotBasicUser && (cfg.isAdmin || cfg.isCurator || cfg.authorId == cfg.userId);
    const canAdminSearch  = isNotBasicUser && (cfg.isAdmin || cfg.isCurator);

    // compact mobile state: active image with auto-open on narrow viewport
    const isMobileAutoOpen = $el.hasClass('active') && $windowWidth <= 600 && window.image_text_open;

    let html = '';
    if (cfg.hideImageTitle) {
        html += `<div class="image-title d-none"><h5>${data.title}</h5></div>`;
    }

    const formatLabelMobile = _buildFormatLabel($el.data('tile-format'), !!$el.data('is-external-iiif'));
    let headerInfo = `<span class="mr-2"> Image ${index + 1} of ${cfg.imageCount} </span>`;
    if (cfg.showImageInfo) {
        const fmtPart = formatLabelMobile ? ` | ${formatLabelMobile}` : '';
        headerInfo += `<span>| e${cfg.exhibitId} | i${imageId}${fmtPart} | ${data.width}x${data.height}px</span>`;
    }
    let titleMobile = cfg.hideImageTitle
        ? `<span class="image-title-mobile" style="white-space:nowrap;text-overflow:ellipsis;overflow:hidden;max-width:93%">${data.title.replace(/<[^>]+>/g, '')}</span>`
        : '';

    html += `<div class="image-info-wrapper${isMobileAutoOpen ? ' active' : ''}">`;
    html += `<div class="image-info-header"><div class="d-flex">${headerInfo}</div>${titleMobile}<button class="btn btn-danger border rounded-circle ml-auto text-decoration-none image-info-close" data-dismiss="modal"><i class="fa fa-times" aria-hidden="true"></i></button></div>`;
    html += `<div class="image-content ck-content" data-comment-image-id="${imageId}">${data.description}${_buildTagsHtml(data.tags)}</div>`;
    html += `<div class="image-documents" data-image-id="${imageId}"></div>`;

    if (!cfg.hideVoiceNotes) {
        html += `<span class="container voice-visibility-image-bottom${isMobileAutoOpen ? ' d-none' : ''}"><span class="voice_note_button_blank_class voice_note_button image-voice-visibility mb-2" data-voice-image-id="${imageId}" data-dots-voice-count="${data.dots_voice_count}"><span><i class="fas fa-volume-up"></i></span><span class="badge">${data.voice_notes_count}</span></span><span class="image-shrink-btn mb-2" data-voice-image-id="${imageId}"><span><i class="fas fa-compress-alt"></i></span></span></span>`;
        html += `<div class="image-voice-container pr-3 d-none" data-voice-image-id="${imageId}"><div class="image-voice-group d-none" data-voice-image-id="${imageId}"><div class="voice_notes"></div></div></div>`;
    }

    let actionBtns = `<button class="btn btn-tdg-blue text-white text-decoration-none exh-prev mt-auto button-round disabledOp" data-title-left="Previous image" style="min-width:32px"><i class="fas fa-chevron-left"></i></button>`;
    actionBtns += `<button type="button" class="btn btn-tdg-blue expand-btn image-expand-btn d-inline mt-auto button-round" style="min-width:32px;font-size:1rem!important;" data-id="${imageId}"><i class="fas fa-expand-alt"></i></button>`;
    if (canEdit) {
        const editStyle = isMobileAutoOpen ? ' style="display:none"' : '';
        actionBtns += `<a class="btn btn-tdg-blue editImage d-lg-inline button-round mt-auto" data-id="${imageId}"${editStyle}><i class="fas fa-edit"></i></a>`;
    }
    if (canAdminSearch) {
        actionBtns += `<a href="/search-google/${imageId}" class="btn btn-tdg-blue d-lg-inline button-round mt-auto" target="_blank"><i class="fa fa-search-plus" aria-hidden="true"></i></a>`;
    }
    if (cfg.isAdmin || cfg.allowShare) {
        const shareClass = isMobileAutoOpen ? 'd-none' : 'd-inline';
        actionBtns += `<a class="btn btn-tdg-blue exhShare imageShare ${shareClass} mt-auto button-round" style="min-width:32px;white-space:nowrap;" data-id="${imageId}"><i class="fas fa-share"></i> <img src="/images/iiif-logo.png" alt="IIIF" width="17" height="15" style="vertical-align:-.1em;filter:brightness(0) invert(1);"></a>`;
    }
    const voiceBadge = data.voice_notes_count > 0 ? data.voice_notes_count : '';
    const voiceBadgeClass = data.voice_notes_count <= 0 ? 'd-none' : '';
    actionBtns += `<button type="button" class="btn btn-tdg-blue text-decoration-none text-white pl-1 pr-1 mt-auto voice-visibility-image-footer image-voice-visibility voice_note_button_blank_class" data-voice-image-id="${imageId}"><i class="fas fa-volume-up"></i> <span class="badge badge-light ${voiceBadgeClass}">${voiceBadge}</span></button>`;
    if (cfg.downloadable || cfg.isAdmin || cfg.isCurator) {
        const downloadClass = isMobileAutoOpen ? 'd-none' : 'd-inline';
        actionBtns += `<a class="btn btn-tdg-blue ${downloadClass} button-round mt-auto image-download" data-image-id="${imageId}"><i class="fa fa-download" aria-hidden="true"></i></a>`;
    }
    actionBtns += `<button class="btn btn-tdg-blue text-white text-decoration-none exh-next mt-auto button-round" data-title-right="Next image" style="min-width:32px"><i class="fas fa-chevron-right"></i></button>`;

    html += `<div class="image-count d-flex justify-content-center align-items-center"><div class="d-flex flex-row">${actionBtns}</div></div>`;
    html += '</div>';

    $el.html(html);
    renderImageDocuments(imageId);
}

function renderDotsCard(imageId, data) {
    const $el = $(`.dots-wrapper .dots-card[data-image-id="${imageId}"]`);
    if (!$el.length) return;

    const cfg   = window.exhibitConfig;
    const index = window.imageIds.indexOf(imageId);
    const isLoggedIn  = typeof window.logged_user !== 'undefined';
    const canAddDot   = (isLoggedIn && cfg.allowUserDots) || cfg.isAdmin || cfg.isCurator || data.allow_guest_dots;
    const csrfToken   = $('meta[name="csrf-token"]').attr('content');

    let sortBtn = '';
    if (cfg.isAdmin || cfg.isCurator) {
        sortBtn = `<a href="/admin/images/${imageId}" class="btn btn-tdg-blue dot-sort"><i class="fas fa-map-pin"></i> Sort</a>`;
    }
    let html = `<span></span><h5 class="card-header">Annotations<div class="d-inline-flex float-right">${sortBtn}<span class="comment-count badge badge-info">${data.dots.length}</span></div></h5>`;
    html += `<div class="card-body p-0">`;

    if (canAddDot) {
        // dotcrt share mode tailors the guest "leave your dot" form
        const _share = window.dotShareMode;
        const _closeBtn = _share ? '' : `<button type="button" class="btn btn-danger border rounded-circle text-decoration-none d-md-none dot-create-close" aria-label="Close"><i class="fa fa-times" aria-hidden="true"></i></button>`;
        // share prompt only until the guest's first submit; then revert to the normal placeholder
        const _placeholder = (_share && !window.dotShareSubmitted) ? 'Enter your first name, city, country' : 'Enter Dot Content';
        const _submitClass = _share ? 'btn-success' : 'btn-dark';
        const _cancelBtn = _share ? `<button type="button" class="btn btn-secondary btn-sm my-2 mr-2 dot-create-cancel">Cancel</button>` : '';
        const _copyBtn = _share ? '' : `<button class="btn btn-dark btn-sm my-2 ml-5 copy-img-txt">Copy Image Text</button>`;
        const _submitBtn = `<button data-post="${imageId}" data-identifier="${index}" class="btn ${_submitClass} btn-sm my-2 save-comment">Submit</button>`;
        // share mode: right-align the actions, cancel left of submit (submit closest to the right border)
        const _actions = _share ? `<div class="dot-share-actions d-flex justify-content-end">${_cancelBtn}${_submitBtn}</div>` : `${_submitBtn}${_copyBtn}`;
        html += `<div class="add-comment mb-3">${_closeBtn}<input type="hidden" name="_token" value="${csrfToken}"><div class="comment-input-wrapper"><div class="error-message"></div><div class="progressBar d-none"><div id="new-dot-progress-bar" class="img-upload-msg pb-3"></div></div><textarea id="dot-creating${index}" class="form-control comment autoExpand comment-textarea" placeholder="${_placeholder}" rows="3" data-min-rows="3" required></textarea><div class="pin-button"><i class="fas fa-thumbtack"></i></div></div><input class="coordx" type="hidden" name="coord_x"><input class="coordy" type="hidden" name="coord_y"><input type="checkbox" class="d-none duplicateImgTxt">${_actions}</div>`;
    }

    html += `<div class="comments">`;
    if (cfg.isAdmin || cfg.isCurator) html += '<hr/>';

    if (data.dots.length > 0) {
        data.dots.forEach((dot, i) => {
            const avatarUrl = dot.user.image
                ? `/images/avatars/${dot.user.image}`
                : '/images/local/SVG/avatar.svg';
            const userDotClass = dot.user.is_user_role ? 'user-dot-color' : '';
            let storyBtn = '';
            if (cfg.isAdmin || cfg.isCurator) {
                storyBtn = `<div class="add-story-buttons"><button class="btn btn-secondary mx-auto my-3 add-dot-to-es d-none" data-dot-id="${dot.id}" data-dot-order="${i + 1}" data-img-id="${imageId}"> Add to exhibit story</button></div>`;
            }
            html += `<div class="dot-short approved d-flex flex-column pointer" data-id="${dot.id}">${storyBtn}<div class="dot-meta" data-dot-id="${dot.id}"><div class="dot-avatar" style="background:url('${avatarUrl}')"><div class="dot-number ${userDotClass}">${i + 1}</div></div><div class="dot-created-info"><div class="dot-author">${dot.user.name}</div><div class="dot-author-username">(@${dot.user.username})</div></div><div class="coord-x">${dot.coord_x}</div><div class="coord-y">${dot.coord_y}</div></div><blockquote class="blockquote mt-2"><small class="mb-0 dot-content-sidebar ck-content">${dot.content}</small></blockquote></div>`;
        });
    } else {
        html += `<p class="no-comments">No annotations yet</p>`;
        if (data.video) {
            html += `<button class="btn btn-secondary mx-auto my-3 add-dot-to-es d-none video-image" data-dot-id="${imageId + Math.floor(Math.random()*9999)}" data-img-id="${imageId}"> Add video to exhibit story</button>`;
        }
    }

    html += '</div></div>';
    $el.html(html);

    // if currently in exhibit story create mode, restore the ES-mode UI for this freshly rendered card
    if (exhibit_story_create_mode) {
        $el.find('.add-dot-to-es').each(function () {
            const $btn = $(this);
            const dotId = $btn.data('dot-id');
            const $esRow = $('#dot-' + dotId);

            if ($esRow.length > 0) {
                // already added to the story — restore added state
                $btn.removeClass('btn-secondary d-none').addClass('btn-success added').text('Remove from exhibit story');

                // re-append zoom and autoplay wrappers that were lost on re-render
                const autoPlay = $esRow.find('input[name="autoPlayVoice"]').is(':checked') ? 1 : 0;
                $btn.parent().append(
                    `<div class="zoom-wrapper my-1 mx-1 d-flex flex-wrap" data-id="${dotId}" style="gap:4px;"><button class="btn btn-sm btn-secondary set-zoom-and-position"> SET ZOOM AND POSITION <i class="fa fa-search"></i></button><button class="btn btn-sm btn-info preview-es-position" data-dot-id="${dotId}" title="Preview saved position"><i class="fa fa-crosshairs"></i> Preview</button></div>`,
                    `<div class="d-flex my-3 auto-play-wrapper" data-id="${dotId}"><label class="custom-toggle"><input type="checkbox" name="autoPlayVoice" ${autoPlay ? 'checked' : ''} value="${autoPlay}"><span class="auto-play-voice custom-toggle-slider rounded-circle" data-label-off="No" data-label-on="Yes"></span></label><div class="ml-2">Auto play voice notes</div></div>`
                );
            } else {
                $btn.removeClass('d-none');
            }
        });

        // mobile: hide card-header and add-comment, ensure comments visible
        if ($windowWidth < 600) {
            $el.removeClass('mt-4').find('.comments').removeClass('d-none');
            $el.find('.card-header').addClass('d-none');
            $el.find('.add-comment').addClass('d-none');
        }
    }

    // init ckeditor for dot creation textarea
    if (canAddDot) {
        create_ck_for_create_dot(index);
    }
}

function renderDotPointers(imageId, data) {
    const $el = $(`.dot-image-wrapper[data-image-id="${imageId}"]`);
    if (!$el.length) return;

    let html = '';
    data.dots.forEach((dot, i) => {
        const userClass = dot.user.is_user_role ? 'user-dot-color' : '';
        const badgeClass = dot.total_voices ? '' : 'd-none';
        html += `<div class="dot-pointer" data-id="${dot.id}"><div class="dot-number ${userClass}"><span class="dot-sort-number">${i + 1}</span><span class="badge ${badgeClass}"><i class="fas fa-volume-up"></i></span></div></div>`;
    });
    $el.html(html);
}

// ────────────────────────────────────────────────────────────────────────────

/**
 * Return the current page number
 * @returns The current page number.
 */
function detectImageAndDotVoiceNotesCount() {
    const current_image_id = $('.image-info.active').data('image-id');
    const image_voice_count = parseInt($('.image-voice-visibility[data-voice-image-id="' + current_image_id + '"] .badge').text());
    const image_dots_voice_count = parseInt($('.image-voice-visibility[data-voice-image-id="' + current_image_id + '"]').data('dots-voice-count'));
    return { image_voice_count, image_dots_voice_count };
}

function handleSidebarImageVoiceNoteIcon(status) {
    const $badge = $('.exh-info-button .badge');
    if (!status) { $badge.addClass('d-none'); } else { $badge.removeClass('d-none'); }
}

function handleSidebarDotVoiceNoteIcon(status) {
    const $badge = $('.exh-dot-button .badge');
    if (!status) { $badge.addClass('d-none'); } else { $badge.removeClass('d-none'); }
}

function curPage() {
    return viewer.currentPage();
}

function escapeHtml(str) {
    return $('<div>').text(str == null ? '' : str).html();
}

// ── OCR & AI analyze modal (admin) ──────────────────────────────────────────
// Same queue endpoint + Pusher log as the admin "Analyze Images" page, for the
// one image whose edit-modal Analyze button was clicked. Progress is per pipeline
// step (1-5) since a single image would otherwise jump straight 0% → 100%.
const ANALYZE_TOTAL_STEPS = 5;
let analyzeImageId = null;
let analyzeImageRunning = false;
let analyzeImageChannelBound = false;

function analyzeLogLine(text, cssClass, withSpinner) {
    const $log = $('#analyze-image-log');
    $log.find('.step-spinner').remove();
    const $li = $('<li>').css('list-style', 'none').addClass(cssClass || '').text(text).appendTo($log);
    if (withSpinner) {
        $li.append('<span class="spinner-border step-spinner text-primary ml-2" role="status" style="width:12px;height:12px;border-width:2px;vertical-align:-1px;"></span>');
    }
    $log.scrollTop($log.get(0).scrollHeight);
}

function analyzeSetProgress(step, finished) {
    const done = finished ? ANALYZE_TOTAL_STEPS : Math.max(0, Math.min(step, ANALYZE_TOTAL_STEPS));
    const percentage = Math.round(done * 100 / ANALYZE_TOTAL_STEPS);
    $('#analyze-image-progress').css('width', percentage + '%').text(percentage + '%').toggleClass('bg-success', !!finished);
    if (step === 0) $('#analyze-image-progress').removeClass('bg-danger');
    $('#analyze-image-steps-count').text(done + '/' + ANALYZE_TOTAL_STEPS);
    $('.analyze-image-steps [data-step]').each(function () {
        const s = $(this).data('step');
        $(this).toggleClass('font-weight-bold text-dark', !finished && s === step)
            .toggleClass('text-success', finished ? true : s < step);
    });
}

function analyzeSetRunning(running) {
    analyzeImageRunning = running;
    const $btn = $('#start-analyze-image');
    $btn.prop('disabled', running).toggleClass('disabled', running);
    $btn.find('.spinner-border').toggleClass('d-none', !running);
    $('#analyze-image-force').prop('disabled', running);
}

function bindAnalyzeImageChannel() {
    if (analyzeImageChannelBound || typeof logged_user === 'undefined' || !window.pusher) return;
    analyzeImageChannelBound = true;
    const channel = window.pusher.subscribe('private-analyze-image-' + logged_user.id);
    channel.bind('analyze-image-event', function (data) {
        if (data.image_id !== analyzeImageId) return;
        const line = (data.step ? 'step ' + data.step + ': ' : '') + data.message;
        let cssClass = {done: 'text-success', skipped: 'text-muted', failed: 'text-danger'}[data.state] || '';
        if (data.step === 4) cssClass = 'text-muted';
        const finished = ['done', 'skipped', 'failed'].includes(data.state);
        analyzeLogLine(line, cssClass, !finished && data.message.endsWith('...'));
        if (data.step) analyzeSetProgress(data.step, false);

        if (finished) {
            if (data.state === 'failed') {
                $('#analyze-image-progress').addClass('bg-danger');
            } else {
                analyzeSetProgress(ANALYZE_TOTAL_STEPS, true);
            }
            analyzeSetRunning(false);
            if (data.state === 'done') {
                refreshAnalyzedImage(analyzeImageId);
            }
        }
    });
}

// Pull the fresh analysis into the page without a reload: sidebar (AI summary),
// OCR highlights on the viewer (when "Show OCR" is on), and the edit
// modal's description — the job rewrote it, so saving the stale editor copy
// would wipe the new AI summary.
function refreshAnalyzedImage(imageId) {
    analyzeLogLine('Refreshing image data...', '', true);
    invalidateImageDataCache(imageId);
    const dataReq = loadImageData(imageId).then(data => {
        if (!data) throw new Error('image data fetch failed');
        if (anno && parseInt(anno.imageId) === imageId) loadWordHighlights(imageId);
    });
    const editReq = ($imageEdit.hasClass('show') && parseInt($('#Image_id').val()) === imageId && window.editor_img_desc)
        ? payload('/images/' + imageId + '/edit', null, 'GET').then(response => {
            if (response.image) window.editor_img_desc.setData(response.image.description || '');
        })
        : Promise.resolve();

    Promise.all([dataReq, editReq])
        .then(() => analyzeLogLine('Done — OCR data and AI summary are updated.', 'text-success font-weight-bold'))
        .catch(() => analyzeLogLine('Analysis finished, but refreshing the page data failed — reload to see it.', 'text-warning'));
}

// opened on top of the image edit modal: lift it (and its backdrop) above that one
$(document).on('show.bs.modal', '#modal-analyze-image, #modal-add-document', function () {
    $(this).css('z-index', 1060);
    setTimeout(() => $('.modal-backdrop').last().css('z-index', 1055), 0);
});
// closing a stacked modal strips body.modal-open, which breaks scrolling in the one below
$(document).on('hidden.bs.modal', '#modal-analyze-image, #modal-add-document', function () {
    if ($('.modal.show').length) $('body').addClass('modal-open');
});

$(document).on('click', '.image-analyze', function (e) {
    e.preventDefault();
    const imageId = parseInt($(this).attr('data-image-id'));
    if (!imageId) return;
    // reopening the modal for another image mid-run would mix two logs
    if (!analyzeImageRunning && imageId !== analyzeImageId) {
        analyzeImageId = imageId;
        $('#analyze-image-log').empty();
        analyzeSetProgress(0, false);
    }
    $('#modal-analyze-image .analyze-image-id').text('(image ' + analyzeImageId + ')');
    bindAnalyzeImageChannel();
    $('#modal-analyze-image').modal('show');
});

$(document).on('click', '#start-analyze-image', function () {
    if (analyzeImageRunning || !analyzeImageId) return;
    $('#analyze-image-log').empty();
    analyzeSetProgress(0, false);
    analyzeSetRunning(true);

    const formData = new FormData();
    formData.append('imageIdList', analyzeImageId);
    formData.append('force', $('#analyze-image-force').is(':checked') ? 1 : 0);
    $.ajax({
        method: 'post',
        headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
        data: formData,
        url: '/admin/images/analyze',
        processData: false,
        contentType: false,
        success: function (result) {
            if (result.status == 'false') {
                analyzeLogLine(result.data, 'text-danger');
                analyzeSetRunning(false);
                return;
            }
            analyzeLogLine('Queued image ' + analyzeImageId + ' with ' + result.provider + '...', '', true);
        },
        error: function (jqXHR, textStatus, error) {
            analyzeLogLine('Error: ' + error, 'text-danger');
            analyzeSetRunning(false);
        },
    });
});

// ── Documents ───────────────────────────────────────────────────────────────
// PDFs attached to the exhibit or its images: listed under the image text and
// in the exhibit info, downloadable by everyone who can view the exhibit.
// Admins and curators add them (read into passages the AI quotes) and remove them.

let exhibitDocuments = [];
let exhibitDocumentsCanManage = false;
let addDocumentToken = null;
let addDocumentSourceId = null;
let addDocumentRunning = false;
// queued steps not finished yet: 'pdf' = the read, else an image id
let addDocumentSteps = new Set();
// a check answered after the curator chose another file is ignored
let addDocumentCheck = 0;
let documentChannelBound = false;

function loadExhibitDocuments() {
    return $.getJSON(buildRegionApiUrl(`/exhibits/${window.exhibitConfig.exhibitId}/documents/list`))
        .done(res => {
            exhibitDocuments = res.documents || [];
            exhibitDocumentsCanManage = !!res.can_manage;
            $('.image-documents').each(function () { renderImageDocuments(parseInt($(this).attr('data-image-id'))); });
            renderExhibitDocuments();
        });
}

// remove = {target, title} when this list may detach it (an image's PDF is removed from its image text)
function _documentItemHtml(doc, suffix, remove) {
    const meta = [doc.citation, doc.pages ? doc.pages + ' pages' : ''].filter(Boolean).join(' · ');
    let html = `<div class="mb-1"><a href="${escapeHtml(doc.url)}" target="_blank" rel="noopener"><i class="far fa-file-pdf mr-1"></i>${escapeHtml(doc.title)}</a>${escapeHtml(suffix)}`;
    if (meta) html += ` <small class="text-muted">${escapeHtml(meta)}</small>`;
    if (exhibitDocumentsCanManage) {
        if (doc.status === 'failed') {
            html += ` <span class="badge badge-danger" title="${escapeHtml(doc.error || '')}">not read</span>`;
        } else if (doc.status && doc.status !== 'ingested') {
            html += ' <span class="badge badge-warning">reading…</span>';
        }
        if (remove) {
            html += ` <a href="#" class="document-remove text-danger ml-1" data-source-id="${doc.id}" data-target="${remove.target}" title="${escapeHtml(remove.title)}"><i class="fas fa-times"></i></a>`;
        }
    }
    return html + '</div>';
}

function _addDocumentButtonHtml(target) {
    return `<button type="button" class="btn btn-sm btn-tdg-blue text-white add-document mt-1" data-target="${target}"><i class="fas fa-plus mr-1"></i>Add PDF</button>`;
}

function renderImageDocuments(imageId) {
    const $el = $(`.image-documents[data-image-id="${imageId}"]`);
    if (!$el.length) return;
    const docs = exhibitDocuments.filter(d => d.images.some(i => i.id === imageId));
    if (!docs.length && !exhibitDocumentsCanManage) {
        $el.empty();
        return;
    }
    let html = '<hr><div class="mb-1">Documents:</div>';
    if (docs.length) {
        html += docs.map(d => _documentItemHtml(d, '', {target: imageId, title: 'Remove from this image'})).join('');
    }
    if (exhibitDocumentsCanManage) html += _addDocumentButtonHtml(imageId);
    $el.html(html);
}

function renderExhibitDocuments() {
    const $el = $('#modal-exhibitinfo .exhibit-documents');
    if (!$el.length) return;
    // the exhibit's own first, then each image's, named by the image's position
    const items = [];
    exhibitDocuments.filter(d => d.exhibit).forEach(d => items.push(_documentItemHtml(d, '', {target: 'exhibit', title: 'Remove from the exhibit'})));
    exhibitDocuments.filter(d => d.images.length).forEach(d => {
        items.push(_documentItemHtml(d, ' — ' + d.images.map(i => 'image #' + i.position).join(', '), null));
    });
    if (!items.length && !exhibitDocumentsCanManage) {
        $el.empty();
        return;
    }
    let html = '<hr><div class="mb-1">Documents:</div>';
    // divs, not a list: the exhibit info's ck-content styles every ul
    html += items.join('');
    if (exhibitDocumentsCanManage) html += _addDocumentButtonHtml('exhibit');
    $el.html(html);
}

function addDocumentLog(line, cssClass) {
    const $log = $('#add-document-log').removeClass('d-none');
    $log.append($('<div>').addClass(cssClass || '').text(line));
    $log.scrollTop($log[0].scrollHeight);
}

function addDocumentSetRunning(running) {
    addDocumentRunning = running;
    $('#add-document-start').prop('disabled', running || !addDocumentToken).find('.spinner-border').toggleClass('d-none', !running);
    $('#add-document-file, #add-document-target, #add-document-locate').prop('disabled', running);
}

// locating needs an image: no box for the exhibit as a whole
function addDocumentToggleLocate() {
    const onImage = $('#add-document-target').val() !== 'exhibit';
    $('.add-document-locate-wrap').toggleClass('d-none', !onImage);
    if (!onImage) $('#add-document-locate').prop('checked', false);
}

function bindDocumentChannel() {
    if (documentChannelBound || typeof logged_user === 'undefined' || !window.pusher) return;
    documentChannelBound = true;
    const channel = window.pusher.subscribe('private-reference-ingest-' + logged_user.id);
    channel.bind('reference-ingest-event', function (data) {
        if (data.source_id !== addDocumentSourceId) return;
        const cssClass = {done: 'text-success', skipped: 'text-muted', failed: 'text-danger'}[data.state] || '';
        addDocumentLog(data.message, cssClass);
        if (!['done', 'skipped', 'failed'].includes(data.state)) return;
        // a failed read stops the locating chained after it
        if (data.state === 'failed' && data.image_id === null) addDocumentSteps.clear();
        addDocumentSteps.delete(data.image_id === null ? 'pdf' : data.image_id);
        if (!addDocumentSteps.size) {
            addDocumentSetRunning(false);
            loadExhibitDocuments();
        }
    });
}

$(document).on('click', '.add-document', function (e) {
    e.preventDefault();
    if (addDocumentRunning) {
        $('#modal-add-document').modal('show');
        return;
    }
    const target = String($(this).attr('data-target'));
    const options = [['exhibit', 'The whole exhibit']].concat(window.imageIds.map((id, i) => [String(id), 'Image #' + (i + 1)]));
    $('#add-document-target').html(options.map(([v, label]) => `<option value="${v}">${escapeHtml(label)}</option>`).join('')).val(target);
    $('#add-document-locate').prop('checked', false);
    addDocumentToggleLocate();
    $('#add-document-file').val('');
    $('.add-document-check').empty();
    $('#add-document-log').empty().addClass('d-none');
    addDocumentToken = null;
    addDocumentSetRunning(false);
    bindDocumentChannel();
    $('#modal-add-document').modal('show');
});

// checked as soon as it is chosen: pages, cost, a scan or too long, before anything is spent
$(document).on('change', '#add-document-file', function () {
    const file = this.files && this.files[0];
    const checkNo = ++addDocumentCheck;
    addDocumentToken = null;
    addDocumentSetRunning(false);
    const $check = $('.add-document-check').removeClass('text-danger').text(file ? 'Checking the PDF…' : '');
    if (!file) return;

    const formData = new FormData();
    formData.append('pdf', file);
    $.ajax({
        method: 'post',
        url: `/exhibits/${window.exhibitConfig.exhibitId}/documents/check`,
        headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
        data: formData,
        processData: false,
        contentType: false,
    }).done(res => {
        if (checkNo !== addDocumentCheck) return;
        addDocumentToken = res.token;
        const scanned = res.scanned ? (res.scanned === res.pages ? ', scanned (read by OCR)' : `, ${res.scanned} scanned (read by OCR)`) : '';
        $check.text(res.pages + ' pages' + scanned + ' · ' + (res.known ? 'already read elsewhere, attaching it is free' : 'reading it costs about $' + res.cost_usd.toFixed(2)));
        addDocumentSetRunning(false);
    }).fail(xhr => {
        if (checkNo !== addDocumentCheck) return;
        $check.addClass('text-danger').text(_documentError(xhr));
    });
});

$(document).on('change', '#add-document-target', addDocumentToggleLocate);

$(document).on('click', '#add-document-start', function () {
    if (addDocumentRunning || !addDocumentToken) return;
    addDocumentSetRunning(true);
    $('#add-document-log').empty();
    $.ajax({
        method: 'post',
        url: `/exhibits/${window.exhibitConfig.exhibitId}/documents`,
        headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
        data: {token: addDocumentToken, target: $('#add-document-target').val(), locate: $('#add-document-locate').is(':checked') ? 1 : 0},
    }).done(res => {
        addDocumentToken = null;
        addDocumentSourceId = res.source_id;
        addDocumentSteps = new Set((res.steps || []).map(k => k === null ? 'pdf' : k));
        if (res.queued) {
            const locate = [...addDocumentSteps].some(k => k !== 'pdf');
            const what = addDocumentSteps.has('pdf') ? 'Reading the PDF' + (locate ? ', then locating it on the image' : '') : 'Already read; locating it on the image';
            addDocumentLog(`Uploaded. ${what} (a few minutes for a long one; you can close this)...`);
        } else {
            addDocumentLog('Attached.', 'text-success');
            addDocumentSetRunning(false);
        }
        loadExhibitDocuments();
    }).fail(xhr => {
        addDocumentLog(_documentError(xhr), 'text-danger');
        addDocumentSetRunning(false);
    });
});

$(document).on('click', '.document-remove', function (e) {
    e.preventDefault();
    const sourceId = $(this).attr('data-source-id');
    const target = String($(this).attr('data-target'));
    const where = target === 'exhibit' ? 'the exhibit' : 'image #' + (window.imageIds.indexOf(parseInt(target)) + 1);
    if (!confirm(`Remove this PDF from ${where}? A PDF attached to nothing else is deleted with its passages.`)) return;
    $.ajax({
        method: 'delete',
        url: `/exhibits/${window.exhibitConfig.exhibitId}/documents/${sourceId}`,
        headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
        data: {target: target},
    }).done(() => loadExhibitDocuments())
        .fail(xhr => alert(_documentError(xhr)));
});

function _documentError(xhr) {
    const res = xhr.responseJSON || {};
    const firstError = res.errors ? Object.values(res.errors)[0] : null;
    return res.data || (firstError && firstError[0]) || res.message || 'Something went wrong (' + xhr.status + ').';
}

$(function () {
    if (window.exhibitConfig) loadExhibitDocuments();
});

// "Show OCR" side button: toggles the OCR/AI region boxes, independent of dots
$(document).on('click', '#showOcrAi', function () {
    ocrHighlightsOn = !ocrHighlightsOn;
    $(this).toggleClass('active', ocrHighlightsOn);
    const imageId = window.imageIds && window.imageIds[curPage()];
    if (!imageId) return;
    const dotsShowing = $openseadragonViewer.attr('data-dots') === 'true';
    if (ocrHighlightsOn) {
        showOcrHighlights(imageId, dotsShowing);
    } else if (anno) {
        loadWordHighlights(imageId);
        // a layer created just for the OCR boxes goes away with them
        if (!dotsShowing && !aiRegionMode) {
            anno.destroy();
            anno = '';
        }
    }
});

// ────────────────────────────────────────────────────────────────────────────
// Per-subject AI chat: reuses the sharable/key query params the same way
// loadImageData() does, so the private-exhibit share-link flow keeps working.

let currentChatRegionId = null;

function buildRegionApiUrl(path) {
    const _sp = new URLSearchParams(window.location.search);
    const _sharable = _sp.get('sharable');
    const _key = _sp.get('key');
    if (_sharable && _key) {
        path += (path.includes('?') ? '&' : '?') + `sharable=${encodeURIComponent(_sharable)}&key=${encodeURIComponent(_key)}`;
    }
    return path;
}

// Minimal, dependency-free markdown -> HTML for AI chat replies (headers,
// bold/italic, inline/fenced code, lists, links, paragraphs). Escapes the
// raw text first so nothing the model returns can inject real markup —
// only the fixed tags this function emits ever reach the DOM.
function renderMarkdownLite(raw) {
    if (!raw) return '';

    let text = escapeHtml(raw);

    const codeBlocks = [];
    text = text.replace(/```[a-zA-Z0-9]*\n?([\s\S]*?)```/g, (m, code) => {
        codeBlocks.push(code.replace(/\n$/, ''));
        return ` CB${codeBlocks.length - 1} `;
    });

    function inline(str) {
        str = str.replace(/`([^`]+)`/g, '<code>$1</code>');
        str = str.replace(/\*\*([^*]+)\*\*|__([^_]+)__/g, (m, a, b) => `<strong>${a || b}</strong>`);
        str = str.replace(/\*([^*]+)\*|_([^_]+)_/g, (m, a, b) => `<em>${a || b}</em>`);
        str = str.replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g, '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>');
        return str;
    }

    let html = '';
    let listType = null;
    let listItems = [];
    let paragraph = [];

    const flushList = () => {
        if (listItems.length) {
            html += `<${listType}>${listItems.map(li => `<li>${li}</li>`).join('')}</${listType}>`;
            listItems = [];
            listType = null;
        }
    };
    const flushParagraph = () => {
        if (paragraph.length) {
            html += `<p>${paragraph.join('<br>')}</p>`;
            paragraph = [];
        }
    };

    text.split('\n').forEach(line => {
        const codeMatch = line.match(/^ CB(\d+) $/);
        const headerMatch = line.match(/^(#{1,6})\s+(.*)$/);
        const ulMatch = line.match(/^\s*[-*]\s+(.*)$/);
        const olMatch = line.match(/^\s*\d+\.\s+(.*)$/);

        if (codeMatch) {
            flushParagraph(); flushList();
            html += `<pre class="region-chat-code-block"><code>${codeBlocks[Number(codeMatch[1])]}</code></pre>`;
        } else if (headerMatch) {
            flushParagraph(); flushList();
            const level = headerMatch[1].length;
            html += `<h${level}>${inline(headerMatch[2])}</h${level}>`;
        } else if (ulMatch) {
            flushParagraph();
            if (listType !== 'ul') flushList();
            listType = 'ul';
            listItems.push(inline(ulMatch[1]));
        } else if (olMatch) {
            flushParagraph();
            if (listType !== 'ol') flushList();
            listType = 'ol';
            listItems.push(inline(olMatch[1]));
        } else if (line.trim() === '') {
            flushParagraph(); flushList();
        } else {
            flushList();
            paragraph.push(inline(line));
        }
    });
    flushParagraph();
    flushList();

    return html;
}

function scrollChatToBottom() {
    const $wrap = $('#modal-region-chat .region-chat-messages');
    $wrap.scrollTop($wrap[0].scrollHeight);
}

function appendChatMessage(role, text) {
    const $wrap = $('#modal-region-chat .region-chat-messages');
    const $msg = $(`<div class="region-chat-msg region-chat-msg-${role}"><div class="region-chat-bubble"></div></div>`);
    const $bubble = $msg.find('.region-chat-bubble');
    if (role === 'assistant') {
        $bubble.html(renderMarkdownLite(text));
    } else {
        $bubble.text(text);
    }
    $wrap.append($msg);
    scrollChatToBottom();
    return $msg;
}

function openRegionChatModal(regionId, roleLabel, subjectText) {
    currentChatRegionId = regionId;

    const preview = subjectText.length > 140 ? subjectText.slice(0, 140) + '…' : subjectText;
    $('#modal-region-chat .region-chat-subject').text(`${roleLabel}: ${preview}`);
    $('#modal-region-chat .region-chat-messages').empty();
    $('#modal-region-chat').modal('show');

    const exhibitId = window.exhibitConfig.exhibitId;
    const imageId = window.imageIds[curPage()];

    fetch(buildRegionApiUrl(`/exhibits/${exhibitId}/images/${imageId}/regions/${regionId}/chat`), {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
        .then(r => r.ok ? r.json() : { messages: [] })
        .then(data => {
            (data.messages || []).forEach(m => appendChatMessage(m.role, m.content));
        })
        .catch(err => console.error('Failed to load region chat history:', err));
}

$(document).on('click', '.region-chat-ask-btn', function (e) {
    e.stopPropagation();
    const $block = $(this).closest('.ocr-ai-block');
    const roleLabel = $block.find('strong').first().text().replace(/:\s*$/, '');
    const subjectText = $block.find('p').first().text();
    openRegionChatModal($(this).data('region-id'), roleLabel, subjectText);
});

$('#modal-region-chat').on('hidden.bs.modal', function () {
    currentChatRegionId = null;
});

$(document).on('submit', '.region-chat-form', function (e) {
    e.preventDefault();

    const $form = $(this);
    const $input = $form.find('.region-chat-input');
    const question = $input.val().trim();
    if (!question || !currentChatRegionId) return;

    const regionId = currentChatRegionId;
    appendChatMessage('user', question);
    $input.val('').prop('disabled', true);
    $form.find('.region-chat-send').prop('disabled', true);

    const $bubble = appendChatMessage('assistant', '').find('.region-chat-bubble').addClass('region-chat-typing');

    const exhibitId = window.exhibitConfig.exhibitId;
    const imageId = window.imageIds[curPage()];
    const token = $('meta[name="csrf-token"]').attr('content');

    fetch(buildRegionApiUrl(`/exhibits/${exhibitId}/images/${imageId}/regions/${regionId}/chat/stream`), {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': token,
            'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ question })
    }).then(response => {
        if (!response.ok || !response.body) throw new Error('chat stream failed');
        $bubble.removeClass('region-chat-typing');

        const reader = response.body.getReader();
        const decoder = new TextDecoder();
        let rawText = '';

        function pump() {
            return reader.read().then(({ done, value }) => {
                if (done) return;
                rawText += decoder.decode(value, { stream: true });
                $bubble.html(renderMarkdownLite(rawText));
                scrollChatToBottom();
                return pump();
            });
        }
        return pump();
    }).catch(err => {
        $bubble.removeClass('region-chat-typing').text('Sorry, something went wrong answering that question.');
        console.error('Region chat stream error:', err);
    }).finally(() => {
        $input.prop('disabled', false).focus();
        $form.find('.region-chat-send').prop('disabled', false);
    });
});

// ── AI "explain this region" ────────────────────────────────────────────────
// #askAiRegion arms a one-shot rectangle tool on the fabric layer; the selected
// bbox (image fractions) goes to POST /exhibits/{e}/images/{i}/ai-explain and
// the answer renders in #ai-region-card next to the rectangle.
const $askAiRegionBtn = $('#askAiRegion');
const $aiRegionCard = $('#ai-region-card');
let aiRegionMode = false;
let aiRegionRestore = null;   // annotator state to put back when leaving the mode
let aiRegionCurrent = null;   // { region, anchor, drawn? } of the rectangle on screen

// the conversation about the rectangle currently on screen
let aiRegionThread = [];      // [{ role: 'user'|'ai', text, meta }]
let aiRegionParentId = null;  // id of the last answer -> parent_id of the next question
let aiRegionTurns = 0;        // answers so far; the opening explain counts as turn 1
let aiRegionPending = false;  // a request is in flight
let aiRegionRestoreToken = 0; // guards against a slow restore landing on a newer selection
let aiRegionRequestToken = 0; // same for an explain/ask answer
let aiRegionDotId = null;     // dot this thread was saved as; Save as DOT then updates it
let aiRegionDragged = false;  // moved by hand: stop re-anchoring it to the rectangle
let aiRegionViewMoved = false; // visitor panned/zoomed since the card opened: don't move the view for it
let aiRegionFresh = false;     // next opening explain must not reuse a cached root (it carries old follow-ups)

function aiRegionMaxTurns() {
    return parseInt($aiRegionCard.data('max-turns')) || 5;
}

function resetAiRegionThread() {
    aiRegionThread = [];
    aiRegionParentId = null;
    aiRegionTurns = 0;
    aiRegionPending = false;
    aiRegionFresh = false;
    aiRegionDotId = null;
    aiRegionRequestToken++;
}

function enterAiRegionMode() {
    const imageId = window.imageIds && window.imageIds[curPage()];
    if (!imageId) return;
    closeAiRegionCard();
    ensureAnnotator(imageId, $showDotsButton.hasClass('active'));
    if (anno.imageId != imageId) anno.setImageId(imageId);
    aiRegionRestore = { readOnly: anno.readOnly, tool: anno.tool };
    anno.readOnly = false;
    anno.setSelectionOnly(true);
    anno.setDrawingTool('ai-region');
    aiRegionMode = true;
    $askAiRegionBtn.addClass('active');
    $openseadragonViewer.addClass('ai-region-select');
    showAnnoToast('<i class="fas fa-vector-square" aria-hidden="true"></i> Drag a rectangle over the part you want explained');
}

function exitAiRegionMode() {
    if (!aiRegionMode) return;
    aiRegionMode = false;
    $askAiRegionBtn.removeClass('active');
    $openseadragonViewer.removeClass('ai-region-select');
    if (anno) {
        anno.setSelectionOnly(false);
        anno.setDrawingTool((aiRegionRestore && aiRegionRestore.tool) || 'rect');
        // back to whatever the admin toolbar had (drawing on only while #mode is active)
        anno.readOnly = aiRegionRestore ? aiRegionRestore.readOnly : !$mode.hasClass('active');
    }
    aiRegionRestore = null;
}

function onAiRegionSelected(payload) {
    aiRegionCurrent = payload;
    exitAiRegionMode();
    openAiRegionCard(payload);
}

const AI_REGION_GAP = 12;     // card <-> rectangle
const AI_REGION_MARGIN = 8;   // card <-> viewer edge

// card beside the rectangle (right, left, below, above - first that fits); when none
// fits, zoom/pan the viewer so the rectangle sits clear of the card. anchor is viewer px.
function positionAiRegionCard(anchor, allowPan = true) {
    if (!anchor || aiRegionDragged || $aiRegionCard.hasClass('d-none')) return;
    allowPan = allowPan && !aiRegionViewMoved;
    // the view may have moved since the anchor was taken: use where the rectangle is now heading
    const live = aiRegionCurrent && aiRegionScreenAnchor(aiRegionCurrent.region, false);
    if (live) anchor = live;
    const G = AI_REGION_GAP, M = AI_REGION_MARGIN;
    const $vc = $(viewer.container);   // anchor coords are relative to this, not #openseadragon_viewer
    const vw = $vc.width();
    const vh = $vc.height();
    const R = { l: anchor.topLeft.x, t: anchor.topLeft.y, r: anchor.bottomRight.x, b: anchor.bottomRight.y };

    // phones: fixed bottom sheet (CSS) - cap it below the rectangle, else move the rectangle above it
    if ($windowWidth < 600) {
        const vcTop = viewer.container.getBoundingClientRect().top;
        const minH = Math.round(window.innerHeight * 0.35);
        const fitH = Math.round(window.innerHeight - (vcTop + R.b + M));
        $aiRegionCard.css('max-height', Math.max(minH, Math.min(fitH, Math.round(window.innerHeight * 0.7))) + 'px');
        if (allowPan && fitH < minH) panAiRegionInto(R, { l: M, t: M, r: vw - M, b: window.innerHeight - minH - vcTop - M }, true);
        return;
    }

    $aiRegionCard.css('max-height', '');   // left over from the phone layout after a resize
    const cw = $aiRegionCard.outerWidth() || 340;
    const ch = $aiRegionCard.outerHeight() || 240;
    const clampX = x => Math.min(Math.max(M, x), Math.max(M, vw - cw - M));
    const clampY = y => Math.min(Math.max(M, y), Math.max(M, vh - ch - M));
    // clamped too: a re-render can come after the rectangle was panned off screen
    const slots = [
        { ok: R.r + G + cw <= vw - M, x: clampX(R.r + G), y: clampY(R.t) },
        { ok: R.l - G - cw >= M, x: clampX(R.l - G - cw), y: clampY(R.t) },
        { ok: R.b + G + ch <= vh - M, x: clampX(R.l), y: clampY(R.b + G) },
        { ok: R.t - G - ch >= M, x: clampX(R.l), y: clampY(R.t - G - ch) },
    ];
    let slot = slots.find(s => s.ok);
    if (!slot && allowPan) {
        // no room: move the rectangle into the area left of a right-docked card
        const moved = panAiRegionInto(R, { l: M, t: M, r: vw - M - cw - G, b: vh - M }, true);
        if (moved) return positionAiRegionCard(moved, false);
    }
    if (!slot) {
        // still no room (pan/zoom limits): the spot hiding the least of the rectangle
        const hidden = s => Math.max(0, Math.min(R.r, s.x + cw) - Math.max(R.l, s.x)) * Math.max(0, Math.min(R.b, s.y + ch) - Math.max(R.t, s.y));
        slot = slots.concat([[M, M], [vw - M - cw, M], [M, vh - M - ch], [vw - M - cw, vh - M - ch]].map(([x, y]) => ({ x, y })))
            .map(s => ({ x: clampX(s.x), y: clampY(s.y) }))
            .reduce((best, s) => (hidden(s) < hidden(best) ? s : best));
    }
    const vo = $vc.offset();
    $aiRegionCard.css({ right: 'auto', bottom: 'auto' }).offset({ left: vo.left + slot.x, top: vo.top + slot.y });
}

// screen bbox (viewer px) of a region in image fractions; current=false gives where it is heading
function aiRegionScreenAnchor(region, current) {
    const ti = viewer.world.getItemAt(0);
    if (!ti || !region) return null;
    const s = ti.getContentSize();
    const pts = [[0, 0], [1, 0], [0, 1], [1, 1]].map(([a, b]) => viewer.viewport.pixelFromPoint(
        ti.imageToViewportCoordinates(new OpenSeadragon.Point((region.left + a * region.width) * s.x, (region.top + b * region.height) * s.y)), current));
    const xs = pts.map(p => p.x), ys = pts.map(p => p.y);
    return { topLeft: new OpenSeadragon.Point(Math.min(...xs), Math.min(...ys)), bottomRight: new OpenSeadragon.Point(Math.max(...xs), Math.max(...ys)) };
}

// zoom out (never in) and pan so rectangle R (viewer px) heads for the centre of area F,
// within the viewer's pan/zoom limits; returns where the rectangle will land
function panAiRegionInto(R, F, reposition) {
    const cur = aiRegionCurrent;
    const fw = F.r - F.l, fh = F.b - F.t;
    if (!cur || fw <= 0 || fh <= 0) return null;
    const vp = viewer.viewport;
    const f = Math.min(1, fw / Math.max(1, R.r - R.l), fh / Math.max(1, R.b - R.t));
    const c = new OpenSeadragon.Point((R.l + R.r) / 2, (R.t + R.b) / 2);
    const to = new OpenSeadragon.Point((F.l + F.r) / 2, (F.t + F.b) / 2);
    if (f < 1) vp.zoomBy(f, vp.viewerElementToViewportCoordinates(c));
    vp.panBy(vp.deltaPointsFromPixels(c.minus(to)));
    vp.applyConstraints();
    const target = aiRegionScreenAnchor(cur.region, false);
    if (!target) return null;
    cur.anchor = target;
    if (Math.abs(target.topLeft.x - R.l) + Math.abs(target.topLeft.y - R.t) + Math.abs(target.bottomRight.x - R.r) < 1) return target;   // limits allow no move
    viewer.addOnceHandler('animation-finish', function () {
        if (cur !== aiRegionCurrent) return;
        cur.anchor = aiRegionScreenAnchor(cur.region, true) || cur.anchor;
        if (reposition) positionAiRegionCard(cur.anchor, false);
    });
    return target;
}

function countWords(str) {
    return ((str || '').trim().match(/\S+/g) || []).length;
}

// live "n / 20 words" counter; over the limit the submit button is disabled
function updateAiRegionWordCount() {
    const $q = $aiRegionCard.find('.ai-region-question');
    const max = parseInt($q.data('max-words')) || 20;
    const n = countWords($q.val());
    $aiRegionCard.find('.ai-region-words').text(`${n} / ${max} words`).toggleClass('over', n > max);
    // never re-enable mid-request: this runs on every keystroke and the form now
    // stays open while an answer is in flight
    $aiRegionCard.find('.ai-region-submit').prop('disabled', aiRegionPending || n > max);
    return n <= max;
}

// the question box after the opening explain: prompt and counter change, and at
// the cap it is replaced by the limit note
function refreshAiRegionForm() {
    const max = aiRegionMaxTurns();
    const $form = $aiRegionCard.find('.ai-region-form, .ai-region-form-actions');
    const $limit = $aiRegionCard.find('.ai-region-limit');
    const $q = $aiRegionCard.find('.ai-region-question');

    if (aiRegionTurns >= max) {
        $form.addClass('d-none');
        $limit.text(`You've used all ${max} questions about this area. Use New Region to start again.`).removeClass('d-none');
        return;
    }

    $limit.addClass('d-none').empty();
    $form.removeClass('d-none');
    $aiRegionCard.find('.ai-region-submit-label').text(aiRegionTurns ? 'Ask' : 'Explain');
    $aiRegionCard.find('.ai-region-turns')
        .text(aiRegionTurns ? `${aiRegionTurns} of ${max} questions used` : '')
        .toggleClass('d-none', !aiRegionTurns);
    if (aiRegionTurns) {
        $q.attr('placeholder', 'Ask a follow-up about this area');
    }
}

function openAiRegionCard(payload) {
    resetAiRegionThread();
    aiRegionDragged = false;
    aiRegionViewMoved = false;
    // a save form left from the last card (saved, or closed mid-form) must not reappear
    closeAiRegionSaveForm();
    $aiRegionCard.find('.ai-region-result').addClass('d-none');
    $aiRegionCard.find('.ai-region-thread').empty();
    $aiRegionCard.find('.ai-region-restored').addClass('d-none').empty();
    $aiRegionCard.find('.ai-region-footer').addClass('d-none');
    $aiRegionCard.find('.ai-region-error').addClass('d-none').empty();
    $aiRegionCard.find('.ai-region-question').val('').removeAttr('placeholder').prop('disabled', false);
    refreshAiRegionForm();
    updateAiRegionWordCount();
    $aiRegionCard.find('.ai-region-submit').prop('disabled', false).find('.spinner').addClass('d-none');
    $aiRegionCard.removeClass('d-none');
    positionAiRegionCard(payload.anchor);
    if ($windowWidth >= 600) $aiRegionCard.find('.ai-region-question').trigger('focus');
    restoreAiRegionThread(payload.region);
}

function closeAiRegionCard() {
    $aiRegionCard.addClass('d-none');
    aiRegionCurrent = null;
    // must be reset here: otherwise a stale thread could be saved as an
    // annotation against a freshly drawn rectangle
    resetAiRegionThread();
    aiRegionRestoreToken++;
    if (anno) anno.clearAiRegions();
}

// same URL shape as the explain POST, so shared-link viewers aren't 403'd
function aiRegionUrl(path, params) {
    const imageId = window.imageIds && window.imageIds[curPage()];
    const sp = new URLSearchParams(params || {});
    const _sp = new URLSearchParams(window.location.search);
    if (_sp.get('sharable') && _sp.get('key')) {
        sp.set('sharable', _sp.get('sharable'));
        sp.set('key', _sp.get('key'));
    }
    const qs = sp.toString();
    return `/exhibits/${window.exhibitConfig.exhibitId}/images/${imageId}/ai-explain${path}` + (qs ? `?${qs}` : '');
}

// re-selecting an area already explored continues that conversation instead of
// starting over; a miss just leaves the blank card alone
function restoreAiRegionThread(region) {
    const token = ++aiRegionRestoreToken;

    fetch(aiRegionUrl('/thread', region), {
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    })
        .then(r => (r.ok ? r.json() : null))
        .then(data => {
            if (!data || token !== aiRegionRestoreToken || !aiRegionCurrent) return;
            // the visitor already asked before the restore came back - don't overwrite their new thread
            if (aiRegionPending || aiRegionThread.length) return;
            if (!data.thread || !data.thread.length) return;

            data.thread.forEach(function (t) {
                if (t.question) aiRegionThread.push({ role: 'user', text: t.question });
                aiRegionThread.push({ role: 'ai', text: (t.answer && t.answer.interpretation) || t.answer_text || '', meta: t });
            });
            const last = data.thread[data.thread.length - 1];
            aiRegionParentId = last.id;
            aiRegionTurns = last.turn;
            aiRegionDotId = data.dot_id || null;

            // outline the stored rectangle, not the rough one just drawn, so the
            // highlight matches the area the AI actually looked at
            if (anno && data.region) {
                const anchor = anno.showAiRegion(data.region);
                // keep the drawn rectangle so "Start fresh" asks about it, not the stored one
                if (anchor) aiRegionCurrent = { region: data.region, anchor: anchor, drawn: aiRegionCurrent.region };
            }
            if (!data.exact) {
                const msg = {
                    inside: 'This spot is inside an area you already asked about — continuing that conversation. ',
                    over: 'Your selection covers an area you already asked about — continuing that conversation. ',
                }[data.match] || 'Continuing your earlier questions about this area. ';
                $aiRegionCard.find('.ai-region-restored')
                    .html(msg + '<a href="#" class="ai-region-fresh">Start fresh</a>')
                    .removeClass('d-none');
            }
            renderAiRegionThread('top');
        })
        .catch(() => {});
}

// Renders the whole conversation. Unlike the old one-shot answer this leaves the
// question box in place, so the visitor can keep asking about the same rectangle.
function renderAiRegionThread(scrollTo) {
    let html = '';
    aiRegionThread.forEach(function (m) {
        if (m.role === 'user') {
            html += `<div class="ai-region-msg ai-region-msg-user"><div class="ai-region-bubble">${escapeHtml(m.text)}</div></div>`;
            return;
        }
        const t = m.meta || {};
        const a = t.answer || {};
        // plain text on purpose (the prompt forbids markdown); only citations and places become links
        let bubble = `<p class="ai-region-interp">${aiRegionInlineLinksHtml(m.text || 'No answer.', a, new Set())}</p>`;
        const conf = (a.confidence !== null && a.confidence !== undefined) ? ` · confidence ${Math.round(a.confidence * 100)}%` : '';
        bubble += aiRegionSourcesHtml(a, t.more_info);
        if (t.links_loading) bubble += '<div class="ai-region-sources ai-region-links-loading">Looking for sources online…</div>';
        const date = aiRegionDate(t.created_at);
        bubble += `<div class="ai-region-meta">AI-generated${conf} · ${escapeHtml(t.model || '')}${t.cached ? ' · cached' : ''}${date ? ' · ' + escapeHtml(date) : ''}</div>`;
        html += `<div class="ai-region-msg ai-region-msg-ai"><div class="ai-region-bubble">${bubble}</div></div>`;
    });

    const keptScroll = $aiRegionCard.find('.ai-region-thread').scrollTop();
    const $thread = $aiRegionCard.find('.ai-region-thread').html(html);
    $aiRegionCard.find('.ai-region-result').removeClass('d-none');
    $aiRegionCard.find('.ai-region-footer').toggleClass('d-none', !aiRegionThread.length);
    $aiRegionCard.find('.ai-region-save-dot').text(aiRegionCanUpdateDot() ? 'Update DOT' : 'Save as DOT');
    refreshAiRegionForm();
    positionAiRegionCard(aiRegionCurrent && aiRegionCurrent.anchor);
    // a restored conversation reads from the start; a new answer from its first line; a just-sent question at the end
    if (!$thread.length) return;
    const $answer = $thread.find('.ai-region-msg-ai').last();
    if (scrollTo === 'keep') $thread.scrollTop(keptScroll);
    else if (scrollTo === 'top') $thread.scrollTop(0);
    else if (scrollTo === 'answer' && $answer.length) $thread.scrollTop($thread.scrollTop() + $answer.offset().top - $thread.offset().top);
    else $thread.scrollTop($thread[0].scrollHeight);
}

// a new answer's "For more information" pages, searched live after it renders (restored answers are not searched)
function loadAiRegionLinks(meta) {
    fetch(aiRegionUrl(`/${meta.id}/links`), {
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    })
        .then(r => (r.ok ? r.json() : null))
        .then(res => { if (res && Array.isArray(res.more_info)) meta.more_info = res.more_info; })
        .catch(() => {})
        .finally(() => {
            meta.links_loading = false;
            // the card moved on (closed, new region) - nothing to redraw
            if (!aiRegionThread.some(m => m.meta === meta)) return;
            // the save form is open: its dot text reads meta.more_info at save time; Back redraws the thread
            if ($aiRegionCard.find('.ai-region-save').length) return;
            renderAiRegionThread('keep');
        });
}

// http(s) urls only; anything else stays plain text
const aiRegionLink = (url, label) => (/^https?:\/\//.test(url || '')
    ? `<a href="${escapeHtml(url)}" target="_blank" rel="noopener">${label}</a>`
    : label);

// "8 Oct 2026"; empty for an unparseable or missing date
function aiRegionDate(iso) {
    const d = iso ? new Date(iso) : new Date();
    return isNaN(d) ? '' : d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
}

// one entry per reference source (web page or ingested PDF) the answer's context drew on
function aiRegionMoreInfoLinks(moreInfo) {
    return (Array.isArray(moreInfo) ? moreInfo : []).map(function (s) {
        // CC BY requires the attribution to travel with the text
        const lic = s.license ? ` <span class="ai-region-license">(${escapeHtml(s.license.replace(/-/g, ' '))})</span>` : '';
        return aiRegionLink(s.url, escapeHtml(s.title || s.url || '')) + lic;
    });
}

// reference sources and identified places the server attached to an answer
function aiRegionSourcesHtml(a, moreInfo) {
    let html = '';

    const links = aiRegionMoreInfoLinks(moreInfo);
    if (links.length) {
        html += '<div class="ai-region-sources"><span class="ai-region-label">For more information see</span><br>' + links.join('<br>') + '</div>';
    }

    const places = Array.isArray(a.places) ? a.places : [];
    if (places.length) {
        html += '<div class="ai-region-places"><span class="ai-region-label">Places</span>'
            + places.map(p => aiRegionLink(p.wikipedia, escapeHtml(p.name))).join(' · ') + '</div>';
    }

    return html;
}

// the conversation as plain-text Q/A blocks, each carrying its answer's meta (sources/places)
function aiRegionTranscriptBlocks() {
    const blocks = [];
    aiRegionThread.forEach(function (m) {
        if (m.role === 'user') {
            blocks.push({ text: `Q: ${m.text}`, meta: null });
            return;
        }
        const prev = blocks.length ? blocks[blocks.length - 1] : null;
        if (prev && !prev.meta && prev.text.indexOf('Q: ') === 0) {
            prev.text += `\nA: ${m.text}`;
            prev.meta = m.meta || {};
        } else {
            blocks.push({ text: m.text, meta: m.meta || {} });
        }
    });
    return blocks;
}

// escaped text with [tag] citations linked to their source and the first mention of each place linked
function aiRegionInlineLinksHtml(text, a, linked) {
    const tags = new Map((Array.isArray(a.sources) ? a.sources : []).filter(s => s.tag).map(s => [s.tag, s.url]));
    const places = (Array.isArray(a.places) ? a.places : []).filter(p => p.name && /^https?:\/\//.test(p.wikipedia || ''));

    const citation = function (inner) {
        if (tags.has(inner)) return '[' + aiRegionLink(tags.get(inner), escapeHtml(inner)) + ']';
        // shared-prefix form: [Van Duzer 2020, Legend 5.5, Legend 5.6]
        const parts = inner.split(', ');
        for (let k = 1; k < parts.length; k++) {
            const prefix = parts.slice(0, k).join(', ');
            const locs = parts.slice(k);
            if (!locs.some(l => tags.has(`${prefix}, ${l}`))) continue;
            return '[' + escapeHtml(prefix) + ', ' + locs.map(l => (tags.has(`${prefix}, ${l}`)
                ? aiRegionLink(tags.get(`${prefix}, ${l}`), escapeHtml(l))
                : escapeHtml(l))).join(', ') + ']';
        }
        return escapeHtml(`[${inner}]`);
    };

    // match on raw text pieces, never on built html, so a name can't hit inside an earlier link
    const plain = function (seg) {
        let pieces = [{ text: seg }];
        places.forEach(function (p) {
            if (linked.has(p.name)) return;
            const re = new RegExp(`(^|[^\\p{L}\\p{N}])(${p.name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})(?![\\p{L}\\p{N}])`, 'u');
            const i = pieces.findIndex(x => !x.url && re.test(x.text));
            if (i < 0) return;
            const m = pieces[i].text.match(re);
            const at = m.index + m[1].length;
            const t = pieces[i].text;
            pieces.splice(i, 1, { text: t.slice(0, at) }, { text: m[2], url: p.wikipedia }, { text: t.slice(at + m[2].length) });
            linked.add(p.name);
        });
        return pieces.map(x => (x.url ? aiRegionLink(x.url, escapeHtml(x.text)) : escapeHtml(x.text))).join('');
    };

    let html = '', last = 0;
    for (const m of text.matchAll(/\[([^\[\]]+)\]/g)) {
        html += plain(text.slice(last, m.index)) + citation(m[1]);
        last = m.index + m[0].length;
    }
    return html + plain(text.slice(last));
}

// the edited blocks as dot HTML with inline links, then the AI label
function aiRegionDotHtml() {
    const blocks = aiRegionTranscriptBlocks();
    const models = [];
    const confidences = [];   // per kept answer, in thread order
    const moreInfo = new Map();   // url/title -> entry, across all blocks
    let html = '';
    $aiRegionCard.find('.ai-region-dot-text').each(function () {
        const text = ($(this).val() || '').trim();
        if (!text) return;
        const block = blocks[$(this).data('idx')] || {};
        const answer = (block.meta && block.meta.answer) || {};
        const model = block.meta && block.meta.model;
        // a thread can span models (provider fallback), so name each one once
        if (model && models.indexOf(model) < 0) models.push(model);
        if (answer.confidence !== null && answer.confidence !== undefined && isFinite(answer.confidence)) confidences.push(Math.round(answer.confidence * 100) + '%');
        ((block.meta && block.meta.more_info) || []).forEach(s => moreInfo.set(s.url || s.title, s));
        const linked = new Set();   // each place is linked once per block
        // <p> per blank-line paragraph, <br> per line (purifier 'dot' allows p/br)
        html += text.split(/\n{2,}/)
            .map(b => '<p>' + aiRegionInlineLinksHtml(b, answer, linked).replace(/\n/g, '<br>') + '</p>')
            .join('');
    });
    if (!html) return '';
    const links = aiRegionMoreInfoLinks([...moreInfo.values()]);
    if (links.length) html += '<p>For more information see:<br>' + links.join('<br>') + '</p>';
    // same provenance line the chat bubbles carry, so it travels with the saved text; dated the day it is saved
    const stamp = 'AI-generated' + (confidences.length ? ' \u00b7 confidence ' + confidences.join(', ') : '')
        + (models.length ? ' \u00b7 ' + models.join(', ') : '') + ' \u00b7 ' + aiRegionDate();
    return html + '<p><em>' + escapeHtml(stamp) + '</em></p>';
}

// "Save as DOT": each Q/A becomes an editable textarea; confirming
// creates a dot just inside the rectangle and (admin/curator) keeps the rectangle as a shape
function showAiRegionSaveForm() {
    // dots.content is TEXT; cap each block so 5 turns stay well inside it
    const blocks = aiRegionTranscriptBlocks().map((b, i) => `<div class="ai-region-dot-block">`
        + `<textarea class="form-control ai-region-dot-text" rows="4" maxlength="2000" data-idx="${i}">${escapeHtml(b.text)}</textarea>`
        + `</div>`).join('');
    const html = `<div class="ai-region-dot-blocks">${blocks}</div>`
        + `<div class="ai-region-dot-note small">Citations become links; the “For more information” links and a dated “AI-generated” label naming the model and confidence are added.</div>`
        + `<div class="ai-region-error text-danger small d-none"></div>`
        + `<div class="ai-region-actions">`
        + `<button type="button" class="btn btn-sm btn-light ai-region-save-back">Back</button>`
        + `<button type="button" class="btn btn-sm btn-tdg-blue ai-region-save-confirm"><span class="spinner spinner-border spinner-border-sm d-none" role="status" aria-hidden="true"></span> ${aiRegionCanUpdateDot() ? 'Update DOT' : 'Save as DOT'}</button>`
        + `</div>`;
    $aiRegionCard.find('.ai-region-form, .ai-region-form-actions').addClass('d-none');
    $aiRegionCard.find('.ai-region-limit').addClass('d-none');
    $aiRegionCard.find('.ai-region-footer').addClass('d-none');
    // laid over the thread rather than replacing it, so Back keeps the thread and its banner
    closeAiRegionSaveForm();
    $aiRegionCard.find('.ai-region-result').addClass('ai-region-saving').removeClass('d-none')
        .append(`<div class="ai-region-save">${html}</div>`);
    positionAiRegionCard(aiRegionCurrent && aiRegionCurrent.anchor);
    $aiRegionCard.find('.ai-region-dot-text').first().trigger('focus');
}

function closeAiRegionSaveForm() {
    $aiRegionCard.find('.ai-region-result').removeClass('ai-region-saving').find('.ai-region-save').remove();
}

// put the thread back after the save form
function restoreAiRegionResultPanel() {
    closeAiRegionSaveForm();
    renderAiRegionThread();
}

// OSD viewport coords (what dots store) just inside the rectangle's top-left corner
const AI_REGION_DOT_INSET_PX = 17;   // half the 30px pin plus its 2px border

function aiRegionDotViewportPoint() {
    const tiledImage = anno && anno.viewer && anno.viewer.world.getItemAt(0);
    if (!tiledImage || !aiRegionCurrent) return null;
    const size = tiledImage.getContentSize();
    const r = aiRegionCurrent.region;
    const pt = (x, y) => tiledImage.imageToViewportCoordinates(new OpenSeadragon.Point(x * size.x, y * size.y));
    const topLeft = pt(r.left, r.top);
    const bottomRight = pt(r.left + r.width, r.top + r.height);
    // the pin is 30px centred on its point - inset it inside the corner, clamped to the centre for small selections
    const inset = anno.viewer.viewport.deltaPointsFromPixelsNoRotate(new OpenSeadragon.Point(AI_REGION_DOT_INSET_PX, AI_REGION_DOT_INSET_PX));
    return new OpenSeadragon.Point(
        Math.min(topLeft.x + inset.x, (topLeft.x + bottomRight.x) / 2),
        Math.min(topLeft.y + inset.y, (topLeft.y + bottomRight.y) / 2)
    );
}

// only admins/curators may edit someone else's dot, and only they link threads to dots
function aiRegionCanUpdateDot() {
    return !!aiRegionDotId && !!(window.exhibitConfig.isAdmin || window.exhibitConfig.isCurator);
}

function aiRegionRootId() {
    const first = aiRegionThread.find(m => m.role === 'ai' && m.meta);
    return first ? (first.meta.root_id || first.meta.id) : null;
}

// remember which dot this thread became, so the next save updates it
function linkAiRegionDot(dotId) {
    const rootId = aiRegionRootId();
    if (!rootId || !(window.exhibitConfig.isAdmin || window.exhibitConfig.isCurator)) return Promise.resolve();
    return payload(aiRegionUrl(`/${rootId}/dot`), { dot_id: dotId }, 'POST').catch(() => {});
}

// rewrite the saved dot in place, same DOM/cache sync as the dot edit modal
function updateAiRegionDot(dotId, dotHtml, imageId) {
    return payload('/dots/' + dotId, { dot_content: dotHtml }, 'PUT').then(function (response) {
        if (response.status == 404) return false;   // deleted meanwhile: caller saves a new one
        $('.dot-short[data-id="' + dotId + '"] .blockquote small').html(response.new_content);
        const cache = window.imageDataCache[parseInt(imageId)];
        const d = cache && Array.isArray(cache.dots) ? cache.dots.find(x => x.id == dotId) : null;
        if (d) d.content = response.new_content;
        loadIframe('.dot-short[data-id="' + dotId + '"] .blockquote small');
        return true;
    });
}

function saveAiRegionAsAnnotation() {
    const dotHtml = aiRegionDotHtml();
    const $err = $aiRegionCard.find('.ai-region-result .ai-region-error').addClass('d-none').empty();
    const $btn = $aiRegionCard.find('.ai-region-save-confirm');
    const imageId = window.imageIds && window.imageIds[curPage()];
    const dotPoint = aiRegionDotViewportPoint();
    if (!dotHtml) { $err.text('Write something to save.').removeClass('d-none'); return; }
    if (!dotPoint || !imageId) { $err.text('Could not place the annotation on the image.').removeClass('d-none'); return; }
    $btn.prop('disabled', true).find('.spinner').removeClass('d-none');

    if (aiRegionCanUpdateDot()) {
        updateAiRegionDot(aiRegionDotId, dotHtml, imageId).then(function (updated) {
            if (!updated) { aiRegionDotId = null; return saveAiRegionAsAnnotation(); }
            showAnnoToast('<i class="fa fa-check" aria-hidden="true"></i> Dot updated');
            closeAiRegionCard();
        }).catch(function (e) {
            $err.text((e && e.responseJSON && e.responseJSON.message) || 'Could not update the dot.').removeClass('d-none');
            $btn.prop('disabled', false).find('.spinner').addClass('d-none');
        });
        return;
    }

    const coordx = dotPoint.x, coordy = dotPoint.y;
    payload('/save-dot', {
        dot_content: dotHtml,
        imageId: imageId,
        coordx: coordx,
        coordy: coordy,
        exhibitId: window.exhibitConfig.exhibitId,
        _token: $('meta[name="csrf-token"]').attr('content'),
    }, 'POST').then(async function (response) {
        if (!$.isEmptyObject(response.error)) {
            throw new Error(Array.isArray(response.error) ? response.error.join(' ') : String(response.error));
        }
        // only admins/curators may persist shapes (/save-annotorious is gated admin_curator).
        // Must complete before appendCreatedDot(): showPins() reloads the shape layer from
        // the server, which would wipe the un-persisted rectangle off the canvas.
        let rectSaved = null;
        if ((window.exhibitConfig.isAdmin || window.exhibitConfig.isCurator) && anno) {
            rectSaved = await anno.persistAiRegion();
        }
        await linkAiRegionDot(response.id);
        appendCreatedDot(response, imageId, coordx, coordy);
        showAnnoToast('<i class="fa fa-check" aria-hidden="true"></i> Annotation saved' + (rectSaved === false ? ' (rectangle could not be saved)' : ''));
        closeAiRegionCard();
    }).catch(function (e) {
        $err.text((e && e.message) || 'Could not save the annotation.').removeClass('d-none');
        $btn.prop('disabled', false).find('.spinner').addClass('d-none');
    });
}

function submitAiRegion() {
    // the form now stays open after an answer, so a second Enter while one is in
    // flight would fork the thread into two turn-N siblings
    if (!aiRegionCurrent || aiRegionPending) return;
    if (aiRegionTurns >= aiRegionMaxTurns()) return;
    const $q = $aiRegionCard.find('.ai-region-question');
    const question = ($q.val() || '').trim();
    const $btn = $aiRegionCard.find('.ai-region-submit');
    const $err = $aiRegionCard.find('.ai-region-form .ai-region-error').addClass('d-none').empty();
    if (!updateAiRegionWordCount()) {
        $err.text(`Keep your question to ${$q.data('max-words') || 20} words.`).removeClass('d-none');
        return;
    }
    // a follow-up needs a question; only the opening explain may be empty
    if (aiRegionTurns > 0 && !question) {
        $err.text('Type a question to ask about this area.').removeClass('d-none');
        return;
    }

    aiRegionPending = true;
    const token = ++aiRegionRequestToken;
    $btn.prop('disabled', true).find('.spinner').removeClass('d-none');
    $q.prop('disabled', true).val('');
    updateAiRegionWordCount();

    // show the question straight away so the thread reads as a conversation
    if (question) {
        aiRegionThread.push({ role: 'user', text: question });
        renderAiRegionThread();
    }

    const body = aiRegionParentId
        ? { parent_id: aiRegionParentId, question: question || null }
        : { ...aiRegionCurrent.region, question: question || null, fresh: aiRegionFresh };

    fetch(aiRegionUrl('', {}), {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
            'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify(body),
    })
        .then(async r => {
            const data = await r.json().catch(() => ({}));
            if (!r.ok) {
                if (data.code === 'turn_limit') {
                    if (token === aiRegionRequestToken) aiRegionTurns = data.limit;
                    const err = new Error(data.message);
                    err.limitReached = true;
                    throw err;
                }
                const msg = r.status === 429
                    ? 'You have reached the AI limit for now — please try again in a minute.'
                    : (data.message || 'Something went wrong. Please try again.');
                throw new Error(msg);
            }
            return data;
        })
        .then(data => {
            if (token !== aiRegionRequestToken) return;   // card moved on to another selection
            aiRegionPending = false;
            $q.prop('disabled', false);
            $btn.find('.spinner').addClass('d-none');
            aiRegionThread.push({
                role: 'ai',
                text: (data.answer && data.answer.interpretation) || data.answer_text || '',
                meta: data,
            });
            aiRegionParentId = data.id;
            aiRegionTurns = data.turn;
            aiRegionFresh = false;
            if (data.links_pending) data.links_loading = true;
            renderAiRegionThread('answer');
            updateAiRegionWordCount();
            if (aiRegionTurns < aiRegionMaxTurns() && $windowWidth >= 600) $q.trigger('focus');
            if (data.links_pending) loadAiRegionLinks(data);
        })
        .catch(e => {
            if (token !== aiRegionRequestToken) return;
            aiRegionPending = false;
            // the box was cleared on submit - put the question back to resend
            $q.prop('disabled', false).val(question);
            $btn.find('.spinner').addClass('d-none');
            // the question is in the thread but got no answer - drop it so a retry doesn't show it twice
            if (question && aiRegionThread.length && aiRegionThread[aiRegionThread.length - 1].role === 'user') {
                aiRegionThread.pop();
                renderAiRegionThread();
            }
            if (e.limitReached) {
                refreshAiRegionForm();
                return;
            }
            $err.text(e.message).removeClass('d-none');
            updateAiRegionWordCount();
        });
}

// empty card for a new thread; useDrawn swaps a restored rectangle back to the one drawn
function startFreshAiRegionThread(useDrawn) {
    if (!aiRegionCurrent || aiRegionPending) return;
    resetAiRegionThread();
    aiRegionRestoreToken++;   // a restore still in flight must not land on the fresh card
    aiRegionFresh = true;
    closeAiRegionSaveForm();
    if (useDrawn && aiRegionCurrent.drawn && anno) {
        const drawn = aiRegionCurrent.drawn;
        aiRegionCurrent = { region: drawn, anchor: anno.showAiRegion(drawn) || aiRegionCurrent.anchor };
    }
    $aiRegionCard.find('.ai-region-result').addClass('d-none');
    $aiRegionCard.find('.ai-region-thread').empty();
    $aiRegionCard.find('.ai-region-restored').addClass('d-none').empty();
    $aiRegionCard.find('.ai-region-footer').addClass('d-none');
    $aiRegionCard.find('.ai-region-error').addClass('d-none').empty();
    $aiRegionCard.find('.ai-region-question').val('').removeAttr('placeholder').prop('disabled', false);
    refreshAiRegionForm();
    updateAiRegionWordCount();
    positionAiRegionCard(aiRegionCurrent && aiRegionCurrent.anchor);
    if ($windowWidth >= 600) $aiRegionCard.find('.ai-region-question').trigger('focus');
}

// hiding dots hides #askAiRegion (CSS), so drop the tool and card with it
if ($showDotsButton.length) {
    new MutationObserver(function () {
        if ($showDotsButton.hasClass('active')) return;
        exitAiRegionMode();
        if (!$aiRegionCard.hasClass('d-none')) closeAiRegionCard();
        else if (anno) anno.clearAiRegions();
    }).observe($showDotsButton[0], { attributes: true, attributeFilter: ['class'] });
}

$(document).on('click', '#askAiRegion', function () {
    if (aiRegionMode) {
        exitAiRegionMode();
        if (anno) anno.clearAiRegions();
    } else {
        enterAiRegionMode();
    }
});
$(document).on('click', '.ai-region-submit', submitAiRegion);
$(document).on('click', '.ai-region-cancel, .ai-region-close', closeAiRegionCard);
// a new conversation about the rectangle already on screen; no redraw, no restore
$(document).on('click', '.ai-region-again', function () {
    startFreshAiRegionThread(false);
});
$(document).on('keydown', '.ai-region-question', function (e) {
    if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); submitAiRegion(); }
});
$(document).on('input', '.ai-region-question', updateAiRegionWordCount);
$(document).on('click', '.ai-region-save-dot', showAiRegionSaveForm);
$(document).on('click', '.ai-region-save-back', function () {
    // re-show the conversation without re-fetching
    restoreAiRegionResultPanel();
});
// a restored thread only roughly matches the rectangle just drawn - let the
// visitor drop it and ask about their own selection instead
$(document).on('click', '.ai-region-fresh', function (e) {
    e.preventDefault();
    startFreshAiRegionThread(true);
});
$(document).on('click', '.ai-region-save-confirm', saveAiRegionAsAnnotation);

// open modals (dot panel, backdrop-less) trap focus via document focusin - keep the card typeable
$aiRegionCard.on('focusin', function (e) { e.stopPropagation(); });

// drag the card by its header (desktop; phones get the bottom sheet), kept inside the viewer
$aiRegionCard.on('pointerdown', '.ai-region-head', function (e) {
    if ($windowWidth < 600 || e.button !== 0 || $(e.target).closest('.ai-region-close').length) return;
    e.preventDefault();
    const $vc = $(viewer.container);
    const vo = $vc.offset();
    const co = $aiRegionCard.offset();
    const start = { x: e.clientX, y: e.clientY, left: co.left - vo.left, top: co.top - vo.top };
    const head = this;
    head.setPointerCapture(e.pointerId);
    const move = function (ev) {
        const maxLeft = $vc.width() - $aiRegionCard.outerWidth();
        const maxTop = $vc.height() - $aiRegionCard.outerHeight();
        aiRegionDragged = true;
        // viewer-relative, like positionAiRegionCard
        $aiRegionCard.offset({
            left: vo.left + Math.min(Math.max(0, start.left + ev.clientX - start.x), Math.max(0, maxLeft)),
            top: vo.top + Math.min(Math.max(0, start.top + ev.clientY - start.y), Math.max(0, maxTop)),
        });
    };
    const end = function () {
        head.removeEventListener('pointermove', move);
        head.removeEventListener('pointerup', end);
        head.removeEventListener('pointercancel', end);
    };
    head.addEventListener('pointermove', move);
    head.addEventListener('pointerup', end);
    head.addEventListener('pointercancel', end);
});

$(document).on('click', '.copy-img-txt', function () {
    $(this).siblings('.duplicateImgTxt').prop('checked', true);

    let ck_id = $(this).siblings('.save-comment').attr('data-identifier');
    let ck_instance = 'editor_crt_dot_' + ck_id;

    let img_id = $(this).siblings('.save-comment').attr('data-post');
    let $content = $('.image-content[data-comment-image-id="' + img_id + '"]').clone();
    $content.find('.image-tags').remove();

    editors[ck_instance].setData($content.html());
});


// Save Dot
/* The below  code is saving the dot data to the database. */
// Append a just-created dot to the dots panel + a pointer on the image, the same
// way the dot form does (the server render on refresh produces identical markup).
function appendCreatedDot(response, imageId, coordx, coordy) {
    let lastNumber = $(".dots-card[data-image-id='" + imageId + "'] .comments .dot-short").length;
    let dotNumber = 1;
    if (lastNumber) {
        dotNumber = parseInt(lastNumber) + 1;
    }

    // regular users and guests get user-dot-color (matches the api re-render on refresh)
    const userDotClass = (window.exhibitConfig.isAdmin || window.exhibitConfig.isCurator) ? '' : 'user-dot-color';

    let _htmlnew = '<div class="dot-short approved d-flex flex-column" data-id="' + response.id + '">\
                        <button data-dot-id="' + response.id + '" data-dot-order="' + dotNumber + '" data-img-id="' + imageId + '" class="btn btn-secondary mx-auto my-3 add-dot-to-es d-none">Add to exhibit story</button>\
                        <div class="dot-meta" data-dot-id="' + response.id + '">\
                        <div class="dot-avatar" style="background: url(' + response.avatar + ')">\
                        <div class="dot-number ' + userDotClass + '">' + (dotNumber) + '</div>\
                </div>\
                    <div class="dot-created-info">\
                        <div class="dot-author">' + (response.author_name || (typeof logged_user !== 'undefined' ? logged_user.name : 'Guest')) + '</div>\
                        <div class="dot-author-username">(@' + (response.author_username || (typeof logged_user !== 'undefined' ? logged_user.username : 'guest')) + ')</div>\
                        <div class="dot-created">' + response.created + '</div>\
                    </div>\
                    <div class="coord-x">' + coordx + '</div>\
                    <div class="coord-y">' + coordy + '</div>\
                </div>\
                    <blockquote class="blockquote mt-2" class="dot">\
                        <small class="mb-0">' + response.content + '</small>\
                    </blockquote>\
                </div>';
    // match renderDotPointers markup (.dot-sort-number + badge) so renumbering
    // and .dot-sort-number readers work on a just-created pin
    let _dotPointer = '<div class="dot-pointer" data-id="' + response.id + '">\
                                                <div class="dot-number added-dot ' + userDotClass + '"><span class="dot-sort-number">' + (dotNumber) + '</span><span class="badge d-none"><i class="fas fa-volume-up"></i></span></div>\
                                            </div>';
    $('.dot-image-wrapper[data-image-id=' + imageId + ']').append(_dotPointer);
    $(".dots-card[data-image-id='" + imageId + "'] .comments").append(_htmlnew);
    $(".dots-card[data-image-id='" + imageId + "'] .comment").val('');
    $(".dots-card[data-image-id='" + imageId + "'] .coordx").val('');
    $(".dots-card[data-image-id='" + imageId + "'] .coordy").val('');
    $(".dots-card[data-image-id='" + imageId + "'] .comment-count").text($('.dots-card[data-image-id="' + imageId + '"] .dot-short').length);
    $(".dots-card[data-image-id='" + imageId + "'] .no-comments").hide();
    // cache predates the new dot; clear it so showPins doesn't overwrite the just-appended dot-pointer
    invalidateImageDataCache(parseInt(imageId));
    showPins(curPage());
    loadIframe('.dot-short[data-id="' + response.id + '"] .blockquote small');
}

$(document).on('click', '.save-comment', function () {
    const domEditableElement = document.querySelector('.ck-editor__editable');
    let ck_id = $(this).attr('data-identifier');
    let ck_instance = 'editor_crt_dot_' + ck_id;

    let _content = editors[ck_instance].getData();
    let _image = $(this).data('post');
    // .closest('.add-comment') not .parent(): in share mode Submit is nested in .dot-share-actions
    let _coordx = $(this).closest('.add-comment').find('input[name="coord_x"]').val();
    let _coordy = $(this).closest('.add-comment').find('input[name="coord_y"]').val();
    let duplicate = $(this).closest('.add-comment').find('.duplicateImgTxt').is(':checked');

    let vm = $(this);
    vm.text('Saving...').addClass('disabled');
    // Run Ajax

    let data = {
        dot_content: _content,
        imageId: _image,
        coordx: _coordx,
        coordy: _coordy,
        exhibitId: exhibit_id,
        duplicateImgTxt: duplicate,
        _token: $('meta[name="csrf-token"]').attr('content')
    };

    payload("/save-dot", data, "POST").then(function (response) {
        if ($.isEmptyObject(response.error)) {
            appendCreatedDot(response, _image, _coordx, _coordy);
            if ($('.newDot').length > 0) {
                $('.newDot').remove();
            }
            $('.pin-button').removeClass('active');
            $('.error-message').removeClass('active');
            $(".card[data-image-id='" + _image + "'] .comment-input-wrapper").removeClass('error');
            $('.error-message').html('');
            $openseadragonViewer.removeClass('custom-pointer');
            // dotcrt share mode: reveal existing pins now the guest has left their dot
            $('body').removeClass('dot-share-hiding');
            // after the first share submit, revert the prompt to the normal placeholder.
            // the visible placeholder is rendered by ckeditor (not the hidden textarea), so update
            // the live editor's root; also set the textarea attr for any editor recreated later.
            if (window.dotShareMode) {
                window.dotShareSubmitted = true;
                $(".dots-card[data-image-id='" + _image + "'] .comment-textarea").attr('placeholder', 'Enter Dot Content');
                try {
                    const _ed = editors[ck_instance];
                    if (_ed && _ed.editing) _ed.editing.view.document.getRoot().placeholder = 'Enter Dot Content';
                } catch (e) { console.error(e); }
            }
            editors[ck_instance].setData('');

            $('.personal-alert').removeAttr('style').addClass('alert alert-success show-alert').html(response.message);

            setTimeout(function () {
                $personalAlert.removeClass('show-alert');
            }, 2500)

            setTimeout(function () {
                $('.personal-alert').removeClass('alert alert-success show-alert').removeAttr('style').html('');
            }, 3000)


            if ($windowWidth <= 600) {
                $dotsWrapper.addClass('d-none');
                $exhDotCreateMobile.removeClass('active');
                $exhInfoButton.css('opacity', '1').removeAttr('disabled');
                $exhThumbsButton.css('opacity', '1').removeAttr('disabled');
                $exhHideButtons.css('opacity', '1').removeAttr('disabled');
                $exhInfo.css('opacity', '1').removeAttr('disabled');
                $exhDziRotateRight.css({'opacity': '1', 'pointer-events': 'all'}).removeAttr('disabled');
                $exhDziReset.css({'opacity': '1', 'pointer-events': 'all'}).removeAttr('disabled');
                $printBuy.css({'opacity': '1', 'pointer-events': 'all'}).removeAttr('disabled');
                $blankButton.addClass('d-none');
                $('.add-comment').addClass('d-none');
                $navButton.removeClass('d-none');
            }

        } else {
            $('.error-message').addClass('active');
            let errMsg = response.error;
            let errString = '';
            let errNewString = '';
            $('.error-message').html('');
            for (let i = 0; i < errMsg.length; i++) {

                errString = errString + errMsg[i] + '<br>'
            }
            if (errString.indexOf('coordx') > 0) {
                $(".card[data-image-id='" + _image + "'] .comment-input-wrapper").addClass('error');
                $(".card[data-image-id='" + _image + "'] .pin-button").addClass('error');
                errNewString = errString.replace('coordx field', 'pin');
                $('.error-message').append(errNewString);
            } else {
                $('.error-message').append(errString);
            }
        }

        // note: on success showPins already ran above (after invalidating the cache);
        // don't call it again here (avoids a double render, and skips it on error)
        vm.text('Submit').removeClass('disabled');
        $('.duplicateImgTxt').prop('checked', false);
    }).catch(function (result) {
        // reset the button so it doesn't stay stuck on "Saving..."
        vm.text('Submit').removeClass('disabled');
    });
});

// simulate click on dot
function triggerMouseTrackerClick(element) {
    const tracker = mouseTrackers.find(t => t.element === element);
    if (tracker && tracker.clickHandler) {
        tracker.clickHandler.call({element: element});
    }
}

// make all short alerts show in alerts wrapper and adjust for mobile

$shortAlerts.on("click", "div.short-alert", function () {
    // // console.log($(this));
    $(this).removeClass('show-alert');
    setTimeout(function () {
        $(this).remove()
    }, 500)
});

//remove pulse on new dots

$(document).on("click", ".dot-pointer .dot-number", function () {
    if ($(this).hasClass('blob')) {
        $(this).removeClass('blob');
    }
});

$(document).on("click", ".dot-pointer", function () {
    if ($('.overlay-exhibit-story').length < 1 && !exhibit_story_create_mode) {
        $(this).addClass('active')
    }
});


// Hide Exhibit main control buttons
$(document).on('click', '#exh-hide-buttons', function () {
    const icon = $(this).find("i")
    if (icon.hasClass('fa-eye-slash')) {
        $exhSideButton.attr('style', 'display: none !important')
        icon.removeClass('fa-eye-slash')
        icon.addClass('fa-eye')
        $(this).attr('data-title-right', 'Show buttons')
    } else {
        $exhSideButton.removeAttr('style')
        icon.removeClass('fa-eye')
        icon.addClass('fa-eye-slash')
        $(this).attr('data-title-right', 'Hide buttons')
    }
})

$(document).on('click', '.exh-info-button', function () {

    //load youtube iframe
    loadIframe('.image-content');

    $('.image-content').scrollTop(0);


    // open/close sidebar (image info) for desktop and mobile
    if (!$contentWrapper.hasClass('active')) {
        $(this).addClass('active');

        if ($videoContainer.is(':visible')) {
            $videoContainer.addClass('vid-shrink');
        }

        $(this).parents('#openseadragon_viewer').find('.openseadragon-container').addClass('shrink');
        stopIframeVid('.dots-card.mt-4.active .blockquote');

        $contentWrapper.addClass('active');
        $('.exhibit-sidebar>.active:not(.content-wrapper)').removeClass('active');

        if ($showDotsButton.hasClass('active') && $('.overlay-exhibit-story').length < 1) {
            $showDotsButton.removeClass('active');
            $dotsWrapper.removeClass('active');
            hidePins();
        }

        if ($windowWidth <= 600) {
            $exhDotCreateMobile.css('opacity', '.5').attr('disabled', true);
            mobileImageModalActivator();
        }
        if ($windowWidth > 600) {
            autoplay_image_first_voice_note();
        }
    } else {
        window.image_text_open = false;
        $(this).removeClass('active');
        stopIframeVid('.image-info.active .image-content');
        $('.image-voice-container').find('audio').each(function () {
            this.pause();
        });

        if ($('.image-voice-visibility').hasClass('active')) {
            $('.voice-visibility-image-footer.active').click();
        }
        if ($windowWidth <= 600) {
            $exhDotCreateMobile.css('opacity', '1').removeAttr('disabled');
            mobileImageModalDeactivator()
        }
        if ($showDotsButton.hasClass('active')) {
            if ($windowWidth > 600) {
                $dotsWrapper.addClass('active');
            }
        } else {
            if ($videoContainer.is(':visible')) {
                $videoContainer.removeClass('vid-shrink');
            }
            $(this).parents('#openseadragon_viewer').find('.openseadragon-container').removeClass('shrink');
            $('.exhibit-sidebar>.active:not(.content-wrapper)').removeClass('active');
        }

        $contentWrapper.removeClass('active');
    }
})

// Activate the image modal for mobile
function mobileImageModalActivator() {
    $viewerWrapper.css('padding-top', 'unset');
    $openseadragonViewer.css({ 'transition': 'none', 'height': '40%' });
    $exhInfoButton.addClass('active');
    $exhibitAttributionWrapper.removeClass('active');
    $exhibitAttributionWrapper.css('display', 'none');
    $buttonsWrapper.addClass('d-none');
    $('.editImage').css('display', 'none');
    $('.imageShare').removeClass('d-inline');
    $('.imageShare').addClass('d-none');
    $('.image-download').removeClass('d-inline');
    $('.image-download').addClass('d-none');
    $('.button-round').css('margin', '5px 5px');
    $('.image-expand-btn').addClass('d-inline');
    $('.voice-visibility-image-bottom').addClass('d-none');
    $('.voice-visibility-image-footer').removeClass('d-none');
    $exhDotCreateMobile.addClass('d-none');
}

// Deactivate the image modal for mobile
function mobileImageModalDeactivator() {

    if (exhibit_story_create_mode) {
        return;
    }
    $viewerWrapper.css('padding-top', '64px');
    $openseadragonViewer.css({ 'transition': '', 'height': '100%' });
    $exhibitAttributionWrapper.addClass('active');
    $exhibitAttributionWrapper.css('display', '');
    $buttonsWrapper.removeClass('d-none');
    $('.editImage').css('display', '');
    $('.imageShare').removeClass('d-none');
    $('.imageShare').addClass('d-inline');
    $('.image-download').removeClass('d-none');
    $('.image-download').addClass('d-inline');
    $('.button-round').css('margin', '5px 2px');
    $('.voice-visibility-image-bottom').removeClass('d-none');
    $('.image-expand-btn').addClass('d-none');
    $('.image-expand-btn').removeClass('d-inline');
    $('.voice-visibility-image-footer').addClass('d-none');
}


// Expand the image modal on mobile
$(document).on('click', '.image-expand-btn', function () {
    mobileImageModalDeactivator()
    $('.image-info-mobile .content-wrapper.active').css('height', 'var(--doc-height)');
    $('.image-info-mobile .content-wrapper.active').css('top', '0');
    $(".image-content[data-comment-image-id='" + $(this).attr('data-id') + "']").removeAttr('style');
    $(".social-comment-container[data-comment-image-id='" + $(this).attr('data-comment-image-id') + "']").removeAttr('style')
})

// Shrink the image modal on mobile
$(document).on('click', '.image-shrink-btn', function () {
    mobileImageModalActivator()
    $('.image-info-mobile .content-wrapper.active').css('height', '60%');
    $('.image-info-mobile .content-wrapper.active').css('top', '40%');
    $(".image-content[data-comment-image-id='" + $(this).attr('data-voice-image-id') + "']").css({'cssText': 'height: 0 !important;min-height:0;'})
    $(".social-comment-container[data-comment-image-id='" + $(this).attr('data-comment-image-id') + "']").css({'cssText': 'height: 100%'})
})

// Revert some settings after user clicking on image close button on a mobile device
$(document).on('click', '.image-info-close', function () {
    if (!$dotsWrapper.hasClass('d-none')) {
        $('.cancel-story-list-button').click();
    }
    $('.image-info-mobile .content-wrapper.active').css('height', '');
    $('.image-info-mobile .content-wrapper.active').css('top', '');
})


// active dot set location
$(document).on('click', '.pin-button', function () {
    $(this).removeClass('error');
    $(this).toggleClass('active');
    $openseadragonViewer.toggleClass('custom-pointer');
})


// create dots for mobile
$(document).on('click', '.exh-dot-create-mobile', function () {

    if ($(this).hasClass('active')) {
        $(this).removeClass('active');
        $('.pin-button').removeClass('active');
        $('.dot-guide-mobile').removeClass('d-flex');
        $exhInfoButton.css('opacity', '1').removeAttr('disabled');
        $exhThumbsButton.css('opacity', '1').removeAttr('disabled');
        $exhHideButtons.css('opacity', '1').removeAttr('disabled');
        $exhInfo.css('opacity', '1').removeAttr('disabled');
        $exhDziRotateRight.css({'opacity': '1', 'pointer-events': 'all'}).removeAttr('disabled');
        $exhDziReset.css({'opacity': '1', 'pointer-events': 'all'}).removeAttr('disabled');
        $printBuy.css({'opacity': '1', 'pointer-events': 'all'}).removeAttr('disabled');
        $blankButton.addClass('d-none');
        $navButton.removeClass('d-none');

        if ($('.newDot').length > 0) {
            $('.newDot').remove();
        }

    } else {
        $(this).addClass('active');
        $('.pin-button').addClass('active');
        $('.dot-guide-mobile').addClass('d-flex');
        $exhInfoButton.css('opacity', '.5').attr('disabled', true);
        $exhThumbsButton.css('opacity', '.5').attr('disabled', true);
        $exhHideButtons.css('opacity', '.5').attr('disabled', true);
        $exhInfo.css('opacity', '.5').attr('disabled', true);
        $exhDziRotateRight.css({'opacity': '.5', 'pointer-events': 'none'}).attr('disabled', true);
        $exhDziReset.css({'opacity': '.5', 'pointer-events': 'none'}).attr('disabled', true);
        $printBuy.css({'opacity': '.5', 'pointer-events': 'none'}).attr('disabled', true);
        $blankButton.removeClass('d-none');
        $navButton.addClass('d-none');

    }

    $('.pin-button').addClass('d-none');
    $dotsWrapper.addClass('d-none');

    $dotsWrapper.css({
        'top': '2px',
        'height': 'fit-content',
        'max-height': '80%',
        'overflow-y': 'scroll',
        'border': '1px solid black',
        // centered on screen: parent starts at screen-left, so 60px left + (100vw-120px) width
        // leaves an equal 60px on the right, clearing the 60px side-button columns both sides.
        // right unset + min/max-width unset so nothing overrides the explicit viewport width
        'left': '60px',
        'right': 'unset',
        'border-radius': '15px',
        'width': 'calc(100vw - 120px)',
        'min-width': 'unset',
        'max-width': 'unset'
    }).find('.dots-card').removeClass('mt-4').find('.comments').addClass('d-none');
    $dotsWrapper.find('.dots-card').find('hr').addClass('d-none');

});

// save dot for mobile
$(document).on('click', '.save-pin', function () {
    if ($('.newDot').length > 0) {
        $dotsWrapper.removeClass('d-none');
        $('.dot-guide-mobile').removeClass('d-flex');
        $('.dots-card.active').find('.add-comment').removeClass('d-none');
    } else {
        alert('Click on the image at the location where you want to place the DOT');
    }

});

// mobile: X button in the dot editor cancels dot creation (mirrors tapping the active create-dot button)
$(document).on('click', '.dot-create-close', function () {
    if ($exhDotCreateMobile.hasClass('active')) {
        $exhDotCreateMobile.trigger('click');
    } else {
        $dotsWrapper.addClass('d-none');
    }
    $('.add-comment').addClass('d-none');
});

// dotcrt share mode: Cancel button beside Submit (desktop + mobile) aborts dot creation
$(document).on('click', '.dot-create-cancel', function () {
    // mobile parity: re-enables the dimmed side buttons, same as the old X
    if ($exhDotCreateMobile.hasClass('active')) $exhDotCreateMobile.trigger('click');
    $('.pin-button').removeClass('active');
    $openseadragonViewer.removeClass('custom-pointer');
    $('.newDot').remove();
    // clear the editor for this card
    const idx = $(this).siblings('.save-comment').data('identifier');
    if (editors['editor_crt_dot_' + idx]) editors['editor_crt_dot_' + idx].setData('');
    // reveal existing pins
    $('body').removeClass('dot-share-hiding');
});

// dots sidebar

$(document).on('click', '.exh-dot-button', function (e) {

    $dotsWrapper.scrollTop(0);

    // if(exhibit_story_create_mode) {
    //     return;
    // }

    $mode.removeClass('d-none');
    // mobile/desktop version
    if ($windowWidth < 600) {
            if ($exhDotCreateMobile.hasClass('active')) {
                $exhDotCreateMobile.removeClass('active');
                $dotsWrapper.addClass('d-none');
                $('.dot-guide-mobile').removeClass('d-flex');
                $('.pin-button').removeClass('active');
                $exhInfoButton.css('opacity', '1').removeAttr('disabled');
                $exhThumbsButton.css('opacity', '1').removeAttr('disabled');
                $exhHideButtons.css('opacity', '1').removeAttr('disabled');
                $exhInfo.css('opacity', '1').removeAttr('disabled');
                $exhDziRotateRight.css({'opacity': '1', 'pointer-events': 'all'}).removeAttr('disabled');
                $exhDziReset.css({'opacity': '1', 'pointer-events': 'all'}).removeAttr('disabled');
                $printBuy.css({'opacity': '1', 'pointer-events': 'all'}).removeAttr('disabled');
                $blankButton.addClass('d-none');
                $navButton.removeClass('d-none');

                if ($('.newDot').length > 0) {
                    $('.newDot').remove();
                }
                stopIframeVid('.dots-card.mt-4.active .blockquote');
                stopIframeVid('.image-info.active .image-content');

            }

            //show dots on mobile without sidebar
            /* This code is adding a class to the button that is clicked. */
            $(this).toggleClass('active');
            $exhDotCreateMobile.toggleClass('d-none');

            if ($openseadragonViewer.attr('data-dots') !== 'true') {
                const _dotBtnPage = curPage();
                const _dotBtnId   = window.imageIds && window.imageIds[_dotBtnPage];
                if (_dotBtnId) {
                    loadImageData(_dotBtnId).then(() => showPins(_dotBtnPage));
                }
            } else {
                if (!$showDotsButton.hasClass('active')) {
                    $dotsWrapper.removeClass('active');
                }
                hidePins();

                if ($('.overlay-exhibit-story').length < 1) {
                    mobileDotModalDeactivator()
                }
            }
    } else {
        //show dots on on other devices with sidebar
        if (!$dotsWrapper.is(':visible')) {

            $dotsWrapper.show()
            $dotsWrapper.removeClass('active')
        }
        if (!$dotsWrapper.hasClass('active')) {
            $(this).addClass('active');
            $openseadragonViewer.find('.openseadragon-container').addClass('shrink');
            stopIframeVid('.image-info.active .image-content');
            $exhInfoButton.removeClass('active');
        } else {
            $openseadragonViewer.find('.openseadragon-container').removeClass('shrink');
            $(this).removeClass('active');
            stopIframeVid('.dots-card.mt-4.active .blockquote');
        }

        // curPage = viewer.currentPage();
        $('.exhibit-sidebar>.active:not(.dots-wrapper)').removeClass('active');
        if (!$dotsWrapper.hasClass('active') && $dotsWrapper.is(':visible')) {
            const _deskPage = viewer.currentPage();
            const _deskId   = window.imageIds && window.imageIds[_deskPage];
            if (_deskId) {
                loadImageData(_deskId).then(() => showPins(_deskPage));
            } else {
                showPins(_deskPage);
            }
        } else {
            hidePins();
        }

        $dotsWrapper.toggleClass('active');
    }

    // load youtube iframe for dots

    loadIframe('.blockquote');
});

// Activate the Dot modal for mobile
function mobileDotModalActivator() {
    $exhInfoButton.removeClass('active');
    $viewerWrapper.css('padding-top', 'unset');
    $openseadragonViewer.css('height', '50%');
    $exhibitAttributionWrapper.removeClass('active');
    $exhibitAttributionWrapper.css('display', 'none');
    $buttonsWrapper.addClass('d-none');
    $('.editDot').css('display', 'none');
    $dotShare.removeClass('d-inline');
    $dotShare.addClass('d-none');
    $('.dot-expand-btn').addClass('d-inline');
    $('.dot-shrink-btn').addClass('d-none');
    $('.dot-shrink-btn').removeClass('d-inline');
    $dotVoiceVisibility.addClass('d-none');
    $('.voice-visibility-dot-footer').removeClass('d-none');
}

// Deactivate the Dot modal for mobile
function mobileDotModalDeactivator() {
    $viewerWrapper.css('padding-top', '64px');
    $openseadragonViewer.css('height', '100%');
    $exhibitAttributionWrapper.addClass('active');
    $exhibitAttributionWrapper.css('display', '');
    $buttonsWrapper.removeClass('d-none');
    $('.editDot').css('display', '');
    $dotShare.removeClass('d-none');
    $dotShare.addClass('d-inline');
    $('.dot-expand-btn').addClass('d-none');
    $('.dot-expand-btn').removeClass('d-inline');
    $('.dot-shrink-btn').removeClass('d-none');
    $('.dot-shrink-btn').addClass('d-inline');
    $dotVoiceVisibility.removeClass('d-none');
    $('.voice-visibility-dot-footer').addClass('d-none');
}

$(document).on('click', '.dot-full-close', function () {
    if ($windowWidth <= 600) {
        mobileDotModalDeactivator()
        $modalDotFullContent.css('height', '');
        $modalDotFullContent.css('top', '');
    }
})

// Expand the Dot modal on mobile
$(document).on('click', '.dot-expand-btn', function () {
    mobileDotModalDeactivator()
    $modalDotFullContent.css({'cssText': 'height: var(--doc-height) !important; top: 0;'});
    $("#modal-dotfull .modal-dialog .modal-content .modal-body").removeAttr('style');
    $(".social-dot-comment-container").removeAttr('style')
})

// Shrink the Dot modal on mobile
$(document).on('click', '.dot-shrink-btn', function () {
    mobileDotModalActivator()
    $modalDotFullContent.css({'cssText': 'height: 50%;'});
    $("#modal-dotfull .modal-dialog .modal-content .modal-body").css({'cssText': 'height: 0 !important;min-height:0;padding:0.5rem;'})
    $(".social-dot-comment-container").css({'cssText': 'height: 100%'})
})

$(document).on('click', '.image-info-close', function () {
    $exhInfoButton.click();
})


// image info and dots sidebars

$(document).on('click', '.exh-dot-button, .exh-info-button', function () {
    //center image title when sidemenu is open

    if ($windowWidth > 600) {
        if ($(this).hasClass('active')) {
            $bottomImageName.css({'padding-left': '330px', 'transition-duration': '300ms'})

            if ($(this).hasClass('active')) {
                $toolbar.css({'left': '400px', 'transition-duration': '260ms'});
            }

        } else {
            if (!$showDotsButton.hasClass('active') && !$exhInfoButton.hasClass('active')) {
                $bottomImageName.css({'padding-left': '0px', 'transition-duration': '300ms'})
            }
            if ($(this).hasClass('active')) {
                $toolbar.css({'left': '70px', 'transition-duration': '260ms'});
            }
        }
    } else {
        if ($exhInfoButton.hasClass('active')) {
            $header.addClass('hiddenHeader');
            $('.image-info-wrapper').addClass('active');
            if (window.autoplay_image_voice_note) {
                autoplay_image_first_voice_note();
            }
        } else {
            $header.removeClass('hiddenHeader');
            $('.image-info-wrapper').removeClass('active');
        }
    }
})

$(document).on('click', '#exh-dzi-fullscreen', function () {
    if (!$('.fullpage').length > 0) {
        $exhInfo.hide();
    }
})

$('.share-exhibit-story').on('click', function () {

    $generatedShortURL.val('');
    $copyShortURL.attr('data-original-title', 'Copy link')
        .tooltip('dispose').tooltip();
    $iiifShareRow.addClass('d-none');
    $('.exhShareModal').modal('show');

    let exhibitStorySlug = $(this).data('exhibit-story-slug');
    let url = new URL($('#storyShareLink').val());
    url.searchParams.set('exhibit-story-slug', exhibitStorySlug);
    url.searchParams.delete('crt');
    url.searchParams.delete('thb');
    url.searchParams.delete('crtim');
    url.searchParams.delete('img-desc');
    $('#storyShareLink').val(url.toString());

    $('#customSwitch6').prop('checked', false);

    generateShortURL(true);
});


// share link button
$(document).on('click', '.exhShare', function () {
    $generatedShortURL.val('');
    $copyShortURL.attr('data-original-title', 'Copy link')
        .tooltip('dispose').tooltip();
    $('.exhShareModal').modal('show');

    // set IIIF manifest URL based on share type
    const cfg = window.exhibitConfig;
    const $miradorBtn = $('#openMiradorBtn');
    // "open image on dot create" toggle only applies to image shares
    $('#switchDotCreate').prop('checked', false);
    if ($(this).hasClass('dotShare')) {
        $iiifShareRow.addClass('d-none');
        $('#dotCreateSwitchWrap').hide();
    } else if ($(this).hasClass('imageShare')) {
        $iiifShareRow.removeClass('d-none');
        $iiifManifestURL.val(cfg.iiifImageManifestBase + '/' + $(this).data('id') + '/manifest.json');
        $miradorBtn.attr('href', '/iiif/viewer/image/' + $(this).data('id'));
        $('#dotCreateSwitchWrap').show();
    } else {
        $iiifShareRow.removeClass('d-none');
        $iiifManifestURL.val(cfg.iiifExhibitManifest);
        $miradorBtn.attr('href', '/iiif/viewer/' + cfg.exhibitId);
        $('#dotCreateSwitchWrap').hide();
    }

    let link = $shareLink.val();
    let substDot = link.substring(link.indexOf('dot=') + 4, link.indexOf('&dotst='));
    let substImg = link.substring(link.indexOf('img-desc=') + 9);
    let substExhThb = link.substring(link.indexOf('thb=') + 4, link.indexOf('&crtim='));
    let substExhInfo = link.substring(link.indexOf('crt=') + 4, link.indexOf('&thb='));
    let substExhPage = link.substring(link.indexOf('page=') + 5, link.indexOf('&key='));
    let substExhFull = link.substring(link.indexOf('shr-full=') + 9, link.indexOf('&shara'));
    if ($(this).hasClass('dotShare')) {
        link = $shareLink.val();
        $shareLink.attr('value', link.replace('dot=' + substDot, 'dot=' + $(this).data('dotid')));

        let link2 = $shareLink.val();
        $shareLink.attr('value', link2.replace('crt=' + substExhInfo, 'crt=false'));
        let link3 = $shareLink.val();
        $shareLink.attr('value', link3.replace('thb=' + substExhThb, 'thb=false'));
        let link5 = $shareLink.val();
        $shareLink.attr('value', link5.replace('shr-full=' + substExhFull, 'shr-full=false'));
        let link6 = $shareLink.val();
        $shareLink.attr('value', link6.replace('page=' + substExhPage, 'page=' + $('.image-info.active').data('image-id')));
    }
    if ($(this).hasClass('imageShare')) {
        $shareLink.attr('value', link.replace('dot=' + substDot, 'dot=false'));
        link = $shareLink.val();
        // // console.log('Link:'+link);
        $shareLink.attr('value', link.replace('img-desc=' + substImg, 'img-desc=true'));
        let link2 = $shareLink.val();
        $shareLink.attr('value', link2.replace('crt=' + substExhInfo, 'crt=false'));
        let link3 = $shareLink.val();
        $shareLink.attr('value', link3.replace('thb=' + substExhThb, 'thb=false'));
        let link4 = $shareLink.val();
        substExhPage = link4.substring(link4.indexOf('page=') + 5, link4.indexOf('&key='));
        let link5 = $shareLink.val();
        $shareLink.attr('value', link5.replace('shr-full=' + substExhFull, 'shr-full=false'));
        let link6 = $shareLink.val();
        $shareLink.attr('value', link6.replace('page=' + substExhPage, 'page=' + $(this).data('id')));
    }
    if ($(this).hasClass('exhDirectlyShare')) {

        $modalExhibitInfo.css('opacity', '.92');
        $shareLink.attr('value', link.replace('dot=' + substDot, 'dot=false'));
        $shareLink.attr('value', link.replace('thb=' + substExhThb, 'thb=true'));
        let link2 = $shareLink.val();
        $shareLink.attr('value', link2.replace('crt=' + substExhInfo, 'crt=true'));
        let link3 = $shareLink.val();
        $shareLink.attr('value', link3.replace('page=' + substExhPage, 'page=first'));
        let link4 = $shareLink.val();
        $shareLink.attr('value', link4.replace('shr-full=' + substExhFull, 'shr-full=false'));

    }

    // hide all opt-in elements (thumbnails, pins, info banner, description) by default in the shared/embedded view
    $('.share-advanced-switch').prop('checked', false);
    const _embedUrl = new URL($shareLink.val());
    _embedUrl.searchParams.set('shr-full', 'false');
    _embedUrl.searchParams.set('thb', 'false');
    _embedUrl.searchParams.set('crt', 'false');
    _embedUrl.searchParams.set('img-desc', 'false');
    _embedUrl.searchParams.set('dotcrt', 'false');
    const _curDot = _embedUrl.searchParams.get('dot');
    if (_curDot === 'true' || _curDot === 'false') {
        _embedUrl.searchParams.set('dot', 'false');
    }
    $shareLink.attr('value', _embedUrl.toString());
    $embedCode.val('<iframe src="' + _embedUrl.toString() + '" width="100%" height="600" style="border:0;" allow="fullscreen" allowfullscreen></iframe>');
    generateShortURL();
});

// show exhibit info modal for mobile
$(document).on('click', '#exh-info', function () {
    $modalExhibitInfo.modal('show');
});

// show image thumbs overlay
// open the thumbnail grid and scroll it to the current image
// (shared by the thumbs button and the cancel-to-grid flow)
function openThumbsGrid() {
    const container = $thumbsWrapper;
    container.addClass('active');
    container.animate({scrollTop: 0}, 0);
    const current_image_id = $('.image-info.active').data('image-id');
    let target = $(".thumb-item[data-image-id='" + current_image_id + "']");
    $(".thumb-item").removeClass('border-danger');
    target.addClass('border-danger');

    if (target.length) {
        const itemsPerRow = getThumbItemsPerRow();
        const targetIndex = $(".thumb-item").index(target);
        const targetRow = Math.floor(targetIndex / itemsPerRow);
        const rowStartIndex = targetRow * itemsPerRow;
        const rowFirstItem = container.find(".thumb-item").eq(rowStartIndex);
        const rowOffsetTop = rowFirstItem.position().top;
        const headerHeight = 32;
        const scrollPosition = rowOffsetTop - headerHeight;

        if (scrollPosition > 0) {
            container.animate({scrollTop: scrollPosition}, 0);
        }
    }
}

$(document).on('click', '.exh-thumbs-button', function () {
    if ($thumbsWrapper.hasClass('active')) {
        $thumbsWrapper.removeClass('active');
    } else {
        openThumbsGrid();
    }
})

// Get thumbnail items per row
function getThumbItemsPerRow() {
    var containerWidth = $(".thumbs-wrapper").width();
    var itemWidth = $(".thumb-item").outerWidth(true);
    return Math.floor(containerWidth / itemWidth);
}

// open selected image from image thumbnails
$(document).on('click', '.thumb-item', function (e) {
    e.stopPropagation();
    stopScrolling();
    viewer.goToPage($(this).index() - 1);
    $thumbsWrapper.removeClass('active');
})

// close image thumbnails overlay
$(document).on('click', '.thumbs-wrapper', function (e) {
    stopScrolling();
    if (e.target.className != 'thumb-item') {
        $thumbsWrapper.removeClass('active');
    }
})
// update the share link & embed code when an advanced-options switch is toggled
$(document).on('change', '.share-advanced-switch', function () {
    const url = new URL($shareLink.val());
    url.searchParams.set('shr-full', $('#customSwitch6').is(':checked') ? 'true' : 'false');
    url.searchParams.set('thb', $('#switchShowThumbs').is(':checked') ? 'true' : 'false');
    url.searchParams.set('crt', $('#switchShowExhText').is(':checked') ? 'true' : 'false');
    url.searchParams.set('img-desc', $('#switchImgText').is(':checked') ? 'true' : 'false');
    url.searchParams.set('dotcrt', $('#switchDotCreate').is(':checked') ? 'true' : 'false');

    const currentDot = url.searchParams.get('dot');
    const isSpecificDot = currentDot !== 'true' && currentDot !== 'false';
    if ($('#switchShowDots').is(':checked')) {
        url.searchParams.set('dot', 'true');
    } else if (!isSpecificDot) {
        url.searchParams.set('dot', 'false');
    }

    $shareLink.attr('value', url.toString());
    $embedCode.val('<iframe src="' + url.toString() + '" width="100%" height="600" style="border:0;" allow="fullscreen" allowfullscreen></iframe>');
    generateShortURL();
})

// disable right click menu when clicking inside image
$(document).on('contextmenu', '.openseadragon-canvas', function (event) {
    event.preventDefault();
});

// ?
$(document).on('click', '.fs-overlay', function () {
    if ($viewerWrapper.data('full') == true && $('.fs-overlay').hasClass('active')) {
        $('.fs-overlay').removeClass('active');
        viewer.setFullScreen(true);
    }
})


// create url for share button
function generateShortURL(story = false) {

    let inputurl = '';

    if (story == false) {
        inputurl = $shareLink.val();
    } else {
        inputurl = $('#storyShareLink').val();
    }

    $('#longURL').html(inputurl);
    $('#shortURL').html('');

    //Custom URL shortener start
    $.ajax({
        headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
        method: "POST",
        url: "/create_short_url",
        data: {
            url: inputurl,
        },
        success: function (response) {
            $('#shortURL').html(response.shorten_url);
            $generatedShortURL.val(response.shorten_url);
            $copyShortURL.attr('title', 'Copy link')
                .tooltip('dispose')
                .tooltip();
        }
    });
}

//Copy to clipboard on share screen START
/* The above code is using the bitly API to shorten the URL. */
$('#copyLink').click(function () {
    generateShortURL()
});
//Copy to clipboard on share screen END

// add keyboard navigation with arrows keys for images
$(document.documentElement).off('keyup.navigation').on('keyup.navigation', function (event) {
    const LEFT_ARROW = 37;
    const UP_ARROW = 38;
    const RIGHT_ARROW = 39;
    const DOWN_ARROW = 40;
    const PAGE_UP = 33;
    const PAGE_DOWN = 34;

    const isLeft = event.which === LEFT_ARROW || event.which === UP_ARROW || event.which === PAGE_UP;
    const isRight = event.which === RIGHT_ARROW || event.which === DOWN_ARROW || event.which === PAGE_DOWN;

    if (!isLeft && !isRight) return;

    // enter the exhibit story from its share overlay via nav keys (mirrors click-anywhere)
    if ($exhibitStoryShare.hasClass('d-flex')) {
        event.preventDefault(); // stop page scroll from PageUp/Down/arrows while overlay up
        $exhibitStoryShare.click();
        return;
    }

    const isModalVisible = $modalDotFull.is(':visible');
    const isExhibitStoryOpen = $('.overlay-exhibit-story').length > 0;
    const isZoomableModalOpen = $('#zoomable-modal').is(':visible');
    const isAnyModalOpen = $('.modal').is(':visible');
    const isTextAreaFocused = $('textarea').is(':focus');
    const isRichTextFocused = $('.ck-content').hasClass('ck-focused');

    if (isExhibitStoryOpen) {
        if (isLeft) {
            $exhibitStoryNavPrev.click();
        } else if (isRight) {
            $exhibitStoryNavNext.click();
        }
        return;
    }

    if (isModalVisible) {
        if (!$modalDotFull.is(':focus')) {
            $modalDotFull.focus();
        }

        if (isLeft) {
            $('.dot-pag .prev').first().click();
        } else if (isRight) {
            $('.dot-pag .next').first().click();
        }

        return;
    }

    if (isZoomableModalOpen) {
        if (isLeft) {
            $('#zoomable-prev-btn').click();
        } else if (isRight) {
            $('#zoomable-next-btn').click();
        }
        return;
    }

    if (isAnyModalOpen || isTextAreaFocused || isRichTextFocused) {
        return;
    }

    if (isLeft) {
        viewer.goToPage(curPage() - 1);
    } else if (isRight) {
        viewer.goToPage(curPage() + 1);
    }
});

// Go to the first image
$(document).on('click', '#exh-first-img', function () {
    viewer.goToPage(0);
})

// Go to the last image
$(document).on('click', '#exh-last-img', function () {
    let mapCount = $('.content-wrapper .image-info').length;
    viewer.goToPage(mapCount - 1);
});

$(document).on('click', '.exh-ss-button', function () {
    $(this).toggleClass('active');
})
//Screensaver delay

/* The below code is adding a functionality to the “plus” and “minus” buttons on slideshow modal */
$('.btn-number').click(function (e) {
    e.preventDefault();

    let fieldName = $(this).attr('data-field');
    let type = $(this).attr('data-type');
    let input = $("input[name='" + fieldName + "']");
    let currentVal = parseInt(input.val());
    if (!isNaN(currentVal)) {
        if (type == 'minus') {
            if (currentVal > input.attr('min')) {
                input.val(currentVal - 1).change();
            }
            if (parseInt(input.val()) == input.attr('min')) {
                $(this).attr('disabled', true);
            }
        } else if (type == 'plus') {
            if (currentVal < input.attr('max')) {
                input.val(currentVal + 1).change();
            }
            if (parseInt(input.val()) == input.attr('max')) {
                $(this).attr('disabled', true);
            }
        }
    } else {
        input.val(0);
    }
});

// numbers in slideshow modal
$('.input-number').focusin(function () {
    $(this).data('oldValue', $(this).val());
});


// numbers in slideshow modal
$('.input-number').change(function () {

    let minValue = parseInt($(this).attr('min'));
    let maxValue = parseInt($(this).attr('max'));
    let valueCurrent = parseInt($(this).val());

    name = $(this).attr('name');
    if (valueCurrent >= minValue) {
        $(".btn-number[data-type='minus'][data-field='" + name + "']").removeAttr('disabled')
    } else {
        alert('Sorry, the minimum value was reached');
        $(this).val($(this).data('oldValue'));
    }
    if (valueCurrent <= maxValue) {
        $(".btn-number[data-type='plus'][data-field='" + name + "']").removeAttr('disabled')
    } else {
        alert('Sorry, the maximum value was reached');
        $(this).val($(this).data('oldValue'));
    }
});

/* The below code is preventing the user from entering any characters other than numbers into the input field. */
$(".input-number").keydown(function (e) {
    // Allow: backspace, delete, tab, escape, enter and .
    if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 190]) !== -1 ||
        // Allow: Ctrl+A
        (e.keyCode == 65 && e.ctrlKey === true) ||
        // Allow: home, end, left, right
        (e.keyCode >= 35 && e.keyCode <= 39)) {
        // let it happen, don't do anything
        return;
    }
    // Ensure that it is a number and stop the keypress
    if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
        e.preventDefault();
    }
});

// Custom fullscreen
async function exitFullScreenValidation(exitCode) {
    $.ajax({
        url: "/exit-full-screen-validation",
        dataType: "json",
        method: "POST",
        data: {
            code: exitCode,
            _token: $('meta[name="csrf-token"]').attr('content')
        }
    }).done(function (data) {
        $('#exitFullScreenError').addClass('d-none');
        $('.exitFullScreenModal').modal('hide')
        exitFullScreen()
        $('#exitFullScreenCode').val('')
    }).fail(await function (xhr) {
        $('#exitFullScreenError').html(xhr.responseJSON.message);
        $('#exitFullScreenError').removeClass('d-none');
    });
}

function detectDoubleTapClosure() {
    let lastTap = 0;
    let timeout;
    return function detectDoubleTap(event) {
        const curTime = new Date().getTime();
        const tapLen = curTime - lastTap;
        if (tapLen < 500 && tapLen > 0) {
            if (((window.USER_IS_TOUCHING && window.innerWidth >= 2560) /* TODO: remove 4k/8k || ($preview4k.length && $preview4k.attr('data-status') == 'enable') */) && window.EXIT_FULL_SCREEN_CODE_STATUS == 1 && $buttonsWrapper.hasClass('d-none')) {
                // open popup for enter code
                $('.exitFullScreenModal').modal('show')
            }
            event.preventDefault();
        } else {
            timeout = setTimeout(() => {
                clearTimeout(timeout);
            }, 500);
        }
        lastTap = curTime;
    };
}

window.addEventListener('touchstart', function onFirstTouch() {
    window.USER_IS_TOUCHING = true;
    document.body.addEventListener('touchend', detectDoubleTapClosure());
    window.removeEventListener('touchstart', onFirstTouch, false);
}, false);

function exitFullScreen() {
    if (document.exitFullscreen) {
        document.exitFullscreen();
    } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
    } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
    }
    $openseadragonViewer.removeClass('contFs');
    $openseadragonViewer.removeClass('fullpage');
    $header.removeClass('hiddenHeader');
    $('.exhibit-info-wrapper').removeClass('d-none');
    $('.viewer-wrapper').css('padding-top', '');
    $modalDotFull.removeClass('full-height')
    $exhibitStoryLeft.removeClass('full-height')

    if (isLoopMode) {
        finishExhibitStory()
    }

    iPadExitFullScreen()
}

function iPadEnterFullScreen() {
    if (navigator.userAgent.match(/Macintosh/i) && "ontouchend" in document) {
        $('.left-exh-buttons').css('margin-top', '80px')
        $('.right-exh-buttons').css('margin-top', '80px')
        $('.image-info-wrapper').css('margin-top', '80px')
    }
}

function iPadExitFullScreen() {
    if (navigator.userAgent.match(/Macintosh/i) && "ontouchend" in document) {
        $('.left-exh-buttons').removeAttr('style')
        $('.right-exh-buttons').removeAttr('style')
        $('.image-info-wrapper').removeAttr('style')
    }
}


$modalDotEdit.on('hidden.bs.modal', function () {
    $editDotPositionInput.find('input').each(function () {
        $(this).val('');
    });

    $('#confirm-dot-position').remove();
    $('.pin-button').removeClass('active');
    $('.newDot').remove();
    $openseadragonViewer.removeClass('custom-pointer');
});

$('#exitFullScreen').on('hidden.bs.modal', function () {
    $('#exitFullScreenCode').val('')
    $('#exitFullScreenError').addClass('d-none');
})

$('.exhShareModal').on('hidden.bs.modal', function () {
    $modalExhibitInfo.css('opacity', '1');
})

function enterFullScreen() {
    var root = document.documentElement;
    if (root.requestFullscreen) {
        root.requestFullscreen();
    } else if (root.mozRequestFullScreen) {
        root.mozRequestFullScreen();
    } else if (root.webkitRequestFullscreen) {
        root.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
    }

    $openseadragonViewer.addClass('contFs');
    $openseadragonViewer.addClass('fullpage');
    $header.addClass('hiddenHeader');
    $('.exhibit-info-wrapper').addClass('d-none');
    $('.viewer-wrapper').css('padding-top', '0');

    $modalDotFull.addClass('full-height')
    $exhibitStoryLeft.addClass('full-height')
    $thumbsWrapper.removeClass('active')

    iPadEnterFullScreen()
}

$('#submitExitCode').on('click', function () {
    const exitCode = $('#exitFullScreenCode').val()
    exitFullScreenValidation(exitCode)
});

//enter fullscreen and disable for touch devices
$('#exh-dzi-fullscreen').on('click', function () {

    if (navigator.userAgent.match(/(iPod|iPhone|iPad)/) || window.innerWidth < 768) {
        return false;
    }
    let elem = document.getElementById('openseadragon_viewer');
    if (document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement) {
        // exit full screen
        if (((window.USER_IS_TOUCHING && window.innerWidth >= 2560) /* TODO: remove 4k/8k || ($preview4k.length && $preview4k.attr('data-status') == 'enable') */) && window.EXIT_FULL_SCREEN_CODE_STATUS == 1) {
            // open popup for enter code
            $('.exitFullScreenModal').modal('show')
            return false
        }
        exitFullScreen()
    } else {
        // enter Full screen
        enterFullScreen()
    }
});

$(document).bind('webkitfullscreenchange mozfullscreenchange fullscreenchange', function (e) {
    let state = document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen;
    let event = state ? 'FullscreenOn' : 'FullscreenOff';
    if (!state) {
        $openseadragonViewer.removeClass('contFs');
        $openseadragonViewer.removeClass('fullpage');
        $header.removeClass('hiddenHeader');
        $('.exhibit-info-wrapper').removeClass('d-none');
        $('.viewer-wrapper').css('padding-top', '');
        $buttonsWrapper.removeClass('d-none');
        $modalDotFull.removeClass('full-height')
        $exhibitStoryLeft.removeClass('full-height')

        if ($('.overlay-exhibit-story').length > 0) {
            finishExhibitStory()
        }

        iPadExitFullScreen()
    }
});
// End custom fullscreen


//Run screensaver

/* The below code is a JavaScript function that will allow the user to view the map in a fullscreen mode. */
$('.go-ss').on('click', function () {
    let ssrange = $('input[name="ss-delay"]').val();
    if (navigator.userAgent.match(/(iPod|iPhone|iPad)/) || window.innerWidth < 768) {
        return false;
    } else {
        $modalExhibitInfo.modal('hide');

        if (document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement) {
            if (((window.USER_IS_TOUCHING && window.innerWidth >= 2560) /* TODO: remove 4k/8k || ($preview4k.length && $preview4k.attr('data-status') == 'enable') */) && window.EXIT_FULL_SCREEN_CODE_STATUS == 1) {
                // open popup for enter code
                $('.exitFullScreenModal').modal('show')
                return false
            }
            exitFullScreen()
        } else {
            enterFullScreen()
        }
        let currentPage = curPage();

        let goscreensaver = setInterval(function () {
            let mapCount = $('.content-wrapper .image-info').length;
            if (currentPage == (mapCount - 1)) {
                viewer.goToPage(0);
                currentPage = 0;
            } else {
                viewer.goToPage(parseInt(currentPage) + 1);
                currentPage++;
            }
        }, ssrange + '000');

        $(document).off('webkitfullscreenchange.ss mozfullscreenchange.ss fullscreenchange.ss').on('webkitfullscreenchange.ss mozfullscreenchange.ss fullscreenchange.ss', function () {
            let state = document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen;
            if (!state) {
                clearInterval(goscreensaver);
                $openseadragonViewer.removeClass('contFs');
                $buttonsWrapper.removeClass('d-none');
                $(document).off('webkitfullscreenchange.ss mozfullscreenchange.ss fullscreenchange.ss');
            }
        });
        $buttonsWrapper.addClass('d-none');
    }
});

// End screensaver


// highlight dot number on image when hovering dot content in sidebar
if ($windowWidth > 600) {
    $(document).on('mouseenter', '.dot-short', function () {
        if ($(this).find('.add-dot-to-es').hasClass('added') && !$(this).find('.set-zoom-and-position').hasClass('btn-success')) {
            return;
        }
        $('.dot-pointer[data-id="' + $(this).attr('data-id') + '"]').addClass('active');
    }).on('mouseleave', '.dot-short', function () {
        if (!$modalDotFull.is(':visible')) {
            if ($(this).find('.add-dot-to-es').hasClass('added') && !$(this).find('.set-zoom-and-position').hasClass('btn-success')) {
                return;
            }
            $('.dot-pointer[data-id="' + $(this).attr('data-id') + '"]').removeClass('active');
        }
    });
}

$(document).on('mouseenter', '.dot-pointer', function () {
    if (!$modalDotFull.is(':visible')) {
        $('.dot-short[data-id="' + $(this).attr('data-id') + '"]').addClass('active');
    }
}).on('mouseleave', '.dot-pointer', function () {
    if (!$modalDotFull.is(':visible')) {
        $('.dot-short[data-id="' + $(this).attr('data-id') + '"]').removeClass('active');
    }
});


// ?
function getScrollHeight(elm) {
    let savedValue = elm.value
    elm.value = ''
    elm._baseScrollHeight = elm.scrollHeight
    elm.value = savedValue
}

function onExpandableTextareaInput({target: elm}) {
    // make sure the input event originated from a textarea and it's desired to be auto-expandable
    if (!elm.classList.contains('autoExpand') || !elm.nodeName == 'TEXTAREA') return

    let minRows = elm.getAttribute('data-min-rows') | 0, rows;
    !elm._baseScrollHeight && getScrollHeight(elm)

    elm.rows = minRows
    rows = Math.ceil((elm.scrollHeight - elm._baseScrollHeight) / 16)
    elm.rows = minRows + rows
}


// global delegated event listener
document.addEventListener('input', onExpandableTextareaInput)
/* Set the width of the side navigation to 250px */


// DOT PAGINATION FULL (next/prev)


$(document).on('click', '.dot-pag .prev', function () {
    const dotIds = activeImageDotIds();
    const idx = dotIds.indexOf(String($('.dot-number.active').parent('.dot-pointer').data('id')));

    if (idx > 0) openDot(dotIds[idx - 1]);
})


$(document).on('click', '.dot-pag .next', function () {
    const dotIds = activeImageDotIds();
    const idx = dotIds.indexOf(String($('.dot-number.active').parent('.dot-pointer').data('id')));

    if (idx >= 0 && idx < dotIds.length - 1) openDot(dotIds[idx + 1]);
})

//END DOT PAGINATION

//?
$(document).on('click', '#modal-crtexh-button', function () {
    $('.modal-backdrop').remove();
})

// mobile ?
document.addEventListener('click', function handleClickOutsideBox(event) {
    const header = document.querySelector('.public');
    const thumbs = document.querySelector('.thumbs-wrapper');
    const button = document.querySelector('.exh-info-button');

    if (thumbs.classList.contains('active')) {
        if (header.contains(event.target)) {
            event.preventDefault();
            document.querySelector('.thumbs-wrapper').classList.remove('active');
            document.querySelector('.content-wrapper').classList.remove('active');
        }
    }

    if (button.classList.contains('active')) {
        if (header.contains(event.target) && window.innerWidth < 768) {
            event.preventDefault();
            document.querySelector('.content-wrapper').classList.toggle('active');
            $('.exhibit-sidebar>.active:not(.content-wrapper)').removeClass('active');
            document.querySelector('#exh-dzi-reset').classList.remove('d-none');
            document.querySelector('#exh-dzi-rotate-right').classList.remove('d-none');
            document.querySelector('.exh-thumbs-button').classList.remove('d-none');
            document.querySelector('.image-info-wrapper').classList.remove('active');
            document.querySelector('.exh-info-button').classList.remove('active');
            stopIframeVid('.image-info.active .image-content');
        }
    }
});


// mobile image info
$(document).on('click', '.mobile-overlay-image-info', function () {
    $contentWrapper.toggleClass('active');
    $('.exhibit-sidebar>.active:not(.content-wrapper)').removeClass('active');
    $exhDziReset.removeClass('d-none');
    $exhDziRotateRight.removeClass('d-none');
    $exhThumbsButton.removeClass('d-none');
    $header.removeClass('hiddenHeader');
    $('.image-info-wrapper').removeClass('active');
    $exhInfoButton.removeClass('active');
    stopIframeVid('.image-info.active .image-content');
})


let editors = [];
let created_dot_ck = []

function create_ck_for_create_dot(image_number) {
    if (created_dot_ck.indexOf(image_number) === -1) {
        const element = document.querySelector('#dot-creating' + image_number);

        // Only initialize CKEditor if the element exists (user has permissions)
        if (element) {
            created_dot_ck.push(image_number)

            createDotEditor(element)
                .then(newEditor => {
                    editors["editor_crt_dot_" + image_number] = newEditor;
                })
                .catch(error => {
                    console.error(error);
                });
        }
    }
}


$(document).on('keydown', '.comments-textarea', autosize);

function autosize() {
    let el = this;
    setTimeout(function () {
        el.style.cssText = 'height:auto;';
        el.style.cssText = 'height:' + el.scrollHeight + 'px';
    }, 0);
}

$(document).on('click', '.comment-reply-cst a', function (e) {
    e.preventDefault();
    $(this).parents('.comment-reply-cst').prev().find('.comments-placeholder').click();
    $(this).parents('.comment-reply-cst').prev().addClass('active');
    $(this).hide();
})

$(document).on('click', '.comments-button.is-link', function () {
    $(this).parents('.comments-form.comments-reply').removeClass('active');
    $('.comment-reply-cst a').show();
})


// End add event listener for swipe action for next/prev image
$(document).on('click', '.image-info-mobile .image-info.active .exh-prev', function () {
    viewer.goToPage(curPage() - 1);
    autoplay_image_first_voice_note();
})
$(document).on('click', '.image-info-mobile .image-info.active .exh-next', function () {
    viewer.goToPage(curPage() + 1);
    autoplay_image_first_voice_note();
})
$(document).on('click', '.exhibit-info-content-wrapper .comment-reply-cst', function () {
    $exhibitInputComment.hide();
})
$(document).on('click', '.exhibit-info-content-wrapper .comments-reply button', function () {
    $exhibitInputComment.show();
})
$(document).on('click', '.image-info-wrapper.active .comment-reply-cst', function () {
    $('.image-info-wrapper.active .image-input-comment').hide();
})
$(document).on('click', '.image-info-wrapper.active .comments-reply button', function () {
    $('.image-info-wrapper.active .image-input-comment').show();
})

$(document).on('click', '.dot-full .comment-reply-cst', function () {
    $('.dot-full .dot-input-comment').hide();
})
$(document).on('click', '.dot-full .comments-reply button', function () {
    $('.dot-full .dot-input-comment').show();
})

$(document).on('click', '.image-info-close', function () {
    $('.image-info-wrapper .image-input-comment').show();
    $(this).parents('.image-info-wrapper').find('button.comments-visibility.active').click();
})
$(document).on('click', '.exhibit-info-content-wrapper .modal-header button', function () {
    $exhibitInputComment.show();
    $(this).parents('.exhibit-info-content-wrapper').find('button.exhibit-comments-visibility.active').click();
})
$(document).on('click', '.dot-full .modal-header button', function () {
    $('.dot-full .dot-input-comment').show();
    $(this).parents('.dot-full').find('button.dot-comments-visibility.active').click();
})
$(document).on('click', ".exhibit-voice-visibility", function () {
    let exhibit_voice_container = $('.exhibit-voice-container').find("[data-voice-exhibit-id='" + exhibit_id + "']")
    if (exhibit_voice_container.hasClass('d-none')) {
        let exhibit_comments_container = $('.social-exhibit-comment-container').find("[data-comment-exhibit-id='" + exhibit_id + "']")
        if (!exhibit_comments_container.hasClass('d-none')) {
            $('.exhibit-comments-visibility').removeClass('active')
            $exhDescription.removeAttr('style')
            $socialExhibitCommentContainer.addClass('d-none')
            $exhibitInputComment.addClass('d-none')
            exhibit_comments_container.addClass('d-none')

        }

        $exhDescription.css({'height': '50%', 'min-height': 'unset'})
        $exhibitVoiceVisibility.css({'background-color': 'green'})
        exhibit_voice_container.find('.voice_notes').html('').append('<img style="position: absolute;left: 45%;top: 45%;z-index: 100000;height: 54px;width: 54px;" src="../../images/local/loading.gif" alt="loading"/>');
        voiceNotes.fetchExhibitVoiceNotes(exhibit_id)
        $(this).addClass('active')
        exhibit_voice_container.removeClass('d-none')
        $exhibitVoiceContainer.removeClass('d-none')
    } else {
        $(this).removeClass('active')
        $('.exhibit-voice-container').find('audio').each(function () {
            this.pause();
        });
        $exhDescription.removeAttr('style')
        $exhibitVoiceVisibility.removeAttr('style')
        $exhibitVoiceContainer.addClass('d-none')
        exhibit_voice_container.addClass('d-none')
        $('.exhibit-voice-container .exhibit-voice-group .voice_notes .voice_notes').remove()
    }
})

$(document).on('click', ".image-voice-visibility", function () {
    const image_id = $(this).attr('data-voice-image-id')
    let image_voice_container = $('.image-voice-container').find("[data-voice-image-id='" + image_id + "']")
    if (image_voice_container.hasClass('d-none')) {
        let image_comments_container = $('.social-comment-container').find("[data-comment-image-id='" + image_id + "']")
        if (!image_comments_container.hasClass('d-none')) {
            $('.comments-visibility').removeClass('active')
            $('.image-description').removeAttr('style')
            $('.social-comment-container').addClass('d-none')
            $('.image-input-comment').addClass('d-none')
            image_comments_container.addClass('d-none')
        }

        if ($('.overlay-exhibit-story').length < 1) {
            $(".image-content[data-comment-image-id='" + image_id + "']").css({'cssText': 'height: 80%'})
        }
        if ($windowWidth <= 600 && !$('.voice-visibility-image-footer').hasClass('d-none')) {
            $(".image-content[data-comment-image-id='" + image_id + "']").css({'cssText': 'height: 0 !important;min-height:0;'})
        }
        $(".image-voice-visibility[data-voice-image-id='" + image_id + "']").css({'background-color': 'green'})
        image_voice_container.find('.voice_notes').html('').append('<img style="position: absolute;left: 45%;top: 45%;z-index: 100000;height: 54px;width: 54px;" src="../../images/local/loading.gif" alt="loading"/>');
        voiceNotes.fetchImageVoiceNotes(image_id)
        $(".image-voice-visibility[data-voice-image-id='" + image_id + "']").addClass('active')
        image_voice_container.removeClass('d-none')
        $(".image-voice-container[data-voice-image-id='" + image_id + "']").removeClass('d-none')
    } else {
        $(".image-voice-visibility[data-voice-image-id='" + image_id + "']").removeClass('active')
        $(".image-voice-visibility[data-voice-image-id='" + image_id + "']").removeAttr('style')
        $(".image-voice-container[data-voice-image-id='" + image_id + "']").addClass('d-none')
        $(".image-content[data-comment-image-id='" + image_id + "']").removeAttr('style')
        $(".image-voice-container[data-voice-image-id='" + image_id + "'] .image-voice-group .voice_notes .voice_notes").remove()
        image_voice_container.addClass('d-none')
        $('.image-voice-container').find('audio').each(function () {
            this.pause();
        });

    }
})

$(document).on('click', ".dot-voice-visibility", function () {
    const dot_id = $(this).attr('data-dot-id')
    let dot_voice_container = $('.dot-voice-container').find("[data-voice-dot-id='" + dot_id + "']")
    if (dot_voice_container.hasClass('d-none')) {
        let dot_comments_container = $('.social-dot-comment-container').find("[data-comment-dot-id='" + exhibit_id + "']")
        if (!dot_comments_container.hasClass('d-none')) {
            $('.dot-comments-visibility').removeClass('active')
            $('.dot-description').removeAttr('style')
            $('.social-dot-comment-container').addClass('d-none')
            $('.dot-input-comment').addClass('d-none')
            dot_comments_container.addClass('d-none')
        }

        $(".dot-content[data-comment-dot-id='" + dot_id + "']").css({'cssText': 'height: 50%'})
        $(this).css({'background-color': 'green'})
        $(this).addClass('active')
        dot_voice_container.removeClass('d-none')
        $dotVoiceContainer.removeClass('d-none')
        $('.dot-input-voice').removeClass('d-none')
    } else {
        $(this).removeClass('active')
        $(this).removeAttr('style')
        $dotVoiceContainer.addClass('d-none')
        $(".dot-content[data-comment-dot-id='" + dot_id + "']").removeAttr('style')
        dot_voice_container.addClass('d-none')
        //stop playing audio when modal is closed
        $('.dot-voice-container').find('audio').each(function () {
            this.pause();
        });
    }
})

const documentHeight = () => {
    const doc = document.documentElement
    doc.style.setProperty('--doc-height', window.innerHeight + 'px')
}
window.addEventListener('resize', documentHeight)
documentHeight()


// ANNOTATION MODE / TOOL TOGGLES

function exitAnnotationDrawingMode() {
    $toolbar.addClass('d-none');
    $mode.removeClass('active');
    if (typeof anno != 'undefined' && anno) {
        anno.readOnly = true;
        if (typeof anno.cancelSelected === 'function') anno.cancelSelected();
    }
}

$mode.on('click', function () {
    if ($(this).hasClass('active')) {
        $toolbar.addClass('d-none');
        $(this).removeClass('active')
        // enable readonly annotations
        if (typeof anno != 'undefined') {
            anno.readOnly = true;
        }
        anno.cancelSelected();

    } else {

        if ($dotsWrapper.hasClass('active') || $exhInfoButton.hasClass('active')) {
            $toolbar.css({'left': '400px'});
        } else {
            $toolbar.css({'left': '70px'});
        }

        $toolbar.removeClass('d-none');
        $(this).addClass('active')
        // disable readonly annotations
        if (typeof anno != 'undefined') {
            anno.readOnly = false;
        }
    }
})

$('.current-tool').on('click', function () {
    $('.current-tool').removeClass('active')
    $(this).addClass('active');
    if (typeof anno != 'undefined') {
        anno.setDrawingTool($(this).data('tool-name'));
    }
})

// TODO: remove 4k/8k
// function bigScreenStylesheetApplier(elm, size) {
//     if (elm.attr('data-status') == 'disable') {
//         elm.addClass('active')
//         elm.attr('data-status', 'enable')
//         addNewStylesheet('/css/app_' + size + '.css')
//     } else {
//         elm.removeClass('active')
//         elm.attr('data-status', 'disable')
//         removeDesiredStylesheet('/css/app_' + size + '.css')
//     }
// }
//
// $preview4k.on('click', function () {
//     bigScreenStylesheetApplier($(this), '4k');
// })
//
// $('#preview-8k').on('click', function () {
//     bigScreenStylesheetApplier($(this), '8k');
// })

function addNewStylesheet(url) {
    const newStylesheet = $('<link>', {
        rel: 'stylesheet',
        type: 'text/css',
        href: url
    });

    $('head').append(newStylesheet);
}

function removeDesiredStylesheet(url) {
    // Select and remove the desired stylesheet
    $('link[rel="stylesheet"][href*="' + url + '"]').remove();
}

// cancel exhibit story creation
$('.cancel-es-create').on('click', function () {
    if (confirm('All exhibit story progress will be lost. Are you sure?')) {
        $('.add-dot-to-es').addClass('d-none btn-secondary').removeClass('added btn-success').text('Add to exhibit story');
        $('.upper-left-exh-buttons').removeClass('d-none');
        $upperRightExhButtons.removeClass('d-none');
        $exhibitStorySetup.addClass('d-none');
        $('.zoom-wrapper').remove();
        $('.auto-play-wrapper').remove();
        $('.es-form-wrapper').html("");
        $('#esFormData').html("");
        $('#finaliseEsModal').modal('hide').find('input[name="es_name"]').val('Exhibit Story Name ' + Math.random().toString(36).substring(2, 7));
        $('#finaliseEsModal').find('input[name="exhibitStoryGroupSpeedMultiplier"]').val(1);
        $('#finaliseEsModal').find('input[name="exhibitStoryLineAnimDuration"]').val(1);
        $navButton.removeClass('d-none');
        $saveExhibitStory.removeClass('update').text('Save');

        // dots wrapper return to normal mobile
        if ($windowWidth < 600) {
            DotsWrapperMobileNormal()
        }


        if ($('.image-info.active').attr('data-is-video') == 1) {
            $dotsWrapper.removeClass('active');
            $showDotsButton.removeClass('d-flex').addClass('d-none')
        }

        exhibit_story_create_mode = false;
    }
    return false;
});

function DotsWrapperMobileNormal() {
    $header.removeClass('hiddenHeader');
    $viewerWrapper.css('padding-top', '64px');
    $openseadragonViewer.css('height', '100%');
    $exhibitAttributionWrapper.addClass('active');
    $exhibitAttributionWrapper.css('display', '');

    if (!exhibit_story_create_mode) {
        $exhInfoButton.css('opacity', '.5').attr('disabled', true);
        $exhThumbsButton.css('opacity', '.5').attr('disabled', true);
        $exhDotCreateMobile.css('opacity', '.5').attr('disabled', true);
        $exhHideButtons.css('opacity', '.5').attr('disabled', true);
        $exhInfo.css('opacity', '.5').attr('disabled', true);
        $exhDziRotateRight.css({'opacity': '.5', 'pointer-events': 'none'}).attr('disabled', true);
        $exhDziReset.css({'opacity': '.5', 'pointer-events': 'none'}).attr('disabled', true);
        $printBuy.css({'opacity': '.5', 'pointer-events': 'none'}).attr('disabled', true);
        $blankButton.removeClass('d-none');
        $navButton.addClass('d-none');
    }

    $dotsWrapper.addClass('d-none').css({
        'top': '2px',
        'height': '80%',
        'overflow-y': 'scroll',
        'border': '1px solid black',
        'left': '50px',
        'border-radius': '15px',
        'width': '100%'
    }).find('.dots-card').removeClass('mt-4').find('.comments').removeClass('d-none')
    $dotsWrapper.find('.dots-card').find('.add-comment').addClass('d-none');
    $dotsWrapper.find('.dots-card').find('.card-header').addClass('d-none');
    $dotsWrapper.find('.dots-card').find('hr').addClass('d-none');

    $('.upper-left-exh-buttons').removeClass('d-none');
    $upperRightExhButtons.removeClass('d-none');

    if (exhibit_story_create_mode) {
        $showDotsButton.removeClass('disabled').attr('disabled', false);
        $showDotsButton.click();
    }
    $exhInfo.click();
}

function DotsWrapperMobileStory() {
    $header.addClass('hiddenHeader');
    $dotsWrapper.removeAttr('style');
    if (exhibit_story_create_mode) {
        $showDotsButton.addClass('disabled').attr('disabled', true);
    }
    $viewerWrapper.css('padding-top', 'unset');
    $openseadragonViewer.css('height', '50%');
    $exhibitAttributionWrapper.removeClass('active');
    $exhibitAttributionWrapper.css('display', 'none');
    $dotsWrapper.removeClass('d-none').css({
        'top': '100%',
        'height': '100%',
        'overflow-y': 'scroll',
        'left': '0',
        'width': $windowWidth
    })
    $('.dots-card').removeClass('mt-4').find('.comments').removeClass('d-none')
    $('.dots-card').find('.card-header').addClass('d-none')
    $('.add-comment').addClass('d-none');
}

// begin exhibit story creation
$('#create-exhibit-story').on('click', function () {
    $('.add-dot-to-es').removeClass('d-none');
    $modalExhibitInfo.modal('hide');
    $exhibitStorySetup.removeClass('d-none');
    $thumbsWrapper.removeClass('active');

    exhibit_story_create_mode = true;
    exitAnnotationDrawingMode();

    // ensure showDotsButton is visible (needed when on video image)
    $showDotsButton.addClass('d-flex').removeClass('d-none');

    // always trigger button click if dots-wrapper is not active to ensure it shows
    if (!$dotsWrapper.hasClass('active')) {
        // ensure button is not already active to allow proper toggle
        if ($showDotsButton.hasClass('active')) {
            $showDotsButton.removeClass('active');
        }
        $showDotsButton.click();
    }

    // reset zoom to home after sidebar animation completes
    setTimeout(() => viewer.viewport.goHome(), 400);

    // dots wrapper mode for mobile
    if ($windowWidth < 600) {
        DotsWrapperMobileStory()
    }
});
$('#finalise-es').on('click', function () {
    // track step number for non-deleted items
    let stepCounter = 0;

    $('.es-form-wrapper').find('form').each(function (index) {
        // skip deleted items
        if ($(this).find('input[name="delete"]').val() == 1) {
            return;
        }


        stepCounter++;
        const stepNumber = stepCounter;

        const isVideo = $(this).find('input[name="isVideo"]').val() === '1';
        const isDotOriginal = $(this).find('input[name="dotId"]').length > 0;
        const isDot = !isVideo && isDotOriginal;
        const baseId = isVideo
            ? $(this).find('input[name="imgId"]').val()
            : (isDot
                    ? $(this).find('input[name="dotId"]').val()
                    : $(this).find('input[name="imgId"]').val()
            );
        const typePrefix = isVideo
            ? 'img-'
            : (isDot ? 'dot-' : 'img-');
        const rowId = typePrefix + baseId;

        const imgId = $(this).find('input[name="imgId"]').val();
        const autoPlayVoice = $(this).find('input[name="autoPlayVoice"]').val();

        let dotContent = 'VIDEO';
        if (isDot) {
            dotContent = $('.dot-short[data-id="' + baseId + '"]')
                .find('.ck-content')
                .text()
                .substring(0, 30);
            if (dotContent.length === 30) dotContent += '…';
        }

        const thumbSrc = $('.thumb-item[data-image-id="' + imgId + '"]')
            .find('img')
            .attr('src');

        const previewText = isVideo
            ? `Step #${stepNumber} - i#${imgId} - ${dotContent}`
            : `Step #${stepNumber} - i#${imgId} | d#${baseId} - ${dotContent}`;

        // check if row already exists
        let $existingRow = $('#' + rowId);

        if ($existingRow.length > 0) {
            // update existing row's preview text with correct step number
            $existingRow.find('.preview-trigger').text(previewText);
            // move row to correct position by appending (jquery moves element if it exists)
            $esFormData.append($existingRow);
        } else {
            // create new row
            const rowHtml = `
                <tr id="${rowId}" class="es-story-row" data-img-id="${imgId}">
                  <td class="es-img-preview" style="cursor: pointer; width: 100%;">
                    <span class="preview-trigger" tabindex="0"
                          style="text-decoration: underline; color: blue;">
                      ${previewText}
                    </span>
                    <div class="preview-image">
                      <img src="${thumbSrc}" alt="">
                    </div>
                  </td>
                  <td class="auto-play-wrapper" data-id="${baseId}">
                    <label class="custom-toggle">
                      <input type="checkbox"
                             name="autoPlayVoice"
                             ${autoPlayVoice == 1 ? 'checked' : ''}
                             value="${autoPlayVoice}">
                      <span class="auto-play-voice custom-toggle-slider rounded-circle"
                            data-label-off="No"
                            data-label-on="Yes"></span>
                    </label>
                  </td>
                  <td class="group-toggle-wrapper">
                    <button class="btn btn-sm btn-outline-primary group-with-next"
                            ${isVideo ? 'disabled' : ''}>
                      <i class="fa fa-link"></i>
                    </button>
                  </td>
                  <td class="line-toggle-wrapper">
                    <button class="btn btn-sm btn-outline-info line-with-next"
                            ${isVideo ? 'disabled' : ''}>
                      <i class="fa fa-route"></i>
                    </button>
                  </td>
                  <td class="skip-zoom-toggle-wrapper">
                    <button class="btn btn-sm btn-outline-warning skip-zoom-with-next"
                            ${isVideo ? 'disabled' : ''}>
                      <i class="fa fa-forward"></i>
                    </button>
                  </td>
                  <td class="d-flex align-items-center" style="gap:6px;">
                    ${isVideo ? '' : `
                      <button class="btn btn-info btn-sm preview-es-position"
                              data-${isDot ? 'dot-id' : 'img-id'}="${baseId}"
                              title="Preview saved position">
                        Preview
                      </button>`}
                    <button class="btn btn-danger btn-sm remove-from-story" ${isDot ? 'dot_id' : 'img_id'}="${baseId}">
                      Remove
                    </button>
                  </td>
                  <td class="drag-handle">
                    <i class="fa fa-arrows-alt drag-handle-es" style="cursor:move; font-size:20px;"></i>
                  </td>
                </tr>
            `;

            $esFormData.append(rowHtml);
        }
    });

    makeEsSortable($("#esFormData"), {
        items: "tr",
        placeholder: "ui-state-highlight",
        handle: ".drag-handle-es",
        onUpdate: function () {
            $("#esFormData tr").each(function (idx) {
                let parts = this.id.split('-');
                let prefix = parts[0];
                let id = parts.slice(1).join('-');
                $esFormWrapper
                    .find(`.added-${prefix}-to-es-wrapper[data-id="${id}"]`)
                    .find('input[name="order"]')
                    .val(idx + 1);
            });
            validateAndUpdateGroups();
        }
    });

    validateAndUpdateGroups();
});


// preview saved zoom/pan for an ES step
function previewSavedEsPosition(baseId, type /* 'dot' | 'img' */) {
    const wrapperSel = type === 'dot'
        ? `.added-dot-to-es-wrapper[data-id="${baseId}"]`
        : `.added-img-to-es-wrapper[data-id="${baseId}"]`;
    const $form = $('.es-form-wrapper').find(wrapperSel).find('form').first();
    if (!$form.length) return;
    if ($form.find('input[name="isVideo"]').val() === '1') return;

    const zoom = parseFloat($form.find('input[name="zoom"]').val());
    const panX = parseFloat($form.find('input[name="panX"]').val());
    const panY = parseFloat($form.find('input[name="panY"]').val());
    const captureAspect = parseFloat($form.find('input[name="captureAspect"]').val());
    const imgId = $form.find('input[name="imgId"]').val();
    if (!isFinite(zoom) || !isFinite(panX) || !isFinite(panY) || !imgId) return;

    const doPanZoom = () => {
        applyView(zoom, panX, panY, captureAspect);
    };
    const thumbIdx = $('.thumb-item[data-image-id="' + imgId + '"]').index() - 1;
    if (curPage() === thumbIdx) {
        doPanZoom();
    } else {
        viewer.goToPage(thumbIdx);
        setTimeout(doPanZoom, 250);
    }
}

$(document).on('click', '.preview-es-position', function (e) {
    e.preventDefault();
    e.stopPropagation();
    const $btn = $(this);
    const dotId = $btn.data('dot-id');
    const imgId = $btn.data('img-id');
    const insideModal = $btn.closest('#finaliseEsModal').length > 0;
    const run = () => {
        if (dotId) previewSavedEsPosition(dotId, 'dot');
        else if (imgId) previewSavedEsPosition(imgId, 'img');
    };
    if (insideModal) {
        $('#finaliseEsModal').one('hidden.bs.modal', run);
        $('#finaliseEsModal').modal('hide');
    } else {
        run();
    }
});

// group with next toggle
$(document).on('click', '.group-with-next:not([disabled])', function () {
    let $btn = $(this);
    let $row = $btn.closest('tr');
    let $nextRow = $row.next('tr.es-story-row');
    if (!$nextRow.length) return;

    if ($btn.hasClass('active')) {
        $btn.removeClass('active btn-primary').addClass('btn-outline-primary');
        $row.removeClass('es-grouped-bottom');
        $nextRow.removeClass('es-grouped-top');
    } else {
        $btn.addClass('active btn-primary').removeClass('btn-outline-primary');
        $row.addClass('es-grouped-bottom');
        $nextRow.addClass('es-grouped-top');
        // mutual exclusion with line group
        let $lineBtn = $row.find('.line-with-next');
        if ($lineBtn.hasClass('active')) {
            $lineBtn.removeClass('active btn-info').addClass('btn-outline-info');
            $row.removeClass('es-line-grouped-bottom');
            $nextRow.removeClass('es-line-grouped-top');
            updateLineGroupIds();
        }
    }
    // full refresh so skip-zoom availability updates (disabled while in a pan/line group)
    validateAndUpdateGroups();
});

// line with next toggle (parallel to group, but locks camera and draws lines between dots during playback)
$(document).on('click', '.line-with-next:not([disabled])', function () {
    let $btn = $(this);
    let $row = $btn.closest('tr');
    let $nextRow = $row.next('tr.es-story-row');
    if (!$nextRow.length) return;

    if ($btn.hasClass('active')) {
        $btn.removeClass('active btn-info').addClass('btn-outline-info');
        $row.removeClass('es-line-grouped-bottom');
        $nextRow.removeClass('es-line-grouped-top');
    } else {
        $btn.addClass('active btn-info').removeClass('btn-outline-info');
        $row.addClass('es-line-grouped-bottom');
        $nextRow.addClass('es-line-grouped-top');
        // mutual exclusion with smooth-pan group
        let $groupBtn = $row.find('.group-with-next');
        if ($groupBtn.hasClass('active')) {
            $groupBtn.removeClass('active btn-primary').addClass('btn-outline-primary');
            $row.removeClass('es-grouped-bottom');
            $nextRow.removeClass('es-grouped-top');
            updateGroupIds();
        }
    }
    // full refresh so skip-zoom availability updates (disabled while in a pan/line group)
    validateAndUpdateGroups();
});

// skip-zoom-out toggle (per-step boolean: move directly to the next step with no zoom-out;
// only enabled on dot steps that are not part of a pan/line group)
$(document).on('click', '.skip-zoom-with-next:not([disabled])', function () {
    let $btn = $(this);
    $btn.toggleClass('active btn-warning').toggleClass('btn-outline-warning');
    updateSkipZoomInputs();
});

// walk rows, write each wrapper's skip_zoom_out input from its button's active state
function updateSkipZoomInputs() {
    $('#esFormData tr.es-story-row').each(function () {
        let $row = $(this);
        let $btn = $row.find('.skip-zoom-with-next');
        let parts = this.id.split('-');
        let id = parts.slice(1).join('-');
        let $wrapper = $('.es-form-wrapper').find(
            `.added-dot-to-es-wrapper[data-id="${id}"], .added-img-to-es-wrapper[data-id="${id}"]`
        );
        $wrapper.find('input[name="skip_zoom_out"]').val($btn.hasClass('active') ? 1 : '');
    });
}

// walk rows, assign line_group_id values to form wrappers (mirror of updateGroupIds)
function updateLineGroupIds() {
    let groupCounter = 0;
    let inGroup = false;

    $('#esFormData tr.es-story-row').each(function () {
        let $row = $(this);
        let $btn = $row.find('.line-with-next');
        let parts = this.id.split('-');
        let id = parts.slice(1).join('-');
        let $wrapper = $('.es-form-wrapper').find(
            `.added-dot-to-es-wrapper[data-id="${id}"], .added-img-to-es-wrapper[data-id="${id}"]`
        );

        if ($btn.hasClass('active')) {
            if (!inGroup) {
                groupCounter++;
                inGroup = true;
            }
            $wrapper.find('input[name="line_group_id"]').val(groupCounter);
        } else {
            if (inGroup) {
                $wrapper.find('input[name="line_group_id"]').val(groupCounter);
                inGroup = false;
            } else {
                $wrapper.find('input[name="line_group_id"]').val('');
            }
        }
    });
}

// walk rows, assign group_id values to form wrappers
function updateGroupIds() {
    let groupCounter = 0;
    let inGroup = false;

    $('#esFormData tr.es-story-row').each(function () {
        let $row = $(this);
        let $groupBtn = $row.find('.group-with-next');
        let parts = this.id.split('-');
        let typePrefix = parts[0];
        let id = parts.slice(1).join('-');
        let $wrapper = $('.es-form-wrapper').find(
            `.added-dot-to-es-wrapper[data-id="${id}"], .added-img-to-es-wrapper[data-id="${id}"]`
        );

        if ($groupBtn.hasClass('active')) {
            if (!inGroup) {
                groupCounter++;
                inGroup = true;
            }
            $wrapper.find('input[name="group_id"]').val(groupCounter);
        } else {
            if (inGroup) {
                // last row in the current group
                $wrapper.find('input[name="group_id"]').val(groupCounter);
                inGroup = false;
            } else {
                $wrapper.find('input[name="group_id"]').val('');
            }
        }
    });
}

// validate groups after reorder or removal: disable toggle if next row is different image or video
function validateAndUpdateGroups() {
    let $rows = $('#esFormData tr.es-story-row');

    // strip stale visual state - we'll re-apply at the end based on active toggles
    $rows.removeClass('es-grouped-top es-grouped-bottom es-line-grouped-top es-line-grouped-bottom');

    // validate toggles: deactivate any that are no longer valid given current row layout
    $rows.each(function (idx) {
        let $row = $(this);
        let $btn = $row.find('.group-with-next');
        let $lineBtn = $row.find('.line-with-next');
        let $skipBtn = $row.find('.skip-zoom-with-next');
        let $nextRow = $rows.eq(idx + 1);
        let isVideo = $row.find('.remove-from-story').attr('img_id') !== undefined;
        let isLastRow = idx === $rows.length - 1;

        // skip-zoom-out helpers (eligibility computed after the group/line validation below)
        let disableSkip = (title) => $skipBtn
            .removeClass('active btn-warning').addClass('btn-outline-warning')
            .attr('disabled', true).attr('title', title);
        let enableSkip = () => $skipBtn
            .removeAttr('disabled').attr('title', 'Skip the zoom-out; move directly to the next step');

        if (isVideo) {
            $btn.removeClass('active btn-primary').addClass('btn-outline-primary');
            $btn.attr('disabled', true).attr('title', 'Videos cannot be grouped');
            $lineBtn.removeClass('active btn-info').addClass('btn-outline-info');
            $lineBtn.attr('disabled', true).attr('title', 'Videos cannot be grouped');
        } else if (isLastRow) {
            $btn.removeClass('active btn-primary').addClass('btn-outline-primary');
            $btn.attr('disabled', true).attr('title', 'No next step to group with');
            $lineBtn.removeClass('active btn-info').addClass('btn-outline-info');
            $lineBtn.attr('disabled', true).attr('title', 'No next step to group with');
        } else if ($nextRow.length) {
            let currentImgId = $row.attr('data-img-id');
            let nextImgId = $nextRow.attr('data-img-id');
            let nextIsVideo = $nextRow.find('.remove-from-story').attr('img_id') !== undefined;

            if (nextIsVideo) {
                $btn.removeClass('active btn-primary').addClass('btn-outline-primary');
                $btn.attr('disabled', true).attr('title', 'Cannot group with a video step');
                $lineBtn.removeClass('active btn-info').addClass('btn-outline-info');
                $lineBtn.attr('disabled', true).attr('title', 'Cannot group with a video step');
            } else if (currentImgId !== nextImgId) {
                $btn.removeClass('active btn-primary').addClass('btn-outline-primary');
                $btn.attr('disabled', true).attr('title', 'No next step to group with');
                $lineBtn.removeClass('active btn-info').addClass('btn-outline-info');
                $lineBtn.attr('disabled', true).attr('title', 'Next step is on a different image');
            } else {
                $btn.removeAttr('disabled').attr('title', 'Group with next step');
                $lineBtn.removeAttr('disabled').attr('title', 'Draw line to next step (locks camera)');
            }
        }

        // skip-zoom-out: available on any dot step that has a next step, EXCEPT when the step is
        // part of a group (pan) or line setup (those already control the zoom-out). a row is part
        // of a group/line if its own toggle is active or the previous row groups into it.
        let $prevRow = $rows.eq(idx - 1);
        let inGroupOrLine = $btn.hasClass('active') || $lineBtn.hasClass('active')
            || (idx > 0 && ($prevRow.find('.group-with-next').hasClass('active')
                         || $prevRow.find('.line-with-next').hasClass('active')));

        if (isVideo) {
            disableSkip('Video steps have no zoom-out to skip');
        } else if (isLastRow) {
            disableSkip('No next step to move to');
        } else if (inGroupOrLine) {
            disableSkip('Not available while this step is in a pan or line group');
        } else {
            enableSkip();
        }
    });

    // re-apply visual classes based on currently active toggles
    $rows.each(function (idx) {
        let $row = $(this);
        let $btn = $row.find('.group-with-next');
        let $lineBtn = $row.find('.line-with-next');
        let $nextRow = $rows.eq(idx + 1);
        if ($btn.hasClass('active') && $nextRow.length) {
            $row.addClass('es-grouped-bottom');
            $nextRow.addClass('es-grouped-top');
        }
        if ($lineBtn.hasClass('active') && $nextRow.length) {
            $row.addClass('es-line-grouped-bottom');
            $nextRow.addClass('es-line-grouped-top');
        }
    });

    updateGroupIds();
    updateLineGroupIds();
    updateSkipZoomInputs();
}

// restore group toggles from data-group-id attributes on rows (used after edit load)
function restoreGroupToggles() {
    let $rows = $('#esFormData tr.es-story-row');
    $rows.each(function (idx) {
        let $row = $(this);
        let groupId = $row.attr('data-group-id');
        if (!groupId) return;

        let $nextRow = $rows.eq(idx + 1);
        if (!$nextRow.length) return;

        let nextGroupId = $nextRow.attr('data-group-id');
        if (groupId === nextGroupId) {
            let $btn = $row.find('.group-with-next');
            $btn.addClass('active btn-primary').removeClass('btn-outline-primary');
            $row.addClass('es-grouped-bottom');
            $nextRow.addClass('es-grouped-top');
        }
    });
    restoreSkipZoomToggles();
    validateAndUpdateGroups();
}

// restore skip-zoom-out toggles from data-skip-zoom-out attributes (used after edit load)
function restoreSkipZoomToggles() {
    $('#esFormData tr.es-story-row').each(function () {
        let $row = $(this);
        if ($row.attr('data-skip-zoom-out') == 1) {
            $row.find('.skip-zoom-with-next')
                .addClass('active btn-warning').removeClass('btn-outline-warning');
        }
    });
}

// restore line group toggles from data-line-group-id attributes on rows (used after edit load)
function restoreLineGroupToggles() {
    let $rows = $('#esFormData tr.es-story-row');
    $rows.each(function (idx) {
        let $row = $(this);
        let lineGroupId = $row.attr('data-line-group-id');
        if (!lineGroupId) return;

        let $nextRow = $rows.eq(idx + 1);
        if (!$nextRow.length) return;

        let nextLineGroupId = $nextRow.attr('data-line-group-id');
        if (lineGroupId === nextLineGroupId) {
            let $btn = $row.find('.line-with-next');
            $btn.addClass('active btn-info').removeClass('btn-outline-info');
            $row.addClass('es-line-grouped-bottom');
            $nextRow.addClass('es-line-grouped-top');
        }
    });
    validateAndUpdateGroups();
}

$(document).on('click', '.add-dot-to-es', function () {
    const $btn = $(this);
    const isVideo = $btn.hasClass('video-image');
    const dotId = isVideo ? null : $btn.data('dot-id');
    const imgId = isVideo ? $btn.data('img-id') : $('.image-info.active').data('image-id');
    const order = $('.es-form-wrapper').find('form').length + 1;

    if (isVideo) {
        if (!$btn.hasClass('added')) {
            // Add video to story
            $btn.addClass('added')
                .removeClass('btn-secondary')
                .addClass('btn-success')
                .text('Remove video from exhibit story');

            // Add to form wrapper
            let $wrapper = $esFormWrapper
                .find(`.added-img-to-es-wrapper[data-id="${imgId}"]`);
            if (!$wrapper.length) {
                $wrapper = $(
                    `<div class="added-img-to-es-wrapper my-4 mx-1 d-flex flex-column" data-id="${imgId}"></div>`
                ).appendTo('.es-form-wrapper');
            }

            let $form = $wrapper.find('form');
            if (!$form.length) {
                $form = $('<form></form>').appendTo($wrapper);
            }

            $form.html(`
                <input name="imgId" value="${imgId}">
                <input name="zoom" value="1">
                <input name="panX" value=".50">
                <input name="panY" value=".25">
                <input type="checkbox" name="autoPlayVoice" value="0">
                <input class="d-none" type="text" name="order" value="${order}">
                <input type="hidden" name="delete" value="0">
                <input type="hidden" name="isVideo" value="1">
                <input type="hidden" name="group_id" value="">
                <input type="hidden" name="line_group_id" value="">
                <input type="hidden" name="skip_zoom_out" value="">
            `);

            // add row to finalize modal table
            // calculate step number based on current table rows to ensure new steps are at the end
            const currentRowCount = $esFormData.find('tr.es-story-row').length;
            const stepNumber = currentRowCount + 1;
            const thumb_src = $('.thumb-item[data-image-id="' + imgId + '"] img').attr('src');
            const previewText = `Step #${stepNumber} – i#${imgId} – Video step`;

            const rowHtml = `
                <tr id="img-${imgId}" class="es-story-row" data-img-id="${imgId}" data-group-id="">
                  <td class="es-img-preview" style="cursor: pointer; width: 100%">
                    <span class="preview-trigger" tabindex="0" style="text-decoration: underline; color: blue;">${previewText}</span>
                    <div class="preview-image"><img src="${thumb_src}" alt=""></div>
                  </td>
                  <td class="auto-play-wrapper" data-id="${imgId}">
                    <label class="custom-toggle">
                      <input type="checkbox" name="autoPlayVoice" disabled value="0">
                      <span class="auto-play-voice custom-toggle-slider rounded-circle"
                            data-label-off="No" data-label-on="Yes"></span>
                    </label>
                  </td>
                  <td class="group-toggle-wrapper">
                    <button class="btn btn-sm btn-outline-primary group-with-next" disabled title="Videos cannot be grouped">
                      <i class="fa fa-link"></i>
                    </button>
                  </td>
                  <td>
                    <button class="btn btn-danger btn-sm remove-from-story" img_id="${imgId}">Remove</button>
                  </td>
                  <td class="drag-handle">
                    <i class="fa fa-arrows-alt drag-handle-es" style="cursor:move; font-size:20px;"></i>
                  </td>
                </tr>
            `;

            $esFormData.append(rowHtml);
        } else {
            // Remove video from story
            // Find and click the remove button in the table
            let $removeButton = $(`.remove-from-story[img_id="${imgId}"]`);

            if ($removeButton.length) {
                $removeButton.click();
            } else {
                // Manual removal if button doesn't exist
                $btn.removeClass('added btn-success')
                    .addClass('btn-secondary')
                    .text('Add video to exhibit story');

                // Remove from form wrapper
                const $item = $('.es-form-wrapper').find(`.added-img-to-es-wrapper[data-id="${imgId}"]`);
                const hasStoryId = $item.find('input[name="story_id"]').val();

                if (hasStoryId && $saveExhibitStory.hasClass('update')) {
                    $item.find('input[name="delete"]').val(1);
                    $item.hide();
                } else {
                    $item.remove();
                }

                // Remove table row
                $(`#img-${imgId}`).remove();

                // Re-order remaining items
                $esFormDataTr.each(function (idx) {
                    const id = this.id.split('-')[1];
                    const prefix = this.id.split('-')[0] + '-';
                    $esFormWrapper
                        .find(`.added-${prefix}to-es-wrapper[data-id="${id}"]`)
                        .find('input[name="order"]')
                        .val(idx + 1);
                });
            }
        }
        return;
    }

    if (!$btn.hasClass('added')) {
        $btn.toggleClass('added');
        $btn.text('Remove from exhibit story')
            .removeClass('btn-secondary')
            .addClass('btn-success');

        let $parent = $btn.parent();
        let added_dot = `<div class="added-dot-to-es-wrapper my-4 mx-1 d-flex flex-column" data-id="${dotId}"></div>`;

        // zoom wrapper
        let $zoomWrapper = $parent.find(`.zoom-wrapper[data-id="${dotId}"]`);
        if ($zoomWrapper.length) {
            $zoomWrapper.removeClass('d-none').children('.btn').removeClass('btn-success').addClass('btn-secondary');
        } else {
            let set_zoom_and_pan_btn = `
        <div class="zoom-wrapper my-1 mx-1 d-flex flex-wrap" data-id="${dotId}" style="gap:4px;">
          <button class="btn btn-sm btn-secondary set-zoom-and-position">
            SET ZOOM AND POSITION <i class="fa fa-search"></i>
          </button>
          <button class="btn btn-sm btn-info preview-es-position" data-dot-id="${dotId}" title="Preview saved position">
            <i class="fa fa-crosshairs"></i> Preview
          </button>
        </div>`;
            $parent.append(set_zoom_and_pan_btn);
        }

        let $autoPlayWrapper = $parent.find(`.auto-play-wrapper[data-id="${dotId}"]`);
        if ($autoPlayWrapper.length) {
            $autoPlayWrapper.removeClass('d-none');
        } else {
            let auto_play_voice = `
        <div class="d-flex my-3 auto-play-wrapper" data-id="${dotId}">
          <label class="custom-toggle">
            <input type="checkbox" name="autoPlayVoice" value="1">
            <span class="auto-play-voice custom-toggle-slider rounded-circle"
                  data-label-off="No" data-label-on="Yes"></span>
          </label>
          <div class="ml-2">Auto play voice notes</div>
        </div>`;
            $parent.append(auto_play_voice);
        }

        let $addedDotWrapper = $('.es-form-wrapper').find(`.added-dot-to-es-wrapper[data-id="${dotId}"]`);

        if ($addedDotWrapper.length) {
            $addedDotWrapper.find('input[name="delete"]').val('0');
        } else {
            $esFormWrapper.append(added_dot);
        }

        $('.dot-pointer[data-id="' + dotId + '"]').addClass('active');

    } else {
        // Remove from exhibit story
        // Find and click the remove button in the table - this will handle everything
        let $removeButton = $(`.remove-from-story[dot_id="${dotId}"]`);

        if ($removeButton.length) {
            // If remove button exists in table, click it to trigger the remove handler
            $removeButton.click();
        } else {
            // If no remove button exists (shouldn't happen), handle removal manually
            $btn.toggleClass('added');
            $btn.text('Add to exhibit story').removeClass('btn-success').addClass('btn-secondary');

            // Remove zoom and autoplay wrappers from sidebar
            $btn.siblings('.zoom-wrapper, .auto-play-wrapper').remove();

            // Remove from form wrapper
            const selector = `.added-dot-to-es-wrapper[data-id="${dotId}"]`;
            const $item = $('.es-form-wrapper').find(selector);

            // Check if this is an existing item or newly added
            const hasStoryId = $item.find('input[name="story_id"]').val();

            if (hasStoryId && $saveExhibitStory.hasClass('update')) {
                // For existing items in edit mode, mark for deletion
                $item.find('input[name="delete"]').val(1);
                $item.hide();
            } else {
                // For newly added items, completely remove
                $item.remove();
            }

            // Remove table row
            $(`#dot-${dotId}`).remove();

            $('.dot-pointer[data-id="' + dotId + '"]').removeClass('active');
            // Re-order remaining items
            $esFormDataTr.each(function (idx) {
                const id = this.id.split('-')[1];
                const prefix = this.id.split('-')[0] + '-';
                $esFormWrapper
                    .find(`.added-${prefix}to-es-wrapper[data-id="${id}"]`)
                    .find('input[name="order"]')
                    .val(idx + 1);
            });
        }
    }
});

// save es

// save (and optionally immediately play) the exhibit story being authored
function submitExhibitStory(playAfter) {
    const token = $("meta[name='csrf-token']").attr('content');
    const isUpdate = $saveExhibitStory.hasClass('update');
    let finaliseModal = $finaliseEsModal;
    let allFormData = [];
    let storyId;

    if (isUpdate) {
        storyId = $('.es-form-wrapper').find('div').eq(0).find('form').find('input[name="story_id"]').val();
    } else {
        storyId = (Math.random().toString(36) + Math.random().toString(36)).substring(2, 12);
    }

    $('.es-form-wrapper').find('div').each(function (index) {
        let formData = {
            dotId: $(this).find('form').find('input[name="dotId"]').val(),
            zoom: $(this).find('form').find('input[name="zoom"]').val(),
            panX: $(this).find('form').find('input[name="panX"]').val(),
            panY: $(this).find('form').find('input[name="panY"]').val(),
            captureAspect: $(this).find('form').find('input[name="captureAspect"]').val(),
            captureWidth: $(this).find('form').find('input[name="captureWidth"]').val(),
            imgId: $(this).find('form').find('input[name="imgId"]').val(),
            autoPlayVoice: $(this).find('form').find('input[name="autoPlayVoice"]').val(),
            order: $(this).find('form').find('input[name="order"]').val(),
            delete: $(this).find('form').find('input[name="delete"]').val(),
            storyId: storyId,
            exhibitId: exhibit_id,
            es_name: finaliseModal.find('input[name="es_name"]').val(),
            auto_play_all_voice_notes: finaliseModal.find('input[name="exhibitStoryAutoplayAll"]').prop('checked') ? 1 : 0,
            isVideo: +$(this).find('form input[name="isVideo"]').val() || 0,
            dont_show_dots: finaliseModal.find('input[name="exhibitStoryDontShowDots"]').prop('checked') ? 1 : 0,
            dont_show_pins: finaliseModal.find('input[name="exhibitStoryDontShowPins"]').prop('checked') ? 1 : 0,
            show_only_active_dot: finaliseModal.find('input[name="exhibitStoryShowOnlyActiveDot"]').prop('checked') ? 1 : 0,
            group_id: $(this).find('form').find('input[name="group_id"]').val() || null,
            group_speed_multiplier: parseInt(finaliseModal.find('input[name="exhibitStoryGroupSpeedMultiplier"]').val(), 10) || 1,
            line_group_id: $(this).find('form').find('input[name="line_group_id"]').val() || null,
            line_anim_duration: parseFloat(finaliseModal.find('input[name="exhibitStoryLineAnimDuration"]').val()) || 1.0,
            skip_zoom_out: $(this).find('form').find('input[name="skip_zoom_out"]').val() || 0
        };

        allFormData.push(formData);

        $(this).remove();
    });

    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': token
        }
    });

    let url;

    if (isUpdate) {
        url = "/admin/es/update";
    } else {
        url = "/admin/exhibit_story_create";
    }

    // every step flagged for deletion means the story is pruned server-side
    const hasSteps = allFormData.some(f => !f.delete || f.delete == 0);

    return $.ajax({
        type: "POST",
        url: url,
        data: {formData: allFormData},
        dataType: "json",
        encode: true,
    }).then(function (response) {
        $('.add-dot-to-es').addClass('d-none btn-secondary').removeClass('added btn-success').text('Add to exhibit story');
        $finaliseEsModal.modal('hide');
        $exhibitStorySetup.addClass('d-none');

        $('.zoom-wrapper').remove();
        $('.auto-play-wrapper').remove();
        $('.es-form-wrapper').html("");

        $('#finaliseEsModal').find('input[name="es_name"]').val('Exhibit Story Name ' + Math.random().toString(36).substring(2, 7));
        $('#finaliseEsModal').find('input[name="exhibitStoryGroupSpeedMultiplier"]').val(1);
        $('#finaliseEsModal').find('input[name="exhibitStoryLineAnimDuration"]').val(1);

        if (response.status == 404) {
            alert(response.message);
        } else {
            $('.personal-alert').addClass('alert alert-success show-alert').css({'left': '50%'}).html(response.message);
            setTimeout(function () {
                $personalAlert.removeClass('show-alert');
            }, 2500);
            setTimeout(function () {
                $('.personal-alert').removeClass('alert alert-success show-alert').removeAttr('style').html('');
            }, 3000);

            if (!isUpdate) {
                let storySlug = response.storySlug;
                let storyName = response.storyName;
                let duration = response.duration;

                let buttonHTML = `
                    <div class="d-flex es-button-container">
                        <button class="btn btn-dark btn-sm my-2 start-exhibit-story" style="width: 90%;" data-exhibit-story-slug="${storySlug}">
                            ${storyName} [${duration}]
                        </button>
                        <button class="btn btn-sm btn-tdg-blue ml-auto my-auto share-exhibit-story" style="width: 32px; height: 32px; line-height: 22px" data-exhibit-story-slug="${storySlug}">
                            <i class="fas fa-share my-auto"></i>
                        </button>
                    </div>
                `;

                $('#es-container').append(buttonHTML);
            }

            // Dots wrapper return to normal mobile
            if ($windowWidth < 600) {
                DotsWrapperMobileNormal();
            }
        }

        if ($('.image-info.active').attr('data-is-video') == 1) {
            $dotsWrapper.removeClass('active');
            $showDotsButton.removeClass('d-flex').addClass('d-none')
        }

        $('#esFormData').html('');
        $('.es-form-wrapper').html('');
        $navButton.removeClass('d-none');
        $('#exhibitStoryAutoplayAll').prop('checked', false);
        exhibit_story_create_mode = false;

        if (playAfter && hasSteps && response.status != 404) {
            playExhibitStory(storyId);
        }
    });
}

$saveExhibitStory.on('click', function () {
    submitExhibitStory(false);
});

$('#saveAndPlayExhibitStory').on('click', function () {
    submitExhibitStory(true);
});


let isLoopMode = false;
let loopTimer = null;

// play a story by slug in normal mode (plays once, manual next/prev nav)
function playExhibitStory(storySlug) {
    // single-story play is never part of a run; clear any leftover run queue
    // so its last-step "next" can't chain into a stale run
    esRunQueue = [];
    esRunIndex = 0;

    return $.ajax({
        type: "GET",
        url: "/get_exh_story/" + storySlug,
    }).then(function (response) {
        if (!response.exh_story?.length) return;
        if (response.exh_story[0]?.dont_show_dots) presentationMode = true;
        if (response.exh_story[0]?.dont_show_pins) hidePinsMode = true;
        if (response.exh_story[0]?.show_only_active_dot) showOnlyActiveDotMode = true;
        groupSpeedMultiplier = parseInt(response.group_speed_multiplier, 10) || 1;
        lineAnimDuration = parseFloat(response.line_anim_duration) || 1.0;
        startExhibitStory(response.exh_story, false, null, false, presentationMode);
    });
}

// play exh story
$(document).on("click", ".start-exhibit-story", function () {
    let storySlug = $(this).attr('data-exhibit-story-slug');
    let loop = $(this).hasClass('es-loop');
    let startAtStep = $(this).hasClass('es-start-at-step');
    let presentationDirect = $(this).hasClass('es-presentation-direct');

    // single-story play is never part of a run; clear any leftover run queue
    // so its last-step "next" can't chain into a stale run
    esRunQueue = [];
    esRunIndex = 0;

    if (presentationDirect) {
        presentationMode = true;
        $.ajax({
            type: "GET",
            url: "/get_exh_story/" + storySlug,
        }).then(function (response) {
            groupSpeedMultiplier = parseInt(response.group_speed_multiplier, 10) || 1;
            startExhibitStory(response.exh_story, false, null, false, true);
            $esInfoArea.addClass('d-none');
        });
    } else if (!loop && !startAtStep) {
        playExhibitStory(storySlug);

    } else if (loop) {
        $('#play-es-loop').attr('data-exhibit-story-slug', storySlug);
        $('#loopEsModal').modal('show');
    } else if (startAtStep) {
        $('#start-at-step-es').attr('data-exhibit-story-slug', storySlug);
        $('#startAtStepEs').modal('show');
        $.ajax({
            type: "GET",
            url: "/get_exh_story/" + storySlug,
        }).then(function (response) {
            let totalSteps = (response.total_steps);
            $('#start-at-step-total').text('Total steps: ' + totalSteps);
        });
    }
});

// play run of show: fetch the story queue and chain playback
$(document).on('click', '.start-es-run', function () {
    const runSlug = $(this).attr('data-es-run-slug');

    $.ajax({
        type: "GET",
        url: "/get_es_run/" + runSlug,
    }).then(function (response) {
        if (!response.stories?.length) return;
        esRunQueue = response.stories;
        esRunIndex = 0;
        startRunStory();
    });
});

// run of show: open the loop config modal (reuses the ES loop modal)
$(document).on('click', '.es-run-loop', function () {
    const runSlug = $(this).attr('data-es-run-slug');
    $('#play-es-loop').attr('data-es-run-slug', runSlug).removeAttr('data-exhibit-story-slug');
    $('#loopEsModal').modal('show');
});

// run of show: stash for the start-at-story picker (fetched stories + slug)
let pendingRunStart = { slug: null, stories: [] };

// run of show: open the start-at-story picker, listing the run's stories by name
$(document).on('click', '.es-run-start-at', function () {
    const runSlug = $(this).attr('data-es-run-slug');

    $.ajax({
        type: "GET",
        url: "/get_es_run/" + runSlug,
    }).then(function (response) {
        if (!response.stories?.length) return;
        pendingRunStart = { slug: runSlug, stories: response.stories };

        const $list = $('#start-at-story-list').empty();
        response.stories.forEach(function (story, i) {
            const name = story.story_name || ('Story ' + (i + 1));
            $list.append(`<li class="list-group-item list-group-item-action pointer start-at-story-item" data-story-index="${i}">${i + 1}. ${name}</li>`);
        });

        $('#startAtStoryEs').attr('data-es-run-slug', runSlug).modal('show');
    });
});

// run of show: pick a story to start the run at, then continue through the rest
$(document).on('click', '.start-at-story-item', function () {
    if (!pendingRunStart.stories.length) return;
    esRunQueue = pendingRunStart.stories;
    esRunIndex = parseInt($(this).data('story-index'), 10) || 0;
    $('#startAtStoryEs').modal('hide');
    startRunStory();
});

// run of show: share link (mirrors .share-exhibit-story but with the es-run-slug param)
$(document).on('click', '.share-es-run', function () {
    $generatedShortURL.val('');
    $copyShortURL.attr('data-original-title', 'Copy link')
        .tooltip('dispose').tooltip();
    $iiifShareRow.addClass('d-none');
    $('.exhShareModal').modal('show');

    let runSlug = $(this).data('es-run-slug');
    let url = new URL($('#storyShareLink').val());
    url.searchParams.set('es-run-slug', runSlug);
    url.searchParams.delete('exhibit-story-slug');
    url.searchParams.delete('crt');
    url.searchParams.delete('thb');
    url.searchParams.delete('crtim');
    url.searchParams.delete('img-desc');
    $('#storyShareLink').val(url.toString());

    $('#customSwitch6').prop('checked', false);

    generateShortURL(true);
});

document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
        if (isLoopMode || esRunQueue.length) {
            finishExhibitStory()
        }
        if (aiRegionMode) {
            exitAiRegionMode();
            if (anno) anno.clearAiRegions();
        } else if (!$aiRegionCard.hasClass('d-none')) {
            closeAiRegionCard();
        }
    }
});

let aStepDur
let bStepDur
let zoomInDur = false;
let zoomOutDur = false;
let defaultPanAnimTime = 1.5;
let defaultZoomAnimTime = 3.2;
let groupSpeedMultiplier = 1;
// let zoomOutDur
// let useVoiceNotes

$('#play-es-loop').on('click', function () {
    isLoopMode = true;
    $('#loopEsModal').modal('hide');
    let storySlug = $(this).attr('data-exhibit-story-slug');
    let esRunSlug = $(this).attr('data-es-run-slug');

    aStepDur = $loopEsModalBody.find('input[name="astep-duration"]').val() * 1000;
    bStepDur = $loopEsModalBody.find('input[name="bstep-duration"]').val() * 1000;
    zoomInDur = $loopEsModalBody.find('input[name="zoom-in-duration"]').val();
    if (zoomInDur == 1) {
        zoomInDur = false;
    }
    zoomOutDur = $loopEsModalBody.find('input[name="zoom-out-duration"]').val();

    // run of show loop: auto-advance through every story, wrapping the whole run
    if (esRunSlug) {
        $.ajax({
            type: "GET",
            url: "/get_es_run/" + esRunSlug,
        }).then(function (response) {
            if (!response.stories?.length) return;
            esRunQueue = response.stories;
            esRunIndex = 0;
            startRunStory(false, true);
            $esInfoArea.addClass('d-none');
            autoAdvanceStory();
        });
        return;
    }

    $.ajax({
        type: "GET",
        url: "/get_exh_story/" + storySlug,
    }).then(function (response) {
        if (response.exh_story[0]?.dont_show_dots) presentationMode = true;
        if (response.exh_story[0]?.dont_show_pins) hidePinsMode = true;
        if (response.exh_story[0]?.show_only_active_dot) showOnlyActiveDotMode = true;
        groupSpeedMultiplier = parseInt(response.group_speed_multiplier, 10) || 1;
        lineAnimDuration = parseFloat(response.line_anim_duration) || 1.0;
        startExhibitStory(response.exh_story, false, null, true, presentationMode);
        $esInfoArea.addClass('d-none');
        autoAdvanceStory();
    });
})

$('#start-at-step-es').on('click', function () {
    $('#startAtStepEs').modal('hide');
    let storySlug = $(this).attr('data-exhibit-story-slug');
    let startingStep = $("input[name='starting-step']").val()

    // console.log(startingStep);
    $.ajax({
        type: "GET",
        url: "/get_exh_story/" + storySlug,
    }).then(function (response) {
        if (response.exh_story[0]?.dont_show_dots) presentationMode = true;
        if (response.exh_story[0]?.dont_show_pins) hidePinsMode = true;
        if (response.exh_story[0]?.show_only_active_dot) showOnlyActiveDotMode = true;
        groupSpeedMultiplier = parseInt(response.group_speed_multiplier, 10) || 1;
        lineAnimDuration = parseFloat(response.line_anim_duration) || 1.0;
        startExhibitStory(response.exh_story, true, startingStep, false, presentationMode);
        $esInfoArea.addClass('d-none');
    });
})


function enableInteractionBlocker() {
    if ($('#interaction-blocker').length === 0) {
        const blocker = $('<div id="interaction-blocker" class="interaction-blocker"></div>');
        $openseadragonViewer.append(blocker);
    }
}

function disableInteractionBlocker() {
    $('#interaction-blocker').remove();
}

// ── line-path sequence helpers ──────────────────────────────────────────
function enterLineGroupIfNeeded(firstRealStep) {
    if (lineGroupActive) return;
    lineGroupActive = true;
    // hard lock camera to first step's saved position
    applyView(parseFloat(firstRealStep.zoom), parseFloat(firstRealStep.pan_x), parseFloat(firstRealStep.pan_y), parseFloat(firstRealStep.capture_aspect));
    // disable user pan/zoom
    viewer.gestureSettingsMouse.dragToPan = false;
    viewer.gestureSettingsMouse.scrollToZoom = false;
    viewer.gestureSettingsMouse.clickToZoom = false;
    viewer.gestureSettingsTouch.dragToPan = false;
    viewer.gestureSettingsTouch.pinchToZoom = false;
    enableInteractionBlocker();
}

function exitLineGroup() {
    if (!lineGroupActive && lineGroupLines.length === 0) return;
    clearAllLineGroupLines();
    viewer.gestureSettingsMouse.dragToPan = true;
    viewer.gestureSettingsMouse.scrollToZoom = true;
    viewer.gestureSettingsMouse.clickToZoom = true;
    viewer.gestureSettingsTouch.dragToPan = true;
    viewer.gestureSettingsTouch.pinchToZoom = true;
    disableInteractionBlocker();
    lineGroupActive = false;
}

function drawLineToDot(fromDotId, toDotId, imgId, durationMs) {
    const cache = window.imageDataCache?.[imgId];
    if (!cache) { console.warn('[line-path] no imageDataCache for img', imgId); return; }
    const fromDot = cache.dots.find(d => d.id == fromDotId);
    const toDot = cache.dots.find(d => d.id == toDotId);
    if (!fromDot || !toDot) { console.warn('[line-path] missing dot(s)', fromDotId, toDotId); return; }
    if (!anno) { console.warn('[line-path] no anno instance'); return; }
    const fabricCanvas = anno.canvas;
    const FabLine = anno.Line;
    if (!fabricCanvas || !FabLine) { console.warn('[line-path] no fabric canvas/Line', !!fabricCanvas, !!FabLine); return; }
    // dot.coord_x/coord_y are viewport-normalized (0-1); convert to image coords for fabric overlay
    const fromImg = viewer.viewport.viewportToImageCoordinates(
        new OpenSeadragon.Point(parseFloat(fromDot.coord_x), parseFloat(fromDot.coord_y))
    );
    const toImg = viewer.viewport.viewportToImageCoordinates(
        new OpenSeadragon.Point(parseFloat(toDot.coord_x), parseFloat(toDot.coord_y))
    );
    console.log('[line-path] drawing', { fromImg, toImg, fromDot, toDot, durationMs });
    // The line group locks the camera to its first step's saved zoom, often well past OSD's
    // home (contain) zoom. The fabric stroke lives in image-space, so it magnifies on screen
    // by displayZoom/homeZoom and covers the image. Divide it back down so the line keeps a
    // constant on-screen thickness (never thicker than at default zoom). Camera is locked, so
    // getZoom() (target) is the settled display zoom for the whole group. Floor at 1px on-screen.
    const baseStrokePx = ($windowWidth < 600 ? 8 : 3);
    const homeZoom = viewer.viewport.getHomeZoom();
    const displayZoom = viewer.viewport.getZoom();              // target zoom (camera locked)
    const zoomRatio = (homeZoom && displayZoom) ? Math.max(1, displayZoom / homeZoom) : 1;
    const homeImgScale = anno._homeImageScale() || 1;
    const minStrokeImg = 1 / (homeImgScale * zoomRatio);        // renders 1px on screen
    const strokeImg = baseStrokePx / (homeImgScale * zoomRatio);
    // start animation from zero-length at fromImg
    const line = new FabLine([fromImg.x, fromImg.y, fromImg.x, fromImg.y], {
        stroke: '#FF5252',
        strokeWidth: Math.max(minStrokeImg, strokeImg),
        strokeUniform: true,
        strokeLineCap: 'round',
        selectable: false,
        evented: false,
        excludeFromExport: true,
    });
    // snap any still-animating line to full length before starting a new one, so clicking
    // next mid-draw completes the current line instead of animating several at once
    completeInProgressLines();

    fabricCanvas.add(line);
    fabricCanvas.requestRenderAll();
    lineGroupLines.push(line);

    // remember the endpoint so the line can be snapped to completion on demand
    line._lineEndX = toImg.x;
    line._lineEndY = toImg.y;
    line._animDone = false;

    // manual rAF tween (avoids fabric v6 animate API quirks)
    const startTs = performance.now();
    const x1 = fromImg.x, y1 = fromImg.y, dx = toImg.x - fromImg.x, dy = toImg.y - fromImg.y;
    function step(now) {
        if (line._animDone) return; // snapped to completion elsewhere
        const t = Math.min(1, (now - startTs) / durationMs);
        // easeOutQuad
        const e = 1 - (1 - t) * (1 - t);
        line.set({ x2: x1 + dx * e, y2: y1 + dy * e });
        fabricCanvas.requestRenderAll();
        if (t < 1 && lineGroupLines.indexOf(line) !== -1) {
            requestAnimationFrame(step);
        } else {
            line._animDone = true;
        }
    }
    requestAnimationFrame(step);
}

// finish any lines still mid-animation by snapping them to their endpoint
function completeInProgressLines() {
    if (!anno) return;
    const fabricCanvas = anno.canvas;
    if (!fabricCanvas) return;
    let changed = false;
    lineGroupLines.forEach(function (line) {
        if (line && !line._animDone) {
            line.set({ x2: line._lineEndX, y2: line._lineEndY });
            line._animDone = true;
            changed = true;
        }
    });
    if (changed) fabricCanvas.requestRenderAll();
}

function removeLastLine() {
    if (!anno) return;
    const fabricCanvas = anno.canvas;
    if (!fabricCanvas || !lineGroupLines.length) return;
    const line = lineGroupLines.pop();
    fabricCanvas.remove(line);
    fabricCanvas.requestRenderAll();
}

function clearAllLineGroupLines() {
    if (!anno) {
        lineGroupLines = [];
        return;
    }
    const fabricCanvas = anno.canvas;
    if (!fabricCanvas) {
        lineGroupLines = [];
        return;
    }
    lineGroupLines.forEach(l => fabricCanvas.remove(l));
    lineGroupLines = [];
    fabricCanvas.requestRenderAll();
}

// fraction above the contain home zoom still treated as a "home" step
const HOME_ZOOM_EPS = 0.03;

// apply a real step's saved viewport view.
// when a home step is reached the viewport is already resting at home (entry goHome for
// step 1, or the preceding middle-step goHome for later steps). under visibilityRatio:1
// that resting zoom is the cover zoom, while goHome()/getHomeZoom() target the contain
// home (more zoomed out than allowed), so re-issuing goHome() makes the spring dip toward
// contain then bounce back to cover -> the visible zoom-out. since we're already at home,
// a home step should simply leave the camera put.
// reproduce a captured viewport view independent of the current container width.
// captureAspect is the osd container aspect ratio at capture time: with zoom+pan it
// reconstructs the authored viewport rect, and fitBounds re-fits that rect into whatever
// width the viewer currently has (matches on normal/mobile playback; keeps the authored
// framing visible when presentation mode / 4k un-shrinks the viewer). legacy steps have no
// captureAspect, so we fall back to the raw panTo/zoomTo.
function applyView(zoom, panX, panY, captureAspect) {
    const vp = viewer.viewport;
    if (isFinite(captureAspect) && captureAspect > 0 && isFinite(zoom) && zoom > 0) {
        const w = 1 / zoom;
        const h = w / captureAspect;
        vp.fitBounds(new OpenSeadragon.Rect(panX - w / 2, panY - h / 2, w, h));
    } else {
        vp.panTo(new OpenSeadragon.Point(panX, panY));
        vp.zoomTo(zoom);
    }
}

function applyStepView(zoom, panX, panY, captureAspect) {
    const vp = viewer.viewport;
    const isHome = !isFinite(zoom) || zoom <= vp.getHomeZoom() * (1 + HOME_ZOOM_EPS);
    if (isHome) {
        return;
    }
    applyView(zoom, panX, panY, captureAspect);
}

// --- upcoming-step tile prefetch -------------------------------------------
// a story step jumps straight to a deep pyramid level over one region, so its
// tiles are usually a cold cloudfront miss (1.5-19s against serverless-iiif).
// while the current step dwells we fetch the next steps' tiles, which puts them
// in the browser cache and warms the edge for everyone else.
const prefetchedTiles = new Set();
const PREFETCH_TILE_SIZE = 256;          // matches IiifCacheService::TILE_SIZE
// A full viewport is ~50-60 tiles at 1700px wide and more on a 4k screen. These
// are the same tiles the step would request anyway, just fetched earlier, so the
// cap is only a runaway guard — set it above a realistic viewport, not below.
const PREFETCH_MAX_TILES_PER_STEP = 90;

// the IIIF level2 region URLs one authored step reads. mirrors
// IiifCacheService::stepUrls(), but uses the container width we're actually
// playing at rather than the one the step was authored in.
function stepTileUrls(step) {
    const base = (window.exhibitConfig && window.exhibitConfig.iiifBase) || '';
    const idx = (window.imageIds || []).indexOf(parseInt(step.img_id, 10));
    const page = idx >= 0 ? (window.pages || [])[idx] : null;
    if (!base || !page || page.type !== 'image'
            || typeof page.tileSource !== 'string' || page.tileSource.indexOf(base) !== 0) {
        return [];
    }

    const imgW = page.imageWidth, imgH = page.imageHeight;
    const zoom = parseFloat(step.zoom);
    const panX = parseFloat(step.pan_x), panY = parseFloat(step.pan_y);
    const capW = viewer.viewport.containerSize.x;
    if (!imgW || !imgH || !capW || !isFinite(zoom) || zoom <= 0
            || !isFinite(panX) || !isFinite(panY)) {
        return [];
    }

    // same rect applyView() reconstructs; viewport units are normalised by the
    // image width on both axes. legacy steps have no capture_aspect and play
    // back through raw panTo/zoomTo, so the live aspect is the right stand-in.
    const aspect = parseFloat(step.capture_aspect);
    const wVp = 1 / zoom;
    const hVp = wVp / (isFinite(aspect) && aspect > 0 ? aspect : viewer.viewport.getAspectRatio());
    const x0 = Math.max(0, (panX - wVp / 2) * imgW);
    const y0 = Math.max(0, (panY - hVp / 2) * imgW);
    const x1 = Math.min(imgW, (panX + wVp / 2) * imgW);
    const y1 = Math.min(imgH, (panY + hVp / 2) * imgW);
    if (x0 >= x1 || y0 >= y1) return [];

    // full-res pixels per screen pixel -> the level OSD will resolve to
    const levels = Math.ceil(Math.log2(Math.max(imgW, imgH) / PREFETCH_TILE_SIZE)) + 1;
    const level = Math.max(0, Math.min(levels - 1, Math.floor(Math.log2(Math.max((x1 - x0) / capW, 1)))));
    const scale = Math.pow(2, level);
    const span = PREFETCH_TILE_SIZE * scale;
    const id = page.tileSource.replace('/info.json', '');

    // the grid must stay aligned to multiples of span or the URLs won't match
    // the ones OSD requests and the prefetch is wasted
    const urls = [];
    for (let ry = Math.floor(y0 / span) * span; ry < imgH && ry < y1; ry += span) {
        for (let rx = Math.floor(x0 / span) * span; rx < imgW && rx < x1; rx += span) {
            const rw = Math.min(span, imgW - rx);
            const rh = Math.min(span, imgH - ry);
            // both size dimensions: OSD requests "256,256" / "240,176", and
            // "256," is a different URL that would miss the cache
            const sw = Math.ceil(rw / scale);
            const sh = Math.ceil(rh / scale);
            const region = (rx === 0 && ry === 0 && rw === imgW && rh === imgH)
                ? 'full'
                : rx + ',' + ry + ',' + rw + ',' + rh;
            urls.push(id + '/' + region + '/' + sw + ',' + sh + '/0/default.jpg');
            if (urls.length >= PREFETCH_MAX_TILES_PER_STEP) return urls;
        }
    }
    return urls;
}

// fromIndex is exclusive of the step being displayed during normal playback, but
// story start passes the first step's own index: at that point we're sitting in
// the "1a" phase at home zoom and its authored viewport hasn't been applied yet.
function prefetchUpcomingSteps(lookahead = 2, fromIndex = null) {
    if (!Array.isArray(stepsArray) || !stepsArray.length || typeof viewer === 'undefined') return;
    let found = 0;
    const start = fromIndex === null ? currentStepIndex + 1 : fromIndex;
    for (let i = start; i < stepsArray.length && found < lookahead; i++) {
        const step = stepsArray[i];
        if (!step || step.is_middle_step) continue;
        found++;
        stepTileUrls(step).forEach(function (url) {
            if (prefetchedTiles.has(url)) return;
            prefetchedTiles.add(url);
            const img = new Image();
            img.decoding = 'async';
            img.src = url;
        });
    }
}

// a step is "home" when its saved zoom is at or below the contain home zoom
function stepIsHome(step) {
    if (!step) return false;
    const z = parseFloat(step.zoom);
    return !isFinite(z) || z <= viewer.viewport.getHomeZoom() * (1 + HOME_ZOOM_EPS);
}

// a middle step needs its goHome zoom-out only when the step we're LEAVING is zoomed in. if
// that step used default zoom/pan (home) there's nothing to pull back from, and re-homing
// would show a spurious dip under visibilityRatio:1. `fromStep` is the departing step (.next
// leaves the earlier step, .prev the later one); `earlierStep` carries the manual skip flag,
// which lives on the earlier step of the boundary and governs both directions.
function middleNeedsZoomOut(fromStep, earlierStep = fromStep) {
    if (earlierStep && earlierStep.skip_zoom_out) return false;
    return !stepIsHome(fromStep);
}

let hasAutoStarted = false;

function autoAdvanceStory() {
    enterFullScreen();
    if (currentStepIndex >= stepsArray.length) {
        // run of show loop: advance to the next story (wrap to the first after the last)
        if (esRunQueue.length) {
            esRunIndex = (esRunIndex < esRunQueue.length - 1) ? esRunIndex + 1 : 0;
            hasAutoStarted = false;

            if (zoomOutDur) {
                viewer.viewport.zoomSpring.animationTime = zoomOutDur;
                viewer.viewport.centerSpringX.animationTime = zoomOutDur;
                viewer.viewport.centerSpringY.animationTime = zoomOutDur;
            }

            viewer.viewport.goHome();

            setTimeout(function () {
                startRunStory(false, true);
                // hasAutoStarted is false, so autoAdvanceStory applies the first-step dwell itself
                loopTimer = setTimeout(autoAdvanceStory, 0);
            }, 1100);

            return;
        }

        currentStepIndex = 0;
        realStepIndex = 1;
        hasAutoStarted = false;
        if (zoomOutDur) {
            viewer.viewport.zoomSpring.animationTime = zoomOutDur;
            viewer.viewport.centerSpringX.animationTime = zoomOutDur;
            viewer.viewport.centerSpringY.animationTime = zoomOutDur;
        }

        viewer.viewport.goHome();

        if (zoomInDur) {
            viewer.viewport.zoomSpring.animationTime = zoomInDur;
            viewer.viewport.centerSpringX.animationTime = zoomInDur - 1;
            viewer.viewport.centerSpringY.animationTime = zoomInDur - 1;
        }

        setTimeout(function () {
            const firstStep = stepsArray[0];
            updateStepUI(realStepIndex, firstStep.img_id);
            const imgOrder = $('.thumb-item[data-image-id="' + firstStep.img_id + '"]').index();
            viewer.goToPage(imgOrder - 1);
            setTimeout(function () {
                if (!presentationMode) {
                    openDot(firstStep.dot_id);
                }
            }, 250)

            loopTimer = setTimeout(autoAdvanceStory, 0);
        }, 1100);

        return;
    }

    const currentStep = stepsArray[currentStepIndex];
    let duration = currentStep.is_middle_step ? aStepDur : bStepDur;

    if (!hasAutoStarted) {
        hasAutoStarted = true;
        enableInteractionBlocker();
        loopTimer = setTimeout(autoAdvanceStory, aStepDur);
        return;
    }

    if (currentStep.is_middle_step) {
        // line-path: no pan/zoom, draw animated line between dots
        if (currentStep.in_line_group) {
            let nextStep = stepsArray[currentStepIndex + 1];
            let prevReal = stepsArray[currentStepIndex - 1];
            let dotId = nextStep.dot_id;

            if (prevReal) enterLineGroupIfNeeded(prevReal);
            if (prevReal) drawLineToDot(prevReal.dot_id, nextStep.dot_id, currentStep.img_id, lineAnimDuration * 1000);

            $('.dot-number').removeClass('current-dot-story-step');
            $('.dot-pointer').removeClass('active');

            setTimeout(() => {
                $('.dot-pointer[data-id="' + nextStep.dot_id + '"]').addClass('active')
                    .children(":first").css('display', 'block').addClass('current-dot-story-step');
                if (!presentationMode) {
                    openDot(dotId);
                }
            }, 30);

            updateStepUI(realStepIndex, nextStep.img_id);
            setStepBText($currentEsStep);
            setStepBText($currentEsStepLeft);
            setStepBText($currentEsStepLeftDotModal);
            realStepIndex++;
            // skip past the real step (already handled), end-of-fn does another increment
            currentStepIndex++;
            duration = Math.max(aStepDur, lineAnimDuration * 1000);
        } else if (currentStep.in_group) {
            // exit any active line group
            exitLineGroup();
            let nextStep = stepsArray[currentStepIndex + 1];
            let dotId = nextStep.dot_id;

            $('.dot-number').removeClass('current-dot-story-step');
            $('.dot-pointer').removeClass('active');

            // slow down pan and zoom by grouped multiplier
            viewer.viewport.centerSpringX.animationTime = defaultPanAnimTime * groupSpeedMultiplier;
            viewer.viewport.centerSpringY.animationTime = defaultPanAnimTime * groupSpeedMultiplier;
            viewer.viewport.zoomSpring.animationTime = defaultZoomAnimTime * groupSpeedMultiplier;

            applyView(parseFloat(nextStep.zoom), parseFloat(nextStep.pan_x), parseFloat(nextStep.pan_y), parseFloat(nextStep.capture_aspect));

            setTimeout(() => {
                $('.dot-pointer[data-id="' + nextStep.dot_id + '"]').addClass('active')
                    .children(":first").css('display', 'block').addClass('current-dot-story-step');
                if (!presentationMode) {
                    openDot(dotId);
                }
            }, 30);

            updateStepUI(realStepIndex, nextStep.img_id);
            // skip "a", go directly to "b" since no zoom-out phase
            setStepBText($currentEsStep);
            setStepBText($currentEsStepLeft);
            setStepBText($currentEsStepLeftDotModal);
            // bump realStepIndex since we just processed a real step (the dot we panned to)
            realStepIndex++;
            // extra increment to skip past the real step (already handled)
            currentStepIndex++;
            duration = Math.max(aStepDur, defaultPanAnimTime * groupSpeedMultiplier * 1000);
        } else {
        // exit any active line group when leaving
        exitLineGroup();
        // restore pan and zoom speed after leaving group
        viewer.viewport.centerSpringX.animationTime = defaultPanAnimTime;
        viewer.viewport.centerSpringY.animationTime = defaultPanAnimTime;
        viewer.viewport.zoomSpring.animationTime = defaultZoomAnimTime;
        if (zoomOutDur) {
            viewer.viewport.zoomSpring.animationTime = zoomOutDur;
            viewer.viewport.centerSpringX.animationTime = zoomOutDur;
            viewer.viewport.centerSpringY.animationTime = zoomOutDur;
        }
        const aaNeedZoomOut = middleNeedsZoomOut(stepsArray[currentStepIndex - 1]);
        if (aaNeedZoomOut) viewer.viewport.goHome();
        if (zoomInDur) {
            viewer.viewport.zoomSpring.animationTime = zoomInDur;
            viewer.viewport.centerSpringX.animationTime = zoomInDur - 1;
            viewer.viewport.centerSpringY.animationTime = zoomInDur - 1;
        }
        updateUIForMiddleStep(aaNeedZoomOut);

        const nextStep = stepsArray[currentStepIndex + 1];
        let targetStep = stepsArray[currentStepIndex + 1] || {};
        let dotId = targetStep.dot_id;

        if (nextStep && currentStep.img_id !== nextStep.img_id) {
            // no zoom-out animation to wait for (manual skip, or already at home): cut immediately
            let zoomOutDelay = (currentStep.skip_zoom || !aaNeedZoomOut) ? 0 : 1100;
            const imageSwitchDelay = 250;
            duration += zoomOutDelay + imageSwitchDelay;

            if (zoomOutDur) {
                viewer.viewport.zoomSpring.animationTime = zoomOutDur;
                viewer.viewport.centerSpringX.animationTime = zoomOutDur;
                viewer.viewport.centerSpringY.animationTime = zoomOutDur;
            }
            if (aaNeedZoomOut) viewer.viewport.goHome();

            if (zoomInDur) {
                viewer.viewport.zoomSpring.animationTime = zoomInDur;
                viewer.viewport.centerSpringX.animationTime = zoomInDur - 1;
                viewer.viewport.centerSpringY.animationTime = zoomInDur - 1;
            }

            setTimeout(function () {
                const imgOrder = $('.thumb-item[data-image-id="' + nextStep.img_id + '"]').index();
                viewer.goToPage(imgOrder - 1);

                setTimeout(() => {
                    updateStepUI(realStepIndex, nextStep.img_id);

                    $('.dot-pointer[data-id="' + nextStep.dot_id + '"]').addClass('active')
                        .children(":first").css('display', 'block').addClass('current-dot-story-step');
                    if (!presentationMode) {
                        openDot(dotId);
                    }
                }, imageSwitchDelay);
            }, zoomOutDelay);
        } else {
            // No image switch, update right away
            updateStepUI(realStepIndex, nextStep.img_id);

            setTimeout(() => {
                $('.dot-pointer[data-id="' + nextStep.dot_id + '"]').addClass('active')
                    .children(":first").css('display', 'block').addClass('current-dot-story-step');
                if (!presentationMode) {
                    openDot(dotId);
                }
            }, 30);
        }
        } // close else for non-grouped middle steps

    } else {
        // const prevStep = stepsArray[currentStepIndex - 1];

        // if (!prevStep || currentStep.img_id !== prevStep.img_id) {
        //     const imgOrder = $('.thumb-item[data-image-id="' + currentStep.img_id + '"]').index();
        //     viewer.goToPage(imgOrder - 1);
        // }

        setTimeout(() => {
            if (!$modalDotFull.is(':visible') && !presentationMode) {
                openDot(currentStep.dot_id);
            }

            const esText = $currentEsStep.text().trim();

            if (esText.endsWith('a')) {
                setStepBText($currentEsStep);
                setStepBText($currentEsStepLeft);
                setStepBText($currentEsStepLeftDotModal);
            }

            applyStepView(parseFloat(currentStep.zoom), parseFloat(currentStep.pan_x), parseFloat(currentStep.pan_y), parseFloat(currentStep.capture_aspect));
        }, 100);

        updateStepUI(realStepIndex, currentStep.img_id);
        realStepIndex++;
    }

    currentStepIndex++;
    loopTimer = setTimeout(autoAdvanceStory, duration);
}


let stepsArray = [];
let currentStepIndex = 0;
let realStepIndex = 1;
let lastDirection = 'forward';
let presentationMode = false;
let hidePinsMode = false;
let showOnlyActiveDotMode = false;
let lineGroupActive = false;
let lineGroupLines = [];
let lineAnimDuration = 1.0;

// run of show: queue of per-story payloads (same shape as /get_exh_story response)
let esRunQueue = [];
let esRunIndex = 0;

// reset per-story flags from a /get_exh_story-shaped payload. full reset matters:
// existing handlers only ever set the flags true and chaining skips finishExhibitStory
function applyStorySettings(payload) {
    presentationMode = !!payload.exh_story[0]?.dont_show_dots;
    hidePinsMode = !!payload.exh_story[0]?.dont_show_pins;
    showOnlyActiveDotMode = !!payload.exh_story[0]?.show_only_active_dot;
    groupSpeedMultiplier = parseInt(payload.group_speed_multiplier, 10) || 1;
    lineAnimDuration = parseFloat(payload.line_anim_duration) || 1.0;
}

// start the story at esRunIndex; atLastStep lands on its final real step (prev chaining)
// looping=true when the run is playing in autoplay/loop mode
function startRunStory(atLastStep = false, looping = false) {
    const payload = esRunQueue[esRunIndex];
    applyStorySettings(payload);
    startExhibitStory(payload.exh_story, atLastStep, atLastStep ? payload.total_steps : null, looping, presentationMode);

    // prev must stay clickable across run boundaries
    if (esRunIndex > 0 || (atLastStep && payload.total_steps > 1)) {
        $exhibitStoryNavPrev.removeClass('disabled').attr('disabled', false);
    }
}

function startExhibitStory(stories, startAtStep = false, startStep = null, looping = false, presentationMode = false) {
    const $exhibitVoiceGroup = $('.exhibit-voice-group');
    const $imageVoiceGroup = $('.image-voice-group');
    const $dotVoiceGroup = $('.dot-voice-group');
    const $exhDotButton = $('.exh-dot-button');
    const $voiceNoteButton = $('.voice_note_button');
    const $dotModalNavigation = $('.dot-modal-navigation');
    const $closeDotModal = $('.close-dot-modal');
    const $editDot = $('.editDot');
    const $mainContent = $('.main-content');
    const $esImageTitleLeft = $('#es-image-title-left');
    const $exhibitStoryNameLeft = $('#exhibit-story-name-left');
    $('.dot-modal-header').addClass('d-none');
    $('.exhibit-story-header').removeClass('d-none');

    // suppress page scrollbar during ES playback (fixed 100vh panels can overflow the viewport)
    $('body').addClass('es-playing');

    $closeExhText.addClass('d-none');
    $esButtonWrapper.removeClass('d-flex').addClass('d-none');
    $dotFullClose.addClass('d-none');
    $dotFooter.addClass('d-none');
    $closeModalBtn.removeClass('d-sm-block');
    $('.image-info-close').addClass('d-none');
    $exhibitTextFooter.addClass('d-none');
    $('.image-count').addClass('d-none').removeClass('d-flex');
    $('.dot-number').each(function () {
        if ($(this).hasClass('user-dot-color')) {
            $(this).removeClass('user-dot-color').addClass('user-dot-color-disabled');
        }
    });

    if ($windowWidth >= 600) {
        enterFullScreen();
    }

    $exhibitVoiceContainer.addClass('d-none');
    $exhibitVoiceGroup.addClass('d-none');
    $('.image-voice-container').addClass('d-none');
    $imageVoiceGroup.addClass('d-none');
    $dotVoiceContainer.addClass('d-none');
    $dotVoiceGroup.addClass('d-none');

    $modalDotFull.modal('hide');

    if ($exhDotButton.hasClass('active')) {
        $exhDotButton.click();
    }

    if ($exhInfoButton.hasClass('active')) {
        $exhInfoButton.click();
    }

    $voiceNoteButton.removeClass('active').removeAttr('style');

    viewer.viewport.zoomSpring.animationTime = 3.2;
    viewer.viewport.centerSpringX.animationTime = 1.5;
    viewer.viewport.centerSpringY.animationTime = 1.5;

    if (screen.width >= 3840) {
        viewer.viewport.zoomSpring.animationTime = 5.5;
        viewer.viewport.centerSpringX.animationTime = 2.5;
        viewer.viewport.centerSpringY.animationTime = 2.5;
    }

    if (zoomInDur) {
        viewer.viewport.zoomSpring.animationTime = zoomInDur;
        viewer.viewport.centerSpringX.animationTime = zoomInDur - 1;
        viewer.viewport.centerSpringY.animationTime = zoomInDur - 1;
    }

    defaultPanAnimTime = viewer.viewport.centerSpringX.animationTime;
    defaultZoomAnimTime = viewer.viewport.zoomSpring.animationTime;

    viewer.viewport.goHome();
    $modalExhibitInfo.modal('hide');
    $thumbsWrapper.removeClass('active');
    $dotModalNavigation.removeClass('d-md-block');
    if (!isLoopMode) {
        $exhibitStoryNavigation.removeClass('d-none');
    }
    $closeDotModal.removeClass('d-sm-block d-inline');
    $dotShare.removeClass('d-sm-block d-inline').addClass('d-none');
    $bottomImageName.addClass('d-none');
    $editDot.addClass('d-none');
    $buttonsWrapper.addClass('d-none');
    $dotsCounter.addClass('d-none');

    if ($windowWidth < 600) {
        $dotFullClose.removeClass('d-block d-sm-none').addClass('d-none');
        $dotsWrapper.addClass('d-none').removeAttr('style');
    } else {
        $('.image-voice-container').css('height', '15%');
        $dotVoiceContainer.css('height', '15%');
        $exhibitVoiceContainer.css('height', '15%');
    }

    if ($('.overlay-exhibit-story').length > 0) {
        $('.overlay-exhibit-story').remove();
    }

    const overlay = `
        <div class="overlay-exhibit-story text-center">
            <button class="cancel-story-button rounded-circle btn btn-danger position-absolute">
                <i class="fa fa-times" aria-hidden="true"></i>
            </button>
            <button class="cancel-story-grid-button rounded-circle btn btn-danger position-absolute">
                <i class="fas fa-th" aria-hidden="true"></i>
            </button>
        </div>`;

    stepsArray = [];

    // Build the steps array from the story
    stories.forEach(function (story) {
        stepsArray.push(story);
    });


    if (looping) {
        stepsArray = stepsArray.filter((item, index, arr) => {
            if (item.video === true) {
                // also remove its following middle step if it exists
                if (arr[index + 1]?.is_middle_step) {
                    arr[index + 1]._remove = true;
                }
                return false;
            }
            return !item._remove;
        });
    }


    $mainContent.prepend(overlay);
    $startExhibitStoryParent.addClass('d-none');
    $exhibitStoryLeft.removeClass('d-none');

    const img_name = $('.image-info[data-image-id="' + stepsArray[0].img_id + '"]').find('.image-title').text();

    $exhibitStoryNameLeft.text(stepsArray[0].story_name);
    $esImageTitleLeft.text(img_name);
    const realSteps = stepsArray.filter(step => !step.is_middle_step);

    let firstStep;
    if (startAtStep === true && startStep) {
        realStepIndex = startStep;
        const targetRealStepIndex = startStep - 1;
        firstStep = realSteps[targetRealStepIndex];
        currentStepIndex = stepsArray.findIndex(s => s === firstStep);
        $currentEsStepLeft.text(startStep);
        $currentEsStepLeftDotModal.text(startStep);
        $currentEsStep.text(startStep);
        $dotFrom.text(startStep);
    } else {
        firstStep = stepsArray[0];
        currentStepIndex = 0;
        // reset explicitly: chained run-of-show starts skip cleanupAfterStory,
        // which normally resets this between stories
        realStepIndex = 1;
        $currentEsStepLeft.text(1);
        $currentEsStepLeftDotModal.text(1);
        $currentEsStep.text(1);
        $dotFrom.text(1);
    }


    $('#total-es-steps').text(realSteps.length);
    $totalEsStepsLeft.text(realSteps.length);
    $('#total-es-steps-left-dotModal').text(realSteps.length);

    // Handle first step logic

    // safety net: if a previous teardown ever bailed out before clearing this,
    // starting a new story must not inherit a flag that blocks ending it
    isFinishingStory = false;

    // step 1a sits at home zoom for aStepDur before 1b applies the authored
    // viewport, so this is the one window to warm the first step's tiles — and
    // the only step nothing else prefetches ahead of. deferred a beat so the
    // fullscreen transition above has settled the container width, which is what
    // decides the pyramid level.
    setTimeout(function () { prefetchUpcomingSteps(2, currentStepIndex); }, 500);

    $currentEsStep.text($currentEsStep.text() + 'a');
    $currentEsStepLeft.text($currentEsStepLeft.text() + 'a');
    $currentEsStepLeftDotModal.text($currentEsStepLeftDotModal.text() + 'a');

    $header.addClass('hiddenHeader');

    const isFirstStepVideo = !firstStep.dot_id;

    $openseadragonViewer.removeClass('hide-dot-pins');
    $openseadragonViewer.removeClass('show-only-active-dot');
    exitLineGroup();

    if (!isFirstStepVideo) {
        if (!$showDotsButton.hasClass('active')) {
            $showDotsButton.addClass('active');
            if ($windowWidth >= 600) {
                $openseadragonViewer.find('.openseadragon-container').addClass('shrink');
            }
            $exhDotCreateMobile.addClass('d-sm-flex').removeClass('d-none');
        }
        $openseadragonViewer.attr('data-dots', 'true');
    }

    // Go to the first image
    const img_id = parseInt(firstStep.img_id);
    const img_order = $('.thumb-item[data-image-id="' + img_id + '"]').index();
    viewer.goToPage(img_order - 1);

    if ($windowWidth < 600) {
        if (!presentationMode) {
            mobileImageModalActivator();
        } else {
            $viewerWrapper.css('padding-top', 'unset');
            $openseadragonViewer.css('height', '100%');
        }
    } else {
        $dotsWrapper.removeClass('active');
    }

    if (isFirstStepVideo && !looping) {
        $exhibitStoryLeft.addClass('d-none');
    } else {
        // Handle dot as first step
        $exhibitStoryLeft.removeClass('d-none');

        // Simulate dot highlight
        setTimeout(function () {
            if (!presentationMode) {
                openDot(firstStep.dot_id);
            }
            setupAutoPlayVoice(firstStep.auto_play_voice, 'dot');

            $('.dot-pointer[data-id="' + firstStep.dot_id + '"]').addClass('active')
                .children(":first").css('display', 'block').addClass('current-dot-story-step');
        }, 250);
    }

    if (presentationMode) {
        $openseadragonViewer.find('.openseadragon-container').removeClass('shrink');
        $exhibitStoryLeft.addClass('d-none');
        $dotsWrapper.removeClass('active');
    }

    if (hidePinsMode) {
        $openseadragonViewer.addClass('hide-dot-pins');
    }

    if (showOnlyActiveDotMode) {
        $openseadragonViewer.addClass('show-only-active-dot');
    }

    // hide other dot pointers that are not from story
    // $('.dot-pointer').each(function () {
    // $(this).children(":first").css('display', 'none');
    // })

    // stories.forEach(function (story) {
    //     $('.dot-pointer[data-id="' + story.dot_id + '"]').children(":first").css('display', 'block');
    //     $('.dot-pointer[data-id="' + story.dot_id + '"]').addClass('active')
    //     $('.dot-pointer[data-id="' + story.dot_id + '"] .dot-sort-number').html(story.order);
    // });
}

// exhibit story navigation ES navigation
$(document).on('click', '.exhibit-story-navigation .next', function () {
    // console.log('current step index next top: '+currentStepIndex);
    // console.log('steps arr:');
    // console.log(stepsArray);
    $esInfoArea.addClass('d-none');
    lastDirection = 'forward';
    if (stepsArray.length > 0) {

        if (currentStepIndex < 0) {
            currentStepIndex = 0;
        }

        if (currentStepIndex >= stepsArray.length) {
            // run of show: chain into the next story instead of finishing
            if (esRunQueue.length && esRunIndex < esRunQueue.length - 1) {
                esRunIndex++;
                startRunStory();
                return;
            }

            finishExhibitStory(true);

            return;
        }

        $exhibitStoryNavPrev.removeClass('disabled').attr('disabled', false);
        // Stop any playing audio
        $('.image-voice-container').addClass('d-none').find('audio').each(function () {
            this.pause();
        });

        $thumbsWrapper.removeClass('active');
        $('.voice_note_button').removeClass('active').removeAttr('style');
        $modalExhibitInfo.modal('hide');

        let currentStep = stepsArray[currentStepIndex];

        if (currentStep.is_middle_step) {
            // line-path: no pan/zoom, draw animated line between dots
            if (currentStep.in_line_group) {
                let nextStep = stepsArray[currentStepIndex + 1];
                let prevReal = stepsArray[currentStepIndex - 1];
                let dotId = nextStep.dot_id;

                if (prevReal) enterLineGroupIfNeeded(prevReal);
                if (prevReal) drawLineToDot(prevReal.dot_id, nextStep.dot_id, currentStep.img_id, lineAnimDuration * 1000);

                $('.dot-number').removeClass('current-dot-story-step');
                $('.dot-pointer').removeClass('active');

                setTimeout(function () {
                    $('.dot-pointer[data-id="' + nextStep.dot_id + '"]').addClass('active')
                        .children(":first").css('display', 'block').addClass('current-dot-story-step');
                }, 30);

                if (!presentationMode) {
                    openDot(dotId);
                }
                setupAutoPlayVoice(nextStep.auto_play_voice, 'dot');

                realStepIndex++;
                updateStepUI(realStepIndex, nextStep.img_id);
                setStepBText($currentEsStep);
                setStepBText($currentEsStepLeft);
                setStepBText($currentEsStepLeftDotModal);
                currentStepIndex += 2;
                return;
            }

            // grouped steps: pan directly without zooming out
            if (currentStep.in_group) {
                // exit any active line group when transitioning to smooth-pan group
                exitLineGroup();
                let nextStep = stepsArray[currentStepIndex + 1];
                let dotId = nextStep.dot_id;

                $('.dot-number').removeClass('current-dot-story-step');
                $('.dot-pointer').removeClass('active');

                // slow down pan and zoom for grouped dots
                viewer.viewport.centerSpringX.animationTime = defaultPanAnimTime * groupSpeedMultiplier;
                viewer.viewport.centerSpringY.animationTime = defaultPanAnimTime * groupSpeedMultiplier;
                viewer.viewport.zoomSpring.animationTime = defaultZoomAnimTime * groupSpeedMultiplier;

                applyView(parseFloat(nextStep.zoom), parseFloat(nextStep.pan_x), parseFloat(nextStep.pan_y), parseFloat(nextStep.capture_aspect));

                setTimeout(function () {
                    $('.dot-pointer[data-id="' + nextStep.dot_id + '"]').addClass('active')
                        .children(":first").css('display', 'block').addClass('current-dot-story-step');
                }, 30);

                if (!presentationMode) {
                    openDot(dotId);
                }
                setupAutoPlayVoice(nextStep.auto_play_voice, 'dot');

                realStepIndex++;
                updateStepUI(realStepIndex, nextStep.img_id);
                // skip "a", go directly to "b" since no zoom-out phase
                setStepBText($currentEsStep);
                setStepBText($currentEsStepLeft);
                setStepBText($currentEsStepLeftDotModal);
                // skip both middle step and real step (already handled the pan/zoom)
                currentStepIndex += 2;
                return;
            }

            // exit any active line group when stepping out
            exitLineGroup();

            // restore pan and zoom speed after leaving group
            viewer.viewport.centerSpringX.animationTime = defaultPanAnimTime;
            viewer.viewport.centerSpringY.animationTime = defaultPanAnimTime;
            viewer.viewport.zoomSpring.animationTime = defaultZoomAnimTime;

            let offset = (lastDirection === 'forward') ? 1 : -1;
            let targetIdx = currentStepIndex + offset;
            let targetStep = stepsArray[targetIdx] || {};
            let dotId = targetStep.dot_id;
            let autoplay = targetStep.auto_play_voice;

            // console.log('middle step');
            // console.log('middle step (going forward csi ' + currentStepIndex);

            // Zoom out for the middle step (skip for home->home: re-fitting would show a
            // spurious zoom-out as the container size shifts mid-ES)
            const nextNeedZoomOut = middleNeedsZoomOut(stepsArray[currentStepIndex - 1]);
            if (nextNeedZoomOut) viewer.viewport.goHome();
            $exhibitStoryNavigation.removeClass('dot-modal-opened');
            updateUIForMiddleStep(nextNeedZoomOut);
            // Handle real step (dot)
            let nextStep = stepsArray[currentStepIndex + 1];
            let nextStepImageId = nextStep.img_id;

            // Switch to a new image if needed
            if (currentStep.img_id != nextStepImageId) {
                $exhibitStoryNavNext.addClass('disabled').attr('disabled', true);
                if (nextNeedZoomOut) viewer.viewport.goHome();

                let betweenStepTimeout = 1100;

                if($('.image-info.active').attr('data-is-video') == 1) {
                    betweenStepTimeout = 0;
                }

                // no zoom-out animation to wait for (manual skip, or already at home): cut immediately
                if (currentStep.skip_zoom || !nextNeedZoomOut) {
                    betweenStepTimeout = 0;
                }

                setTimeout(function () {
                    let img_order = $('.thumb-item[data-image-id="' + nextStepImageId + '"]').index();
                    if ($('.image-info.active[data-image-id="' + nextStepImageId + '"]').length == 0) {
                        if (!$showDotsButton.hasClass('active') && !currentStep.video) {
                            $exhibitStoryLeft.removeClass('d-none');
                        }
                        // $modalDotFull.modal('hide');
                        viewer.goToPage(img_order - 1);

                        if (currentStep.video) {
                            $exhibitStoryLeft.addClass('d-none');
                            $modalDotFull.modal('hide');

                            realStepIndex++;
                            updateStepUI(realStepIndex, nextStepImageId);
                            currentStepIndex++;

                            $exhibitStoryNavNext.removeClass('disabled').removeAttr('disabled');
                            return;
                        }

                        if (!$showDotsButton.hasClass('active')) {
                            $showDotsButton.addClass('active');
                            if ($windowWidth < 600) {
                                $exhDotCreateMobile.removeClass('d-none');
                            } else {
                                $openseadragonViewer.find('.openseadragon-container').addClass('shrink');
                            }
                            $openseadragonViewer.attr('data-dots', 'true');
                        }

                        setTimeout(function () {
                            $('.dot-pointer[data-id="' + nextStep.dot_id + '"]').addClass('active')
                                .children(":first").css('display', 'block').addClass('current-dot-story-step');


                            // Open the dot for the current step
                            if (!$modalDotFull.is(':visible') && !presentationMode) {
                                openDot(dotId);
                            }

                            setTimeout(function () {
                                $('.dot-pointer[data-id="' + nextStep.dot_id + '"]').addClass('active')
                                    .children(":first").css('display', 'block').addClass('current-dot-story-step');
                            }, 30);

                            realStepIndex++;
                            updateStepUI(realStepIndex, nextStepImageId);
                            setupAutoPlayVoice(autoplay, 'dot');

                            currentStepIndex++;

                        }, 250);

                        if (presentationMode) {
                            $openseadragonViewer.find('.openseadragon-container').removeClass('shrink');
                            $exhibitStoryLeft.addClass('d-none');
                            $dotsWrapper.removeClass('active');
                        }
                        if (hidePinsMode) {
                            $openseadragonViewer.addClass('hide-dot-pins');
                        }
                        if (showOnlyActiveDotMode) {
                            $openseadragonViewer.addClass('show-only-active-dot');
                        }
                    }
                    $exhibitStoryNavNext.removeClass('disabled').removeAttr('disabled');
                }, betweenStepTimeout)
            } else {

                if (!currentStep.video) {
                    if (!presentationMode) {
                        openDot(dotId);
                    }
                    setupAutoPlayVoice(autoplay, 'dot');
                }


                setTimeout(function () {
                    $('.dot-pointer[data-id="' + nextStep.dot_id + '"]').addClass('active')
                        .children(":first").css('display', 'block').addClass('current-dot-story-step');
                }, 30);

                realStepIndex++;
                updateStepUI(realStepIndex, nextStepImageId);
                currentStepIndex++; // Move to the next real step

            }
        } else {
            // console.log('real step');
            // console.log('real step (going forward csi ' + currentStepIndex);

            if (currentStep.video) {
                // same as stopVideo above: the player is absent until the YouTube
                // API has built it, and an unguarded call throws mid-playback
                window.player?.playVideo();
                currentStepIndex++;

                const esText = $currentEsStep.text().trim();

                if (esText.endsWith('a')) {
                    setStepBText($currentEsStep);
                    setStepBText($currentEsStepLeft);
                    setStepBText($currentEsStepLeftDotModal);
                }

                return;
            }

            // Open the dot for the current step
            if (!$modalDotFull.is(':visible') && !currentStep.video && !presentationMode) {
                openDot(currentStep.dot_id);
            }

            let pan_x = parseFloat(currentStep.pan_x);
            let pan_y = parseFloat(currentStep.pan_y);
            let zoom = parseFloat(currentStep.zoom);

            const esText = $currentEsStep.text().trim();

            if (esText.endsWith('a')) {
                setStepBText($currentEsStep);
                setStepBText($currentEsStepLeft);
                setStepBText($currentEsStepLeftDotModal);
            }

            applyStepView(zoom, pan_x, pan_y, parseFloat(currentStep.capture_aspect));

            // Set up the auto-play voice if needed
            setupAutoPlayVoice(currentStep.auto_play_voice, 'dot');


            currentStepIndex++;
        }
    }
    // console.log('current step index next bot: '+currentStepIndex);
});


// Exhibit story previous navigation
$(document).on('click', '.exhibit-story-navigation .prev', function () {
    // console.log('current step index prev top: '+currentStepIndex);
    if (stepsArray.length > 0) {
        // Stop any playing audio
        $('.image-voice-container').addClass('d-none').find('audio').each(function () {
            this.pause();
        });
        $('.voice_note_button').removeClass('active').removeAttr('style');

        // run of show: prev on the fresh-start state of a chained story goes back
        // to the previous story's last step
        if (esRunQueue.length && esRunIndex > 0 && realStepIndex === 1 && currentStepIndex === 0) {
            esRunIndex--;
            startRunStory(true);
            return;
        }


        // If the current step is undefined, just disable prev button
        // if (typeof stepsArray[currentStepIndex] === 'undefined') {
        //     if(currentStepIndex - 1 <= 0) {
        //         $exhibitStoryNavPrev.addClass('disabled').attr('disabled', true);
        //
        //         return;
        //     }
        // }

        // console.log(stepsArray[currentStepIndex]);

        // Check if this is the first time going back after a forward navigation
        if (lastDirection === 'forward') {
            if (stepsArray[currentStepIndex - 1].is_middle_step) {
                currentStepIndex--;
            } else {
                currentStepIndex -= 2;
            }
        } else {
            currentStepIndex--;
            const esText = $currentEsStep.text().trim();

            if (currentStepIndex == 0 && esText.endsWith('b')) {
                // run of show: instead of disabling at this story's first step,
                // go back to the previous story's last step
                if (esRunQueue.length && esRunIndex > 0) {
                    esRunIndex--;
                    startRunStory(true);
                    return;
                }

                $exhibitStoryNavPrev.addClass('disabled').attr('disabled', true);

                currentStepIndex = 1;
                return;
            }
        }

        lastDirection = 'prev'; // Update last direction

        if (currentStepIndex < 0) {
            currentStepIndex = 0;
        }

        let currentStep = stepsArray[currentStepIndex]; // Update to the new current step
        // console.log(currentStep);

        // Handle middle step
        if (currentStep.is_middle_step) {
            // line-path going back: remove last drawn line, no pan/zoom
            if (currentStep.in_line_group) {
                let realStep = stepsArray[currentStepIndex - 1];

                removeLastLine();

                $('.dot-number').removeClass('current-dot-story-step');
                $('.dot-pointer').removeClass('active');

                setTimeout(function () {
                    $('.dot-pointer[data-id="' + realStep.dot_id + '"]').addClass('active')
                        .children(":first").css('display', 'block').addClass('current-dot-story-step');
                }, 30);

                if (!presentationMode) {
                    openDot(realStep.dot_id);
                }

                realStepIndex--;
                if (realStepIndex <= 0) realStepIndex = 1;
                updateStepUI(realStepIndex, realStep.img_id);
                setStepBText($currentEsStep);
                setStepBText($currentEsStepLeft);
                setStepBText($currentEsStepLeftDotModal);
                currentStepIndex--;
                if (currentStepIndex <= 0) currentStepIndex = 1;
                return;
            }

            // grouped steps going back: pan directly without zooming out
            if (currentStep.in_group) {
                exitLineGroup();
                let realStep = stepsArray[currentStepIndex - 1];

                $('.dot-number').removeClass('current-dot-story-step');
                $('.dot-pointer').removeClass('active');


                // slow down pan and zoom by grouped multiplier
                viewer.viewport.centerSpringX.animationTime = defaultPanAnimTime * groupSpeedMultiplier;
                viewer.viewport.centerSpringY.animationTime = defaultPanAnimTime * groupSpeedMultiplier;
                viewer.viewport.zoomSpring.animationTime = defaultZoomAnimTime * groupSpeedMultiplier;

                applyView(parseFloat(realStep.zoom), parseFloat(realStep.pan_x), parseFloat(realStep.pan_y), parseFloat(realStep.capture_aspect));

                setTimeout(function () {
                    $('.dot-pointer[data-id="' + realStep.dot_id + '"]').addClass('active')
                        .children(":first").css('display', 'block').addClass('current-dot-story-step');
                }, 30);

                if (!presentationMode) {
                    openDot(realStep.dot_id);
                }

                realStepIndex--;
                if (realStepIndex <= 0) realStepIndex = 1;
                updateStepUI(realStepIndex, realStep.img_id);
                // skip "a", go directly to "b" since no zoom-out phase
                setStepBText($currentEsStep);
                setStepBText($currentEsStepLeft);
                setStepBText($currentEsStepLeftDotModal);
                // move past the real step we just panned to, so next prev doesn't re-process it
                currentStepIndex--;
                if (currentStepIndex <= 0) currentStepIndex = 1;
                return;
            }

            // exit any active line group when stepping out
            exitLineGroup();

            // restore pan and zoom speed after leaving group
            viewer.viewport.centerSpringX.animationTime = defaultPanAnimTime;
            viewer.viewport.centerSpringY.animationTime = defaultPanAnimTime;
            viewer.viewport.zoomSpring.animationTime = defaultZoomAnimTime;

            let offset = (lastDirection === 'forward') ? 1 : -1;
            let targetIdx = currentStepIndex + offset;
            let targetStep = stepsArray[targetIdx] || {};
            let dotId = targetStep.dot_id;

            // console.log('middle step (going back) csi ' + currentStepIndex );
            // skip zoom-out for home->home (re-fitting would show a spurious zoom-out as the
            // container size shifts mid-ES)
            // going back we leave the later step (currentStepIndex + 1); earlier step carries the skip flag
            const prevNeedZoomOut = middleNeedsZoomOut(stepsArray[currentStepIndex + 1], stepsArray[currentStepIndex - 1]);
            if (prevNeedZoomOut) viewer.viewport.goHome();
            updateUIForMiddleStep(prevNeedZoomOut); // Zoom out and reset UI for middle step

            // Highlight the real step for the middle step
            let realStep = stepsArray[currentStepIndex - 1]; // Real step just before middle step
            let img_order = $('.thumb-item[data-image-id="' + realStep.img_id + '"]').index();

            let realStepBefore = stepsArray[currentStepIndex - 1];
            let isVideoStep = false;
            if (realStepBefore && realStepBefore.video) {
                isVideoStep = true;
            }

            if (!$showDotsButton.hasClass('active') && !isVideoStep) {
                $exhibitStoryLeft.removeClass('d-none');
                $showDotsButton.addClass('active');
                if ($windowWidth >= 600) {
                    $openseadragonViewer.find('.openseadragon-container').addClass('shrink');
                } else {
                    $exhDotCreateMobile.addClass('d-sm-flex').removeClass('d-none');
                }
                $openseadragonViewer.attr('data-dots', 'true');
            }

            if (isVideoStep) {
                if ($('.image-info.active[data-image-id="' + realStep.img_id + '"]').length == 0) {
                    viewer.goToPage(img_order - 1);
                }

                $exhibitStoryLeft.addClass('d-none');
                $modalDotFull.modal('hide');


                $exhibitStoryNavNext.removeClass('disabled').removeAttr('disabled');
                realStepIndex--;
                if (realStepIndex <= 0) {
                    realStepIndex = 1;
                }

                let prevImgId = stepsArray[currentStepIndex - 1];
                prevImgId = parseInt(prevImgId.img_id);

                updateStepUI(realStepIndex, prevImgId);

                if (currentStepIndex <= 0) {
                    currentStepIndex = 1;
                }
                return;
            }

            if ($('.image-info.active[data-image-id="' + realStep.img_id + '"]').length == 0) {
                viewer.goToPage(img_order - 1);
                setTimeout(function () {
                    $('.dot-pointer[data-id="' + realStep.dot_id + '"]').addClass('active')
                        .children(":first").css('display', 'block').addClass('current-dot-story-step');
                    if (!presentationMode) {
                        openDot(dotId);
                    }
                }, 250);
            } else {
                if (!presentationMode) {
                    openDot(dotId);
                }
            }


            setTimeout(function () {
                $('.dot-pointer[data-id="' + realStep.dot_id + '"]').addClass('active')
                    .children(":first").css('display', 'block').addClass('current-dot-story-step');
            }, 30);

            // Update UI and indices
            realStepIndex--;
            if (realStepIndex <= 0) {
                realStepIndex = 1;
            }

            let prevImgId = stepsArray[currentStepIndex - 1];
            prevImgId = parseInt(prevImgId.img_id);

            updateStepUI(realStepIndex, prevImgId);
        } else {

            if (currentStep.video) {
                // same as stopVideo above: the player is absent until the YouTube
                // API has built it, and an unguarded call throws mid-playback
                window.player?.playVideo();

                if (currentStepIndex <= 0) {
                    currentStepIndex = 1;
                }

                const esText = $currentEsStep.text().trim();

                if (esText.endsWith('a')) {
                    setStepBText($currentEsStep);
                    setStepBText($currentEsStepLeft);
                    setStepBText($currentEsStepLeftDotModal);
                }

                return;
            }

            // Open the dot for the real step
            setTimeout(function () {

                if (!$modalDotFull.is(':visible') && !presentationMode) {
                    openDot(currentStep.dot_id);
                }

                let pan_x = parseFloat(currentStep.pan_x);
                let pan_y = parseFloat(currentStep.pan_y);
                let zoom = parseFloat(currentStep.zoom);

                const esText = $currentEsStep.text().trim();

                if (esText.endsWith('a')) {
                    setStepBText($currentEsStep);
                    setStepBText($currentEsStepLeft);
                    setStepBText($currentEsStepLeftDotModal);
                }

                applyStepView(zoom, pan_x, pan_y, parseFloat(currentStep.capture_aspect));
            }, 50);
        }
    }

    // console.log('current step before zero check: '+currentStepIndex);

    if (currentStepIndex <= 0) {
        currentStepIndex = 1;
    }
    // console.log('current step index prev bot: '+currentStepIndex);
});


// Utility function to update the UI for each step
function updateStepUI(stepNumber, img_id) {
    // console.log('Update step UI new step number: '+stepNumber);
    // every playback path (auto-advance, manual next/prev, runs) lands here on a
    // real step, so it's the one place to warm what's coming next
    prefetchUpcomingSteps();

    if (stepNumber <= 0) {
        stepNumber = 1
        $exhibitStoryNavPrev.addClass('disabled').attr('disabled', true);
    }

    let img_name = $('.image-info[data-image-id="' + img_id + '"]').find('.image-title').text();
    $dotFrom.text(stepNumber);
    $currentEsStep.text(stepNumber);
    $currentEsStepLeft.text(stepNumber);
    $currentEsStepLeftDotModal.text(stepNumber);
    $('#es-image-title-left').text(img_name);

    const esText = $currentEsStep.text().trim();

    if (!/[ab]$/.test(esText)) {
        $currentEsStep.text(esText + 'a');
        $currentEsStepLeft.text($currentEsStepLeft.text() + 'a');
        $currentEsStepLeftDotModal.text($currentEsStepLeftDotModal.text() + 'a');
    }
}

// Handle middle step UI reset when zooming out
// doZoomOut=false skips the goHome (used for home->home transitions where re-fitting
// would show a spurious zoom-out as the container size shifts mid-ES)
function updateUIForMiddleStep(doZoomOut = true) {
    if (zoomOutDur) {
        viewer.viewport.zoomSpring.animationTime = zoomOutDur;
        viewer.viewport.centerSpringX.animationTime = zoomOutDur;
        viewer.viewport.centerSpringY.animationTime = zoomOutDur;
    }
    if (doZoomOut) viewer.viewport.goHome();

    if (zoomInDur) {
        viewer.viewport.zoomSpring.animationTime = zoomInDur;
        viewer.viewport.centerSpringX.animationTime = zoomInDur - 1;
        viewer.viewport.centerSpringY.animationTime = zoomInDur - 1;
    }

    $exhibitStoryNavigation.removeClass('dot-modal-opened');
    $('.dot-number').removeClass('current-dot-story-step next-dot-story-step prev-dot-story-step');
    $('.dot-pointer').removeClass('active');
    // $modalDotFull.modal('hide');
}


// exitFullScreen() below fires fullscreenchange, and that handler calls this
// function again whenever .overlay-exhibit-story is present. The re-entrant pass
// ran the whole non-natural teardown (emptying stepsArray, opening the thumbnail
// grid) while the natural end was still waiting on its 800ms goHome timeout, so
// the real pass then crashed on the state the second one had already cleared.
let isFinishingStory = false;

function finishExhibitStory(naturalEnd = false, showExhibitInfo = true, showImageInfoOnMobile = true) {
    if (isFinishingStory) {
        return;
    }
    isFinishingStory = true;

    // clear run of show state on any exit (cancel, escape, natural end)
    esRunQueue = [];
    esRunIndex = 0;

    const wasInPresentationMode = presentationMode;
    const isVideoStep = $('.image-info.active').attr('data-is-video') == 1;

    const wasHidePinsMode = hidePinsMode;
    const wasShowOnlyActiveDotMode = showOnlyActiveDotMode;
    isLoopMode = false;
    presentationMode = false;
    hidePinsMode = false;
    showOnlyActiveDotMode = false;
    // note: do NOT remove hide-dot-pins / show-only-active-dot here. removing them eagerly
    // (before the goHome zoom-out) reveals the still-display:block dot-pointers for the whole
    // animation. they're removed later (after cleanup + hidePins) via the was* conditionals below,
    // so dots stay hidden until they're cleared.
    exitLineGroup();

    if (loopTimer) {
        clearTimeout(loopTimer);
        exitFullScreen();
    }

    zoomInDur = false;
    zoomOutDur = false;
    hasAutoStarted = false;

    disableInteractionBlocker();

    if ($windowWidth >= 600 && (document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement)) {
        exitFullScreen();
    }

    viewer.viewport.zoomSpring.animationTime = 0.8;
    viewer.viewport.centerSpringX.animationTime = 1.2;
    viewer.viewport.centerSpringY.animationTime = 1.2;

    if (naturalEnd) {
        viewer.viewport.goHome();

        let timeout = isVideoStep ? 0 : 800;

        setTimeout(function() {
            viewer.goToPage(0);
            cleanupAfterStory(true, showImageInfoOnMobile);

            if (wasInPresentationMode) {
                $openseadragonViewer.find('.openseadragon-container').addClass('shrink');
                $exhibitStoryLeft.addClass('d-none');
                $dotsWrapper.removeClass('active');
            }

            if ($showDotsButton.hasClass('active')) {
                $showDotsButton.removeClass('active');
                if ($windowWidth >= 600) {
                    $openseadragonViewer.find('.openseadragon-container').removeClass('shrink');
                    $dotsWrapper.removeClass('active');
                }
                hidePins();
            }

            if (wasHidePinsMode) {
                $openseadragonViewer.removeClass('hide-dot-pins');
            }

            if (wasShowOnlyActiveDotMode) {
                $openseadragonViewer.removeClass('show-only-active-dot');
            }

            if (showExhibitInfo) {
                $('#modal-exhibitinfo:not(.hidemodal)').modal('show');
            }

            isFinishingStory = false;
        }, timeout);
    } else {
        viewer.viewport.goHome();

        if (wasInPresentationMode) {
            $openseadragonViewer.find('.openseadragon-container').addClass('shrink');
            $exhibitStoryLeft.addClass('d-none');
        }

        if ($showDotsButton.hasClass('active')) {
            $showDotsButton.removeClass('active');
            if ($windowWidth >= 600) {
                $openseadragonViewer.find('.openseadragon-container').removeClass('shrink');
            }
            hidePins();
        }

        if (wasHidePinsMode) {
            $openseadragonViewer.removeClass('hide-dot-pins');
        }

        if (wasShowOnlyActiveDotMode) {
            $openseadragonViewer.removeClass('show-only-active-dot');
        }

        cleanupAfterStory(true, showImageInfoOnMobile);
        $exhThumbsButton.click();
        if (showExhibitInfo) {
            $('.exh-title').click();
        }

        isFinishingStory = false;
    }
}

function cleanupAfterStory(hideDots = false, showImageInfoOnMobile = true) {
    $('.dot-number').each(function () {
        if ($(this).hasClass('user-dot-color-disabled')) {
            $(this).removeClass('user-dot-color-disabled');
            $(this).addClass('user-dot-color');
        }
    })
    // restore page scrollbar after ES playback ends
    $('body').removeClass('es-playing');
    $dotsWrapper.removeClass('blur-div');
    $dotsCounter.removeClass('d-none');
    $exhibitStoryLeft.addClass('d-none');
    $esButtonWrapper.addClass('d-flex').removeClass('d-none');
    $exhibitStoryNavigation.addClass('d-none').removeClass('dot-modal-opened');
    $header.removeClass('hiddenHeader');
    $('.dot-number').removeClass('current-dot-story-step next-dot-story-step prev-dot-story-step');
    $exhibitStoryNavPrev.addClass('disabled').attr('disabled', true);
    $exhibitStoryNavNext.removeClass('disabled').attr('disabled', false);
    $startExhibitStoryParent.removeClass('d-none');

    $('.dot-modal-header').removeClass('d-none');
    $('.exhibit-story-header').addClass('d-none');

    //add logic for other voice notes
    if ($modalDotFull.find('.modal-dialog').find('.modal-content').find('.dot-voice-container').find('audio').length > 0) {
        $modalDotFull.find('.modal-dialog').find('.modal-content').find('.dot-voice-container').find('audio').first()[0].pause();
    }
    $modalDotFull.modal('hide');
    $('.dot-pointer').filter(function () {
        if ($(this).css('position') === 'absolute' && $(this).css('display') === 'block') {
            return $(this);
        }
    }).each(function (index) {
        $(this).children(":first").css('display', 'block');
        $(this).find('.dot-sort-number').html(index + 1);
        $(this).removeClass('active');
    });
    $('.overlay-exhibit-story').remove();
    $buttonsWrapper.removeClass('d-none');

    $exhibitVoiceContainer.addClass('d-none');
    $('.exhibit-voice-group').addClass('d-none');

    $('.image-voice-container').addClass('d-none');
    $('.image-voice-group').addClass('d-none');

    $dotVoiceContainer.addClass('d-none');
    $('.dot-voice-group').addClass('d-none');

    $('.voice_note_button').removeClass('active').removeAttr('style');
    $('.image-voice-container').addClass('d-none').find('audio').each(function () {
        this.pause();
    });

    setTimeout(function () {
        $('.dot-modal-navigation').addClass('d-md-block');
        $('.close-dot-modal').addClass('d-sm-block d-none');
        $dotShare.addClass('d-sm-block d-inline').removeClass('d-none');
        $bottomImageName.removeClass('d-none');
        $('.editDot').removeClass('d-none');
        $dotFooter.removeClass('d-none');
        $dotFullClose.addClass('d-block d-sm-none').removeClass('d-none');
    }, 800);

    $closeExhText.removeClass('d-none');
    $dotFullClose.removeClass('d-none');
    $('.image-info-close').removeClass('d-none');
    $closeModalBtn.addClass('d-sm-block');
    $exhibitTextFooter.removeClass('d-none');
    $('.image-count').removeClass('d-none').addClass('d-flex');

    if (($windowWidth < 600)) {
        $modalDotFull.removeAttr('style').find('.modal-dialog').removeAttr('style').find('.modal-content').removeAttr('style');
        $dotsWrapper.addClass('d-none');
        $('.image-info-mobile').removeClass('d-none');
        $openseadragonViewer.removeAttr('style');
        $viewerWrapper.css('padding-top', '64px');

        if ($showDotsButton.hasClass('active')) {
            $('.upper-left-exh-buttons').find('.exh-dot-stories-mobile').removeClass('d-none');
            $exhDotCreateMobile.removeClass('d-none');
        }

        if ($exhInfoButton.hasClass('active')) {
            $exhInfoButton.click();
        }

        viewer.panHorizontal = true;
        viewer.panVertical = true;

        // maybe adjust this for cancel/natural end
        if (showImageInfoOnMobile) {
            $exhInfo.click();
        }
    } else {
        if (!hideDots) {
            $dotsWrapper.addClass('active');
        }
        $('.image-voice-container').removeAttr('style');
        $dotVoiceContainer.removeAttr('style');
        $exhibitVoiceContainer.removeAttr('style');
    }

    if (realStepIndex == 1) {
        realStepIndex = 0;
        // stepsArray is emptied at the end of this function, so a second pass
        // finds nothing here — don't assume a step exists
        if (stepsArray[realStepIndex]?.video) {
            $dotsWrapper.removeClass('active');
        }
    } else {
        let lastStep = stepsArray.pop();

        if (lastStep?.video) {
            $dotsWrapper.removeClass('active');
        }
    }

    stepsArray = [];
    currentStepIndex = 0;
    realStepIndex = 1;
    $esInfoArea.removeClass('d-none');
    window.history.pushState(null, null, window.location.pathname);
        // window.player only exists once the YouTube API has built it, which never
    // happens on an exhibit with no video. This is the last statement in the
    // function, so throwing here aborted the caller mid-teardown — which is what
    // stopped the exhibit text from showing at the end of a story.
    if (window.player && typeof window.player.stopVideo === 'function') {
        window.player.stopVideo();
    }
}

// cancel exh story
$(document).on("click", ".overlay-exhibit-story", function (e) {
    if ($(e.target).hasClass('cancel-story-button')) {
        finishExhibitStory();
    }
    if ($(e.target).hasClass('cancel-story-grid-button')) {
        // cancel story, show thumbnail grid, but don't show exhibit info modal or image info on mobile
        finishExhibitStory(false, false, false);

        // close image text if it's open by clicking the button (uses proper state management)
        if ($exhInfoButton.hasClass('active')) {
            $exhInfoButton.click();
        }

        // force dots sidebar closed (button/wrapper can desync after finishExhibitStory)
        $showDotsButton.removeClass('active');
        $dotsWrapper.removeClass('active');

        // show the grid as the final, deterministic action
        openThumbsGrid();
    }
});

// es finalize screen mobile show preview
$(document).on('click touchstart', '.es-img-preview .preview-trigger', function (e) {
    e.stopPropagation();
    $(this).closest('.es-img-preview').toggleClass('show-preview');
});

$(document).on('click touchstart', function (e) {
    if (!$(e.target).closest('.es-img-preview').length) {
        $('.es-img-preview.show-preview').removeClass('show-preview');
    }
});

$(document).on("click", ".delete-exhibit-story", function () {
    if (confirm('Are you sure you want to delete this exhibit story?')) {
        let slug = $(this).attr('data-story-slug');
        let button = $(this);

        $.ajax({
            type: "POST",
            url: "/admin/delete_exhibit_story/" + slug,
            data: {
                _token: $('meta[name="csrf-token"]').attr('content')
            }
        }).then(function (response) {
            if (response.status == 200) {
                button.parent().remove();

                $('.start-exhibit-story[data-exhibit-story-slug="' + slug + '"]').parent().remove();

                // mirror the backend cascade: drop the story from runs, remove emptied runs
                $('#es-run-story-picker li[data-story-slug="' + slug + '"]').remove();
                $('#es-run-list li').each(function () {
                    let $li = $(this);
                    let runStories = JSON.parse($li.attr('data-run-stories') || '[]').filter(s => s !== slug);
                    if (!runStories.length) {
                        $('.start-es-run[data-es-run-slug="' + $li.attr('data-run-slug') + '"]').parent().remove();
                        $li.remove();
                    } else {
                        $li.attr('data-run-stories', JSON.stringify(runStories));
                    }
                });

                $('.personal-alert').addClass('alert alert-success show-alert').css({'left': '50%'}).html(response.message);
                setTimeout(function () {
                    $personalAlert.removeClass('show-alert');
                }, 2500)
                setTimeout(function () {
                    $('.personal-alert').removeClass('alert alert-success show-alert').removeAttr('style').html('');
                }, 3000)
            } else {
                alert('Oops, something went wrong! Try again later.');
            }
        });
    }
    return false;
});

// drag-drop reorder of exhibit stories in the #editExhibitStories modal.
// init lazily when the modal opens so jQuery UI sees the rendered list.
$(document).on("shown.bs.modal", "#editExhibitStories", function () {
    // run of show story picker: order is only read at save time, no ajax on drag
    let $picker = $("#es-run-story-picker");
    if ($picker.length) {
        makeEsSortable($picker, {
            items: "li",
            handle: ".es-run-handle",
            onUpdate: function () {}
        });
    }

    let $list = $("#es-reorder-list");
    if (!$list.length) {
        return;
    }

    makeEsSortable($list, {
        items: "li",
        handle: ".es-reorder-handle",
        onUpdate: function () {
            let order = [];
            let $esContainer = $("#es-container");
            $list.find("li").each(function (idx) {
                let slug = $(this).attr("data-story-slug");
                order.push({
                    story_id: slug,
                    position: idx + 1
                });

                // keep the front play-button list (#es-button-wrapper) in sync
                $esContainer
                    .find('.start-exhibit-story[data-exhibit-story-slug="' + slug + '"]')
                    .first()
                    .closest('.d-flex')
                    .appendTo($esContainer);
            });

            $.ajax({
                type: "POST",
                url: "/admin/es/reorder",
                data: {
                    exhibit_id: $list.attr("data-exhibit-id"),
                    order: order,
                    _token: $('meta[name="csrf-token"]').attr('content')
                }
            }).then(function (response) {
                if (response.status != 200) {
                    alert('Oops, something went wrong! Try again later.');
                }
            });
        }
    });
});

// ── run of show management (#editExhibitStories modal) ─────────────────

// reset the run form: empty name/id, all stories unchecked, picker back to story list order
function resetEsRunForm() {
    let $form = $('#es-run-form');
    $form.find('input[name="es_run_id"]').val('');
    $form.find('input[name="es_run_name"]').val('');
    $form.find('.es-run-story-check').prop('checked', false);

    let $picker = $('#es-run-story-picker');
    $('#es-reorder-list li').each(function () {
        let slug = $(this).attr('data-story-slug');
        $picker.find('li[data-story-slug="' + slug + '"]').appendTo($picker);
    });
}

// build/update the modal list item for a saved run
function upsertEsRunListItem(run) {
    let $list = $('#es-run-list');
    let $li = $list.find('li[data-run-id="' + run.id + '"]');

    if (!$li.length) {
        $li = $('<li><i class="fas fa-layer-group mr-2 text-muted"></i><span class="es-run-name"></span><button class="btn btn-sm edit-es-run"> <i class="far fa-edit"></i></button><button class="btn btn-sm delete-es-run"> <i class="fa fa-trash" aria-hidden="true"></i></button></li>');
        $li.appendTo($list);
    } else {
        // blade renders the name as a bare text node; normalize to a span for updates
        if (!$li.find('.es-run-name').length) {
            $li.contents().filter(function () { return this.nodeType === 3; }).remove();
            $('<span class="es-run-name"></span>').insertAfter($li.find('i.fa-layer-group'));
        }
    }

    $li.attr('data-run-id', run.id)
        .attr('data-run-slug', run.slug)
        .attr('data-run-name', run.name)
        .attr('data-run-stories', JSON.stringify(run.stories));
    $li.find('.es-run-name').text(run.name);
}

// build/update the front play button for a saved run
function upsertEsRunButton(run) {
    let $container = $('#es-run-container');
    let $button = $container.find('.start-es-run[data-es-run-slug="' + run.slug + '"]');

    if (!$button.length) {
        let $row = $('<div class="d-flex"><button class="btn btn-dark btn-sm my-2 start-es-run" style="width: 90%; border-left: 4px solid #ffc107;"><i class="fas fa-layer-group mr-1"></i><span class="es-run-label"></span></button><button class="btn btn-sm btn-tdg-blue my-auto es-run-loop" style="width: 32px; height: 32px; line-height: 22px"><i class="fas fa-play my-auto"></i></button><button class="btn btn-sm btn-tdg-blue my-auto es-run-start-at" style="width: 32px; height: 32px; line-height: 22px"><i class="fas fa-dot-circle m-auto"></i></button><button class="btn btn-sm btn-tdg-blue my-auto share-es-run" style="width: 32px; height: 32px; line-height: 22px"><i class="fas fa-share my-auto"></i></button></div>');
        $row.find('.start-es-run, .es-run-loop, .es-run-start-at, .share-es-run').attr('data-es-run-slug', run.slug);
        $button = $row.find('.start-es-run');
        $row.appendTo($container);
    } else if (!$button.find('.es-run-label').length) {
        // blade renders the label as a bare text node; normalize to a span for updates
        $button.contents().filter(function () { return this.nodeType === 3; }).remove();
        $button.append('<span class="es-run-label"></span>');
    }

    $button.find('.es-run-label').text(run.name + ' [' + run.duration_formatted + ']');
}

$(document).on('click', '#es-run-new', function () {
    resetEsRunForm();
    $('#es-run-form').removeClass('d-none');
});

$(document).on('click', '#es-run-cancel', function () {
    $('#es-run-form').addClass('d-none');
});

$(document).on('click', '.edit-es-run', function () {
    let $li = $(this).closest('li');
    let runStories = JSON.parse($li.attr('data-run-stories') || '[]');

    resetEsRunForm();

    let $form = $('#es-run-form');
    $form.find('input[name="es_run_id"]').val($li.attr('data-run-id'));
    $form.find('input[name="es_run_name"]').val($li.attr('data-run-name'));

    // check the run's stories and move them to the top in run order
    let $picker = $('#es-run-story-picker');
    runStories.slice().reverse().forEach(function (slug) {
        let $item = $picker.find('li[data-story-slug="' + slug + '"]');
        $item.find('.es-run-story-check').prop('checked', true);
        $item.prependTo($picker);
    });

    $form.removeClass('d-none');
});

$(document).on('click', '#es-run-save', function () {
    let $form = $('#es-run-form');
    let runId = $form.find('input[name="es_run_id"]').val();
    let name = $form.find('input[name="es_run_name"]').val().trim();

    // checked stories in dom order define the run
    let stories = [];
    $('#es-run-story-picker li').each(function () {
        if ($(this).find('.es-run-story-check').is(':checked')) {
            stories.push($(this).attr('data-story-slug'));
        }
    });

    if (!name || !stories.length) {
        alert('A run needs a name and at least one story.');
        return;
    }

    $.ajax({
        type: "POST",
        url: "/admin/es-run/save",
        data: {
            exhibit_id: $('#es-run-list').attr('data-exhibit-id'),
            run_id: runId,
            name: name,
            stories: stories,
            _token: $('meta[name="csrf-token"]').attr('content')
        }
    }).then(function (response) {
        if (response.status == 200) {
            $form.addClass('d-none');
            upsertEsRunListItem(response.run);
            upsertEsRunButton(response.run);

            $('.personal-alert').addClass('alert alert-success show-alert').css({'left': '50%'}).html(response.message);
            setTimeout(function () {
                $personalAlert.removeClass('show-alert');
            }, 2500)
            setTimeout(function () {
                $('.personal-alert').removeClass('alert alert-success show-alert').removeAttr('style').html('');
            }, 3000)
        } else {
            alert('Oops, something went wrong! Try again later.');
        }
    });
});

$(document).on('click', '.delete-es-run', function () {
    if (confirm('Are you sure you want to delete this run of show?')) {
        let $li = $(this).closest('li');
        let runId = $li.attr('data-run-id');
        let runSlug = $li.attr('data-run-slug');

        $.ajax({
            type: "POST",
            url: "/admin/es-run/delete/" + runId,
            data: {
                _token: $('meta[name="csrf-token"]').attr('content')
            }
        }).then(function (response) {
            if (response.status == 200) {
                $li.remove();
                $('.start-es-run[data-es-run-slug="' + runSlug + '"]').parent().remove();

                $('.personal-alert').addClass('alert alert-success show-alert').css({'left': '50%'}).html(response.message);
                setTimeout(function () {
                    $personalAlert.removeClass('show-alert');
                }, 2500)
                setTimeout(function () {
                    $('.personal-alert').removeClass('alert alert-success show-alert').removeAttr('style').html('');
                }, 3000)
            } else {
                alert('Oops, something went wrong! Try again later.');
            }
        });
    }
    return false;
});

//edit dot story button
$(document).on("click", ".edit-exhibit-story", function () {

    // $dotsCardActive.find('.card-body').find('.comments').find('.dot-story-form-wrapper').find('.create-dot-story').text('Update dot story').addClass('active update');
    // $dotsCardActive.find('.card-body').find('.comments').find('.dot-story-form-wrapper').find('.cancel-dot-story').removeClass('d-none');
    // $('.color-choice-wrapper').remove();

    // return ;
    // need to fill es-form-wrapper also since that is where the data is when we are saving the es ??
    // set the story id ???
    exhibit_story_create_mode = true;
    exitAnnotationDrawingMode();

    let storySlug = $(this).attr('data-story-slug');

    $.ajax({
        type: "GET",
        url: "/edit_exh_story/" + storySlug,
    }).then(function (response) {

        $('#esFormData').html('');
        $('.es-form-wrapper').html('');

        $saveExhibitStory.addClass('update').text('Update');


        $modalExhibitInfo.modal('hide');
        $thumbsWrapper.removeClass('active');

        $exhibitStorySetup.removeClass('d-none');

        $('.add-dot-to-es').removeClass('d-none');

        let stories = response.exh_story;

        let $formWrapper = $finaliseEsModal;
        $formWrapper.find('input[name="es_name"]').val(stories[0].story_name);
        $formWrapper.find('input[name="exhibitStoryDontShowDots"]').prop('checked', stories[0].dont_show_dots == 1);
        $formWrapper.find('input[name="exhibitStoryDontShowPins"]').prop('checked', stories[0].dont_show_pins == 1);
        $formWrapper.find('input[name="exhibitStoryShowOnlyActiveDot"]').prop('checked', stories[0].show_only_active_dot == 1);
        $formWrapper.find('input[name="exhibitStoryGroupSpeedMultiplier"]').val(stories[0].group_speed_multiplier ?? 1);
        $formWrapper.find('input[name="exhibitStoryLineAnimDuration"]').val(stories[0].line_anim_duration ?? 1);
        $formWrapper.modal('show');
        $('#editExhibitStories').modal('hide');

        // let autoPlayVoice = parseInt(stories[0].auto_play_voice);

        stories.forEach(function (story) {
            let stepNumber = story.order
            let storyId = story.story_id;
            let imgId = story.img_id;
            let zoom = story.zoom;
            let panX = story.pan_x;
            let panY = story.pan_y;
            let autoPlayVoice = story.auto_play_voice;

            // Check if it's a video step (dot_id is null) or a dot step
            let isVideo = !story.dot_id;
            let typePrefix = isVideo ? 'img-' : 'dot-';
            let baseId = isVideo ? imgId : story.dot_id;
            let cardId = typePrefix + baseId;

            let thumb_src = $('.thumb-item[data-image-id="' + imgId + '"] img').attr('src');
            let content_text = '';
            let previewText = '';

            if (isVideo) {
                // For video steps, use image title or a default text
                content_text = 'Video step';
                previewText = `Step #${stepNumber} – i#${imgId} – ${content_text}`;
            } else {
                // For dot steps, get the dot content
                let dot_content = $('.dot-short[data-id="' + baseId + '"]')
                    .find('.ck-content').text().slice(0, 30);
                if (dot_content.length === 30) dot_content += '...';
                content_text = dot_content;
                previewText = `Step #${stepNumber} – i#${imgId} | d#${baseId} – ${content_text}`;
            }

            let htmlContent = `
              <tr id="${typePrefix}${baseId}" class="es-story-row" data-img-id="${imgId}" data-group-id="${story.group_id || ''}" data-line-group-id="${story.line_group_id || ''}" data-skip-zoom-out="${story.skip_zoom_out ? 1 : 0}">
                <td class="es-img-preview" style="cursor: pointer; width: 100%">
                  <span class="preview-trigger" tabindex="0" style="text-decoration: underline; color: blue;">${previewText}</span>
                  <div class="preview-image"><img src="${thumb_src}" alt=""></div>
                </td>
                <td class="auto-play-wrapper" data-id="${baseId}">
                  <label class="custom-toggle">
                    <input type="checkbox" name="autoPlayVoice"
                           ${autoPlayVoice == 1 ? 'checked' : ''}
                           value="${autoPlayVoice}"
                           ${isVideo ? 'disabled' : ''}>
                    <span class="auto-play-voice custom-toggle-slider rounded-circle"
                          data-label-off="No" data-label-on="Yes"></span>
                  </label>
                </td>
                <td class="group-toggle-wrapper">
                  <button class="btn btn-sm btn-outline-primary group-with-next"
                          ${isVideo ? 'disabled' : ''}>
                    <i class="fa fa-link"></i>
                  </button>
                </td>
                <td class="line-toggle-wrapper">
                  <button class="btn btn-sm btn-outline-info line-with-next"
                          ${isVideo ? 'disabled' : ''}>
                    <i class="fa fa-route"></i>
                  </button>
                </td>
                <td class="skip-zoom-toggle-wrapper">
                  <button class="btn btn-sm btn-outline-warning skip-zoom-with-next"
                          ${isVideo ? 'disabled' : ''}>
                    <i class="fa fa-forward"></i>
                  </button>
                </td>
                <td class="d-flex align-items-center" style="gap:6px;">
                  ${isVideo ? '' : `
                    <button class="btn btn-info btn-sm preview-es-position"
                            data-dot-id="${baseId}"
                            title="Preview saved position">
                      <i class="fa fa-crosshairs"></i> Preview
                    </button>`}
                  <button class="btn btn-danger btn-sm remove-from-story" ${isVideo ? 'img_id' : 'dot_id'}="${baseId}">Remove</button>
                </td>
                <td class="drag-handle">
                  <i class="fa fa-arrows-alt drag-handle-es"
                     style="cursor:move; font-size:20px;"></i>
                </td>
              </tr>
            `;

            $esFormData.append(htmlContent);

            if (isVideo) {
                // Update video button state for this image
                $(`.add-dot-to-es.video-image[data-img-id="${imgId}"]`)
                    .removeClass('btn-secondary')
                    .addClass('btn-success added')
                    .text('Remove video from exhibit story');
            } else {
                // Update dot button state
                $('.add-dot-to-es[data-dot-id="' + baseId + '"]').removeClass('btn-secondary').addClass('btn-success added').text('Remove from exhibit story');

                let set_zoom_and_pan_btn = '<div class="zoom-wrapper my-1 mx-1 d-flex flex-wrap" data-id="' + baseId + '" style="gap:4px;">\
                                        <button class="btn btn-sm btn-secondary set-zoom-and-position"> SET ZOOM AND POSITION <i class="fa fa-search"></i></button>\
                                        <button class="btn btn-sm btn-info preview-es-position" data-dot-id="' + baseId + '" title="Preview saved position"><i class="fa fa-crosshairs"></i> Preview</button>\
                                </div>';

                let auto_play_voice_wrapper = '<div class="d-flex my-3 auto-play-wrapper"  data-id="' + baseId + '">\
                    <label class="custom-toggle">\
                        <input type="checkbox" name="autoPlayVoice" ' + (autoPlayVoice == 1 ? 'checked' : '') + ' value="' + autoPlayVoice + '">\
                        <span class="auto-play-voice custom-toggle-slider rounded-circle" data-label-off="No" data-label-on="Yes"></span>\
                    </label>\
                        <div class="ml-2">Auto play voice notes</div>\
                    </div>';

                $('.add-dot-to-es[data-dot-id="' + baseId + '"]').parent().append([set_zoom_and_pan_btn, auto_play_voice_wrapper])
            }

            let esWrapperElem = `<div class="added-${typePrefix}to-es-wrapper" data-id="${baseId}">
                                        <form>
                                            <input name="imgId" value="${imgId}">
                                            ${isVideo ? '' : `<input name="dotId" value="${baseId}">`}
                                            <input name="zoom" value="${zoom}">
                                            <input name="panX" value="${panX}">
                                            <input name="panY" value="${panY}">
                                            <input name="captureAspect" value="${story.capture_aspect ?? ''}">
                                            <input name="captureWidth" value="${story.capture_width ?? ''}">
                                            <input name="story_id" value="${storyId}">
                                            <input type="checkbox" name="autoPlayVoice" value="${autoPlayVoice}">
                                            <input class="d-none" type="text" name="order" value="${stepNumber}">
                                            <input type="checkbox" name="delete" value="0">
                                            ${isVideo ? '<input type="hidden" name="isVideo" value="1">' : ''}
                                            <input type="hidden" name="group_id" value="${story.group_id || ''}">
                                            <input type="hidden" name="line_group_id" value="${story.line_group_id || ''}">
                                            <input type="hidden" name="skip_zoom_out" value="${story.skip_zoom_out ? 1 : ''}">
                                        </form>
                                    </div>`;

            $esFormWrapper.append(esWrapperElem);
        });

        makeEsSortable($("#esFormData"), {
            items: "tr",
            placeholder: "ui-state-highlight",
            handle: ".drag-handle-es",
            onUpdate: function () {
                $("#esFormData tr").each(function (idx) {
                    let parts = this.id.split('-');
                    let typePrefix = parts[0] + '-';
                    let id = parts[1];
                    $esFormWrapper
                        .find(`.added-${typePrefix}to-es-wrapper[data-id="${id}"]`)
                        .find('input[name="order"]')
                        .val(idx + 1);
                });
                validateAndUpdateGroups();
            }
        });

        // restore group toggles from loaded data
        restoreGroupToggles();
        restoreLineGroupToggles();

        // ensure showDotsButton is visible (needed when on video image)
        $showDotsButton.addClass('d-flex').removeClass('d-none');

        // always trigger button click if dots-wrapper is not active to ensure it shows
        if (!$dotsWrapper.hasClass('active')) {
            // ensure button is not already active to allow proper toggle
            if ($showDotsButton.hasClass('active')) {
                $showDotsButton.removeClass('active');
            }
            $showDotsButton.click();
        }

        // reset zoom to home after sidebar animation completes
        setTimeout(() => viewer.viewport.goHome(), 400);

        if ($windowWidth < 600) {
            DotsWrapperMobileStory()
        }
    });
});
$(document).on("click", ".remove-from-story", function () {
    const itemId = $(this).attr('dot_id') || $(this).attr('img_id');
    const itemType = $(this).attr('dot_id') ? 'dot' : 'img';

    // Remove table row from finalize modal
    $(this).closest('tr').remove();

    if (itemId) {
        const selector = `.added-${itemType}-to-es-wrapper[data-id="${itemId}"]`;
        const item = $('.es-form-wrapper').find(selector);

        // Check if this is an existing item (has story_id) or newly added
        const hasStoryId = item.find('input[name="story_id"]').val();

        if (hasStoryId && $saveExhibitStory.hasClass('update')) {
            // For existing items in edit mode, mark for deletion
            item.find('input[name="delete"]').val(1);
            item.hide();
        } else {
            // For newly added items, completely remove from form
            item.remove();
        }
    }

    // Update sidebar button state based on item type
    if (itemType === 'img') {
        // For video items, update the video button
        $(`.add-dot-to-es.video-image[data-img-id="${itemId}"]`)
            .removeClass('btn-success added')
            .addClass('btn-secondary')
            .text('Add video to exhibit story');
    } else {
        // For dot items, update the dot button
        $(`.add-dot-to-es[data-dot-id="${itemId}"]`)
            .removeClass('btn-success added')
            .addClass('btn-secondary')
            .text('Add to exhibit story')
            .siblings('.zoom-wrapper, .auto-play-wrapper')
            .addClass('d-none')
            .end()
            .siblings('.zoom-wrapper, .auto-play-wrapper')
            .remove();
    }

    // Re-order remaining items
    $esFormDataTr.each(function (idx) {
        const id = this.id.split('-')[1];
        const prefix = this.id.split('-')[0] + '-';
        $esFormWrapper
            .find(`.added-${prefix}to-es-wrapper[data-id="${id}"]`)
            .find('input[name="order"]')
            .val(idx + 1);
    });

    validateAndUpdateGroups();
});

// Copies the plain text of a read-more block's hidden part, without the
// "Read less" link. Only clickable while expanded, so innerText sees the
// rendered layout and keeps paragraph/list line breaks.
function createReadMoreCopyBtn(hidden, readLessBtn) {
    const copyBtn = document.createElement('a');
    copyBtn.href = '#';
    copyBtn.className = 'read-more-copy';
    copyBtn.title = 'Copy text';
    copyBtn.innerHTML = '<i class="fas fa-copy"></i>';

    copyBtn.addEventListener('click', async function (e) {
        e.preventDefault();
        e.stopPropagation();

        // write each link's URL after its text (e.g. the "Sources" list), so
        // the copy carries the links and not just their titles
        const urlMarks = [];
        hidden.querySelectorAll('a[href]').forEach(a => {
            // the copy / read-less buttons are href="#" — a.href would resolve them to the page URL
            if (a === copyBtn || a === readLessBtn || (a.getAttribute('href') || '').startsWith('#')) return;
            const href = a.href;
            if (!/^https?:/i.test(href)) return;
            if (a.innerText.trim() === href || a.innerText.trim() === a.getAttribute('href')) return;
            const mark = document.createElement('span');
            mark.textContent = ' (' + href + ')';
            a.after(mark);
            urlMarks.push(mark);
        });
        // innerText drops <ol> numbering, but the text cites sources as [1], [2]…
        // so write the number in front of each item
        hidden.querySelectorAll('ol').forEach(ol => {
            let n = parseInt(ol.getAttribute('start'), 10) || 1;
            ol.querySelectorAll(':scope > li').forEach(li => {
                const mark = document.createElement('span');
                mark.textContent = '[' + n++ + '] ';
                li.prepend(mark);
                urlMarks.push(mark);
            });
        });
        let text = hidden.innerText.trim();
        urlMarks.forEach(m => m.remove());

        const readLess = readLessBtn.innerText.trim();
        if (readLess && text.endsWith(readLess)) {
            text = text.slice(0, -readLess.length).trim();
        }
        if (!text) return;

        // HTML flavour too, so pasting into CKEditor (or Docs/Word) keeps real
        // hyperlinks; the <ol> stays a list there, so no [n] marks in it
        const clone = hidden.cloneNode(true);
        clone.querySelectorAll('.read-more-copy, .read-less-toggle').forEach(el => el.remove());
        clone.querySelectorAll('a[href]').forEach(a => {
            const href = a.getAttribute('href') || '';
            if (href.startsWith('#')) {
                a.replaceWith(...a.childNodes);
            } else {
                a.setAttribute('href', new URL(href, location.href).href); // absolute, survives the paste
            }
        });
        const html = clone.innerHTML.trim();

        try {
            if (navigator.clipboard && window.isSecureContext && window.ClipboardItem) {
                await navigator.clipboard.write([new ClipboardItem({
                    'text/plain': new Blob([text], { type: 'text/plain' }),
                    'text/html': new Blob([html], { type: 'text/html' }),
                })]);
            } else {
                // navigator.clipboard is missing on plain-http origins — a one-shot
                // copy listener can still set both flavours
                const onCopy = ev => {
                    ev.preventDefault();
                    ev.clipboardData.setData('text/plain', text);
                    ev.clipboardData.setData('text/html', html);
                };
                document.addEventListener('copy', onCopy, { once: true });
                const ok = document.execCommand('copy');
                document.removeEventListener('copy', onCopy);
                if (!ok) throw new Error('copy failed');
            }
            copyBtn.innerHTML = '<i class="fas fa-check" style="color:#28a745;"></i>';
            setTimeout(() => { copyBtn.innerHTML = '<i class="fas fa-copy"></i>'; }, 1200);
        } catch (err) {}
    });

    return copyBtn;
}

function initCkEditorReadMoreToggles(context = document) {
    context.querySelectorAll('.read-more-block').forEach(block => {
        // Prevent adding buttons twice
        if (block.dataset.readMoreInitialized) return;
        block.dataset.readMoreInitialized = "1";

        const preview = block.querySelector('.read-more-main');
        const hidden = block.querySelector('.read-more-hidden');
        if (!preview || !hidden) return;

        // Create the toggle button (Read more/Read less) at end of preview
        const toggleBtn = document.createElement('a');
        toggleBtn.href = '#';
        toggleBtn.className = 'read-more-toggle';
        toggleBtn.textContent = 'Read more...';

        // Create Read less at end of hidden
        const readLessBtn = document.createElement('a');
        readLessBtn.href = '#';
        readLessBtn.className = 'read-less-toggle';
        readLessBtn.textContent = 'Read less';

        preview.appendChild(toggleBtn);
        hidden.appendChild(readLessBtn);

        // lives inside the hidden part, so it only shows once the block is expanded
        hidden.prepend(createReadMoreCopyBtn(hidden, readLessBtn));

        hidden.style.display = 'none';
        readLessBtn.style.display = 'none';

        toggleBtn.addEventListener('click', function (e) {
            e.preventDefault();
            if (!block.classList.contains('expanded')) {
                hidden.style.display = '';
                readLessBtn.style.display = '';
                toggleBtn.textContent = 'Read less';
                block.classList.add('expanded');
            } else {
                hidden.style.display = 'none';
                readLessBtn.style.display = 'none';
                toggleBtn.textContent = 'Read more...';
                block.classList.remove('expanded');
            }
        });

        readLessBtn.addEventListener('click', function (e) {
            e.preventDefault();
            hidden.style.display = 'none';
            readLessBtn.style.display = 'none';
            toggleBtn.textContent = 'Read more...';
            block.classList.remove('expanded');

            const container = document.querySelector('.modal-body');

            if (container && container.contains(block)) {
                const blockTop = block.offsetTop - container.offsetTop;
                container.scrollTo({
                    top: blockTop,
                    behavior: 'smooth'
                });
            } else {
                block.scrollIntoView({behavior: 'smooth', block: 'start'});
            }
        });
    });
}

$(document).on('click', '.image-download', function (e) {
    const image_id = $(this).data('image-id');
    const image_element = $('.image-download[data-image-id="' + image_id + '"]');

    if (image_id && !$(this).attr('href')) {
        image_element.addClass('disabled');
        payload("/download-image/" + image_id, null, "GET")
            .then(function (response) {
                image_element.attr('href', response.main_image_download_link)
                    .attr('target', '_blank')
                    .removeClass('disabled')
                    .attr('download', '')[0]
                    .click();
            }).catch(function (response) {
            console.log(response)
            image_element.removeClass('disabled');
        });
    }
});
